import { Component, ElementRef, HostListener, ViewChild, Directive, OnInit, OnDestroy } from '@angular/core';
import { DecimalCommaFixDirective } from '../directives/decimal-comma-fix.directive';
import { BrowserProvider } from 'ethers';
import { SwapApiService } from '../services/swap-api.service';
import { BridgeApiService } from '../services/bridge-api.service';
import { WalletService } from '../services/wallet.service';
import { WalletConnectorService } from '../services/wallet-connector.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QuotePreviewComponent } from '../quote-preview/quote-preview.component';
import { QuotePreviewV2Component } from '../quote-preview/quote-preview-v2.component';
import { QuotePreviewComponentV3 } from '../quote-preview/quote-preview-v3.component';
import { QuotePreviewComponentV4 } from '../quote-preview/quote-preview-v4.component';
import { BridgeQuotePreviewV2Component } from '../bridge-quote-preview/bridge-quote-preview-v2.component';
import { DebugTelemetryService } from '../core/debug-telemetry.service';
import { NgOptimizedImage } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router'; // 👈 AJOUT
import { ethers } from 'ethers';
import { parseUnits } from 'ethers';
import { JsonRpcProvider } from 'ethers';
import { Interface, hexlify } from 'ethers';
import { CtaParams } from '../seo/seo-content.service';
import { Input } from '@angular/core';
import { isAddress } from 'ethers';
import { ZeroAddress } from 'ethers';
import { AfterViewInit } from '@angular/core';
import { Contract, formatUnits, toBigInt } from 'ethers';
import ABI from '../abis/FillOrder.json';
import { SettingsComponent } from '../settings/settings.component';
import SignClient from "@walletconnect/sign-client";
import { async, firstValueFrom } from 'rxjs';
import { encodePermitSingle } from '../swap/permit2-helpers';
import { Subscription } from 'rxjs';
import { PriceService } from '../services/price.service';
import { environment } from '../../environments/environment';
import { BlurOnClickDirective } from '../directives/blur-on-click.directive';
import { ActivatedRoute } from '@angular/router';
import { Params } from '@angular/router';
import { TokenSelectorComponent } from '../token-selector/token-selector.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { TypedDataDomain } from 'ethers';
import { timeout } from 'rxjs/operators';
import { DeeplinkGate } from '../services/deeplink-gate';
import { BalanceValidatorService } from '../services/balance-validator.service';
import { WalletConnectV2Service } from '../services/walletconnect-v2.service';
import { NativeTokenPriceService } from '../services/native-token-price.service';
import { WalletGatekeeperService } from '../services/wallet-gatekeeper.service';
import type { UniversalSeoResolved } from '../seo/seo-universal.resolver';
import { TOKENS_SSR_KEY, CHAIN_SSR_KEY } from '../resolvers/tokens.resolver';
import { isPlatformBrowser } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/core';
import { FooterNavComponent } from '../footer-nav/footer-nav.component';
import { Inject, PLATFORM_ID } from '@angular/core';
import { ConnectWalletLegacyComponent } from '../connect-wallet/connect-wallet-legacy.component';
import type { TransactionResponse } from 'ethers';
import {
  PERMIT2_ADDRESS,
  PermitSingle,
  AllowanceTransfer
} from '@uniswap/permit2-sdk';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import ERC20_ABI from '../abis/ERC20.json'; // Minimal ERC-20 ABI
import { createAppKit } from '@reown/appkit';
// imports à ajouter
import { AppSeoService } from '../seo/seo.service';       // ton service meta (ou équivalent)
import { SeoContentService, ResolvedSeo } from '../seo/seo-content.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TokenPortfolioCacheService } from '../services/token-portfolio-cache.service';

// ou simplement: let appKit: any;  // si tu veux être pragmatique

import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import * as net from '@reown/appkit/networks'
import * as networks from '@reown/appkit/networks';

// Ethers v6: Transaction* types are top-level exports (no `providers` namespace)
type TxResponse = import('ethers').TransactionResponse;
type TxRequest = import('ethers').TransactionRequest;

// If you ever need to compile against ethers v5 types instead, use:
// import type { TransactionResponse as V5TxResponse,
//               TransactionRequest  as V5TxRequest } from '@ethersproject/abstract-provider';
// type TxResponse = V5TxResponse;
// type TxRequest  = V5TxRequest;
// ─────────────────────────────────────────────────────────────
// Helpers globaux d’armement / cooldown deeplink (parité Bridge)
// ─────────────────────────────────────────────────────────────
function safeJson(obj: any, depth: number = 2): string {
  const seen = new WeakSet();
  const recur = (value: any, level: number): any => {
    if (value === null || typeof value !== 'object') return value;
    if (seen.has(value)) return '[Circular]';
    if (level <= 0) return '[MaxDepth]';
    seen.add(value);

    if (Array.isArray(value)) {
      return value.slice(0, 10).map(v => recur(v, level - 1));
    }

    const out: any = {};
    Object.keys(value).slice(0, 20).forEach(k => {
      try {
        out[k] = recur((value as any)[k], level - 1);
      } catch {
        out[k] = '[Error]';
      }
    });
    return out;
  };

  try {
    return JSON.stringify(recur(obj, depth), null, 2);
  } catch {
    return '[Unserializable]';
  }
}

// ─────────────────────────────────────────────────────────────
// Helpers clés unifiées (mêmes conventions que Swap)
// ─────────────────────────────────────────────────────────────
function balanceKey(address: string, chainId: number): string {
  return `${(address || '').toLowerCase()}_${Number(chainId)}`;
}

export function setAllowWcDeeplinkFor(ms = 12_000): void {
  try {
    const until = Date.now() + ms;
    sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
  } catch { /* noop */ }
}
export function clearAllowWcDeeplink(): void {
  try {
    sessionStorage.removeItem('st/allowWcDeeplinkUntil');
    // 🧹 important: on nettoie aussi l’ID d’autorisation lié au run
    sessionStorage.removeItem('st/allowWcRunId');
  } catch { /* noop */ }
}

const WC_QUOTE_COOLDOWN_MS = 4000;
// Logos locaux pour rendu instantané (au-dessus de la ligne de flottaison)
const LOCAL_TOKEN_LOGO: Record<string, string> = {
  USDC: 'assets/tokens/usdc.webp',
  ETH: 'assets/tokens/ethereum.webp',
  MATIC: 'assets/tokens/matic.png',
  BNB: 'assets/tokens/bnb.webp',
  USDT: 'assets/tokens/usdt.webp',     // ajoute le fichier si tu l’as
  // fallback générique si besoin
  UNKNOWN: 'assets/tokens/unknown-token.webp'
};

// Paires par défaut pour "hot start" selon le réseau
const HOT_START_DEFAULTS: Record<number, { sell: string; buy: string }> = {
  1: { sell: 'USDC', buy: 'ETH' }, // Ethereum
  42161: { sell: 'USDC', buy: 'ETH' }, // Arbitrum
  137: { sell: 'USDC', buy: 'MATIC' }, // Polygon (Inde plus tard)
  56: { sell: 'USDT', buy: 'BNB' }, // BNB Chain
};


// 🔎 Mapping régional minimal (langue navigateur → pays → chainId)
const REGIONAL_HOTSTART: Record<string, { chainId: number }> = {
  IN: { chainId: 137 }, // Inde → Polygon
  VN: { chainId: 56 }, // Vietnam → BNB Chain
  ID: { chainId: 56 }, // Indonésie → BNB Chain
};

function detectCountryFromLang(): string | null {
  try {
    const lang = (navigator?.language || navigator?.languages?.[0] || '').toUpperCase();
    // ex: "hi-IN", "vi-VN", "id-ID"
    const cc = lang.includes('-') ? lang.split('-')[1] : '';
    return cc || null;
  } catch { return null; }
}

function pickRegionalChainId(): number | null {
  const cc = detectCountryFromLang();
  const hit = cc ? REGIONAL_HOTSTART[cc] : undefined;
  return hit ? hit.chainId : null;
}

// Helper: muter une seule fois display_uri après hard reload
function setWcSuppressOnce(ms = 5000) {
  try {
    const until = Date.now() + ms;
    sessionStorage.setItem('st/suppressWcUriUntil', String(until));
    console.warn(`[WC] set suppress-once until=${until} (+${ms}ms)`);
  } catch { }
}


function logRouteHeader(tag: string, route: any, extra?: Record<string, any>) {
  const i = dbgRouteInfo(route);
  console.log(
    `[${tag}] route | provider=${i.provider} | routeId=${i.routeId} | steps=${i.stepCount} | approveSteps=${i.approveStepCount}` +
    (i.execTo ? ` | exec.to=${i.execTo}` : ''),
    extra ?? ''
  );
}

function dbgRouteInfo(route: any) {
  if (!route) return { provider: 'unknown', routeId: 'unknown' };
  const provider =
    route.provider ?? route.tool ?? route.name ?? route.type ?? 'unknown';
  const routeId =
    route.id ?? route.routeId ?? route.quoteId ?? route.requestId ?? 'n/a';

  // exécuteur (si déjà préparé par l’aggregator)
  const execTo =
    route?.transactionRequest?.to ??
    route?.to ??
    route?.tx?.to ??
    route?.steps?.find?.((s: any) => s.type === 'TRANSACTION')?.to ??
    null;

  // éventuels steps d’approve
  const steps = (route.steps ?? route.actions ?? []).filter(
    (s: any) => /approve/i.test(s.type || s.action || '') || s.approvalAddress
  );

  return {
    provider,
    routeId,
    execTo,
    stepCount: (route.steps ?? route.actions ?? []).length || 0,
    approveStepCount: steps.length,
  };
}

async function abortWalletConnectSoft(this: any, reason = 'quote-switch') {
  if (this.walletIntentActive) {
    this.debug?.add?.(
      `[WC][SOFT][SKIP] reason=${reason} (intent=${this.walletIntentPhase} runId=${this.walletIntentRunId ?? 'n/a'})`
    );
    return;
  }

  const log = (m: string, o?: any) =>
    this?.addLog ? this.addLog(`[WC][SOFT] ${m}${o ? ' ' + JSON.stringify(o) : ''}`) : console.warn('[WC][SOFT]', m, o ?? '');
  try {
    log('begin', { reason });
    try { await this.appKitModal?.close?.(); log('modal.close ok'); } catch (e: any) { log('modal.close error', { err: e?.message || String(e) }); }
    // NE PAS disconnect()/delete pairings ici → on garde la session active
    try {
      this._wcShown = false;
      this._wcLastUri = null;
      this._wcUri$?.next(null);
      this.wcUri = '';
      log('ui uri reset');
    } catch { }
    log('end', { ok: true });
  } catch (e: any) {
    log('fatal', { err: e?.message || String(e) });
  }
}








async function abortWalletConnectSafely(this: any, reason = 'timeout') {
  const log = (m: string, o?: any) =>
    this?.addLog ? this.addLog(`[WC][ABORT] ${m}${o ? ' ' + JSON.stringify(o) : ''}`) : console.warn('[WC][ABORT]', m, o ?? '');

  try {
    log('begin', { reason });

    // 1) Fermer la modale si ouverte
    try {
      await this.appKitModal?.close?.();
      log('modal.close ok');
    } catch (e: any) {
      log('modal.close error', { err: e?.message || String(e) });
    }

    // 2) Déconnecter le provider (universal-provider)
    try {
      await this.wc?.disconnect?.();
      log('wc.disconnect ok');
    } catch (e: any) {
      log('wc.disconnect error', { err: e?.message || String(e) });
    }

    // 3) Nettoyer les pairings orphelins
    try {
      const sc: any =
        (this.wc as any)?._signClient ||
        (this as any).signClient ||
        (this as any).appKit?.signClient;

      if (!sc?.core?.pairing) {
        log('no signClient.pairing found → skip');
      } else {
        const raw =
          sc.core.pairing.getPairings?.() ||
          sc.core.pairing.pairings?.values?.() ||
          sc.pairing?.getAll?.() ||
          [];
        const list = Array.isArray(raw) ? raw : Array.from(raw || []);
        log('pairings.list', { count: list.length });

        for (const p of list) {
          const topic = p?.topic;
          try {
            await sc.core.pairing.delete?.(topic, { code: 5000, message: `abort:${reason}` });
            log('pairing.delete ok', { topic });
          } catch (e: any) {
            log('pairing.delete error', { topic, err: e?.message || String(e) });
          }
        }
      }
    } catch (e: any) {
      log('pairings cleanup error (outer)', { err: e?.message || String(e) });
    }

    // 4) Annuler toute proposal / pending request (best-effort)
    try {
      const sc: any =
        (this.wc as any)?._signClient ||
        (this as any).signClient ||
        (this as any).appKit?.signClient;

      const pendings =
        sc?.pendingRequest?.values?.() ||
        sc?.core?.history?.records?.values?.() ||
        [];
      const arr = Array.isArray(pendings) ? pendings : Array.from(pendings || []);
      if (arr.length) log('pending.clear maybe', { count: arr.length });
      // pas d’API standard cross-version → log only
    } catch (e: any) {
      log('pending cleanup error (outer)', { err: e?.message || String(e) });
    }

    // 5) Reset UI
    try {
      this._wcShown = false;
      this._wcLastUri = null;
      this._wcUri$?.next(null);
      log('ui reset done');
    } catch { }

    // 6) Programmer la suppression de display_uri juste après reload
    setWcSuppressOnce(5000);
    log('suppress-once set (5s)');

    log('end', { ok: true, reason });
  } catch (e: any) {
    log('fatal error', { err: e?.message || String(e) });
  }
}

const FEEDS: Record<number, string> = {
  1: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419", // ETH/USD
  42161: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612", // Arbitrum ETH/USD
  137: "0xab594600376ec9fd91f8e885dadf0ce036862de0", // Polygon MATIC/USD
  10: "0x13e3ee699d1909e989722e753853ae30b17e08c5", // Optimism ETH/USD
  8453: "0x4d96b5df8d6794a3a3bf1a9e6519733b94e5b8a1", // Base ETH/USD
  43114: "0x0a77230d17318075983913bc2145db16c7366156", // Avalanche AVAX/USD
};


const FEED_ABI = [
  "function latestRoundData() view returns (uint80 roundId, int256 answer, uint256 startedAt, uint256 updatedAt, uint80 answeredInRound)",
  "function decimals() view returns (uint8)"
] as const;
function isL2Chain(id: number) {
  return [42161, 42170, 10, 8453, 84531, 59144, 7777777].includes(id);
}
// à mettre dans le même fichier que fetchQuote (ou util local)
function normalizeAltRoute(r: any, data: any, nativeUsd: number, debug: boolean = true) {
  console.log('[SWAP][ALT][NORM][IN]');
  const out = { ...r };
  const id =
    r?.providerName ||
    r?.tool ||
    r?.provider ||
    r?.routeId ||
    r?.id ||
    r?.name ||
    'alt';

  // ----  A. Flatten "received amount" ----
  const est = r?.estimate ?? r?.Estimate ?? r?.step?.estimate ?? null;
  const toTok = est?.toToken ?? r?.toToken ?? r?.action?.toToken ?? null;

  out.toAmountRaw = String(est?.toAmount ?? r?.toAmountRaw ?? 0);
  out.toAmountUsd = est?.toAmountUSD ?? r?.toAmountUsd ?? null;
  out.toTokenDecimals = Number(
    r?.toTokenDecimals ??
    toTok?.decimals ??
    data?.buyTokenDecimals ??
    data?.BuyTokenDecimals ??
    18
  );
  out.buyTokenSymbol =
    out.buyTokenSymbol ?? toTok?.symbol ?? data?.buyTokenSymbol ?? data?.BuyTokenSymbol;

  if (!out.formattedBuyAmount && out.toAmountRaw && out.toTokenDecimals >= 0) {
    out.formattedBuyAmount = Number(out.toAmountRaw) / Math.pow(10, out.toTokenDecimals);
  }

  // Prix unitaire USD du token reçu (pour la ligne "≈ ... USD")
  out.buyTokenUsdPrice = Number(
    out.buyTokenUsdPrice ?? data?.buyTokenUsdPrice ?? data?.BuyTokenUsdPrice ?? 0
  );

  // ----  B. Mirror des frais LiFi -> clés "lifi*" attendues par le template ----
  out.lifiEstimatedGas =
    out.lifiEstimatedGas ?? out.estimatedGas ?? out.EstimatedGas ?? est?.gasCosts?.[0]?.estimate ?? null;
  out.lifiGasPriceWei =
    out.lifiGasPriceWei ?? out.gasPriceWei ?? out.GasPriceWei ?? est?.gasCosts?.[0]?.price ?? null;
  out.lifiGasAmountWei =
    out.lifiGasAmountWei ?? out.gasAmountWei ?? out.GasAmountWei ?? est?.gasCosts?.[0]?.amount ?? null;
  out.lifiGasFeeUsd =
    out.lifiGasFeeUsd ?? out.gasFeeUsd ?? out.GasFeeUsd ?? est?.gasCosts?.[0]?.amountUSD ?? null;
  out.lifiGasTokenPriceUsd =
    out.lifiGasTokenPriceUsd ??
    out.gasTokenPriceUsd ??
    out.GasTokenPriceUsd ??
    data?.gasTokenPriceUsd ??
    data?.GasTokenPriceUsd ??
    nativeUsd ??
    null;

  // --- DEBUG (avant flatten MM) ---
  if (debug) {
    console.log('[SWAP][ALT][NORM][IN]', id, {
      hasSingleRoutes: Array.isArray(r?.singleRoutes),
      singleRoutesLen: r?.singleRoutes?.length ?? 0,
      topLevel: {
        mmExpected: r?.mmExpectedNetworkFeeWei ?? null,
        mmNetwork: r?.mmNetworkFeeWei ?? null,
        mmMax: r?.mmMaxNetworkFeeWei ?? null,
      },
      sr0: {
        mmExpected: r?.singleRoutes?.[0]?.mmExpectedNetworkFeeWei ?? null,
        mmNetwork: r?.singleRoutes?.[0]?.mmNetworkFeeWei ?? null,
        mmMax: r?.singleRoutes?.[0]?.mmMaxNetworkFeeWei ?? null,
      },
    });
  }

  // ----  C. MM-like (gating) : remonter les champs depuis singleRoutes[0] si absents au niveau route ----
  const sr0 = r?.singleRoutes?.[0] ?? null;
  out.mmExpectedNetworkFeeWei =
    out.mmExpectedNetworkFeeWei ?? sr0?.mmExpectedNetworkFeeWei ?? r?.mmExpectedNetworkFeeWei ?? null;
  out.mmNetworkFeeWei =
    out.mmNetworkFeeWei ?? sr0?.mmNetworkFeeWei ?? r?.mmNetworkFeeWei ?? null;
  out.mmMaxNetworkFeeWei =
    out.mmMaxNetworkFeeWei ?? sr0?.mmMaxNetworkFeeWei ?? r?.mmMaxNetworkFeeWei ?? null;

  // (optionnel) symbol du gas token si utile côté UI/gating
  out.gasTokenSymbol = out.gasTokenSymbol ?? data?.gasTokenSymbol ?? data?.GasTokenSymbol ?? 'ETH';

  // --- DEBUG (après flatten MM) ---
  if (debug) {
    const price = Number(out.lifiGasTokenPriceUsd ?? nativeUsd ?? data?.gasTokenPriceUsd ?? 0);
    const toEth = (w: any) => {
      try {
        if (w == null) return 0;
        const n = typeof w === 'bigint' ? Number(w) : Number(String(w).startsWith('0x') ? BigInt(w) : Number(w));
        return n / 1e18;
      } catch { return 0; }
    };
    const expEth = toEth(out.mmExpectedNetworkFeeWei);
    const netEth = toEth(out.mmNetworkFeeWei);
    const maxEth = toEth(out.mmMaxNetworkFeeWei);
    console.log('[SWAP][ALT][NORM][OUT]', id, {
      mmExpectedWei: out.mmExpectedNetworkFeeWei ?? null,
      mmNetworkWei: out.mmNetworkFeeWei ?? null,
      mmMaxWei: out.mmMaxNetworkFeeWei ?? null,
      mmExpectedEth: expEth,
      mmNetworkEth: netEth,
      mmMaxEth: maxEth,
      mmExpectedUsd: expEth > 0 && price ? expEth * price : null,
      reason:
        (out.mmExpectedNetworkFeeWei ? 'expected_at_route' :
          sr0?.mmExpectedNetworkFeeWei ? 'expected_from_sr0' :
            out.mmNetworkFeeWei ? 'fallback_mmNetwork' :
              out.mmMaxNetworkFeeWei ? 'fallback_mmMax' : 'missing_all'),
    });
  }

  return out;
}

// Helpers de typage
type Ongoing = 'pending' | 'approve';
type Terminal = 'success' | 'error' | 'cancelled';

function isOngoing(s: BridgeStatus): s is Ongoing {
  return s === 'pending' || s === 'approve';
}
function isTerminal(s: BridgeStatus): s is Terminal {
  return s === 'success' || s === 'error' || s === 'cancelled';
}


export async function getOnChainNativeUsd(chainId: number, provider: ethers.Provider): Promise<number | null> {
  try {
    const feedAddr = FEEDS[chainId];
    if (!feedAddr) return null;

    const feed = new ethers.Contract(feedAddr, FEED_ABI, provider);

    // ✅ Utiliser l’index signature
    const round = await feed["latestRoundData"]();
    const answer = round[1] as bigint;              // int256 → bigint en ethers v6
    const decimals = Number(await feed["decimals"]());

    if (answer <= 0n) return null;

    return Number(answer) / 10 ** decimals;
  } catch (e) {
    console.warn("[Chainlink] getOnChainNativeUsd failed:", e);
    return null;
  }
}

// --- Helpers gas/fees (ajouter hors classe) ---
export function sanitizeTxForWallet<T extends Record<string, any>>(tx: T): T {
  // retire tout ce qui “suggère par le site”
  const { gas, gasLimit, gasPrice, maxFeePerGas, maxPriorityFeePerGas, type, ...rest } = tx || {};
  return { ...rest } as T;
}

function hexToBigIntSafe(h?: string | null): bigint {
  try { return h ? BigInt(h) : 0n; } catch { return 0n; }
}

export async function getSuggestedEip1559Price(
  provider: ethers.Provider,
  speed: "slow" | "medium" | "fast" = "slow"
): Promise<{ priceWei: bigint; baseFeeWei: bigint; priorityWei: bigint; factor: number }> {

  // 1) Base fee du dernier bloc
  const rpc = provider as unknown as ethers.JsonRpcProvider;
  const latest = await rpc.send("eth_getBlockByNumber", ["latest", false]);
  const baseFeeWei = hexToBigIntSafe(latest?.baseFeePerGas);
  if (baseFeeWei === 0n) {
    // Chaîne sans EIP-1559 -> fallback eth_gasPrice
    const gasPriceHex = await rpc.send("eth_gasPrice", []);
    const gp = hexToBigIntSafe(gasPriceHex);
    return { priceWei: gp, baseFeeWei: 0n, priorityWei: 0n, factor: 1.0 };
  }

  // 2) Priority (tip)
  let priorityWei = 0n;
  try {
    const tipHex = await rpc.send("eth_maxPriorityFeePerGas", []);
    priorityWei = hexToBigIntSafe(tipHex);
  } catch {
    // RPC ne supporte pas -> plancher 1 gwei
    priorityWei = 1_000_000_000n;
  }

  // 3) Facteur selon la vitesse désirée
  const factor = speed === "fast" ? 1.5 : speed === "medium" ? 1.2 : 1.10;

  // 4) Prix suggéré = base * facteur + tip
  // (arrondi en bigint)
  const priceWei = (baseFeeWei * BigInt(Math.round(factor * 100))) / 100n + priorityWei;

  return { priceWei, baseFeeWei, priorityWei, factor };
}

// ---- SessionStore ultra simple ----------------------------------------------
const ST_SESSION_KEY = 'st/session/v1';

type SimpleSession = {
  address: string;
  chainId: number;
  providerType?: string; // (facultatif: 'walletconnect' | 'injected' etc.)
  ts: number;            // timestamp pour debug
};
let signClient: any;
async function initSignClient() {
  signClient = await SignClient.init({
    projectId: "ton_project_id_wc",
    relayUrl: "wss://relay.walletconnect.com",
    metadata: {
      name: "SwapTokens",
      description: "SwapTokens App",
      url: "https://swaptokens.app",
      icons: ["https://swaptokens.app/logo.png"],
    },
  });
}

// 🔌 1) Débrancher toutes les sessions & pairings WC v2
async function killWalletConnectV2(client?: SignClient) {
  try {
    if (!client) return;

    const sessions = client.session?.getAll?.() ?? [];
    for (const s of sessions) {
      await client.disconnect({
        topic: s.topic,
        reason: { code: 6000, message: 'USER_DISCONNECTED' }
      }).catch(() => { });
    }

    const pairings = client.core?.pairing?.getPairings?.() ?? [];
    for (const p of pairings) {
      await client.core?.pairing?.disconnect({ topic: p.topic }).catch(() => { });
    }
  } catch { }
}
// Fallbacks connus par chaîne (complets si tu veux)
const FALLBACK_TOKEN_ADDRESSES: Record<number, Record<string, string>> = {
  1: { // Ethereum
    USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'
  },
  137: { // Polygon
    USDT: '0xC2132D05D31c914a87C6611C10748AEb04B58e8F',
    // USDC natif (Circle)
    USDC: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    // USDC bridgé (ex-USDC.e)
    'USDC.E': '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174'
  },
  42161: { // Arbitrum
    USDT: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831'
  },
  56: { // BNB Chain
    USDT: '0x55d398326f99059fF775485246999027B3197955'
  }
};

// 🧹 2) Purger l’IndexedDB (WalletConnect/AppKit)
async function purgeWCIndexedDB() {
  try {
    // @ts-ignore
    const dbs = await indexedDB.databases?.();
    if (!dbs) return;
    for (const db of dbs) {
      const name = (db.name || '').toLowerCase();
      if (name.includes('walletconnect') || name.includes('appkit') || name.includes('wagmi')) {
        await new Promise<void>(res => {
          const req = indexedDB.deleteDatabase(db.name!);
          req.onsuccess = req.onerror = req.onblocked = () => res();
        });
      }
    }
  } catch { }
}

// 🧯 3) Teardown AppKit/modal pour stopper la réhydratation
function teardownAppKit(modal?: any) {
  try { modal?.removeAllListeners?.(); } catch { }
  (window as any).walletConnectProvider = undefined;
}

function loadSimpleSession(): SimpleSession | null {
  const raw = localStorage.getItem(ST_SESSION_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
}
async function backupSession() {
  const sessions = signClient.session.getAll();
  if (sessions.length > 0) {
    const session = sessions[0];
    localStorage.setItem("wc_session_backup", JSON.stringify(session));
    console.log("💾 Session backup:", session.topic, session.expiry);
  } else {
    console.log("ℹ️ Pas de session active à sauvegarder");
  }
}
function saveSimpleSession(s: SimpleSession) {
  localStorage.setItem(ST_SESSION_KEY, JSON.stringify(s));
}
let modal: ReturnType<typeof createAppKit> | undefined;
function isEip1193(p: any): boolean {
  return !!p && typeof p.request === 'function';
}

function initAppKit(projectId: string) {
  if (modal) return;
  const adapter = new EthersAdapter();

  console.log('[APPKIT] init...');
  modal = createAppKit({
    adapters: [adapter],
    networks: [
      networks.mainnet,
      networks.arbitrum,
      networks.polygon,   // ✅ Polygon
      networks.bsc     // ✅ BNB Chain
    ],
    projectId,
    metadata: {
      name: 'SwapTokens',
      description: 'Swap & Bridge',
      url: 'https://swaptokens-zeta.vercel.app',
      icons: ['https://swaptokens-zeta.vercel.app/assets/icon-512.png']
    },
    // ⬇️ Désactive tout sauf les connexions “wallet”
    features: {
      analytics: true,   // garde si tu veux la télémétrie
      email: false,      // ❌ pas de login email
      socials: false,    // ❌ pas de login socials
      onramp: false,     // ❌ pas d'achat CB/on-ramp
      swaps: false,      // ❌ pas de swap intégré AppKit (tu as déjà ton flow)
      send: false        // ❌ pas de “send” AppKit
      // (ajoute d'autres flags présents dans ta version si besoin, tous à false)
    }
  });
  console.log('[APPKIT] ready');

  // ✅ expose globalement pour debug / rehydration
  (window as any).appKitModal = modal;

  // ✅ s'abonne aux events pour auto-réattache
  try {
    // Certaines versions émettent { type: 'CONNECT_SUCCESS' } ou { event: 'session_update' }
    (modal as any)?.subscribe?.((evt: any) => {
      try {
        const type = evt?.type || evt?.event || '(unknown)';
        console.log('[APPKIT][event]', type, evt);
        if (type === 'CONNECT_SUCCESS' || type === 'session_update') {
          console.log('[APPKIT] 🔁 trigger softReloadWalletSession()');
          // On relance la reconnexion silencieuse
          (window as any)?.ngComponentRef?.instance?.softReloadWalletSession?.(0);
        }
      } catch (e) {
        console.warn('[APPKIT][event] error', e);
      }
    });
  } catch (err) {
    console.warn('[APPKIT][subscribe] unavailable', err);
  }

  return modal; // ✅ renvoie toujours la même instance
}

const ALLOWANCE_TRANSFER_ABI = [
  "function permit(address owner, (address token,uint160 amount,uint48 expiration,uint48 nonce) details, address spender, uint256 sigDeadline, bytes signature)"
];

const tokenDecimalsMap: Record<string, number> = {
  ETH: 18,
  USDC: 6,
  USDT: 6,
  MATIC: 18,
  BNB: 18,
  // ajoute ici les tokens que tu utilises
};

const L = {
  d: (tag: string, ...v: any[]) => console.debug(`%c[DEBUG] ${tag}`, 'color:#7c3aed', ...v),
  i: (tag: string, ...v: any[]) => console.info(`%c[INFO ] ${tag}`, 'color:#10b981;font-weight:bold;', ...v),
  w: (tag: string, ...v: any[]) => console.warn(`%c[WARN ] ${tag}`, 'color:#eab308;font-weight:bold;', ...v),
  e: (tag: string, ...v: any[]) => console.error(`%c[ERROR] ${tag}`, 'color:#ef4444;font-weight:bold;', ...v),
};

export const OPENOCEAN_ROUTER = '0x6352a56caadC4F1E25CD6c75970Fa768A3304e64';

export const TOKEN_ADDRESS_MAP: Record<string, string> = {
  USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  DAI: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
  ETH: '0xC02aaa39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  WBTC: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  MATIC: '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0'
};
// swap.component.ts (en haut du fichier – hors de la classe)
export const CHAIN_MAP: Record<number, { icon: string; name: string }> = {
  1: { icon: 'assets/chains/ethereum-eth-logo.svg', name: 'Ethereum' },
  42161: { icon: 'assets/chains/arbitrum-arb-logo.svg', name: 'Arbitrum' },
  137: { icon: 'assets/chains/polygon-matic-logo.svg', name: 'Polygon' },
  56: { icon: 'assets/chains/bnb-bnb-logo.svg', name: 'BNB Chain' },
};

export function formatTokenAmount(value: number): string {
  if (value === 0) return '0';
  if (value >= 1) return value.toFixed(4).replace(/\.?0+$/, '');
  if (value >= 0.01) return value.toFixed(5).replace(/\.?0+$/, '');
  if (value >= 0.000001) return value.toFixed(7).replace(/\.?0+$/, '');
  return value.toExponential(2); // ex: 1.23e-6
}

export async function disconnectWallet(this: any, forceKill = true): Promise<void> {
  try {
    logStep('DISCONNECT-START');
    /* ----------------------------------------------------------------
     * 1️⃣  Réinitialiser l’état du composant
     * ---------------------------------------------------------------- */
    this.takerAddress = null;
    this.provider = null;
    /*this.quote = null;*/
    this.signature = null;
    this.session = null;          // ← ajoute

    /* ----------------------------------------------------------------
     * 2️⃣  Purger le stockage local
     * ---------------------------------------------------------------- */
    localStorage.removeItem('wallet');
    localStorage.removeItem('walletconnect');
    localStorage.removeItem('walletconnect_session');
    localStorage.removeItem('wc_session_id');   // ← ajoute
    sessionStorage.removeItem('WC_DEFAULT_SESSION');

    /* ----------------------------------------------------------------
     * 3️⃣  Déconnecter WalletConnect v2 (mobile & desktop)
     * ---------------------------------------------------------------- */
    const wc: any = (window as any).walletConnectProvider;
    if (wc) {
      try {
        wc.removeAllListeners?.();

        if (typeof wc.disconnect === 'function') {
          await wc.disconnect(forceKill);
        } else if (typeof wc.close === 'function') {
          await wc.close();
        }

        wc.connector?.killSession?.();
      } catch (err) {
        console.warn('[disconnectWallet] WC disconnect error', err);
      }
    }
    delete (window as any).walletConnectProvider; // ← garantit qu’on repart de zéro

    /* ----------------------------------------------------------------
     * 4️⃣  Déconnecter l’extension MetaMask (desktop)
     * ---------------------------------------------------------------- */
    const eth: any = (window as any).ethereum;
    if (eth) {
      eth.removeAllListeners?.();
      if (typeof eth.disconnect === 'function') {
        try {
          await eth.disconnect();
        } catch {/* certaines extensions n’implémentent pas .disconnect() */ }
      }
    }

    /* ----------------------------------------------------------------
     * 5️⃣  (Optionnel) notifier ton backend de supprimer la session
     * ---------------------------------------------------------------- */
    const storedSessionId = localStorage.getItem('wc_session_id');
    if (storedSessionId) {
      fetch(`https://walletconnect-api.vercel.app/api/session?sessionId=${storedSessionId}`, {
        method: 'DELETE'
      }).catch(() => {/* silencieux */ });
    }
    //this.chainId = null;
    //this.chainInfo = null;
    /* ----------------------------------------------------------------
     * 6️⃣  Feedback utilisateur
     * ---------------------------------------------------------------- */
    console.log('[disconnectWallet] fully disconnected');
    const msg = await firstValueFrom(this.translate.get('WALLET_DISCONNECTED'));
    logStep('DISCONNECT-DONE');
    alert(msg);


  } catch (error) {
    console.error('[disconnectWallet] error', error);
    const fallback = await firstValueFrom(this.translate.get('WALLET_DISCONNECT_ERROR'));
    alert(fallback);
  }
}



function logStep(tag: string, ...msg: any[]) {
  const now = new Date().toISOString().split('T')[1].slice(0, 8); // HH:MM:SS
  console.log(`[WC][${now}] ${tag}`, ...msg);
}

type BridgeStatus = 'idle' | 'approve' | 'pending' | 'success' | 'error' | 'cancelled';
type CtaParamsCompat = CtaParams & { from?: string; to?: string; chain?: string };

export const TOKEN_DECIMALS_MAP: Record<string, number> = {
  USDC: 6,
  USDT: 6,
  DAI: 18,
  ETH: 18,
  WBTC: 8,
  MATIC: 18
};

const ZERO = '0x0000000000000000000000000000000000000000';
const toAddr = (x: any) => String(x ?? '').trim().toLowerCase();
const isAddr = (a?: string) => {
  const s = toAddr(a);
  return !!(s && s.startsWith('0x') && s.length === 42 && s !== ZERO);
};

function pickSellTokenAddress(route: any, quote: any, ui?: any): string {
  const cands = [
    // standards intégrateurs
    route?.sellTokenAddress,
    route?.inTokenAddress,
    route?.sellToken?.address,
    route?.tokenIn?.address,
    route?.inToken?.address,

    // variantes côté "quote"
    quote?.sellTokenAddress,
    quote?.inTokenAddress,
    quote?.sellToken?.address,
    quote?.tokenIn?.address,
    quote?.inToken?.address,

    // fallback UI (si tu as un state local)
    ui?.sellToken?.address,

    // ULTRA fallback: ce que ta simu utilise déjà si tu as un utilitaire interne
    // getSellTokenAddress(route) // <- si tu as déjà cette fonction ailleurs
  ].map(toAddr);



  return cands.find(isAddr) || '';
}

// swap.component.ts (en haut du fichier)
const PENDING_BRIDGE_TX_KEY = 'bridge/pendingTx/v1';
@Directive({
  selector: '[appFocusScrollGuard]',
  standalone: true
})
export class FocusScrollGuardDirective {
  private y = 0;
  private locked = false;

  @HostListener('focusin')
  onFocus() {
    if (this.locked) return;
    this.y = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    this.locked = true;
  }

  @HostListener('focusout')
  onBlur() {
    if (!this.locked) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    this.locked = false;
    window.scrollTo(0, this.y);
  }
}
@Component({
  selector: 'app-bridge',
  standalone: true,
  templateUrl: './bridge.component.html',
  styleUrls: ['./bridge.component.scss'],
  imports: [
    QuotePreviewComponentV4, QuotePreviewComponentV3, QuotePreviewV2Component,
    CommonModule, FormsModule, QuotePreviewComponent, TranslateModule, RouterModule,
    SettingsComponent, BlurOnClickDirective, TokenSelectorComponent, SideNavComponent, BridgeQuotePreviewV2Component,
    NgOptimizedImage,
    FooterNavComponent,  // 👈 NEW
    FocusScrollGuardDirective,
    ConnectWalletLegacyComponent,
    DecimalCommaFixDirective
  ]
})

export class BridgeComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('footerMenuRoot', { static: false }) footerMenuRoot?: ElementRef;
  @ViewChild('settingsRoot', { static: false }) settingsRoot?: ElementRef;
  @ViewChild('networkRoot', { static: false }) networkRoot?: ElementRef;
  @ViewChild('networkBuyRoot', { static: false }) networkBuyRoot?: ElementRef;
  @ViewChild('chainTrigger', { static: false }) chainTrigger?: ElementRef;
  @ViewChild('chainMenuRoot', { static: false }) chainMenuRoot?: ElementRef;
  @ViewChild('footerHost', { static: false, read: ElementRef }) footerHost?: ElementRef<HTMLElement>;
  @ViewChild('legacyConnect') legacyConnect?: ConnectWalletLegacyComponent;
  showDebug = false;
  debugLogs: string[] = [];
  mmBaseFeeWei: bigint = 0n;
  mmTipWei: bigint = 0n;
  mmUnitWei: bigint = 0n;
  mmBufferedGasLimit: bigint = 0n;


  @Input() bridgePrefill?: {
    fromChainId: number;
    toChainId: number;
    tokenIn: string;
    tokenOut: string;
  }
  public onChildLogConsole = (m: string, extra?: any) => {
    console.log('[PARENT]', m, extra ?? '');
    this.addLog?.(`[legacy] ${m}${extra ? ' ' + (JSON.stringify(extra).slice(0, 1000)) : ''}`);
  };
  private _lastApprovePreRunId: number | null = null;

  public onChildLog = (m: string) => this.addLog(m);
  allChainIds: number[] | undefined;

  get debugText() { return this.debugLogs.join('\n'); }
  public addLog(m: string) {
    const stamp = new Date().toISOString().slice(11, 19);
    this.debugLogs.push(`[${stamp}] ${m}`);
    console.log(m);
  }
  inTokenPriceUSD?: number;
  outTokenPriceUSD?: number;
  bridgeFeePriceUSD?: number;
  gasFeePriceUSD?: number;
  isDebugCollapsed = false;
  isMMInApp: boolean = false;
  hasMMExt: boolean = false;
  isMobile: boolean = false;
  availableTokens: any[] = [];
  availableBuyTokens: any[] = [];
  filteredSellTokens: any[] = [];
  filteredBuyTokens: any[] = [];
  sellAmount = '1';
  sellTokenSymbol = 'USDC';
  buyTokenSymbol = 'ETH';
  sellTokenAddress: string = '';
  buyTokenAddress: string = '';
  takerAddress: string | null = null;
  quote: any;
  sellTokenSearch: string = '';
  buyTokenSearch: string = '';
  signature: string | null = null;
  provider: BrowserProvider | null = null;
  tokenAddressMap = TOKEN_ADDRESS_MAP;
  objectKeys = Object.keys;
  quoteErrorMessage: string | null = null;
  tokenBalances: Record<string, string> = {};
  tokenCachedBalances: Record<string, string> = {};
  buyTokenCachedBalances: Record<string, string> = {};
  buyTokenBalances: Record<string, string> = {};
  showSettings = false;
  showChainMenu = false;
  showBuyDropdown = false;
  priceMap: Record<string, number> = {};
  priceBuyMap: Record<string, number> = {};
  defaultFiat = localStorage.getItem('currency') || 'EUR';
  fullGasWei: bigint = 0n;
  gasPriceWei: bigint = 0n;
  nativeTokenUsd: number = 0;
  isLoadingQuote = false;
  showFooterMenu = false;
  rawProvider: any = null;
  validatingKey: string | null = null;
  bridgeStatus: 'idle' | 'approve' | 'pending' | 'success' | 'cancelled' | 'error' = 'idle';
  bridgeHash: string | null = null;
  bridgeError: string | null = null;
  // --- Gestion WalletConnect / persistance ---
  /* ------------------ propriétés manquantes pour le template ----------------- */
  showWcModal = false;   // ← le template s’en sert pour afficher la modale
  wcUri = '';      // ← idem (QR + deep-link)
  private session: any;  // ← seulement si tu veux réutiliser la session plus tard
  private lastSimFailedKey: string | null = null;
  private failedAltKeys = new Set<string>();
  /* -------------------------------------------------------------------------- */
  isConnected: boolean = false;
  encodeURIComponent = encodeURIComponent;
  // --- Permit2 -------------------------------------------------------------
  permit?: PermitSingle;          // objet PermitSingle généré
  permitSig?: string;             // signature EIP-712 du permit
  ultraMode: boolean = false;

  private readonly enablePermit2: boolean = false; // coupe Permit2 côté swap
  // en haut de la classe
  private _lastWcWake:
    | { ctx: string; runId: number | null; at: number }
    | null = null;

  private _approveDeeplinkRunId: number | null = null;

  public showSellDropdown = false;
  private nfCache = new Map<string, Intl.NumberFormat>();
  readonly CHAIN_MAP = CHAIN_MAP;
  private allTokens: any[] = [];
  tokensLoaded = false;
  availableNetworks = ['ethereum', 'arbitrum', 'optimism', 'polygon', 'bsc'];
  selectedNetwork = 1;
  selectedBuyNetwork = 1;
  showNetworkDropdown = false;
  showNetworkBuyDropdown = false;
  fiatRates: Record<string, number> = { USD: 1 };
  swapDisabled = true;
  swapReasons: string[] = [];
  reasonLabels: Record<string, string> = {};
  tBase = '';
  editorialH1 = '';
  editorialBody = '';
  faqJsonLd: string | null = null;
  seoResolved?: ResolvedSeo; // si pas déjà présent
  seoChainId: number | null = null;
  selectedAltKey: string | null = null;
  selectedAlternative: any | null = null;
  headerBackdropColor = '#0b1220';
  currentNativeBalanceWei: bigint = 0n;
  debugBypassGasCheck: boolean = false;
  private readonly debug = false;
  toggleFooterMenu() { this.showFooterMenu = !this.showFooterMenu; }
  closeFooterMenu() { this.showFooterMenu = false; }
  // swap.component.ts
  public needsApprovalMain: boolean = false;
  public needsApprovalForAlt: (r: any) => boolean = () => false;



  // ============================================================
  // Apex: Wallet intent lock (prevents WC soft reset during MM sheet)
  // ============================================================
  private walletIntentActive = false;
  private walletIntentPhase: 'none' | 'approve' | 'send' = 'none';
  private walletIntentRunId: number | null = null;
  private walletIntentStartedAt = 0;

  private intentEnter(phase: 'approve' | 'send', runId?: number) {
    this.walletIntentActive = true;
    this.walletIntentPhase = phase;
    this.walletIntentRunId = typeof runId === 'number' ? runId : null;
    this.walletIntentStartedAt = Date.now();
    this.addLog?.(
      `[INTENT] ENTER phase=${phase} runId=${this.walletIntentRunId ?? 'n/a'}`
    );
  }

  private intentExit(reason: string) {
    const dur = Date.now() - this.walletIntentStartedAt;
    this.addLog?.(
      `[INTENT] EXIT phase=${this.walletIntentPhase} runId=${this.walletIntentRunId ?? 'n/a'} reason=${reason} durMs=${dur}`
    );
    this.walletIntentActive = false;
    this.walletIntentPhase = 'none';
    this.walletIntentRunId = null;
    this.walletIntentStartedAt = 0;
  }


  // --- Provider surfacing (singleton / quote-independent) ---
  private _rawProviderRef: any = null;
  // (optionnel) pour future mutex propre, on garde le champ
  private _attachProviderPromise: Promise<void> | null = null;
  private _attachProviderSeq = 0; // utilisé comme "in-flight flag"

  // --- Quote lifecycle cancel token (anti late-connect) ---
  private _quoteLifeId = 0;
  private _quoteConnectSeq = 0;
  private _activeQuoteConnectSeq: number | null = null;
  private _activeQuoteConnectLifeId: number | null = null;

  // provider pump when connect is started from quote (kept independent from quote UI)
  private _quoteProviderPump: { seq: number; lifeId: number; t0: number; cancelled: boolean; timer?: any } | null = null;


  private _legacyConnectSubs: any[] = [];






  // --- cancel-flow timers (trx/apprv)
  private _cfTimers: Record<string, any> = {};
  private _cfDone: Record<string, boolean> = {};

  // Helper: clear timer safely
  private cfClearTimer(phase: 'trx' | 'apprv', reason: string) {
    const t = this._cfTimers?.[phase];
    if (t) {
      clearTimeout(t);
      this._cfTimers[phase] = null;
      this.addLog?.(`[cancel][clear] phase=${phase} reason=${reason}`);
    }
  }

  // Helper: mark phase done (prevents future timeout cancel)
  private cfMarkDone(phase: 'trx' | 'apprv', reason: string) {
    this._cfDone[phase] = true;
    this.cfClearTimer(phase, `done:${reason}`);
    this.addLog?.(`[cancel][done] phase=${phase} reason=${reason}`);
  }





  // ⬇️ juste sous tes propriétés existantes
  isCriticalAboveTheFold = true;         // pour le logo/token au dessus de la ligne de flottaison
  tokenImgSize = 24;                     // largeur/hauteur fixes pour éviter le CLS
  readonly ZERO_WEI: bigint = 0n;
  /** Anti-concurrence pour les watchers (un watcher obsolète ne peut pas écraser l’état). */
  private _watchRunId = 0;
  // ⬇️ TrackBy pour listes (évite re-rendus inutiles)
  trackBySymbol(_i: number, t: any) { return t?.symbol || _i; }

  //onLegacyConnected(e: { address: string; chainId: number; providerType: string; provider: any }) {
  //  // Si tu veux laisser le composant faire la persistance basique, ne touche à rien.
  //  // Si tu préfères, tu peux aussi refaire ici:
  //  // this.provider = new BrowserProvider(e.provider); etc.

  //  this.takerAddress = e.address;
  //  this.isConnected = true;
  //  this.rawProvider = e.provider;
  //  try { this.provider = new BrowserProvider(e.provider); } catch { this.addLog("onLegacyConnected error"); }
  //  this.setChain(e.chainId);
  //  this.bindPortfolioIfReady('onLegacyConnected');
  //  try { this.refreshTokensForChain(); } catch { /* noop */ }
  //  this.resumeOpenProbe('wallet-connected');   // 👈 réactive la sonde
  //  this.cd.detectChanges();
  //}


  public async onLegacyConnected(ev: any, source: string) {
    try {
      const addr = (ev?.address || '').toString();
      const cid = ev?.chainId ?? null;
      const ptype = ev?.providerType || '-';
      const hasProv = !!ev?.provider;
      this.addLog?.(
        `[wallet] legacy-connected event | source=${source} hasProv=${hasProv} cid=${cid ?? 'null'} ` +
        `addr=${addr ? (addr.slice(0, 6) + '…' + addr.slice(-4)) : '(empty)'} type=${ptype} quoteOpen=${!!this.quote}`
      );

      // ✅ Provider attach = singleton, indépendant de la quote
      if (ev?.provider) {
        await this.attachEthersProvider(ev.provider, `legacy-connected:${source}`);
      }

      // ✅ Anti late-connect: si quote fermée entre-temps → ignore UI quote
      if (this._activeQuoteConnectSeq != null) {
        const isLate =
          (this._activeQuoteConnectLifeId != null) &&
          (this._quoteLifeId !== this._activeQuoteConnectLifeId);

        if (isLate || !this.quote) {
          this.addLog?.(
            `[quote][connect] late-connected -> ignore quote UI | lifeNow=${this._quoteLifeId} ` +
            `lifeStart=${this._activeQuoteConnectLifeId ?? 'null'} quoteOpen=${!!this.quote}`
          );
        } else {
          // ✅ IMPORTANT: on ne ferme plus la quote à la connexion.
          // On garde l'expérience “quote stays open”, et on rafraîchit juste le gate (disabled/enabled).
          this.addLog?.('[quote][connect] connected while quote open -> KEEP quote open (refresh gate only)');
          try {
            // refresh le disabled state (le bouton Execute doit s'activer si tout est ok)
            await this.isBridgeDisabled();
          } catch (e2: any) {
            this.addLog?.(`[quote][connect] gate refresh error | ${e2?.message || e2}`);
          }
        }

        // cleanup flags quoi qu'il arrive
        this.connectInFlight = false;
        this.connectInFlightUntil = 0;
        this._activeQuoteConnectSeq = null;
        this._activeQuoteConnectLifeId = null;
      }
    } catch (e: any) {
      this.addLog?.(`[wallet] legacy-connected handler error | ${e?.message || e}`);
    }
  }

  onLegacyDisconnected() {
    this.isConnected = false;
    this.takerAddress = null;
    this.pauseOpenProbe('wallet-disconnected'); // 👈 re-pause
    this.cd.detectChanges();
  }



  private _runSeq = 0;
  private _deeplinkOpenedForRun: number | null = null;
  private _deeplinkReopenTimer?: any;
  private _vvSpacerEl?: HTMLDivElement;
  private _vvCleanup?: () => void;

  private _lastQuoteClickAt = 0;

  private _ctaTimer?: any;
  private _tpcReadyArmed = false; // 1ère arrivée des tokens -> forceRefresh une fois


  // ─────────────────────────────────────────────
  // 🧠 Portfolio bindings (addr+chainId) : anti race-condition (debug=1 ou pas)
  // ─────────────────────────────────────────────
  private _portfolioBindKey: string | null = null;
  private _ownedTokensSub?: Subscription;
  private _tokenBalancesSub?: Subscription;
  private _portfolioRetryCount = 0;
  private _portfolioLastCount = -1;
  private _portfolioLastBalKeys = -1;
  // ─────────────────────────────────────────────
  // 🔵 Nouvelle voie “cache” (n’affecte pas les anciennes listes)
  // ─────────────────────────────────────────────
  userCachedTokens: any[] = [];
  popularCachedTokens: any[] = [];
  userBuyCachedTokens: any[] = [];
  popularBuyCachedTokens: any[] = [];

  private _tpcSellSub?: Subscription;
  private _tpcBuySub?: Subscription;

  /** Hauteur mesurée du footer (réservée en padding-bottom). */
  footerHpx = 72;

  /** Padding-bottom utilisé comme reverse-spacer : hauteur footer + safe-area. */
  get footerPaddingBottom(): string {
    // calc() pour intégrer les insets iOS/Android sans reflow JS
    return '0px';
  }


  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  onWinResize() { setTimeout(() => this.measureFooter(), 50); }

  /** Uniformise la clé d'un token (sell/buy) */
  private tokenKey(t: { address: string; chainId: number }): string {
    return balanceKey(t.address, t.chainId);
  }
  /** Raccourcis lecture */
  private getBal(map: Record<string, string>, t: { address: string; chainId: number }): string {
    return map[this.tokenKey(t)] || '0';
  }
  private setBal(map: Record<string, string>, t: { address: string; chainId: number }, v?: string | null) {
    map[this.tokenKey(t)] = v ?? '0';
  }



  // 🔁 Swap parity (no auto-deeplink): contextual WC modal state
  public wcModalPhase: 'approve' | 'tx' | null = null;
  public wcModalCtx: string | null = null;
  public wcModalRunId: number | null = null;

  // Auto-close hooks (close WC modal as soon as user leaves the page to the wallet)
  private _wcAutoCloseInstalled = false;
  private _wcAutoCloseRunId: number | null = null;
  private _wcOnVisibility: any = null;
  private _wcOnBlur: any = null;
  private _wcOnPageHide: any = null;
  private _suspendRestoreSession = false;
  private _suspendRestoreSessionReason: string = '';


  // restoreSession runtime handles (so we can hard-stop on CTA connect)
  private _restoreSessionPollTimer: any = null;
  private _restoreSessionUnsub: any = null;
  private _restoreSessionRunId = 0;
  private _restoreSessionSleepTimer: any = null;
  private _restoreSessionSleepResolve: ((ok: boolean) => void) | null = null;


  private suspendRestoreSession(reason: string) {
    this._suspendRestoreSession = true;
    this._suspendRestoreSessionReason = reason || 'unknown';


    // 🔥 HARD STOP: invalidate any in-flight restoreSession work (loops/sleeps/polls/subscriptions)
    this._restoreSessionRunId++;

    // cancel pending sleep (if restoreSession is between retries)
    try {
      if (this._restoreSessionSleepTimer) {
        clearTimeout(this._restoreSessionSleepTimer);
        this._restoreSessionSleepTimer = null;
      }
      if (this._restoreSessionSleepResolve) {
        this._restoreSessionSleepResolve(false);
        this._restoreSessionSleepResolve = null;
      }
    } catch { /* no-op */ }

    // cancel poll interval (fallback subscribeProviders)
    try {
      if (this._restoreSessionPollTimer) {
        clearInterval(this._restoreSessionPollTimer);
        this._restoreSessionPollTimer = null;
      }
    } catch { /* no-op */ }

    // cancel provider subscription (fallback subscribeProviders)
    try {
      this._restoreSessionUnsub?.();
      this._restoreSessionUnsub = null;
    } catch { /* no-op */ }
    this.addLog?.(`[restoreSession] SUSPENDED | reason=${this._suspendRestoreSessionReason}`);
  }

  private resumeRestoreSession(reason: string) {
    this._suspendRestoreSession = false;
    this.addLog?.(`[restoreSession] RESUMED | reason=${reason}`);
  }

  private _installWcModalAutoClose(runId: number) {
    try {
      // Always reset (avoid duplicate handlers)
      this._uninstallWcModalAutoClose('reinstall');

      this._wcAutoCloseInstalled = true;
      this._wcAutoCloseRunId = runId;

      this._wcOnVisibility = () => {
        try {
          const hidden = !!(document as any)?.hidden;
          if (hidden && this.showWcModal && this.wcModalRunId === runId) {
            this._hideWcModal('visibility:hidden');
          }
        } catch { }
      };

      this._wcOnBlur = () => {
        try {
          if (this.showWcModal && this.wcModalRunId === runId) {
            this._hideWcModal('window:blur');
          }
        } catch { }
      };

      this._wcOnPageHide = () => {
        try {
          if (this.showWcModal && this.wcModalRunId === runId) {
            this._hideWcModal('pagehide');
          }
        } catch { }
      };

      document?.addEventListener?.('visibilitychange', this._wcOnVisibility as any, { passive: true } as any);
      window?.addEventListener?.('blur', this._wcOnBlur as any, { passive: true } as any);
      window?.addEventListener?.('pagehide', this._wcOnPageHide as any, { passive: true } as any);

      this.addLog?.(`🧭 [WALLET][MODAL] autoClose installed runId=${runId}`);
    } catch (e: any) {
      this.addLog?.(`🧭 [WALLET][MODAL] autoClose install error: ${e?.message || e}`);
    }
  }

  private _uninstallWcModalAutoClose(reason: string) {
    try {
      if (!this._wcAutoCloseInstalled) return;

      document?.removeEventListener?.('visibilitychange', this._wcOnVisibility as any);
      window?.removeEventListener?.('blur', this._wcOnBlur as any);
      window?.removeEventListener?.('pagehide', this._wcOnPageHide as any);

      this._wcAutoCloseInstalled = false;
      this._wcAutoCloseRunId = null;
      this._wcOnVisibility = null;
      this._wcOnBlur = null;
      this._wcOnPageHide = null;

      this.addLog?.(`🧭 [WALLET][MODAL] autoClose uninstalled reason=${reason}`);
    } catch { }
  }

  private _showWcModalForPhase(phase: 'approve' | 'tx', ctx: string, runId: number) {
    try {
      this.wcModalPhase = phase;
      this.wcModalCtx = ctx;
      this.wcModalRunId = runId;
      this.showWcModal = true;
      this.addLog?.(`🧭 [WALLET][MODAL] show phase=${phase} ctx=${ctx} runId=${runId}`);
      // 🔥 auto-close as soon as wallet takes focus (iOS / Android)
      this._installWcModalAutoClose(runId);
      this.cd?.detectChanges?.();
    } catch (e: any) {
      this.addLog?.(`🧭 [WALLET][MODAL] show error: ${e?.message || e}`);
    }
  }

  private _hideWcModal(reason: string) {
    try {
      if (this.showWcModal) {
        this.showWcModal = false;
        this.addLog?.(`🧭 [WALLET][MODAL] hide reason=${reason}`);
        // cleanup hooks whenever we hide
        this._uninstallWcModalAutoClose(`hide:${reason}`);
        this.cd?.detectChanges?.();
      }
    } catch { }
  }

  // ─────────────────────────────────────────────────────────────
  // CancelFlowV1 — sidecar, add-only (aucune régression)
  // ─────────────────────────────────────────────────────────────
  // ─────────────────────────────────────────────────────────────
  // Shims for cancel-flow (add-only, safe no-ops if nothing to do)
  // Paste these inside the class SwapComponent (near other utils)
  // ─────────────────────────────────────────────────────────────

  // 1) Unified setter that uses your existing `swapStatus` field
  private setBridgeStatusLocal(s: 'idle' | 'approve' | 'pending' | 'success' | 'error' | 'cancelled'): void {
    try {
      // if you already have a dedicated setter, call it here instead
      (this as any).bridgeStatus = s;
      this.cd?.detectChanges?.();
    } catch { /* no-op */ }
  }

  // 2) Soft abort (tries your existing helpers, never throws)
  private abortWalletConnectSoft(): void {
    try { (this as any).abortWalletConnectSafely?.(); } catch { }
    try { (this as any).abortWalletConnectSafe?.(); } catch { }
    try { (this as any).abortWalletConnect?.(); } catch { }

    // AppKit / WalletConnect modal close attempts (best-effort)
    try { (this as any).modal?.close?.(); } catch { }
    try { (window as any).modal?.close?.(); } catch { }
  }

  // 3) Soft close of any open modal/sheet (best-effort, never throws)
  private closeAnyOpenModalSoftly(): void {
    try { (this as any).modal?.close?.(); } catch { }
    try { (window as any).modal?.close?.(); } catch { }
    // Add any local refs you use (e.g., this.mmSheetRef?.dismiss?.())
    try { (this as any).mmSheetRef?.dismiss?.(); } catch { }
  }

  private cancelFlowV1 = {
    enabled: true,                                     // kill-switch
    timers: new Map<'apprv' | 'trx', number>(),
    hasHash: { apprv: false, trx: false } as Record<'apprv' | 'trx', boolean>,
    runId: 0
  };

  private cfPreDeeplink(phase: 'apprv' | 'trx', runId?: number): void {
    if (!this.cancelFlowV1.enabled) return;

    // if a runId is provided, record it for logging/timeout correlation
    if (typeof runId === 'number') {
      this.cancelFlowV1.runId = runId;
    }

    const ms = phase === 'apprv' ? 120_000 : 45_000;

    // ✅ "done" flag (hashless success, or hash detected) – optional but critical
    const cfAny = this.cancelFlowV1 as any;
    if (!cfAny.done) cfAny.done = { apprv: false, trx: false };
    cfAny.done[phase] = false;

    // remplacer l’ancien timer si réarmé
    const prev = this.cancelFlowV1.timers.get(phase);
    if (prev) window.clearTimeout(prev);

    // armer timeout local (uniquement avant hash / done)
    const t = window.setTimeout(() => {
      // hash arrivé entretemps
      if (this.cancelFlowV1.hasHash[phase]) return;

      // ✅ phase marked done (ex: hashless balance-delta success)
      if (cfAny.done?.[phase] === true) {
        this.addLog?.(`[cancel:timeout] phase=${phase} IGNORED (done=true) ms=${ms} runId=${this.cancelFlowV1.runId}`);
        return;
      }

      this.addLog?.(`[cancel:timeout] phase=${phase} ms=${ms} runId=${this.cancelFlowV1.runId}`);

      // ✅ On ne mappe JAMAIS un timeout technique en "cancelled"
      if (phase === 'trx') {
        // Si déjà success (hashless), on ignore
        const st = (this as any).bridgeStatus;
        if (st === 'success') {
          this.addLog?.(`[cancel:timeout] phase=trx IGNORED (bridgeStatus=success) runId=${this.cancelFlowV1.runId}`);
          cfAny.done.trx = true;
          return;
        }

        // sinon: wallet lent / hash manquant => rester pending (ou status dédié si tu as)
        this.addLog?.(`[cancel:trx] wallet slow/no-hash -> KEEP pending (no cancelled) runId=${this.cancelFlowV1.runId}`);

        // Optionnel : si tu as un status "pending" / "waiting_hash" / "slow"
        // try { this.setBridgeStatusLocal('pending'); } catch {}

        // ❌ surtout PAS :
        // this.setBridgeStatusLocal('cancelled');
        // this.softCleanupAfterCancel('timeout', phase);
      }

      // pour apprv, tu peux juste logguer et ne rien casser
    }, ms);

    this.cancelFlowV1.timers.set(phase, t);

    this.addLog?.(`[cancel:arm] phase=${phase} ms=${ms} runId=${this.cancelFlowV1.runId}`);
    this.addLog?.(`deeplink:announce | phase=${phase} | runId=${this.cancelFlowV1.runId}`);
  }


  private cfOnHash(phase: 'apprv' | 'trx'): void {
    if (!this.cancelFlowV1.enabled) return;
    this.cancelFlowV1.hasHash[phase] = true;
    const t = this.cancelFlowV1.timers.get(phase);
    if (t) window.clearTimeout(t);
    this.cancelFlowV1.timers.delete(phase);
    // pas d’autre action: on laisse tes watchers/flows actuels gérer
  }

  private cfCancel(reason: 'user_rejected' | 'closed' | 'timeout', phase: 'apprv' | 'trx'): void {
    if (!this.cancelFlowV1.enabled) return;
    if (this.cancelFlowV1.hasHash[phase]) return; // si un hash existe, ce n’est plus un cancel local

    const t = this.cancelFlowV1.timers.get(phase);
    if (t) window.clearTimeout(t);
    this.cancelFlowV1.timers.delete(phase);

    this.addLog?.(`[cancel:${reason}] phase=${phase} runId=${this.cancelFlowV1.runId}`);
    this.setBridgeStatusLocal('cancelled');
    this.softCleanupAfterCancel(reason, phase);
  }

  /** Nettoyage doux, sans casser tes sessions/process existants */
  private softCleanupAfterCancel(reason: string, phase: 'apprv' | 'trx') {
    try { this.clearAllowWcDeeplink?.(); } catch { }
    try { this.abortWalletConnectSoft?.(); } catch { }
    try { this.closeAnyOpenModalSoftly?.(); } catch { } // s'il existe déjà chez toi
    // NB: rien d’autre — on ne touche pas à tes watchers ni à la state machine existante
  }


  // ─────────────────────────────────────────────────────────────
  // Helpers globaux de gestion "allow deeplink"
  // ─────────────────────────────────────────────────────────────
  private setAllowWcDeeplinkFor(runId: number, ms = 45000): void {
    try {
      const until = Date.now() + Math.max(1000, ms);
      sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
      sessionStorage.setItem('st/allowWcRunId', String(runId));
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
      this.addLog?.(`[BRIDGE][ALLOW] WC deeplink runId=${runId} until=${until}`);
    } catch { /* noop */ }
  }


  private clearAllowWcDeeplink(): void {
    try {
      sessionStorage.removeItem('st/allowWcDeeplinkUntil');
      sessionStorage.removeItem('st/allowWcRunId');
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
      try { delete (window as any).__dlOpenedForRunId; } catch { }
      this.addLog(`[deeplink][allow] cleared`);
    } catch { /* noop */ }
  }

  private measureFooter() {
    try {
      const el = this.footerHost?.nativeElement;
      if (!el) return;
      const h = Math.round(el.getBoundingClientRect().height || 0);
      if (h > 0 && h !== this.footerHpx) {
        this.footerHpx = h;
        this.cd?.detectChanges?.();
      }
    } catch { /* no-op */ }
  }

  /** Petit utilitaire: force un flush UI puis attend le frame suivant (rendu effectif). */
  private async safeRafTick(): Promise<void> {
    try { this.cd?.detectChanges?.(); } catch { }
    await Promise.resolve(); // microtask
    await new Promise<void>(r => requestAnimationFrame(() => r()));
  }

  /** Affiche un libellé CTA immédiat (sans délai), avec auto-clear optionnel. */
  private flashCtaNow(msg: string, ms?: number) {
    if (!msg) return;
    try { if (this._ctaTimer) clearTimeout(this._ctaTimer); } catch { }
    this.ctaLabel = msg;
    try { this.cd?.detectChanges?.(); } catch { }
    if (ms && ms > 0) {
      this._ctaTimer = setTimeout(() => {
        this.ctaLabel = null;
        try { this.cd?.detectChanges?.(); } catch { }
      }, ms);
    }
  }

  /** Phase pré-popup: annonce claire à l’utilisateur AVANT ouverture MetaMask (taguée par runId). */
  /** Phase pré-popup: annonce claire à l’utilisateur AVANT ouverture MetaMask (taguée par runId). */
  private async preDeeplinkAnnounce(
    ctx: 'main-cta' | 'alt-cta' | 'approve-cta' = 'main-cta',
    runId?: number
  ) {
    // NO AUTO-DEEPLINK (parité Swap) : on n’arme rien ici.
    // Ce helper ne fait que la trace UI. L’ouverture du wallet doit venir d’un click user.
    this.addLog?.(`[UI] preDeeplinkAnnounce ctx=${ctx} UI-only (no auto-deeplink) runId=${runId ?? 'n/a'} currentSeq=${this._runSeq}`);
    return;
  }





  kbOffset = 0;

  // 2) Abonnement VisualViewport
  private _vvHandlersAttached = false;
  private _onVvResize = () => {
    try {
      const vv = (window as any).visualViewport;
      if (!vv) { this.kbOffset = 0; return; }

      // Espace “mangé” par le clavier: innerHeight - (vv.height + vv.offsetTop)
      const eaten = (window.innerHeight || 0) - ((vv.height || 0) + (vv.offsetTop || 0));
      // On garde un offset >= 0 et on ajoute éventuellement le safe-area
      const safe = (window as any).CSS?.supports?.('height: env(safe-area-inset-bottom)') ? 0 : 0;
      this.kbOffset = Math.max(0, Math.ceil(eaten)) + safe;
      this.cd?.detectChanges?.();
    } catch {
      this.kbOffset = 0;
    }
  };




  /**
 * Entre deux quotes/CTA, impose un petit cooldown et “rafraîchit” la session WC
 * pour garantir l’apparition de la feuille de confirmation MetaMask.
 * - bloque tout deeplink automatique pendant WC_QUOTE_COOLDOWN_MS
 * - purge l’armement précédent
 * - reset visuel de l’URI (sans casser trop fort la session)
 */
  private async cooldownAndResetWcSession(ctx: 'main' | 'alt'): Promise<void> {
    try {
      this._lastQuoteClickAt = Date.now();
      // 1) Désarmer une éventuelle fenêtre “allow” précédente
      clearAllowWcDeeplink();
      // 2) Soft-reset des pointeurs d’URI pour forcer un nouveau display_uri au prochain besoin
      try { (this as any)._wcLastUri = null; } catch { }
      try { this.wcUri = ''; } catch { }
      try { (this as any)._wcUri$?.next?.(null); } catch { }
      // 3) Best-effort : soft close de la modale sans tuer la session/pairings
      try { await (abortWalletConnectSoft as any)?.call?.(this, `quote-switch:${ctx}`); } catch { }
      this.addLog(`[WC] cooldown+soft-reset done (${ctx})`);
    } catch {
      /* no-op */
    }
  }

  private _netSwitching = false;
  // ⬇️ ajoute cette méthode utilitaire dans la classe SwapComponent
  //private async softReloadAfterNetworkSwitch(reason: string) {
  //  if (this._netSwitching) return;
  //  this._netSwitching = true;
  //  this.addLog(`🔧 soft-reload after network switch | reason=${reason}`);

  //   0) Snapshot de l’état courant
  //  const prevAddr = this.takerAddress || null;
  //  const prevCid = this.chainId ?? null;

  //   1) Recrée un provider propre depuis le provider actuel (MM/WC)
  //  const eth: any = (window as any).ethereum || this.rawProvider;
  //  if (eth && typeof eth.request === 'function') {
  //    this.rawProvider = eth;
  //    this.provider = new BrowserProvider(eth);
  //  }

  //   2) Relit chainId + address réels du wallet (sans prompt)
  //  let newCid: number | null = null;
  //  let newAddr: string | null = null;

  //  try {
  //    const hexId: string = await (this.provider as any).send('eth_chainId', []);
  //    newCid = Number.parseInt(hexId, 16);
  //  } catch (e) {
  //    this.addLog(`[soft-reload] eth_chainId failed ${e}`);
  //  }

  //  try {
  //    const signer = await this.provider?.getSigner();
  //    newAddr = signer ? await signer.getAddress() : null;
  //  } catch {
  //     Fallback EIP-1193 (session déjà autorisée)
  //    try {
  //      const accs: string[] = await (this.provider as any).send('eth_accounts', []);
  //      newAddr = accs?.[0] ?? null;
  //    } catch {  no-op  }
  //  }

  //   3) Garde: silent reattach → NE PAS fermer la quote si addr/chain identiques
  //  if (newCid != null && prevCid != null && newCid === prevCid &&
  //    newAddr && prevAddr && newAddr.toLowerCase() === prevAddr.toLowerCase()) {
  //    this.addLog('🤫 soft-reload: silent reattach sans changement (addr/chain identiques) → skip closeQuote()');
  //    this._netSwitching = false;
  //    try { this.cd.detectChanges(); } catch { }
  //    return; // on ne touche pas à la modale de quote
  //  }
  //      this.logAltState('softReloadAfterNetworkSwitch:before-close');
  //      this.closeQuoteWithReason('softReloadAfterNetworkSwitch');
  //      this.logAltState('softReloadAfterNetworkSwitch:after-close');
  //   4) Vrai changement → nettoyage de l’UI d’exécution
  //  try { this.closeQuote?.(); } catch { }

  //   5) Aligner l’UI si on connait le nouveau chainId
  //  if (Number.isFinite(newCid as number)) {
  //    this.setChain(newCid as number); // met à jour chainInfo + refreshNativeBalance (debouncé)
  //  }

  //   6) Petit délai pour laisser MM/WC “flusher” son état
  //  await new Promise(r => setTimeout(r, 250));

  //   7) Rafraîchis les listes/balances côté app (pas de fetchQuote auto)
  //  try { this.refreshTokensForChain(); } catch { }
  //  try { this.refreshNativeBalance?.(); } catch { }

  //  this._netSwitching = false;
  //  try { this.cd.detectChanges(); } catch { }
  //  this.addLog('✅ soft-reload done');
  //}

  private async softReloadAfterNetworkSwitch(reason: string) {
    if (this._netSwitching) return;
    this._netSwitching = true;
    this.addLog(`🔧 soft-reload AFTER network switch (from init) | reason=${reason}`);

    // On ferme proprement la quote en cours
    /*this.closeQuoteWithReason('softReloadAfterNetworkSwitch');*/

    try {
      // 1) Récupérer le provider EIP-1193 “source de vérité” (MM / WC)
      const eth: any = (window as any).ethereum || this.rawProvider;
      if (!eth || typeof eth.request !== 'function') {
        this.addLog('[soft-reload-from-init] aucun provider EIP-1193 dispo → abort');
        this._netSwitching = false;
        try { this.cd.detectChanges(); } catch { }
        return;
      }

      // 2) Rejouer EXACTEMENT la même mécanique que lors du boot :
      //    attachEthersProvider(eth) est ce qui, au ngOnInit, :
      //    - crée le BrowserProvider
      //    - lit chainId + address
      //    - aligne this.chainId, this.takerAddress
      //    - appelle setChain(...)
      //    - rafraîchit le solde natif
      await this.attachEthersProvider(eth);


      // 3) Ensuite on laisse le pipeline normal faire son travail :
      //    - chainId$ → setChain(...)
      //    - TokenPortfolioCacheService se rebind
      //    On peut juste relancer un refresh des tokens pour être sûr.
      try { await this.refreshTokensForChain(); } catch { }

      this.addLog('✅ soft-reload-from-init done (attachEthersProvider rejoué)');
    } catch (e) {
      this.addLog('[soft-reload-from-init] ERROR ' + (e as any)?.message);
    } finally {
      this._netSwitching = false;
      try { this.cd.detectChanges(); } catch { }
    }
  }

  // ------------------------------
  // Helpers watcher robustes
  // ------------------------------
  /** Provider read-only pour finir un watch même sans wallet rattaché. */
  // en haut du fichier si ce n’est pas déjà fait
  // import { JsonRpcProvider } from 'ethers';

  private getReadonlyProvider(chainId: number): JsonRpcProvider | null {
    const urls: Record<number, string> = {
      1: 'https://eth-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN',           // Ethereum
      42161: 'https://arb-mainnet.g.alchemy.com/v2/id2ETOtmTy1BpEYYsngoBNiBwnx2bGeD',           // Arbitrum
      137: 'https://polygon-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN',           // Polygon
      10: 'https://opt-mainnet.g.alchemy.com/v2/YOUR_KEY',                                   // Optimism (à remplacer)
      8453: 'https://base-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN',          // Base
      43114: 'https://avax-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN',          // Avalanche
      56: 'https://bnb-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN'            // BNB Chain
    };

    const numericId = Number(chainId);
    const url = urls[numericId];

    if (!url) {
      // log soft, on ne crashe pas l’app
      this.addLog?.(`[ro][provider] missing URL for chainId=${numericId}`);
      return null;
    }

    try {
      const provider = new JsonRpcProvider(url);
      this.addLog?.(`[ro][provider] ready | cid=${numericId} url=${url}`);
      return provider;
    } catch (err: any) {
      this.addLog?.(
        `[ro][provider][err] cid=${numericId} msg=${err?.message ?? err}`
      );
      return null;
    }
  }


  /** Pose un statut en interdisant toute régression depuis un état terminal. */
  private setBridgeStatusSafe(next: typeof this.bridgeStatus) {
    const cur = this.bridgeStatus;
    if (cur === 'success' || cur === 'error' || cur === 'cancelled') return; // pas de downgrade
    this.bridgeStatus = next;
  }

  /** Efface immédiatement le pending persistant (hash/addr/ts/chain…). */














  // swap.component.ts (dans la classe)
  /** Watcher de receipt robuste (runId, read-only fallback, timeout, clear). */
  private async watchSwapReceiptUntilFinal(hash: string, chainId: number, opts?: { confirmations?: number, timeoutMs?: number }) {
    if (!hash || !Number(chainId)) return;

    const myRun = ++this._watchRunId;           // 🔒 verrou anti-concurrence
    const needConf = Math.max(0, Number(opts?.confirmations ?? 1));
    const deadline = Date.now() + Math.max(60_000, Number(opts?.timeoutMs ?? 180_000)); // ≥60s, défaut 180s

    this.setBridgeStatusSafe('pending');        // ne “downgrade” pas si terminal déjà atteint

    // Provider pour la lecture: wallet attaché sinon fallback RPC public
    let p: any = this.provider ?? this.getReadonlyProvider(chainId);
    const rpc = p?.send ? p : null;

    while (true) {
      // 🛑 Sorties rapides
      if (myRun !== this._watchRunId) return;               // watcher obsolète
      if (Date.now() > deadline) {
        this.addLog?.('[SWAP][WATCH] timeout → clear pending');
        this.clearPendingSwap();
        this.bridgeError = 'timeout';
        this.setBridgeStatusSafe('error');
        this.cd?.detectChanges?.();
        return;
      }

      if (!rpc) {
        // Essaye de (re)fabriquer un provider (wallet ou read-only)
        p = this.provider ?? this.getReadonlyProvider(chainId);
      }

      try {
        const receipt = await (p as any)?.waitForTransaction?.(hash, needConf, 4000)
          ?? await (p as any)?.getTransactionReceipt?.(hash);
        if (receipt) {
          if (myRun !== this._watchRunId) return;           // re-check
          const ok = (receipt.status === 1 || receipt.status === '0x1');
          this.addLog?.(`[SWAP][WATCH] final receipt block=${receipt.blockNumber} ok=${ok}`);
          this.clearPendingSwap();                          // 🧹 clear atomique
          this.bridgeError = null;
          this.bridgeHash = hash;
          this.bridgeStatus = ok ? 'success' : 'error';     // état terminal
          this.cd?.detectChanges?.();
          try { this.refreshNativeBalance?.(); } catch { }
          try { this.refreshTokensForChain?.(); } catch { }
          return;
        }
      } catch (e: any) {
        // Network hiccup → on continue tant que pas timeout
        this.addLog?.(`[SWAP][WATCH] poll error: ${e?.message || e}`);
      }

      await new Promise(r => setTimeout(r, 2500));
    }
  }
  ctaLabel: string | null = null;

  private _ctaDelayTimer?: any;   // timer de délai avant affichage

  private flashCta(msg: string | null | undefined, visibleMs = 5000, delayMs = 0) {
    // Nettoie tout ce qui pourrait être en cours
    try { if (this._ctaTimer) clearTimeout(this._ctaTimer); } catch { }
    try { if (this._ctaDelayTimer) clearTimeout(this._ctaDelayTimer); } catch { }

    if (!msg) { this.ctaLabel = null; this.cd?.detectChanges?.(); return; }

    const showNow = () => {
      this.ctaLabel = msg;
      this.cd?.detectChanges?.();
      this._ctaTimer = setTimeout(() => {
        this.ctaLabel = null;
        this.cd?.detectChanges?.();
      }, visibleMs);
    };

    if (delayMs > 0) {
      this._ctaDelayTimer = setTimeout(showNow, delayMs);
    } else {
      showNow();
    }
  }

  // (optionnel) util pour annuler totalement un flash en attente
  private cancelCtaFlash() {
    try { if (this._ctaTimer) clearTimeout(this._ctaTimer); } catch { }
    try { if (this._ctaDelayTimer) clearTimeout(this._ctaDelayTimer); } catch { }
    this.ctaLabel = null;
    this.cd?.detectChanges?.();
  }

  private savePendingSwap(hash: string, chainId: number) {
    try { localStorage.setItem(PENDING_BRIDGE_TX_KEY, JSON.stringify({ hash, chainId, t: Date.now() })); } catch { }
  }
  private loadPendingSwap(): { hash: string; chainId: number } | null {
    try { return JSON.parse(localStorage.getItem(PENDING_BRIDGE_TX_KEY) || 'null'); } catch { return null; }
  }
  private clearPendingSwap() {
    try { localStorage.removeItem(PENDING_BRIDGE_TX_KEY); } catch { }
  }

  private __restoreInFlight = false;

  // Dans class SwapComponent
  private async softReloadWalletSession(delayMs = 0): Promise<void> {
    try {
      if (this.__restoreInFlight) {
        this.addLog?.('[restoreSession] softReloadWalletSession SKIP (already in flight)');
        return;
      }
      this.__restoreInFlight = true;
      this.addLog?.(`[restoreSession] softReloadWalletSession ENTER | delayMs=${delayMs}`);
      if (delayMs > 0) {
        await new Promise(r => setTimeout(r, delayMs));
      }

      // 1) Si un provider existe déjà, log + early-exit
      if (this.provider) {
        try {
          const net0 = await this.provider.getNetwork();
          this.addLog?.(`[restoreSession] provider already set | chainId=${Number(net0.chainId)} addrKnown=${!!this.takerAddress}`);
        } catch {
          this.addLog?.('[restoreSession] provider already set | getNetwork failed (will still proceed)');
        }
      }

      // 2) Source EIP-1193 potentielle
      const eth: any = (window as any).ethereum || this.rawProvider;
      const hasEth = !!eth;
      const hasReq = !!eth && typeof eth.request === 'function';
      const ctor = eth?.constructor?.name || '(unknown)';
      this.addLog?.(`[restoreSession] probe window/raw | hasEth=${hasEth} has.request=${hasReq} ctor=${ctor}`);

      if (!hasEth || !hasReq) {
        this.addLog?.('[restoreSession] no usable EIP-1193 → try WalletConnect rehydrate');
        // 🔹 Purge de petits flags qui peuvent empêcher l’ouverture de la modale
        try {
          sessionStorage.removeItem('st/skipAutoRestoreOnce');
          sessionStorage.removeItem('st/supAutoRestoreUntil');
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
        } catch { /* noop */ }

        // 🔹 Tenter d'obtenir un provider WC à partir d'une session existante (AppKit / Legacy)
        try {
          initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c'); // ✅ au lieu de this.initAppKit()
          this.addLog?.('[restoreSession] global initAppKit called');
        } catch (e: any) {
          this.addLog?.(`[restoreSession] initAppKit failed | ${e?.message || e}`);
        }

        let wcProv: any = null;
        try {
          // helper interne si présent
          wcProv = await (this as any).getWalletConnectProvider?.();
          if (!wcProv && (this as any).appKit?.getProvider) {
            wcProv = await (this as any).appKit.getProvider('eip155'); // best-effort
          }
        } catch (e: any) {
          this.addLog?.(`[restoreSession] get WC provider failed | ${e?.message || e}`);
        }

        if (wcProv && typeof wcProv.request === 'function') {
          this.addLog?.('[restoreSession] WC provider rehydrated → rebuild BrowserProvider');
          this.rawProvider = wcProv;
          try {
            this.provider = new BrowserProvider(wcProv);
            const net = await this.provider.getNetwork();
            const chainId = Number(net.chainId);
            let owner = '(n/a)'; try { owner = await this.provider.getSigner().then(s => s.getAddress()); } catch { }
            this.addLog?.(`[restoreSession] WC reattach OK | chainId=${chainId} owner=${owner}`);
            this.addLog?.('[restoreSession] softReloadWalletSession EXIT (ok/wc)');
            return;
          } catch (e: any) {
            this.addLog?.(`[restoreSession] BrowserProvider ctor (wc) FAILED | ${e?.message || e}`);
            // on tombera sur l’ouverture modale juste après
          }
        }

        // 🔹 Pas de session exploitable → ouverture de la modale Legacy (auto-connect)
        this.addLog?.('[restoreSession] no WC session usable → open legacy connect modal');
        try {
          await (this as any).openLegacyConnectModal?.();   // si dispo
        } catch {
          // fallback : certains projets nomment différemment
          try { await (this as any).connectLegacy?.(); } catch { }
        }
        this.addLog?.('[restoreSession] EXIT (modal opened)');
        return;
      }


      // 3) (Ré)injection
      this.rawProvider = eth;
      try {
        this.provider = new BrowserProvider(eth);
        this.addLog?.('[restoreSession] BrowserProvider constructed');
      } catch (e: any) {
        this.addLog?.(`[restoreSession] BrowserProvider ctor FAILED | ${e?.message || e}`);
        return;
      }

      // 4) Diagnostic réseau + adresse si possible
      try {
        const net = await this.provider.getNetwork();
        const chainId = Number(net.chainId);
        let owner = '(n/a)';
        try { owner = await this.provider.getSigner().then(s => s.getAddress()); } catch { }
        this.addLog?.(`[restoreSession] provider rebuilt | chainId=${chainId} owner=${owner}`);
      } catch (e: any) {
        this.addLog?.(`[restoreSession] getNetwork/signature probe FAILED | ${e?.message || e}`);
      }

      this.addLog?.('[restoreSession] softReloadWalletSession EXIT (ok)');
    } catch (e: any) {
      this.addLog?.(`[restoreSession] softReloadWalletSession ERROR | ${e?.message || e}`);
    } finally {
      this.__restoreInFlight = false;
    }
  }

  private lockChainToSeo = false; // empêche l'écrasement par le wallet tant qu'il est true
  @Input() swapPrefill?: {
    chainId: number;
    tokenIn: string;
    tokenOut: string;
  } | null;

  @Input() seoPage?: any;
  @ViewChild('mobileHeader') mobileHeader!: ElementRef<HTMLDivElement>;
  headerHpx = 72; // fallback
  constructor(
    private gate: WalletGatekeeperService,
    private nativeTokenPrice: NativeTokenPriceService,
    private wc2: WalletConnectV2Service,
    private balanceValidator: BalanceValidatorService,
    private wallet: WalletService,
    private swapApi: SwapApiService,
    private bridgeApi: BridgeApiService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,   // ⬅️ 1
    private zone: NgZone,            // ⬅️ 2
    private connector: WalletConnectorService,
    private price: PriceService,
    private route: ActivatedRoute,
    private seoContent: SeoContentService,
    private appSeo: AppSeoService,
    private sanitizer: DomSanitizer,
    private ts: TransferState,
    private dbg: DebugTelemetryService,
    private portfolio: TokenPortfolioCacheService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.reasonLabels = {
      // — SWAP-SPECIFIC KEYS —
      WALLET_DISCONNECTED: this.translate.instant('SWAP_REASON_WALLET_DISCONNECTED'),
      INVALID_AMOUNT: this.translate.instant('SWAP_REASON_INVALID_AMOUNT'),
      INSUFFICIENT_NATIVE_GAS: this.translate.instant('SWAP_REASON_INSUFFICIENT_NATIVE_GAS'),
      INSUFFICIENT_SELL_TOKEN: this.translate.instant('SWAP_REASON_INSUFFICIENT_SELL_TOKEN'),

      // (Optional) fallback aliases if some older code still emits BRIDGE_* during swap:
      BRIDGE_REASON_WALLET_DISCONNECTED: this.translate.instant('SWAP_REASON_WALLET_DISCONNECTED'),
      BRIDGE_REASON_INVALID_AMOUNT: this.translate.instant('SWAP_REASON_INVALID_AMOUNT'),
      BRIDGE_REASON_INSUFFICIENT_NATIVE_GAS: this.translate.instant('SWAP_REASON_INSUFFICIENT_NATIVE_GAS'),
      BRIDGE_REASON_INSUFFICIENT_SELL_TOKEN: this.translate.instant('SWAP_REASON_INSUFFICIENT_SELL_TOKEN'),
    };
    // Charger la langue sauvegardée au démarrage
    const savedLang = localStorage.getItem('lang') || 'en'; // Langue par défaut : 'en'
    /*    this.translate.use(savedLang); // Définir la langue au démarrage*/
    // Charger le thème sauvegardé au démarrage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      document.body.classList.remove('light-mode', 'dark-mode');
      document.body.classList.add(savedTheme + '-mode');
    } else {
      // ⚡ Dark mode par défaut
      document.body.classList.remove('light-mode', 'dark-mode');
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark'); // enregistre pour les prochaines fois
    }

  }
  /* --------------------------------------------------------------------
 * Réseau en cours
 * ------------------------------------------------------------------*/
  chainId: number | null = null;            // ex. 1, 42161, 137…
  buyChainId: number | null = null;            // ex. 1, 42161, 137…
  chainInfo: { name: string; icon: string } | null = null;
  private sub!: Subscription;
  /** Table de correspondance : ajoute tes réseaux si besoin */
  userTokens: any[] = [];
  popularTokens: any[] = [];




  userBuyTokens: any[] = [];
  popularBuyTokens: any[] = [];
  showTokenModal = false;
  showBuyTokenModal = false;
  private _ssrTokens: any[] | null = null;
  private _ssrChainId: number | null = null;
  fiatLoading = true;
  balancesLoading = true;
  private firstPaintDone = false;
  /** Retourne un logo "local" immédiat si tokens non chargés, sinon le logo réel (avec fallback local). */
  getTokenLogo(symbol: string | null | undefined): string {
    const sym = (symbol || '').toUpperCase();
    // 1) Tant que la liste n’est pas disponible → logos locaux instantanés
    if (!this.tokensLoaded || !this.firstPaintDone) {
      return LOCAL_TOKEN_LOGO[sym] ?? LOCAL_TOKEN_LOGO['UNKNOWN'];
    }

    // 2) Liste dispo → essaye d'abord la vraie URL (logoURI), sinon fallback local
    const t = this.availableTokens?.find(x => (x.symbol || '').toUpperCase() === sym);
    const uri = t?.logoURI || t?.logo_uri || t?.logoUrl || t?.logo_url || '';
    if (uri && typeof uri === 'string') return uri;

    return LOCAL_TOKEN_LOGO[sym] ?? LOCAL_TOKEN_LOGO['UNKNOWN'];
  }
  private deeplink = new DeeplinkGate(1500, 800);

  // utilitaire pour fabriquer l'URL (schema unique : n’envoie pas 3 versions différentes)
  private buildMmUrl(displayUri?: string): string {
    if (!displayUri) return 'metamask://';      // foreground-only
    return `metamask://wc?uri=${encodeURIComponent(displayUri)}`;
  }

  /** Applique la paire par défaut "hot start" pour le réseau donné, sans écraser un choix explicite. */
  /** Applique la paire par défaut "hot start" pour le réseau donné,
 *  sans écraser un choix explicite et en évitant les incohérences. */
  private applyHotStartDefaults(chainId: number): void {
    const defaults = HOT_START_DEFAULTS[chainId] || HOT_START_DEFAULTS[1];

    // Si les deux sont déjà définis explicitement → ne rien faire
    if (this.sellTokenSymbol && this.buyTokenSymbol) {
      if (this.debug) {
        console.log('[applyHotStartDefaults] skip (déjà défini)', {
          chainId, sell: this.sellTokenSymbol, buy: this.buyTokenSymbol
        });
      }
      return;
    }

    const norm = (s?: string) => (s ?? '').trim().toUpperCase();

    // 1) Préparer les cibles (en respectant ce qui est déjà défini)
    let targetSell = this.sellTokenSymbol ? norm(this.sellTokenSymbol) : defaults.sell;
    let targetBuy = this.buyTokenSymbol ? norm(this.buyTokenSymbol) : defaults.buy;

    // 2) Éviter sell == buy (choisir un alt par chaîne)
    if (targetSell && targetBuy && targetSell === targetBuy) {
      const ALT_BUY: Record<number, string> = {
        1: 'ETH',        // Ethereum
        42161: 'ETH',    // Arbitrum
        137: 'MATIC',    // Polygon
        56: 'BNB',       // BNB Chain
      };
      // Si l'alt retombe encore sur la même valeur, basculer vers un classique ETH/USDC
      const proposed = ALT_BUY[chainId] || (targetBuy === 'ETH' ? 'USDC' : 'ETH');
      targetBuy = proposed === targetSell ? (proposed === 'ETH' ? 'USDC' : 'ETH') : proposed;
    }

    // 3) Validation par rapport au catalogue de tokens (si dispo)
    const hasTokensList = Array.isArray(this.allTokens) && this.allTokens.length > 0;
    const hasSymbol = (sym: string) =>
      hasTokensList
        ? this.allTokens.some(t => norm(t.symbol) === sym)
        : true; // si pas de liste, on fait confiance aux defaults

    if (!this.sellTokenSymbol) {
      if (hasSymbol(targetSell)) {
        this.sellTokenSymbol = targetSell;
      } else if (hasSymbol(defaults.sell)) {
        this.sellTokenSymbol = defaults.sell;
      }
    }

    if (!this.buyTokenSymbol) {
      if (hasSymbol(targetBuy)) {
        this.buyTokenSymbol = targetBuy;
      } else if (hasSymbol(defaults.buy)) {
        this.buyTokenSymbol = defaults.buy;
      }
    }

    // 4) Dernier garde-fou : encore identiques après validation ? → choisir un remplaçant présent
    if (norm(this.sellTokenSymbol) === norm(this.buyTokenSymbol)) {
      const candidates = ['ETH', 'USDC', 'USDT', 'MATIC', 'BNB'];
      const pick = candidates.find(sym =>
        sym !== norm(this.sellTokenSymbol) && hasSymbol(sym)
      );
      if (pick) this.buyTokenSymbol = pick;
    }

    if (this.debug) {
      console.log('[applyHotStartDefaults] appliqué', {
        chainId,
        sell: this.sellTokenSymbol,
        buy: this.buyTokenSymbol
      });
    }
  }

  /** Trace compacte de l’état ALT/quote (sans refactor) */
  private logAltState(tag: string) {
    try {
      this.addLog(
        `[ALT][VIS] ${tag} | hasQuote=${!!this.quote} | selectedAltKey=${this.selectedAltKey ?? 'null'} | selAlt=${this.selectedAlternative ? 'y' : 'n'} | status=${this.bridgeStatus}`
      );
    } catch { /* no-op */ }
  }

  ngAfterViewInit() {
    this.installLegacyConnectHooks('ngAfterViewInit');
    // Mesurer dès que le footer est peint
    this.measureFooter();

    // Re-mesurer après un tick pour capturer les polices/icônes
    setTimeout(() => this.measureFooter(), 50);
    setTimeout(() => { this.firstPaintDone = true; }, 0);
    const el = document.getElementById('app-root') || document.body;
    const bg = getComputedStyle(el).backgroundColor;
    if (bg) this.headerBackdropColor = bg;
    const update = () => {
      const h = this.mobileHeader?.nativeElement?.offsetHeight || 96;
      this.headerHpx = h;
    };
    // 1er calcul après rendu
    setTimeout(update, 0);
    // recalcule si orientation/viewport change
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent) {
    const target = ev.target as Node;

    // Footer
    if (this.showFooterMenu && this.footerMenuRoot && !this.footerMenuRoot.nativeElement.contains(target)) {
      this.showFooterMenu = false;
    }

    // Settings
    if (this.showSettings && this.settingsRoot && !this.settingsRoot.nativeElement.contains(target)) {
      this.showSettings = false;
    }


    // Menu des chaînes (trigger + liste fixe)
    if (this.showChainMenu) {
      const inTrigger = this.chainTrigger?.nativeElement.contains(target);
      const inMenu = this.chainMenuRoot?.nativeElement.contains(target);
      if (!inTrigger && !inMenu) {
        this.showChainMenu = false;
      }
    }


  }
  // SwapComponent.ts
  // Afficher le disque blanc uniquement pour certains symboles (ici, ETH)
  private readonly WHITE_DISK = new Set(['ETH']);
  hasWhiteDisk(sym?: string | null): boolean {
    return !!sym && this.WHITE_DISK.has(String(sym).toUpperCase());
  }

  private appliedCtaOnce = false;

  // Compat: accepte l'ancien schéma (from/to/chain) et le nouveau (tokenIn/tokenOut/chainId)


  // si pas déjà déclaré quelque part :
  private installLegacyConnectHooks(reason: string) {
    try {
      const anySelf: any = this as any;
      if (anySelf.__legacyHooksInstalled) return;
      anySelf.__legacyHooksInstalled = true;

      const lc: any = (this as any).legacyConnect;
      if (!lc) {
        this.addLog?.(`[legacy] hooks skipped: legacyConnect missing | reason=${reason}`);
        return;
      }

      // EventEmitter: connected(provider,address,chainId,providerType)
      const sub = lc.connected?.subscribe?.((ev: any) => this.onLegacyConnected(ev, 'connected$'));
      if (sub?.unsubscribe) this._legacyConnectSubs.push(sub);

      // Fallback hook (si jamais le component expose une callback)
      if (!lc.__bridgeOnConnectedWrapped) {
        lc.__bridgeOnConnectedWrapped = true;
        const prev = lc.onConnected;
        lc.onConnected = (ev: any) => {
          try { prev?.(ev); } catch { }
          try { this.onLegacyConnected(ev, 'onConnected'); } catch { }
        };
      }

      this.addLog?.(`[legacy] hooks installed | reason=${reason}`);
    } catch (e: any) {
      this.addLog?.(`[legacy] hooks install error | ${e?.message || e}`);
    }
  }

  private applyCtaDefaultsFromSeo(resolved: ResolvedSeo) {
    console.log('[SEO] applyCtaDefaultsFromSeo:start', { appliedCtaOnce: this.appliedCtaOnce, resolved });

    if (this.appliedCtaOnce) {
      console.log('[SEO] already applied → exit');
      return;
    }

    const cta = (resolved?.ctaParams || resolved?.page?.ctaParams) as CtaParamsCompat | undefined;
    console.log('[SEO] parsed CTA =', cta);
    if (!cta) {
      console.log('[SEO] no CTA found → exit');
      return;
    }

    // 1) priorité aux query params si présents
    const qp = this.route.snapshot.queryParamMap;
    const qpTokenIn = qp.get('tokenIn');
    const qpTokenOut = qp.get('tokenOut');
    const qpChainId = qp.get('chainId');
    const qpNetwork = qp.get('network');
    const hasQP = !!(qpTokenIn || qpTokenOut || qpChainId || qpNetwork);
    console.log('[SEO] query params =', { qpTokenIn, qpTokenOut, qpChainId, qpNetwork, hasQP });

    if (hasQP) {
      this.appliedCtaOnce = true;
      console.log('[SEO] query params present → skip CTA');
      return;
    }

    // 2) ne pas écraser un choix utilisateur persistant
    const persisted = localStorage.getItem('swap:lastSelection');
    console.log('[SEO] persisted selection =', persisted);
    if (persisted) {
      this.appliedCtaOnce = true;
      console.log('[SEO] persisted exists → skip CTA');
      return;
    }

    // 3) appliquer les valeurs CTA (compat ancien/nouveau)
    const tokenIn = (cta.tokenIn ?? cta.from)?.toUpperCase();
    const tokenOut = (cta.tokenOut ?? cta.to)?.toUpperCase();
    console.log('[SEO] computed tokens =', { tokenIn, tokenOut });

    if (tokenIn) {
      this.sellTokenSymbol = tokenIn;
      console.log('[SEO] set sellTokenSymbol =', this.sellTokenSymbol);
    }
    if (tokenOut) {
      this.buyTokenSymbol = tokenOut;
      console.log('[SEO] set buyTokenSymbol =', this.buyTokenSymbol);
    }

    // chainId direct (nouveau) ou fallback via slug (ancien)
    const chainId = cta.chainId ?? this.slugToChainId(cta.chain ?? '');
    console.log('[SEO] computed chainId =', chainId, '(from chainId:', cta.chainId, ', chain:', cta.chain, ')');

    if (chainId) {
      this.setChain(Number(chainId));
      this.seoChainId = Number(chainId);
      this.lockChainToSeo = true;
      this.selectedNetwork = this.seoChainId;
      console.log('[SEO] setChain done →', Number(chainId));
    }

    this.appliedCtaOnce = true;
    console.log('[SEO] applyCtaDefaultsFromSeo:done');
  }



  private slugToChainId(slug: string): number | null {
    const map: Record<string, number> = {
      ethereum: 1,
      arbitrum: 42161,
      base: 8453,
      polygon: 137,
      bsc: 56,
      celo: 42220,
      optimism: 10,
      avalanche: 43114
    };
    return map[slug.toLowerCase()] ?? null;
  }

  /** 
 * Installe une sonde de debug RPC (idempotente) pour logguer les appels
 * qui peuvent déclencher une popup MetaMask (switch réseau, request accounts,
 * envoi de transaction, signatures).
 *
 * ⚠️ Ne modifie PAS le comportement : elle se contente de logger.
 * À appeler par ex. dans setChain() ou juste après avoir attaché le provider.
 */
  private installRpcDebugProbe(label: string = 'probe'): void {
    const p: any = this.provider as any;
    if (!p) {
      this.addLog(`[rpc] debug probe skipped (${label}): no provider`);
      return;
    }
    // éviter d'installer plusieurs fois
    if ((p as any).__rpcDebugProbeInstalled) {
      return;
    }

    const SENSITIVE = new Set<string>([
      'wallet_switchEthereumChain',
      'wallet_addEthereumChain',
      'eth_requestAccounts',
      'eth_sendTransaction',
      'eth_sign',
      'personal_sign',
      'eth_signTypedData',
      'eth_signTypedData_v3',
      'eth_signTypedData_v4'
    ]);

    // wrap request()
    if (typeof p.request === 'function') {
      const origReq = p.request.bind(p);
      p.request = async (args: { method: string; params?: any[] }) => {
        try {
          if (args && args.method && SENSITIVE.has(args.method)) {
            this.addLog(`[rpc][${label}] ${args.method} params=${JSON.stringify(args.params ?? [])}`);
          }
        } catch { /* no-op */ }
        return origReq(args);
      };
    }

    // wrap send() — certains providers appellent send(method, params)
    if (typeof p.send === 'function') {
      const origSend = p.send.bind(p);
      p.send = async (method: string, params?: any[]) => {
        try {
          if (method && SENSITIVE.has(method)) {
            this.addLog(`[rpc][${label}] ${method} params=${JSON.stringify(params ?? [])}`);
          }
        } catch { /* no-op */ }
        return origSend(method, params);
      };
    }

    (p as any).__rpcDebugProbeInstalled = true;
    this.addLog(`[rpc] debug probe installed (${label})`);
  }

  private getOpenProbeState(): 'active' | 'paused' {
    try { return (sessionStorage.getItem('st/openProbeState') as any) === 'active' ? 'active' : 'paused'; } catch { return 'paused'; }
  }
  private pauseOpenProbe(reason = 'boot'): void {
    try { sessionStorage.setItem('st/openProbeState', 'paused'); } catch { }
    this.addLog?.(`[open-probe] state=paused reason=${reason}`);
  }
  private resumeOpenProbe(reason = 'connected'): void {
    try { sessionStorage.setItem('st/openProbeState', 'active'); } catch { }
    this.addLog?.(`[open-probe] state=active reason=${reason}`);
  }


  // ⚙️ Sonde navigateur: log tout window.open / location.* (deeplinks iOS)
  // Et applique un "deny-by-default" pour metamask://, metamask.app.link, wc:
  private installWindowOpenProbe(label: string = 'boot'): void {
    const w: any = window as any;
    if ((w as any).__openProbeInstalled) {
      this.addLog?.(`[open-probe] already installed (${label})`);
      return;
    }

    this.pauseOpenProbe('install');

    const shortStack = () => {
      try {
        const s = (new Error()).stack || '';
        return s.split('\n').slice(1, 4).map(l => l.trim()).join(' ⟂ ');
      } catch {
        return '';
      }
    };

    const isMetaLink = (u: string) =>
      /^metamask:/.test(u) || /metamask\.app\.link/.test(u) || /^wc:/.test(u);
    const now = () => Date.now();
    const getNum = (k: string) => {
      try {
        const v = Number(sessionStorage.getItem(k) || '0');
        return Number.isFinite(v) ? v : 0;
      } catch {
        return 0;
      }
    };
    const consumeSkipOnce = () => {
      try {
        const k = 'st/skipWcDeeplinkOnce';
        const hit = sessionStorage.getItem(k) === '1';
        if (hit) sessionStorage.removeItem(k);
        return hit;
      } catch {
        return false;
      }
    };

    const shouldBlock = (url: string) => {
      if (!url || !isMetaLink(url)) return false;

      // ⛔ Bypass global quand la sonde est en pause (avant connexion)
      const probeState = this.getOpenProbeState();
      if (probeState !== 'active') {
        this.addLog?.(`[deeplink][probe] BYPASS (paused) url=${url}`);
        return false;
      }

      const allowUntil = getNum('st/allowWcDeeplinkUntil');
      const allowRunId = getNum('st/allowWcRunId');
      const suppressUntil = getNum('st/suppressWcUriUntil');
      const underCooldown = suppressUntil > 0 && now() < suppressUntil;
      const skipOnce = sessionStorage.getItem('st/skipWcDeeplinkOnce') === '1';
      const hasWalletSession = sessionStorage.getItem('st/hasWalletSession') === '1';

      // 1) Cooldown / skipOnce
      if (skipOnce || underCooldown) {
        this.addLog?.(
          `[deeplink][probe] BLOCK url=${url} reason=${underCooldown ? 'cooldown' : 'skip-once'
          } allow=false`
        );
        if (skipOnce) consumeSkipOnce();
        return true;
      }

      // 2) Fenêtre autorisée avec runId actif
      const windowAllowed = allowUntil > 0 && now() < allowUntil;
      if (windowAllowed && allowRunId > 0) {
        this.addLog?.(
          `[deeplink][probe] ALLOW (one-shot) url=${url} allowRunId=${allowRunId}`
        );
        // ⏳ Consommer immédiatement la fenêtre d’autorisation
        try {
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
          sessionStorage.removeItem('st/allowWcRunId');
          // on peut garder skipWcDeeplinkOnce pour d’autres use cases
        } catch { /* noop */ }

        return false; // laisse passer CETTE ouverture seulement
      }


      // 3) Première connexion (aucun runId et aucune session connue)
      if (!allowRunId && !hasWalletSession) {
        this.addLog?.(`[deeplink][probe] ALLOW initial login url=${url}`);
        try {
          sessionStorage.setItem('st/hasWalletSession', '1');
        } catch { }
        return false;
      }

      // 4) Sinon → block
      this.addLog?.(
        `[deeplink][probe] BLOCK url=${url} reason=deny-by-default allow=${windowAllowed} allowRunId=${allowRunId}`
      );
      return true;
    };

    try {
      // window.open → wrap configurable/writable uniquement
      try {
        const desc = Object.getOwnPropertyDescriptor(w, 'open');
        if (!desc || desc.writable || desc.configurable) {
          const origOpen = w.open?.bind(w);
          if (typeof origOpen === 'function') {
            w.open = (...args: any[]) => {
              const url = String(args?.[0] ?? '');
              this.addLog?.(`[open] url=${url} | stack=${shortStack()}`);
              if (shouldBlock(url)) return null;
              return origOpen(...args);
            };
          }
        } else {
          this.addLog?.('[open-probe] skip wrap window.open (readonly)');
        }
      } catch { }

      // location.assign/replace → wrap des méthodes
      try {
        const loc: any = w.location;
        if (loc && typeof loc.assign === 'function') {
          const a0 = loc.assign.bind(loc);
          loc.assign = (u: string) => {
            this.addLog?.(`[open] location.assign → ${u} | stack=${shortStack()}`);
            if (shouldBlock(String(u))) return;
            return a0(u);
          };
        }
        if (loc && typeof loc.replace === 'function') {
          const r0 = loc.replace.bind(loc);
          loc.replace = (u: string) => {
            this.addLog?.(`[open] location.replace → ${u} | stack=${shortStack()}`);
            if (shouldBlock(String(u))) return;
            return r0(u);
          };
        }
      } catch { }

      // lien <a> (deeplinks)
      document.addEventListener(
        'click',
        (ev: any) => {
          const a = ev?.target?.closest?.('a[href]');
          if (!a) return;
          const href = String(a.getAttribute('href') || '');
          if (!href) return;
          if (/metamask\.app\.link|metamask:|wc:/.test(href)) {
            this.addLog?.(`[open] anchor-click → ${href} | stack=${shortStack()}`);
            if (shouldBlock(href)) {
              try {
                ev.preventDefault?.();
                ev.stopPropagation?.();
              } catch { }
              return;
            }
          }
        },
        { capture: true, passive: true }
      );

      (w as any).__openProbeInstalled = true;
      this.addLog?.(`[open-probe] installed (${label})`);
    } catch (e: any) {
      this.addLog?.(
        `[open-probe] install failed (soft): ${e?.message || e}`
      );
    }
  }




  /** Anti-spam hard reload (max 1 toutes les 20s) */
  private _reconnectLockUntil = 0;

  /** Détecte toutes les variantes “annulation utilisateur” */
  private isUserRejected(e: any): boolean {
    const code = e?.code ?? e?.error?.code;
    const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase();
    return (
      code === 4001 ||                       // EIP-1193 standard
      code === 5000 ||                       // MetaMask mobile
      code === 'ACTION_REJECTED' ||          // ethers v6
      /action_rejected/.test(String(code).toLowerCase()) ||
      /denied|rejected|user denied|user rejected/.test(msg)
    );
  }
  async disconnectWalletReload() {
    await this.wallet.disconnect();
    this.takerAddress = null;
  }

  private setBuyChain(id: number) {



    // 🔁 Rebind cache dès qu'on change de réseau
    const addr = (this.takerAddress || '').toLowerCase();
    if (addr) {
      // garantit le catalogue tokens pour la nouvelle chaîne (hit cache + revalidation)
      this.portfolio.ensure(id);

      this.portfolio.ownedTokens$(addr, id).subscribe(list => {
        this.userBuyCachedTokens = list;                                // ✅ mêmes clés / même variable
      });

      // Soldes (patches) → fusion dans tokenBalances
      this.portfolio.tokenBalances$(addr, id).subscribe(patch => {
        Object.assign(this.buyTokenCachedBalances, patch);              // ✅ mêmes clés "<addr>_<cid>"
      });
    }


    // Si on est connecté, relire la balance (debounce simple)
    if (this.isConnected) {
      clearTimeout((this as any).__nb_to);
      (this as any).__nb_to = setTimeout(() => {
        this.refreshNativeBalance();
        this.addLog('[ui] setChain → refreshNativeBalance() triggered');
      }, 200);
    }
  }
  // 🔐 Connect mutex (anti double modal / iOS AppKit)
  private connectInFlight = false;
  private connectInFlightUntil = 0;

  private isConnectInFlight(): boolean {
    return this.connectInFlight && Date.now() < this.connectInFlightUntil;
  }
  // ─────────────────────────────────────────────
  // Portfolio bind/warmup (cache-first) — anti refresh/debug race
  // ─────────────────────────────────────────────
  private _portfolioKey: string | null = null;
  private _portfolioOwnedSub?: Subscription;
  private _portfolioBalSub?: Subscription;
  private _portfolioWarmKey: string | null = null;
  private _portfolioWarmUntil = 0;

  private bindPortfolioIfReady(reason: string): void {
    const cid = Number(this.chainId || 0);
    const addr = (this.takerAddress || '').toLowerCase();


    if (this.isConnectInFlight?.()) {
      const n = ((this as any).__pf_retry_n = (((this as any).__pf_retry_n ?? 0) + 1));
      this.addLog?.(`[portfolio] bind deferred (connectInFlight) | reason=${reason} retry=${n}`);
      if (n <= 20) {
        setTimeout(() => this.bindPortfolioIfReady(`${reason}:retry`), 250);
      }
      return;
    } else {
      (this as any).__pf_retry_n = 0;
    }

    if (!cid || !addr) {
      this.addLog?.(`[portfolio] bind skip | reason=${reason} addr=${!!addr} cid=${cid || 'null'}`);
      return;
    }

    const key = `${addr}_${cid}`;
    if (this._portfolioKey === key) {
      this.addLog?.(`[portfolio] bind noop | reason=${reason} key=${key}`);
      // still ensure warmup after some refresh edge-cases
      this.maybeWarmUpPortfolio(reason, key, addr, cid);
      return;
    }

    // cleanup old subs
    try { this._portfolioOwnedSub?.unsubscribe(); } catch { }
    try { this._portfolioBalSub?.unsubscribe(); } catch { }
    this._portfolioOwnedSub = undefined;
    this._portfolioBalSub = undefined;

    this._portfolioKey = key;
    this.addLog?.(`[portfolio] bind start | reason=${reason} key=${key}`);

    try { this.portfolio.ensure(cid); } catch { }

    this._portfolioOwnedSub = this.portfolio.ownedTokens$(addr, cid).subscribe(list => {
      this.userCachedTokens = list;
      this.addLog?.(`[portfolio] ownedTokens updated | key=${key} count=${list?.length ?? 0}`);
    });

    this._portfolioBalSub = this.portfolio.tokenBalances$(addr, cid).subscribe(patch => {
      Object.assign(this.tokenCachedBalances, patch);
      this.addLog?.(`[portfolio] tokenBalances patch | key=${key} keys=${Object.keys(patch || {}).length}`);
    });

    this.maybeWarmUpPortfolio(reason, key, addr, cid);
  }

  private maybeWarmUpPortfolio(reason: string, key: string, addr: string, cid: number): void {
    // 🔐 During connect flow, NEVER warm up portfolio.
    // Reason: portfolio.forceRefresh can trigger provider RPCs while AppKit is still pairing,
    // which may swallow / delay the deep-link "Open in MetaMask" flow on iOS.
    if (this.isConnectInFlight()) {
      this.addLog?.(`[portfolio] warmUp skip (connectInFlight) | reason=${reason} key=${key}`);
      return;
    }
    const now = Date.now();
    if (this._portfolioWarmKey === key && now < this._portfolioWarmUntil) {
      this.addLog?.(`[portfolio] warmUp skip (cooldown) | reason=${reason} key=${key}`);
      return;
    }

    // 5s cooldown per key: avoids spam on route changes / debug reloads
    this._portfolioWarmKey = key;
    this._portfolioWarmUntil = now + 5000;

    // Defer to next tick: provider/session can settle (WC silent reattach)
    setTimeout(async () => {
      try {
        if (!this.isConnected) {
          this.addLog?.(`[portfolio] warmUp abort (not connected) | key=${key}`);
          return;
        }
        this.addLog?.(`[portfolio] warmUp start | reason=${reason} key=${key}`);
        await this.portfolio.forceRefresh(addr, cid);
        this.addLog?.(`[portfolio] warmUp done | key=${key}`);
      } catch (e: any) {
        this.addLog?.(`[portfolio] warmUp error | key=${key} msg=${e?.message ?? e}`);
      }
    }, 0);
  }

  private setChain(id: number, source: 'ui' | 'attach' | 'evm' | 'restore' | 'auto' = 'ui') {
    const prev = this.chainId;

    // ✅ Source of truth: UI selection persisted as "desired"
    if (source === 'ui') {
      try { (this as any).desiredChainId = id; } catch { }
      try { sessionStorage.setItem('st/desiredChainId', String(id)); } catch { }
    }

    // ✅ no-op if unchanged (avoid loops + extra balance refresh)
    if (prev === id) {
      this.addLog?.(`[ui] setChain NOOP | src=${source} id=${id}`);
      return;
    }

    this.chainId = id;
    this.chainInfo = CHAIN_MAP[id] ?? null;
    this.addLog?.(`[ui] setChain called | src=${source} prev=${prev ?? 'null'} now=${id} desired=${(this as any).desiredChainId ?? 'null'}`);

    this.installRpcDebugProbe('setChain');
    this.installRpcDebugProbeOnWindow('setChain');

    // ✅ bind tokens/portfolio quand (addr+chainId) sont prêts (anti race)
    /* this.tryBindPortfolio('setChain');*/

    this.bindPortfolioIfReady('setChain');

    // Si on est connecté, relire la balance (debounce simple)
    if (this.isConnected) {
      // ✅ do not block WC modal animation during connect flow
      if (this.isConnectInFlight?.()) {
        this.addLog?.('[ui] setChain → refreshNativeBalance() SKIP (connectInFlight)');
        return;
      }
      clearTimeout((this as any).__nb_to);
      (this as any).__nb_to = setTimeout(() => {
        this.refreshNativeBalance();
        this.addLog('[ui] setChain → refreshNativeBalance() triggered');
      }, 200);
    }
  }

  onQuoteRequestConnect(): void {
    this.onChildLogConsole?.('[quote][connect] requestConnect -> legacyConnect.connectWallet()');


    const scheduleResume = (src: string) => {
      const ms = Math.max(0, (this.connectInFlightUntil || 0) - Date.now());
      try { clearTimeout((this as any)._resumeRestoreSessionTO); } catch { }
      (this as any)._resumeRestoreSessionTO = setTimeout(() => {
        this.resumeRestoreSession(`bridge-cta-connect-timeout:${src}`);
      }, ms || 0);
      this.addLog?.(`[restoreSession] resume scheduled in ${ms || 0}ms | src=${src}`);
    };

    // 🔐 lock connect (20s safety window)
    this.connectInFlight = true;
    this.connectInFlightUntil = Date.now() + 20_000;





    this.addLog('[CONNECT][flag] connectInFlight=true (quote CTA)');

    // ✅ cancel token: si la quote est fermée, on ignore les retours tardifs (late-connect)
    const lifeId = this._quoteLifeId;
    const seq = ++this._quoteConnectSeq;
    this._activeQuoteConnectSeq = seq;
    this._activeQuoteConnectLifeId = lifeId;
    // Arm provider pump: provider surfacing must be singleton and must not depend on quote lifecycle
    this.startQuoteProviderPump(seq, lifeId, 'quote-connect');

    this.addLog?.(`[quote][connect] start | seq=${seq} lifeId=${lifeId}`);

    // 🧊 suspend silent restore/polls during CTA connect to avoid fighting the WC modal on iOS
    // this.suspendRestoreSession('bridge-cta-connect');

    try {
      // ⚠️ adapte le nom exact de la méthode publique exposée par ConnectWalletLegacyComponent
      // souvent: connectWallet() / openConnect() / connect()
      // ✅ let UI paint the WC modal smoothly before doing anything heavy
      setTimeout(async () => {
        try {
          await (this.legacyConnect as any)?.connectWallet?.();
        } catch (e) {
          this.addLog?.(`[legacy][quote][connect] connectWallet threw: ${e}`);
        } finally {
          // ❗️Ne PAS resume immédiatement : connectWallet() return vite sur iOS,
          // ça relance restoreSession/polls pendant que la modal tourne encore.
          scheduleResume('finally');
        }
      }, 0);
    } catch (e: any) {
      console.error('[quote][connect] legacyConnect.connectWallet ERROR', e);
      // rollback si exception immédiate
      this.connectInFlight = false;
      this.connectInFlightUntil = 0;
      this.addLog('[CONNECT][flag] rollback connectInFlight=false (error)');

      // ensure restore is resumed even if connect throws synchronously
      this.resumeRestoreSession('bridge-cta-connect-error-sync');
    }
  }


  private cancelQuoteProviderPump(reason: string): void {
    const pump: any = this._quoteProviderPump as any;
    if (!pump) return;
    pump.cancelled = true;

    // Cleanup timers + optional AppKit subscription
    try { if (pump.timer) window.clearTimeout(pump.timer); } catch { }
    try { if (typeof pump.unsub === 'function') pump.unsub(); } catch { }

    this._quoteProviderPump = null;
    this.addLog?.(`[quote][connect][pump] cancelled | reason=${reason}`);
  }

  private startQuoteProviderPump(seq: number, lifeId: number, reason: string): void {
    // Cancel any previous pump
    this.cancelQuoteProviderPump(`restart:${reason}`);

    const pump: any = {
      seq,
      lifeId,
      t0: Date.now(),
      cancelled: false as boolean,
      timer: null as any,
      unsub: null as any,
    };
    this._quoteProviderPump = pump;

    // 🔥 DESIGN GOAL (Apex determinism):
    // - Provider surfacing must be independent from quote UI lifecycle.
    // - We ALWAYS attach provider to global state as soon as it becomes available.
    // - We NEVER close the quote automatically on wallet-connected.
    // - We only best-effort close the WC/AppKit modal once provider is attached.

    const w: any = window as any;

    // Prefer a stable singleton surface:
    // - In your codebase, legacyConnect is your "singleton connect layer"
    // - window.appKitModal can exist but is sometimes funky on iOS/Safari
    const modalPrimary: any = (this as any).legacyConnect ?? null;
    const modalWindow: any = w?.appKitModal ?? null;

    const hasSubPrimary = typeof modalPrimary?.subscribeProviders === 'function';
    const hasGetPrimary = typeof modalPrimary?.getWalletProvider === 'function';

    const hasSubWindow = typeof modalWindow?.subscribeProviders === 'function';
    const hasGetWindow = typeof modalWindow?.getWalletProvider === 'function';

    this.addLog?.(
      `[quote][connect][pump] start | seq=${seq} lifeId=${lifeId} ` +
      `hasSub(primary)=${hasSubPrimary} hasGet(primary)=${hasGetPrimary} ` +
      `hasSub(win)=${hasSubWindow} hasGet(win)=${hasGetWindow}`
    );

    // Only guards for the pump itself (NOT quote lifecycle)
    const stillRunning = () => {
      if (!this._quoteProviderPump || this._quoteProviderPump !== pump) return false;
      if (pump.cancelled) return false;
      // optional: ensure we're still on the same connect seq (prevents cross-run bleed)
      if (this._activeQuoteConnectSeq !== seq) return false;
      return true;
    };

    const closeModalBestEffort = () => {
      // Try both surfaces, ignore errors
      try {
        if (typeof modalPrimary?.close === 'function') {
          modalPrimary.close();
          this.addLog?.('[quote][connect][pump] modalPrimary.close() called');
          return;
        }
      } catch { }

      try {
        if (typeof modalWindow?.close === 'function') {
          modalWindow.close();
          this.addLog?.('[quote][connect][pump] window.appKitModal.close() called');
          return;
        }
      } catch { }
    };

    const normalizeProvider = async (maybe: any): Promise<any> => {
      if (!maybe) return null;

      // If it's a Promise-like
      if (maybe && typeof maybe.then === 'function') {
        try { return await maybe; } catch { return null; }
      }

      // If subscribeProviders returned an unsubscribe function, it's not a provider
      if (typeof maybe === 'function') return null;

      return maybe;
    };

    const isEip1193 = (raw: any) => typeof raw?.request === 'function';

    const tryAttach = async (raw: any, via: string): Promise<boolean> => {
      if (!stillRunning()) return true; // stop
      const p0 = await normalizeProvider(raw);
      if (!p0) return false;

      if (!isEip1193(p0)) return false;

      try {
        this.addLog?.(`[quote][connect][pump] provider surfaced | via=${via} request=${typeof p0?.request === 'function'}`);
        await this.attachEthersProvider(p0, `quote-pump:${via}`);

        // After attach, close WC/AppKit modal best-effort (independent from quote)
        closeModalBestEffort();

        return true; // done
      } catch (e: any) {
        this.addLog?.(`[quote][connect][pump] attach error | via=${via} err=${e?.message || e}`);
        // Stop pumping on error to avoid loops that spam
        return true;
      }
    };

    // Subscribe helper (supports both callback-style + promise-style)
    const armSubscribe = (modalX: any, label: string) => {
      if (!modalX || typeof modalX.subscribeProviders !== 'function') return;

      try {
        // 1) Try callback-style (often returns unsubscribe function)
        const r1: any = modalX.subscribeProviders((state: any) => {
          try {
            // Attempt common shapes
            const raw =
              state?.eip155?.provider ||
              state?.eip155?.rpcProviders?.eip155 ||
              state?.eip155 ||
              null;

            if (raw) void tryAttach(raw, `${label}:subscribe(cb)`);

            // If provider isn't in state, ask getter (if exists)
            if (!raw && typeof modalX.getWalletProvider === 'function') {
              const got = modalX.getWalletProvider('eip155');
              void tryAttach(got, `${label}:getWalletProvider(afterSub)`);
            }
          } catch { }
        });

        // store unsubscribe if provided
        if (typeof r1 === 'function') {
          pump.unsub = r1;
          this.addLog?.(`[quote][connect][pump] subscribe armed | ${label} unsub=function`);
        }

        // 2) If it was promise-style, attach it too
        if (r1 && typeof r1.then === 'function') {
          r1.then((raw: any) => void tryAttach(raw, `${label}:subscribe(promise)`))
            .catch((e: any) => this.addLog?.(`[quote][connect][pump] subscribeProviders throw | ${label}: ${e?.message || e}`));
          this.addLog?.(`[quote][connect][pump] subscribe armed | ${label} promise=true`);
        }
      } catch (e1: any) {
        // 3) If callback-style throws, attempt no-arg promise-style
        this.addLog?.(`[quote][connect][pump] subscribe(cb) failed | ${label}: ${e1?.message || e1}`);

        try {
          const r2: any = modalX.subscribeProviders();
          if (r2 && typeof r2.then === 'function') {
            r2.then((raw: any) => void tryAttach(raw, `${label}:subscribe(noarg-promise)`))
              .catch((e: any) => this.addLog?.(`[quote][connect][pump] subscribeProviders throw | ${label}: ${e?.message || e}`));
            this.addLog?.(`[quote][connect][pump] subscribe armed | ${label} noarg-promise=true`);
          } else if (r2) {
            void tryAttach(r2, `${label}:subscribe(noarg-sync)`);
            this.addLog?.(`[quote][connect][pump] subscribe armed | ${label} noarg-sync=true`);
          }
        } catch (e2: any) {
          this.addLog?.(`[quote][connect][pump] subscribe(noarg) failed | ${label}: ${e2?.message || e2}`);
        }
      }
    };

    // Arm subscribes (both surfaces)
    armSubscribe(modalPrimary, 'primary');
    armSubscribe(modalWindow, 'window');

    // Poll getWalletProvider (fallback)
    const step = async (tick: number) => {
      if (!stillRunning()) {
        this.cancelQuoteProviderPump('stop:cancelled');
        return;
      }

      // Try getters in priority order
      const tries: Array<{ modal: any; label: string }> = [
        { modal: modalPrimary, label: 'primary' },
        { modal: modalWindow, label: 'window' },
      ];

      for (const t of tries) {
        const m = t.modal;
        if (!m || typeof m.getWalletProvider !== 'function') continue;

        try {
          // Some runtimes need namespace, others don't
          let got: any = null;
          try { got = m.getWalletProvider('eip155'); } catch { got = null; }
          if (!got) {
            try { got = m.getWalletProvider(); } catch { got = null; }
          }

          const done = await tryAttach(got, `${t.label}:getWalletProvider#${tick}`);
          if (done) {
            this.cancelQuoteProviderPump('stop:done');
            return;
          }
        } catch (e: any) {
          this.addLog?.(`[quote][connect][pump] getWalletProvider error | ${t.label}: ${e?.message || e}`);
        }
      }

      // Allow very late resolution on iOS (you observed > 160s)
      const elapsed = Date.now() - pump.t0;
      if (elapsed >= 180_000) {
        this.cancelQuoteProviderPump('stop:timeout');
        return;
      }

      pump.timer = window.setTimeout(() => void step(tick + 1), 1000);
    };

    pump.timer = window.setTimeout(() => void step(1), 250);
  }


  private maybeRetryPortfolioBind(key: string, addr: string, cid: number, reason: string) {
    // On ne retry que si on est connecté et que le bind correspond au key courant
    if (!this.isConnected) return;
    if (this._portfolioBindKey !== key) return;

    // Condition "vide" : tokens=0 ET balances=0 (ou pas encore arrivés)
    const count = this._portfolioLastCount;
    const balKeys = this._portfolioLastBalKeys;
    const looksEmpty = (count === 0) && (balKeys === 0 || balKeys === -1);
    if (!looksEmpty) return;

    if (this._portfolioRetryCount >= 2) {
      this.addLog(`[portfolio] retry stop | key=${key} after=${this._portfolioRetryCount} last=count=${count} balKeys=${balKeys}`);
      return;
    }

    this._portfolioRetryCount++;
    const delay = this._portfolioRetryCount === 1 ? 350 : 1200;
    this.addLog(`[portfolio] retry scheduled | #${this._portfolioRetryCount} in ${delay}ms | because=${reason} key=${key}`);

    setTimeout(() => {
      // force rebind even if same key
      if (this._portfolioBindKey !== key) return;
      this._portfolioBindKey = null;

      this.bindPortfolioIfReady(`retry#${this._portfolioRetryCount}`);
    }, delay);
  }

  //private refreshTokensForChain() {
  //  if (!this.tokensLoaded || !this.chainId) {
  //    console.warn('[refreshTokens] Ignored (tokens or chainId not ready)', {
  //      tokensLoaded: this.tokensLoaded, chainId: this.chainId
  //    });
  //    return;
  //  }

  //  console.log('[refreshTokens] >>> ENTER chainId=', this.chainId,
  //    'sell=', this.sellTokenSymbol, 'buy=', this.buyTokenSymbol);

  //  const normalizeNumber = (x: any): number => {
  //    if (typeof x === 'number') return x;
  //    if (typeof x === 'string') {
  //      // supprime espaces, gère virgule décimale, enlève séparateurs de milliers
  //      let s = x.trim().replace(/\s/g, '');
  //      if (s.includes(',') && !s.includes('.')) s = s.replace(',', '.');
  //      s = s.replace(/,/g, '');
  //      const n = Number(s);
  //      return isFinite(n) ? n : NaN;
  //    }
  //    return NaN;
  //  };

  //  // 1) Filtre brut par chaîne
  //  const rawForChain = (this.allTokens || [])
  //    .filter(t => Number(t.chainId) === Number(this.chainId));

  //  const rawForBuyChain = (this.allTokens || [])
  //    .filter(t => Number(t.buyChainId) === Number(this.buyChainId));

  //  // 2) Normalisation des tokens (snake → camel, types)
  //  const normalized = rawForChain.map(t => {
  //    const chainId = Number(t.chainId);
  //    const address = (t.address ?? t.address_lower ?? '').toLowerCase();
  //    const logoURI = t.logoURI ?? t.logo_uri ?? t.logoUrl ?? t.logo_url ?? '';
  //    const priceUSD = t.priceUSD ?? t.price_usd ?? t.priceUsd;
  //    const volumeRaw = t.volumeUsd24h ?? t.volume_usd_24h ?? t.volume_usd24h ?? t.volumeUsd24H;



  //    return {
  //      ...t,
  //      chainId,                                // number
  //      address,                                // lowercase
  //      logoURI,                                // camelCase
  //      priceUSD: priceUSD,                     // conserve la source, on normalise pour le map
  //      volumeUsd24h: normalizeNumber(volumeRaw) || 0,
  //      symbol: t.symbol,
  //      name: t.name ?? t.fname ?? t.tokenName ?? t.symbol
  //    };
  //  })
  //    .filter(t => !!t.symbol)
  //    .sort((a, b) => (a.symbol || '').localeCompare(b.symbol || ''));

  //  this.availableTokens = normalized;


  //  const normalizedBuy = rawForBuyChain.map(t => {
  //    const chainId = Number(t.chainId);
  //    const address = (t.address ?? t.address_lower ?? '').toLowerCase();
  //    const logoURI = t.logoURI ?? t.logo_uri ?? t.logoUrl ?? t.logo_url ?? '';
  //    const priceUSD = t.priceUSD ?? t.price_usd ?? t.priceUsd;
  //    const volumeRaw = t.volumeUsd24h ?? t.volume_usd_24h ?? t.volume_usd24h ?? t.volumeUsd24H;
  //    return {
  //      ...t,
  //      chainId,                                // number
  //      address,                                // lowercase
  //      logoURI,                                // camelCase
  //      priceUSD: priceUSD,                     // conserve la source, on normalise pour le map
  //      volumeUsd24h: normalizeNumber(volumeRaw) || 0,
  //      symbol: t.symbol,
  //      name: t.name ?? t.fname ?? t.tokenName ?? t.symbol
  //    };
  //  })
  //    .filter(t => !!t.symbol)
  //    .sort((a, b) => (a.symbol || '').localeCompare(b.symbol || ''));

  //  this.availableBuyTokens = normalizedBuy;


  //  // 3) priceMap[address_chainId] avec normalisation numérique robuste
  //  this.priceMap = {};
  //  for (const t of this.availableTokens) {
  //    const p = normalizeNumber(t.priceUSD);
  //    if (t.symbol && t.address && t.chainId && isFinite(p) && p > 0) {
  //      const key = `${t.address}_${t.chainId}`;
  //      this.priceMap[key] = p;
  //    } else {
  //      // log ciblé utile si un token clé manque (ex: LINK/56)
  //      if ((t.symbol?.toUpperCase?.() === 'LINK') && t.chainId === 56) {
  //        console.warn('⛔ LINK/56 skipped (priceUSD invalid)', { addr: t.address, raw: t.priceUSD, parsed: p });
  //      }
  //    }
  //  }


  //  this.priceBuyMap = {};
  //  for (const t of this.availableBuyTokens) {
  //    const p = normalizeNumber(t.priceUSD);
  //    if (t.symbol && t.address && t.chainId && isFinite(p) && p > 0) {
  //      const key = `${t.address}_${t.chainId}`;
  //      this.priceMap[key] = p;
  //    } else {
  //      // log ciblé utile si un token clé manque (ex: LINK/56)
  //      if ((t.symbol?.toUpperCase?.() === 'LINK') && t.chainId === 56) {
  //        console.warn('⛔ LINK/56 skipped (priceUSD invalid)', { addr: t.address, raw: t.priceUSD, parsed: p });
  //      }
  //    }
  //  }

  //  // 4) Fallback si le token sélectionné n’est plus présent (sans écraser si valide)
  //  const prefer = ['USDC', 'USDT', 'DAI'];
  //  const stable = this.availableTokens.find(t => prefer.includes((t.symbol || '').toUpperCase()));
  //  const first = this.availableTokens[0]?.symbol;

  //  // SELL
  //  if (!this.sellTokenSymbol) {
  //    const fb = stable?.symbol ?? first ?? '';
  //    console.log('[refreshTokens] SELL vide → fallback', fb);
  //    this.sellTokenSymbol = fb;
  //  } else if (!this.availableTokens.some(t => t.symbol === this.sellTokenSymbol)) {
  //    const fb = stable?.symbol ?? first ?? this.sellTokenSymbol;
  //    console.log('[refreshTokens] SELL invalide sur chain', this.chainId, '→', this.sellTokenSymbol, '→', fb);
  //    this.sellTokenSymbol = fb;
  //  } else {
  //    console.log('[refreshTokens] SELL conservé =', this.sellTokenSymbol);
  //  }

  //  // BUY
  //  if (!this.buyTokenSymbol) {
  //    const fb = stable?.symbol ?? first ?? '';
  //    console.log('[refreshTokens] BUY vide → fallback', fb);
  //    this.buyTokenSymbol = fb;
  //  } else if (!this.availableBuyTokens.some(t => t.symbol === this.buyTokenSymbol)) {
  //    const fb = stable?.symbol ?? first ?? this.buyTokenSymbol;
  //    console.log('[refreshTokens] BUY invalide sur chain', this.chainId, '→', this.buyTokenSymbol, '→', fb);
  //    this.buyTokenSymbol = fb;
  //  } else {
  //    console.log('[refreshTokens] BUY conservé =', this.buyTokenSymbol);
  //  }

  //  // 5) Listes affichées
  //  this.filteredSellTokens = this.availableTokens;
  //  this.filteredBuyTokens = this.availableBuyTokens;

  //  // 6) Populaires + balances
  //  if (this.availableTokens.length > 0) {
  //    this.popularTokens = [...this.availableTokens].sort(
  //      (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
  //    );
  //    if (this.takerAddress) this.loadBalancesOptimized();
  //  } else {
  //    console.warn('[Tokens] Liste vide, balances non chargées');
  //  }

  //  if (this.availableBuyTokens.length > 0) {
  //    this.popularBuyTokens = [...this.availableBuyTokens].sort(
  //      (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
  //    );
  //  } else {
  //    console.warn('[Tokens] Liste vide, balances non chargées');
  //  }

  //  console.log('[refreshTokens] <<< EXIT chainId=', this.chainId,
  //    'sell=', this.sellTokenSymbol, 'buy=', this.buyTokenSymbol);
  //}

  private refreshTokensForChain() {
    if (!this.tokensLoaded || !this.chainId) {
      console.warn('[refreshTokens] Ignored (tokens or chainId not ready)', {
        tokensLoaded: this.tokensLoaded, chainId: this.chainId
      });
      return;
    }

    console.log('[refreshTokens] >>> ENTER chainId=', this.chainId, 'chainBuyId=', this.buyChainId,
      'sell=', this.sellTokenSymbol, 'buy=', this.buyTokenSymbol);

    const normalizeNumber = (x: any): number => {
      if (typeof x === 'number') return x;
      if (typeof x === 'string') {
        // supprime espaces, gère virgule décimale, enlève séparateurs de milliers
        let s = x.trim().replace(/\s/g, '');
        if (s.includes(',') && !s.includes('.')) s = s.replace(',', '.');
        s = s.replace(/,/g, '');
        const n = Number(s);
        return isFinite(n) ? n : NaN;
      }
      return NaN;
    };

    // 1) Filtre brut par chaîne
    const rawForChain = (this.allTokens || [])
      .filter(t => Number(t.chainId) === Number(this.chainId));

    const rawForBuyChain = (this.allTokens || [])
      // 👉 les tokens n'ont pas buyChainId : on filtre sur chainId === buyChainId
      .filter(t => Number(t.chainId) === Number(this.buyChainId));

    // 2) Normalisation des tokens (snake → camel, types)
    const normalized = rawForChain.map(t => {
      const chainId = Number(t.chainId);
      const address = (t.address ?? t.address_lower ?? '').toLowerCase();
      const logoURI = t.logoURI ?? t.logo_uri ?? t.logoUrl ?? t.logo_url ?? '';
      const priceUSD = t.priceUSD ?? t.price_usd ?? t.priceUsd;
      const volumeRaw = t.volumeUsd24h ?? t.volume_usd_24h ?? t.volume_usd24h ?? t.volumeUsd24H;

      return {
        ...t,
        chainId,                                // number
        address,                                // lowercase
        logoURI,                                // camelCase
        priceUSD: priceUSD,                     // conserve la source, on normalise pour le map
        volumeUsd24h: normalizeNumber(volumeRaw) || 0,
        symbol: t.symbol,
        name: t.name ?? t.fname ?? t.tokenName ?? t.symbol
      };
    })
      .filter(t => !!t.symbol)
      .sort((a, b) => (a.symbol || '').localeCompare(b.symbol || ''));

    this.availableTokens = normalized;



    const normalizedBuy = rawForBuyChain.map(t => {
      const chainId = Number(t.chainId);
      const address = (t.address ?? t.address_lower ?? '').toLowerCase();
      const logoURI = t.logoURI ?? t.logo_uri ?? t.logoUrl ?? t.logo_url ?? '';
      const priceUSD = t.priceUSD ?? t.price_usd ?? t.priceUsd;
      const volumeRaw = t.volumeUsd24h ?? t.volume_usd_24h ?? t.volume_usd24h ?? t.volumeUsd24H;
      return {
        ...t,
        chainId,                                // number
        address,                                // lowercase
        logoURI,                                // camelCase
        priceUSD: priceUSD,                     // conserve la source, on normalise pour le map
        volumeUsd24h: normalizeNumber(volumeRaw) || 0,
        symbol: t.symbol,
        name: t.name ?? t.fname ?? t.tokenName ?? t.symbol
      };
    })
      .filter(t => !!t.symbol)
      .sort((a, b) => (a.symbol || '').localeCompare(b.symbol || ''));

    this.availableBuyTokens = normalizedBuy;

    // 3) priceMap[address_chainId] avec normalisation numérique robuste
    this.priceMap = {};
    for (const t of this.availableTokens) {
      const p = normalizeNumber(t.priceUSD);
      if (t.symbol && t.address && t.chainId && isFinite(p) && p > 0) {
        const key = `${t.address}_${t.chainId}`;
        this.priceMap[key] = p;
      } else {
        // log ciblé utile si un token clé manque (ex: LINK/56)
        if ((t.symbol?.toUpperCase?.() === 'LINK') && t.chainId === 56) {
          console.warn('⛔ LINK/56 skipped (priceUSD invalid)', { addr: t.address, raw: t.priceUSD, parsed: p });
        }
      }
    }



    this.priceBuyMap = {};
    for (const t of this.availableBuyTokens) {
      const p = normalizeNumber(t.priceUSD);
      if (t.symbol && t.address && t.chainId && isFinite(p) && p > 0) {
        const key = `${t.address}_${t.chainId}`;
        this.priceBuyMap[key] = p;
      } else {
        // log ciblé utile si un token clé manque (ex: LINK/56)
        if ((t.symbol?.toUpperCase?.() === 'LINK') && t.chainId === 56) {
          console.warn('⛔ LINK/56 skipped (priceUSD invalid)', { addr: t.address, raw: t.priceUSD, parsed: p });
        }
      }
    }


    this.priceBuyMap = {};
    for (const t of this.availableBuyTokens) {
      const p = normalizeNumber(t.priceUSD);
      if (t.symbol && t.address && t.chainId && isFinite(p) && p > 0) {
        const key = `${t.address}_${t.chainId}`;
        this.priceBuyMap[key] = p;
      } else {
        // log ciblé utile si un token clé manque (ex: LINK/56)
        if ((t.symbol?.toUpperCase?.() === 'LINK') && t.chainId === 56) {
          console.warn('⛔ LINK/56 skipped (priceUSD invalid)', { addr: t.address, raw: t.priceUSD, parsed: p });
        }
      }
    }

    // 4) Fallback si le token sélectionné n’est plus présent (sans écraser si valide)
    const prefer = ['USDC', 'USDT', 'DAI'];
    const stable = this.availableTokens.find(t => prefer.includes((t.symbol || '').toUpperCase()));
    const first = this.availableTokens[0]?.symbol;


    const stableBuy = this.availableBuyTokens.find(t => prefer.includes((t.symbol || '').toUpperCase()));
    const firstBuy = this.availableBuyTokens[0]?.symbol;

    // SELL
    if (!this.sellTokenSymbol) {
      const fb = stable?.symbol ?? first ?? '';
      console.log('[refreshTokens] SELL vide → fallback', fb);
      this.sellTokenSymbol = fb;
    } else if (!this.availableTokens.some(t => t.symbol === this.sellTokenSymbol)) {
      const fb = stable?.symbol ?? first ?? this.sellTokenSymbol;
      console.log('[refreshTokens] SELL invalide sur chain', this.chainId, '→', this.sellTokenSymbol, '→', fb);
      this.sellTokenSymbol = fb;
    } else {
      console.log('[refreshTokens] SELL conservé =', this.sellTokenSymbol);
    }

    // BUY
    if (!this.buyTokenSymbol) {
      const fb = stableBuy?.symbol ?? firstBuy ?? '';
      console.log('[refreshTokens] BUY vide → fallback', fb);
      this.buyTokenSymbol = fb;
    } else if (!this.availableBuyTokens.some(t => t.symbol === this.buyTokenSymbol)) {
      const fb = stableBuy?.symbol ?? firstBuy ?? this.buyTokenSymbol;
      console.log('[refreshTokens] BUY invalide sur chain', this.buyChainId, '→', this.buyTokenSymbol, '→', fb);
      this.buyTokenSymbol = fb;
    } else {
      console.log('[refreshTokens] BUY conservé =', this.buyTokenSymbol);
    }

    // 5) Listes affichées
    this.filteredSellTokens = this.availableTokens;
    this.filteredBuyTokens = this.availableBuyTokens;

    // 6) Populaires + balances
    if (this.availableBuyTokens.length > 0) {
      this.popularBuyTokens = [...this.availableBuyTokens].sort(
        (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
      );
    } else {
      console.warn('[TokensBuy] Liste vide, balances non chargées');
    }


    if (this.availableTokens.length > 0) {
      this.popularTokens = [...this.availableTokens].sort(
        (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
      );
      if (this.takerAddress) this.loadBalancesOptimized();
    } else {
      console.warn('[Tokens] Liste vide, balances non chargées');
    }



    console.log('[refreshTokens] <<< EXIT chainId=', this.chainId,
      'sell=', this.sellTokenSymbol, 'buy=', this.buyTokenSymbol);
  }
  get fullGasWeiForChild(): bigint {
    return this.debugBypassGasCheck ? this.ZERO_WEI : this.fullGasWei;
  }


  private lockBodyScroll(lock: boolean) {
    const el = document?.documentElement || document?.body;
    if (!el) return;
    if (lock) el.classList.add('overflow-hidden');
    else el.classList.remove('overflow-hidden');
  }





  copyDebugLogs(): void {
    if (!this.debugText) return;

    navigator.clipboard.writeText(this.debugText)
      .then(() => {
        alert('Logs copiés dans le presse-papier 📋');
      })
      .catch(err => {
        console.error('Erreur copie logs', err);
        alert('Impossible de copier les logs.');
      });
  }

  private isMobileDevice(): boolean {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }
  // de-dupe guard for mobile deeplinks
  private __dlLock = false;
  private __dlLast: { url: string; ts: number } = { url: '', ts: 0 };
  public closeQuoteUI(reason: string) {
    this.closeQuoteWithReason(reason);
  }

  private __dlOpenedForRun: number | null = null; // (déclarée dans la classe)


  // --- BUY cache binds
  private _buyOwnedSub?: Subscription;
  private _buyBalSub?: Subscription;

  private initBuyCacheBindings(): void {
    if (this.buyChainId == null) {
      this.addLog?.('[buyCache] skip: buyChainId is null');
      return;
    }
    this.addLog?.(`[buyCache] ensure for buyChainId=${this.buyChainId}`);
    try { this.portfolio.ensure(this.buyChainId); } catch { }

    if (!this.takerAddress) {
      this.addLog?.('[buyCache] skip: no takerAddress yet (will bind on address$)');
      return;
    }

    this.addLog?.(`[buyCache] warmUp addr=${this.takerAddress} buyCid=${this.buyChainId}`);
    try { this.portfolio.warmUp(this.takerAddress, this.buyChainId, this.allChainIds); } catch { }

    this._buyOwnedSub?.unsubscribe();
    this._buyBalSub?.unsubscribe();

    this._buyOwnedSub = this.portfolio
      .ownedTokens$(this.takerAddress, this.buyChainId)
      .subscribe(list => {
        this.userBuyCachedTokens = list;
        this.addLog?.(`[buyCache] ownedTokens$ → ${list?.length ?? 0} items`);
      });

    this._buyBalSub = this.portfolio
      .tokenBalances$(this.takerAddress, this.buyChainId)
      .subscribe(patch => {
        Object.assign(this.buyTokenCachedBalances, patch);
        this.addLog?.(`[buyCache] tokenBalances$ patch applied (keys=${Object.keys(patch).length})`);
      });
  }



  /**
 * Open a wallet deeplink at most once per ~2.5s and only once “in flight”.
 * Logs what it does via this.addLog.
 */
  private openDeeplinkOnce(url: string, reason = 'wc', runId?: number): void {
    try {
      const now = Date.now();
      const allowRunId = Number(sessionStorage.getItem('st/allowWcRunId') || '0');
      const allowUntil = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0');
      const deltaMs = allowUntil - now;

      this.addLog?.(
        `[deeplink][allow-check] reason=${reason} runId=${String(runId ?? '-')} ` +
        `allowRunId=${allowRunId} allowUntil=${allowUntil} now=${now} deltaMs=${deltaMs}`
      );

      // ⛔ Run gate : si un allowRunId est présent, il doit correspondre
      if (allowRunId && (typeof runId !== 'number' || runId !== allowRunId)) {
        this.addLog?.(
          `[deeplink] SKIP (runId mismatch) reason=${reason} runId=${String(runId)} allowRunId=${allowRunId}`
        );
        return;
      }

      // ⛔ Fenêtre d’autorisation expirée
      if (!allowUntil || now >= allowUntil) {
        this.addLog?.(
          `[deeplink] blocked (allow window expired) reason=${reason} now=${now} allowUntil=${allowUntil}`
        );
        return;
      }

      // ⛔ Une seule ouverture par run
      if (typeof runId === 'number' && this.__dlOpenedForRun === runId) {
        this.addLog?.(`[deeplink] skip (run-locked) reason=${reason} runId=${runId}`);
        return;
      }

      // ⛔ Garde globale anti hard reload / cancel récent
      try {
        const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0');
        if (Number.isFinite(sup) && now < sup) {
          this.addLog?.(
            `[deeplink] global-suppress (${sup - now}ms left) reason=${reason} url=${url}`
          );
          return;
        }
      } catch { /* noop */ }

      // ⛔ Validation de l’URL
      if (!url.includes(':')) {
        this.addLog?.(
          `[deeplink] skip (suspicious url) reason=${reason} url=${String(url)}`
        );
        return;
      }


      // Throttle anti-spam court terme (2.5s)
      const sameUrl = url === this.__dlLast?.url;
      const within = now - (this.__dlLast?.ts || 0) < 2500;
      const bypassThrottle =
        typeof runId === 'number' && this.__dlOpenedForRun !== runId;

      if (this.__dlLock && !bypassThrottle) {
        this.addLog?.(`[deeplink] skip (locked) reason=${reason} url=${url}`);
        return;
      }

      if (sameUrl && within && !bypassThrottle) {
        this.addLog?.(
          `[deeplink] skip (throttled ${now - (this.__dlLast?.ts || 0)}ms) reason=${reason}`
        );
        return;
      }

      // ✅ Pose des marqueurs
      this.__dlLock = true;
      this.__dlLast = { url, ts: now };
      if (typeof runId === 'number') this.__dlOpenedForRun = runId;

      // 🚀 Ouverture réelle du deeplink
      this.addLog?.(`[deeplink] open (${reason}) → ${url}`);
      window.open(url, '_blank');

      // 🔓 Libération du lock quand la fenêtre reprend le focus ou après 2.5s
      const release = () => { this.__dlLock = false; };
      const onVisible = () => {
        if (!document.hidden) {
          release();
          document.removeEventListener('visibilitychange', onVisible);
        }
      };

      document.addEventListener('visibilitychange', onVisible, { once: true });

      setTimeout(() => {
        release();
        document.removeEventListener('visibilitychange', onVisible);
      }, 2500);

    } catch (e: any) {
      this.__dlLock = false;
      this.addLog?.(`[deeplink] open error: ${e?.message || e}`);
    }
  }


  private initVisualViewportSpacer() {
    const vv = (window as any).visualViewport as VisualViewport | undefined;
    if (!vv) return;
    this._vvSpacerEl = document.createElement('div');
    this._vvSpacerEl.style.width = '100%';
    this._vvSpacerEl.style.height = '0px';
    this._vvSpacerEl.style.pointerEvents = 'none';
    document.body.appendChild(this._vvSpacerEl);

    const handler = () => {
      const bottomInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      if (this._vvSpacerEl) this._vvSpacerEl.style.height = `${bottomInset}px`;
    };
    vv.addEventListener('resize', handler);
    vv.addEventListener('scroll', handler);
    handler();

    this._vvCleanup = () => {
      vv.removeEventListener('resize', handler);
      vv.removeEventListener('scroll', handler);
    };
  }

  private teardownVisualViewportSpacer() {
    try { this._vvCleanup?.(); } finally { this._vvCleanup = undefined; }
    if (this._vvSpacerEl?.parentNode) this._vvSpacerEl.parentNode.removeChild(this._vvSpacerEl);
    this._vvSpacerEl = undefined;
    // Safety: s’assurer que le body n’est pas resté “fixed”
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
  }

  private _scrollUnlockSeq = 0;
  closeQuote() {
    this.unlockScrollAll('closeQuote');
    this.logAltState('closeQuoteWithReason:enter');
    this.quote = null;
    // Optionnel mais propre : on nettoie l’état de validation
    this.swapDisabled = false;
    this.swapReasons = [];
    this.bridgeStatus = 'idle';
    this.bridgeHash = null;
    this.bridgeError = null;


  }




  private unlockScrollAll(reason: string) {
    const seq = ++this._scrollUnlockSeq;
    try {
      const body = document.body as HTMLBodyElement;
      const html = document.documentElement as HTMLElement;

      // 0) Restore overscroll (pull-to-refresh / rubber-band)
      try {
        html.style.overscrollBehavior = '';
        body.style.overscrollBehavior = '';
        // bonus iOS feel (defensive)
        (body.style as any).webkitOverflowScrolling = '';
      } catch { }

      // 1) Unlock the "overflow-hidden" lock
      try { this.lockBodyScroll(false); } catch { }

      const before = {
        htmlOverflowHidden: html.classList.contains('overflow-hidden'),
        htmlOverscroll: html.style.overscrollBehavior || '',
        bodyOverscroll: body.style.overscrollBehavior || '',
        bodyPos: body.style.position || '',
        bodyTop: body.style.top || '',
        bodyLeft: body.style.left || '',
        bodyRight: body.style.right || '',
        bodyWidth: body.style.width || '',
        scrollY: window.scrollY || 0,
      };

      // 2) Unlock "body fixed"
      let restored = false;
      const topStr = (body.style.top || '').trim();
      const wasFixed = (body.style.position || '') === 'fixed';

      if (wasFixed) {
        let y = 0;
        const m = topStr.match(/^(-?\d+)(px)?$/);
        if (m) y = Math.abs(parseInt(m[1], 10)) || 0;

        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';

        window.scrollTo(0, y);
        restored = true;
      } else {
        if (body.style.top || body.style.left || body.style.right || body.style.width) {
          body.style.top = '';
          body.style.left = '';
          body.style.right = '';
          body.style.width = '';
        }
      }

      // 3) Re-restore overscroll AGAIN after style flips (some flows re-apply)
      try {
        html.style.overscrollBehavior = '';
        body.style.overscrollBehavior = '';
        (body.style as any).webkitOverflowScrolling = '';
      } catch { }

      const after = {
        htmlOverflowHidden: html.classList.contains('overflow-hidden'),
        htmlOverscroll: html.style.overscrollBehavior || '',
        bodyOverscroll: body.style.overscrollBehavior || '',
        bodyPos: body.style.position || '',
        bodyTop: body.style.top || '',
        restored,
        scrollY: window.scrollY || 0,
      };

      this.addLog?.(
        `[scroll][unlock] seq=${seq} reason=${reason} | ` +
        `before=${JSON.stringify(before)} after=${JSON.stringify(after)}`
      );
    } catch (e: any) {
      this.addLog?.(`[scroll][unlock][error] reason=${reason} | ${e?.message || e}`);
    }
  }




  ngOnDestroy() {
    this.lockBodyScroll(false);
    try { this.teardownVisualViewportSpacer(); } catch { }
    try {
      const vv = (window as any).visualViewport;
      if (vv && this._vvHandlersAttached) {
        vv.removeEventListener('resize', this._onVvResize);
        vv.removeEventListener('scroll', this._onVvResize);
        this._vvHandlersAttached = false;
      }
    } catch { }
    try { this._tpcSellSub?.unsubscribe(); } catch { }
    try { this._tpcBuySub?.unsubscribe(); } catch { }


    // cleanup legacy connect hooks
    try {
      for (const s of (this._legacyConnectSubs || [])) {
        try { s?.unsubscribe?.(); } catch { }
      }
      this._legacyConnectSubs = [];
    } catch { }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  async ngOnInit(): Promise<void> {
    this.allChainIds = [1, 137, 42161, 56];

    // 🧹 APEX: reset complet du gate WC au boot du Bridge
    try {
      sessionStorage.setItem('st/allowWcDeeplinkUntil', '0');
      sessionStorage.setItem('st/allowWcRunId', '0');
      // On laisse "deny-by-default" tant que preDeeplinkAnnounce n'a pas parlé
      this.addLog?.('[ApexInit][bridge] WC deeplink gate reset (deny-by-default)');
    } catch { }
    // ─────────────────────────────────────────────────────────────
    // Installation d'une sonde globale pour intercepter window.open
    // ─────────────────────────────────────────────────────────────

    const w: any = window as any;
    if (!(w as any).__openProbeInstalled) {
      (w as any).__openProbeInstalled = true;
      const origOpen = w.open.bind(w);
      w.open = (url: string, target?: string, feat?: string) => {
        try {
          const allow = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0');
          const allowRun = Number(sessionStorage.getItem('st/allowWcRunId') || '0');
          const now = Date.now();
          if (!Number.isFinite(allow) || now >= allow) {
            console.warn(`[deeplink][probe] BLOCK url=${url} reason=deny-by-default allowRunId=${allowRun}`);
            return null;
          }
          const match = typeof allowRun === 'number' && allowRun > 0;
          if (match && !String(url).includes('metamask://') && !String(url).includes('wc?')) {
            console.warn(`[deeplink][probe] BLOCK url=${url} reason=not-wallet-link allowRunId=${allowRun}`);
            return null;
          }
          console.log(`[deeplink][probe] ALLOW url=${url} allowRunId=${allowRun}`);
          // One-shot: clear immédiatement après ouverture
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
          sessionStorage.removeItem('st/allowWcRunId');
          return origOpen(url, target, feat);
        } catch (e) {
          console.error(`[deeplink][probe] EXC ${e}`);
          return origOpen(url, target, feat);
        }
      };
      this.addLog?.('[open-probe] installed (ngOnInit)');
    } else {
      this.addLog?.('[open-probe] already installed (ngOnInit)');
    }

    // ─────────────────────────────────────────────────────────
    // Pont global pour display_uri → wallet.wcUri$
    // ─────────────────────────────────────────────────────────
    try {
      (window as any).__onWcDisplayUri = (uri: string) => {
        const safe = uri || '';
        (window as any)._wcLastUri = safe; // 🔍 trace brute globale

        this.addLog?.(
          `[wc][display_uri] received | len=${safe.length} | head=${safe.slice(0, 32)}…`
        );

        // 🧪 Voir ce que AppKit a dans sa modale au moment du display_uri
        try {
          const wAny: any = window as any;
          this.addLog?.(
            '[wc][display_uri][SAFE] ' +
            safeJson(
              {
                uri: safe,
                appKitModalKeys: Object.keys(wAny.appKitModal || {}),
                appKitModal: wAny.appKitModal,
                lastAppkitDisplayUri: wAny._appkit_last_display_uri,
              },
              1
            )
          );
        } catch (e: any) {
          this.addLog?.('[wc][display_uri][SAFE] error ' + (e?.message || e));
        }

        // 📝 Persistance pour le restore / wcSync
        try {
          sessionStorage.setItem('st/wcLastUri', safe);
        } catch {
          this.addLog?.('[wc][display_uri] failed to persist st/wcLastUri');
        }

        try {
          this.wallet.wcUri$.next(safe || null);
          this.addLog?.('[wc][display_uri] pushed into wallet.wcUri$');
        } catch (err: any) {
          this.addLog?.(
            `[wc][display_uri] push error | ${err?.message ?? err}`
          );
        }
      };

      this.addLog?.('[wc][display_uri] hook installed in ngOnInit (bridge)');
    } catch {
      // no-op
    }

    // au tout début de ngOnInit()
    this.initVisualViewportSpacer();

    this._installQuotePropDebugHook();
    let skipDeeplinkOnce = false;
    let suppressWcUriUntil = 0;
    try {
      skipDeeplinkOnce = sessionStorage.getItem('skipWcDeeplinkOnce') === '1';
      if (skipDeeplinkOnce) sessionStorage.removeItem('skipWcDeeplinkOnce');

      const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0');
      suppressWcUriUntil = Number.isFinite(sup) ? sup : 0;
    } catch { }


    this.installWindowOpenProbe('ngOnInit');
    if (!this.buyChainId) {
      this.buyChainId = this.chainId ?? 1;
    }
    // 1) Récupérer l’état SSR si présent
    this._ssrTokens = this.ts.get(TOKENS_SSR_KEY, null as any);
    this._ssrChainId = this.ts.get(CHAIN_SSR_KEY, null as any);
    this.route.queryParamMap.subscribe(p => {
      if (p.get('debug') === '1') {
        this.showDebug = true;
        this.addLog('🪵 Debug mode enabled via ?debug=1');
      }
    });
    const pending = this.loadPendingSwap?.();
    if (pending?.hash && Number.isFinite(pending.chainId)) {
      this.addLog(`🧯 [boot] pending swap found → resume watch ${pending.hash}`);
      // ne ferme pas l’UI; remet en pending et surveille
      try { await this.watchSwapReceiptUntilFinal(pending.hash, pending.chainId); } catch { }
    }
    if (Array.isArray(this._ssrTokens) && this._ssrTokens.length > 0) {
      // ✅ Reuse SSR → pas de refetch
      console.info('[Client] tokens reused from SSR:', this._ssrTokens.length);

      this.allTokens = this._ssrTokens;     // ⚠️ adapte si ton backing store a un autre nom
      this.tokensLoaded = true;

      // Chaîne initiale: priorité SEO, sinon SSR, sinon 1
      const initialChain = this.seoChainId ?? this._ssrChainId ?? 1;
      if (!this.chainId) this.chainId = initialChain;
      this.chainInfo = CHAIN_MAP[this.chainId] ?? null;
      this.swapApi.setChainId(this.chainId);

      // Normalisation + listes + popular + (balances si address déjà connue)
      this.refreshTokensForChain();

    } else {
      // ❌ Pas de SSR → fallback client (appel unique)
      console.info('[Client] no SSR tokens → fallback to client fetch');

      this.swapApi.getAvailableTokens().subscribe({
        next: tokens => {
          this.allTokens = tokens ?? [];
          this.tokensLoaded = true;

          // Si aucune chaîne fixée, prends SEO si dispo, sinon 1
          if (!this.chainId) {
            const cid = this.seoChainId ?? 1;
            this.chainId = cid;
            this.buyChainId = cid;
            this.chainInfo = CHAIN_MAP[cid] ?? null;
            this.swapApi.setChainId(cid);
            console.log('[INIT] chainId initialisé via', this.seoChainId ? 'SEO' : 'fallback', '→', cid);
          }
          this.applyHotStartDefaults(this.chainId!);
          this.refreshTokensForChain();


          this.initBuyCacheBindings();
          // 👉 si tu as des "defaults UI" (USDC/ETH, nearby lists…), garde ton bloc tel quel ici.
        },
        error: err => console.error('Erreur récupération tokens :', err)
      });
    }

    // 2) Non-bloquant après paint (client only)
    if (isPlatformBrowser(this.platformId)) {
      if (this.takerAddress) {
        this.balancesLoading = true;
        this.loadBalancesOptimized().finally(() => this.balancesLoading = false);
      } else {
        // pas d’adresse → pas de chargement de balances, enlève le skeleton
        this.balancesLoading = false;
      }
    }
    const skip = localStorage.getItem('st/skipAutoRestoreOnce') === '1';
    const eth = (window as any).ethereum;
    const ua = navigator.userAgent || '';

    this.isMMInApp = !!eth?.isMetaMask && /MetaMaskMobile/i.test(ua);
    this.hasMMExt = !!eth?.isMetaMask && !/MetaMaskMobile/i.test(ua);
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(ua);

    // Desktop sans MetaMask → init WalletConnect v2
    if (!this.isMobile && !this.hasMMExt) {
      await this.wc2.init('8d74b0ff39c361ecaa9c3dd96ac0055c');
    }

    // Address → ferme la modale WC si connecté
    this.wallet.address$.subscribe(addr => {
      if (addr) {
        this.showWcModal = false;
        this._hideWcModal('wallet-connected');
        this.wcUri = '';
      }
    });

    // Devise & taux fiat
    // Devise & taux fiat
    const savedCurrency = localStorage.getItem('currency');
    if (savedCurrency) this.defaultFiat = savedCurrency;

    this.fiatLoading = true;
    this.price.fetchFiatRates().subscribe({
      next: rates => {
        this.fiatRates = rates;
        this.fiatLoading = false;      // ✅ débloque l’affichage
      },
      error: err => {
        console.warn('[fiat] fetchFiatRates failed', err);
        this.fiatRates = { USD: 1 };   // petit fallback
        this.fiatLoading = false;      // ✅ ne laisse pas l’UI bloquée
      }
    });


    // ---- (1) chainId$ : ne pas écraser le réseau imposé par le SEO tant que lock actif
    this.sub = this.wallet.chainId$.subscribe(id => {
      this.zone.run(() => {
        this.addLog(`[wallet] chainId$ emitted → ${id}`);
        if (this.lockChainToSeo && this.seoChainId != null) {
          if (id === this.seoChainId) {
            this.lockChainToSeo = false;        // le wallet a rejoint le réseau SEO → on déverrouille
          } else {
            this.addLog(`[wallet] chainId ignored due to SEO lock (seoChainId=${this.seoChainId}, got=${id})`);
            return;                              // on ignore tant que le wallet est sur un autre réseau
          }
        }
        const prev = this.chainId;
        this.chainId = id;
        this.chainInfo = id ? CHAIN_MAP[id] ?? null : null;
        this.swapApi.setChainId(id);
        this.refreshTokensForChain();
        this.refreshNativeBalance();
        this.cd.detectChanges();
        this.addLog(`[wallet] chainId set | prev=${prev ?? 'null'} now=${id}`);


      });
    });

    // ---- (2) wallet address
    this.wallet.address$.subscribe(addr => {
      this.addLog(`[wallet] address$ emitted → ${addr || '(null)'}`);
      const prev = this.takerAddress;
      this.takerAddress = addr;

      if (addr) {
        this.balancesLoading = true;
        this.loadBalancesOptimized().finally(() => this.balancesLoading = false);
        this.refreshNativeBalance();

        this.initBuyCacheBindings();
        this.addLog(`[wallet] takerAddress set | prev=${prev || '(null)'} now=${addr}`);
        if (this.takerAddress && this.chainId != null) {
          console.log(`portfolio.warmUp`);
          this.portfolio.warmUp(this.takerAddress, this.chainId, this.allChainIds);




          this.portfolio.ownedTokens$(this.takerAddress, this.chainId).subscribe(list => {
            this.userCachedTokens = list;                                // ✅ mêmes clés / même variable
          });

          // Soldes (patches) → fusion dans tokenBalances
          this.portfolio.tokenBalances$(this.takerAddress, this.chainId).subscribe(patch => {
            Object.assign(this.tokenCachedBalances, patch);              // ✅ mêmes clés "<addr>_<cid>"
          });
        }
      } else {
        // reset propre si déconnexion
        this.tokenBalances = {};
        this.buyTokenBalances = {};
        this.userTokens = [];
        this.userBuyTokens = [];
        this.balancesLoading = false;
        this.currentNativeBalanceWei = 0n;
        this.addLog('[wallet] cleared state after disconnect');
      }
    });


    // ---- (3) WalletConnect URI (QR / deep-link)
    this.wallet.wcUri$.subscribe(uri => {
      this.wcUri = uri ?? '';
      // Parité Swap: show/hide via helpers (phase=tx par défaut)
      if (uri) {
        // runId best-effort (si tu as un compteur run, mets-le ici). Sinon 0.
        /*                    this._showWcModalForPhase('tx', 'wc-uri', 0);*/
      } else {
        this._hideWcModal('wc-uri-cleared');
      }
      this.addLog(`[wc][uri$] got=${!!uri} ${uri ? '| len=' + uri.length : ''}`);

      // (legacy) skip exact one-shot
      if (skipDeeplinkOnce) {
        this.addLog('[deeplink] skip once due to cancel/hard-reload');
        skipDeeplinkOnce = false;
        return;
      }

      // ⛔ NEW: cooldown temporel — ignore toutes les émissions tant que la fenêtre est active
      if (Date.now() < suppressWcUriUntil) {
        this.addLog(`[deeplink] suppressed by cooldown (${suppressWcUriUntil - Date.now()}ms left)`);
        return;
      }

      // ✅ Bridge-like: au boot on n'auto-ouvre PAS MetaMask.
      // On affiche la modale (showWcModal=true) et on laisse l’utilisateur cliquer "Connect".
      if (uri) {
        this.addLog('[wc][uri$] modal only (no auto-deeplink)');
      }
    });

    // ---- (3b) Restore wcUri depuis sessionStorage (même contrat que Swap)
    try {
      const cached = sessionStorage.getItem('st/wcLastUri') || '';
      if (cached && /^wc:/i.test(cached)) {
        this.addLog?.(
          `[wc][uri$][restore] reusing cached wcUri from sessionStorage | len=${cached.length}`
        );
        (this as any)._wcLastUri = cached;
        this.wcUri = cached;
        (this as any)._wcUri$?.next?.(cached);
      } else {
        this.addLog?.('[wc][uri$][restore] no cached wcUri');
      }
    } catch {
      this.addLog?.('[wc][uri$][restore] error reading sessionStorage');
    }

    // ---- (4) Restauration session locale
    const savedWallet = !skip ? localStorage.getItem('wallet') : null;

    if (savedWallet) this.takerAddress = savedWallet;

    if (!modal) initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c');
    const last = loadSimpleSession();
    if (last) {
      this.setChain(last.chainId);              // ⚠️ n’affirme pas la connexion provider
      this.isConnected = false;
    }

    this.subscribeEvmChanges();
    void this.restoreSessionDocStyle();
    void this.restoreSessionIfAny();

    // ---- (5) Chargement des tokens
    this.swapApi.getAvailableTokens().subscribe({
      next: tokens => {
        this.allTokens = tokens;
        this.tokensLoaded = true;

        // Si aucun chainId n’est fixé, prends SEO si dispo, sinon 1 (Ethereum)
        if (!this.chainId) {
          const forced = this.seoChainId;
          const cid = forced ?? 1;
          this.chainId = cid;
          this.chainInfo = CHAIN_MAP[cid];
          this.swapApi.setChainId(cid);
          console.log('[INIT] chainId initialisé via', forced ? 'SEO' : 'fallback', '→', cid);
        }
        const savedBuy = Number(localStorage.getItem('bridge:lastBuyChainId') || '') || NaN;
        this.buyChainId = Number.isFinite(savedBuy) ? savedBuy : (this.chainId ?? 1);
        this.refreshTokensForChain();

        // 🔌 Bind des flux cache (SELL/BUY) une fois qu’on connaît les chainIds


        // Defaults UI (gardés, n'écrasent pas une sélection valide)
        const defaultSellSymbol = 'USDC';
        const defaultBuySymbol = 'ETH';  // garde ETH si c’est ton buy par défaut

        const sellValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
        const buyValid = this.availableBuyTokens.some(t => t.symbol === this.buyTokenSymbol);

        if (!sellValid) {
          console.log('[defaultsUI] apply SELL →', defaultSellSymbol);
          this.sellTokenSymbol = defaultSellSymbol;
        } else {
          console.log('[defaultsUI] keep SELL =', this.sellTokenSymbol);
        }

        if (!buyValid) {
          console.log('[defaultsUI] apply BUY →', defaultBuySymbol);
          this.buyTokenSymbol = defaultBuySymbol;
        } else {
          console.log('[defaultsUI] keep BUY =', this.buyTokenSymbol);
        }

        // Construire les listes autour de la sélection finale (sans la changer)
        const indexSell = this.availableTokens.findIndex(t => t.symbol === this.sellTokenSymbol);
        const indexBuy = this.availableTokens.findIndex(t => t.symbol === this.buyTokenSymbol);
        const getNearby = (i: number) => this.availableTokens.slice(Math.max(0, i - 10), i + 10);
        this.filteredSellTokens = getNearby(indexSell);
        this.filteredBuyTokens = getNearby(indexBuy);


        // Query params → pré-remplissage + auto-quote
        this.route.queryParams.subscribe((params: Params) => {
          const tokenIn = params['tokenIn'];
          const tokenOut = params['tokenOut'];
          const amountInRaw = params['amountIn'];

          // NEW: support fromChainId (fallback sur chainId)
          const fromChainIdRaw = params['fromChainId'] ?? params['chainId'];
          const fromChainId = Number(fromChainIdRaw);
          if (fromChainId && !Number.isNaN(fromChainId)) {
            this.setChain(fromChainId);              // met à jour chainId + chainInfo
            this.selectedNetwork = fromChainId;      // garde l’UI en phase
            this.swapApi.setChainId(fromChainId);
            this.refreshTokensForChain();
          }

          if (tokenIn) this.sellTokenSymbol = tokenIn;
          if (tokenOut) this.buyTokenSymbol = tokenOut;

          if (amountInRaw) {
            const amountIn = parseFloat(amountInRaw);
            if (!isNaN(amountIn) && amountIn > 0) this.sellAmount = amountIn.toString();
          }

          //if (this.sellTokenSymbol && this.buyTokenSymbol && this.sellAmount && (params['tokenIn'] || params['fromChainId'])) {
          //  this.fetchQuote();
          //}
        });


        // ---------- (6) SEO depuis la route parente (SeoLandingComponent) ----------
        const applyResolved = (resolved: ResolvedSeo | undefined) => {
          if (!resolved) return;

          // a) langue = celle du resolver (URL) → cohérence UI + SEO
          // utilitaire compact
          const getParam = (r: ActivatedRoute, k: string): string => {
            // 1) route courante
            const v1 = r.snapshot.paramMap.get(k);
            if (v1) return v1;

            // 2) parent direct
            const v2 = r.parent?.snapshot.paramMap.get(k);
            if (v2) return v2;

            // 3) premier enfant de la racine (au cas où)
            const v3 = r.root.firstChild?.snapshot.paramMap.get(k);
            return v3 ?? '';
          };

          // ---
          const urlLoc = getParam(this.route, 'locale').toLowerCase();
          console.log('locale from URL =', urlLoc || '(empty)');
          const loc = urlLoc || 'en'; // ou 'hi' si tu veux forcer un défaut
          this.translate.use(loc);
          localStorage.setItem('lang', loc);

          this.translate.use(loc);
          localStorage.setItem('lang', loc);

          // b) base i18n optionnelle (si tu utilises des clés)
          this.tBase = resolved.tKey ? `SEO_PAGES.${resolved.tKey}` : 'SEO_PAGES';

          // c) valeurs SEO (priorité aux textes fournis par le resolver)
          const title =
            resolved.page?.title ??
            this.translate.instant(`${this.tBase}.TITLE`) ??
            'Swap Tokens';

          const meta =
            resolved.page?.metaDescription ??
            this.translate.instant(`${this.tBase}.META`) ??
            'Swap instantané sur EVM (Polygon, Arbitrum, BSC, Ethereum).';

          const h1 =
            resolved.page?.h1 ??
            this.translate.instant(`${this.tBase}.H1`) ??
            'Swap Tokens (EVM)';

          const ed =
            resolved.page?.editorial ??
            this.translate.instant(`${this.tBase}.EDITORIAL`) ??
            'Comparez les meilleurs taux via notre agrégateur (Uniswap, 1inch, Paraswap…).';

          // d) UI
          this.editorialH1 = h1;
          this.editorialBody = ed;

          // e) Balises <title> + <meta> + FAQ JSON-LD
          this.appSeo.apply(
            {
              slug: resolved.slug,
              tKey: resolved.tKey,
              ctaParams: resolved.ctaParams,
              title,
              metaDescription: meta,
              h1,
              editorial: ed,
              faq: resolved.page?.faq ?? []
            } as any,
            this.seoContent.getDefaults(),
            window?.location?.href || resolved.canonicalPath
          );
          this.faqJsonLd = this.seoContent.buildFaqJsonLd(
            resolved,
            window?.location?.href || resolved.canonicalPath
          );

          // f) CTA de la page SEO (sans écraser les choix user / query params)
          if (resolved.ctaParams || resolved.page?.ctaParams) {
            this.applyCtaDefaultsFromSeo(resolved);
          }
        };

        // Lecture réactive des données du resolver (mise à jour quand :locale/:slug changent)
        this.route.parent?.data.subscribe(d => {
          // Le resolver met son résultat sous la clé 'seo'
          const wrap = d['seo'] as UniversalSeoResolved | ResolvedSeo | null | undefined;

          // Supporte les deux cas: wrapper {type, resolved} ou ResolvedSeo direct
          const resolved: ResolvedSeo | undefined =
            wrap && 'resolved' in (wrap as any) ? (wrap as any).resolved as ResolvedSeo
              : (wrap as ResolvedSeo | undefined);

          if (resolved) {
            this.seoResolved = resolved;
            applyResolved(resolved);
          } else if (this.seoPage && this.swapPrefill) {
            // fallback @Input (comme tu l’avais)
            const urlLoc = (this.route.parent?.snapshot.paramMap.get('locale') || '').toLowerCase();
            const loc = urlLoc || 'en';
            const fake: ResolvedSeo = {
              locale: 'hi',
              slug: '',
              tKey: this.tBase?.split('.').pop() || '',
              ctaParams: this.swapPrefill!,
              canonicalPath: window?.location?.pathname || '/',
              page: {
                tKey: '',
                ctaParams: this.swapPrefill!,
                title: this.seoPage?.title,
                metaDescription: this.seoPage?.metaDescription,
                h1: this.seoPage?.h1,
                editorial: this.seoPage?.editorial,
                faq: this.seoPage?.faq
              }
            };
            this.seoResolved = fake;
            applyResolved(fake);
          } else {
            console.warn('[SEO] ni parent.data.seo ni @Input seoPage/swapPrefill → UI par défaut');
          }
        });
        // --------------------------------------------------------------------------
      },
      error: err => console.error('Erreur récupération tokens :', err)
    });


    const vv = (window as any).visualViewport;
    if (vv && !this._vvHandlersAttached) {
      vv.addEventListener('resize', this._onVvResize);
      vv.addEventListener('scroll', this._onVvResize);
      this._vvHandlersAttached = true;
      // première mesure
      this._onVvResize();
    }
  }







  // 🔹 Ajoute ça dans ton component (ou un utils partagé)
  private getSimFailLabel(err: any): string {
    try {
      const raw: string | undefined =
        err?.error?.data ?? err?.data ?? err?.info?.error?.data ?? err?.reason;

      // Panic(uint256)
      if (typeof raw === 'string' && raw.startsWith('0x4e487b71')) {
        const code = Number(BigInt('0x' + raw.slice(74, 138)));
        const table: Record<number, string> = {
          0x01: 'assertion', 0x11: 'overflow/underflow', 0x12: 'div by zero',
          0x21: 'invalid enum', 0x22: 'bytes OOB', 0x31: 'pop empty array',
          0x32: 'array OOB', 0x41: 'alloc error', 0x51: 'abi.decode OOB'
        };
        return `panic:${table[code] ?? 'unknown'}`;
      }

      // Error(string)
      if (typeof raw === 'string' && raw.startsWith('0x08c379a0')) {
        try {
          const msg = ethers.toUtf8String('0x' + raw.slice(138));
          // tronquer proprement si trop long
          const short = msg.length > 80 ? msg.slice(0, 77) + '…' : msg;
          return `revert:${short}`;
        } catch { /* ignore */ }
      }

      // Custom errors usuelles (nom seul, sans args)
      try {
        const ifc = new ethers.Interface([
          'error InsufficientOutput()',
          'error SlippageExceeded()',
          'error TooLittleReceived()',
          'error TransferFailed()',
          'error InsufficientAllowance()',
          'error InvalidPermit()',
          'error SignatureExpired()',
        ]);
        const dec = ifc.parseError(raw as any);
        if (dec?.name) return `revert:${dec.name}`;
      } catch { /* ignore */ }

      // Messages provider courts si dispo
      if (typeof err?.error?.message === 'string') return err.error.message;
      if (typeof err?.message === 'string') return err.message;
    } catch { /* ignore */ }

    return 'execution reverted';
  }


  private async refreshNativeBalance(): Promise<void> {
    const TAG = '[swap][nativeBalance]';
    try {
      const addr = this.takerAddress;
      const cid = this.chainId;

      // 0) Garde-fous
      if (!addr || !cid) {
        this.currentNativeBalanceWei = 0n;
        this.addLog(`${TAG} skip: missing addr/chainId | addr=${!!addr} cid=${cid ?? 'null'}`);
        return;
      }

      // 1) Provider valide ?
      const prov = this.provider as unknown as ethers.Provider | null;
      const hasGetBal = !!prov && typeof (prov as any).getBalance === 'function';
      if (!hasGetBal) {
        this.currentNativeBalanceWei = 0n;
        this.addLog(`${TAG} skip: provider invalid (no getBalance) | provider=${!!prov}`);
        return;
      }

      // 2) Contexte chaîne (pour lecture rapide des logs)
      const sym =
        cid === 137 ? 'POL' :
          cid === 42161 ? 'ETH' :
            cid === 56 ? 'BNB' :
              'ETH';

      // 3) Fetch + chronométrage
      const t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
      this.addLog(`${TAG} fetching… addr=${addr} | chainId=${cid} (${sym})`);
      let bal = await (prov as any).getBalance(addr);
      const t1 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
      const ms = Math.round(t1 - t0);

      // 4) Normalisation -> bigint
      const asBig = typeof bal === 'bigint' ? bal : BigInt(bal ?? 0);
      this.currentNativeBalanceWei = asBig;

      // 5) Lecture humaine (⚠️ seulement pour debug/affichage)
      const human = (() => {
        try { return ethers.formatEther(asBig); } catch { return '0'; }
      })();

      // 6) Logs détaillés
      this.addLog(`${TAG} ok in ${ms}ms | wei=${asBig.toString()} | ~${human} ${sym}`);

      // 7) Forcer le rafraîchissement UI
      this.cd.detectChanges();
    } catch (e: any) {
      console.warn(`${TAG} failed`, e);
      this.addLog(`${TAG} error: ${e?.message ?? e}`);
      this.currentNativeBalanceWei = 0n;
    }
  }

  private async attachEthersProvider(eip1193: any, reason: string = 'unknown') {
    if (!eip1193 || typeof eip1193.request !== 'function') {
      console.warn('[attachEthersProvider] Provider invalide');
      return;
    }

    const TAG = '[attachEthersProvider]';

    try {
      // ✅ Singleton attach: provider remonte indépendamment de la quote.
      // On évite les re-attach concurrent et on ignore les doublons (même raw provider).
      if (this._rawProviderRef === eip1193 && !!this.provider) {
        this.addLog?.(`[wallet] attachEthersProvider skip (same raw) | reason=${reason}`);
        return;
      }

      if (this._attachProviderSeq) {
        this.addLog?.(`[wallet] attachEthersProvider join (in-flight) | reason=${reason}`);
        // petite attente active (max ~2s) pour éviter les races
        for (let i = 0; i < 80; i++) {
          await new Promise((r) => setTimeout(r, 25));
          if (!this._attachProviderSeq) break;
        }
        if (this._rawProviderRef === eip1193 && !!this.provider) return;
      }

      this._attachProviderSeq = 1;
      this._rawProviderRef = eip1193;

      const wait = (ms: number) => new Promise((r) => setTimeout(r, ms));
      const toHex = (n: number) => '0x' + n.toString(16);

      // ─────────────────────────────────────────────
      // 1️⃣ Log et analyse du provider brut
      // ─────────────────────────────────────────────
      this.addLog?.(`${TAG} raw=${!!eip1193} has.request=${typeof eip1193?.request === 'function'} isMM=${!!eip1193?.isMetaMask} isWC=${!!eip1193?.isWalletConnect}`);
      console.log(`${TAG} Raw provider`, eip1193);

      // ─────────────────────────────────────────────
      // 2️⃣ Création du provider ethers
      // ─────────────────────────────────────────────
      this.provider = new BrowserProvider(eip1193, 'any');
      this.rawProvider = eip1193;

      // Installe les sondes globales (RPC debug)
      this.installRpcDebugProbe?.('attach');
      this.installRpcDebugProbeOnWindow?.('attach');
      this.installWindowOpenProbe('attach');

      // ─────────────────────────────────────────────
      // 3️⃣ Sondes sur provider interne (inner) d’ethers
      // ─────────────────────────────────────────────
      try {
        const inner: any = (this.provider as any)?.provider ?? null;
        if (inner && !inner.__rpcDebugProbeInstalled) {
          const SENSITIVE = new Set([
            'wallet_switchEthereumChain',
            'wallet_addEthereumChain',
            'eth_requestAccounts',
            'eth_sendTransaction',
            'eth_sign',
            'personal_sign',
            'eth_signTypedData',
            'eth_signTypedData_v3',
            'eth_signTypedData_v4'
          ]);
          const tag = '[rpc][attach-inner]';

          if (typeof inner.request === 'function') {
            const orig = inner.request.bind(inner);
            inner.request = async (a: { method: string; params?: any[] }) => {
              if (a?.method && SENSITIVE.has(a.method)) {
                this.addLog?.(`${tag} ${a.method} params=${JSON.stringify(a.params ?? [])}`);
              }
              return orig(a);
            };
          }

          if (typeof inner.send === 'function') {
            const s0 = inner.send.bind(inner);
            inner.send = async (m: string, p?: any[]) => {
              if (m && SENSITIVE.has(m)) {
                this.addLog?.(`${tag} ${m} params=${JSON.stringify(p ?? [])}`);
              }
              return s0(m, p);
            };
          }

          inner.__rpcDebugProbeInstalled = true;
          this.addLog?.('[rpc] inner provider probe installed');
        }
      } catch (err) {
        this.addLog?.(`${TAG} inner probe install failed: ${err}`);
      }

      // ─────────────────────────────────────────────
      // 4️⃣ Écouteurs EIP-1193 (événements natifs)
      // ─────────────────────────────────────────────
      try {
        const raw = eip1193;
        const ev = (name: string, fn: any) => {
          try {
            (raw?.removeListener ?? raw?.off)?.(name, fn);
            (raw?.on ?? raw?.addListener)?.(name, fn);
          } catch { }
        };
        ev('accountsChanged', (a: any) => this.addLog?.(`[evm][accountsChanged] ${JSON.stringify(a)}`));
        ev('chainChanged', (c: any) => this.addLog?.(`[evm][chainChanged] ${c}`));
        ev('connect', (i: any) => this.addLog?.(`[evm][connect] ${JSON.stringify(i)}`));
        ev('disconnect', (e: any) => this.addLog?.(`[evm][disconnect] ${JSON.stringify(e)}`));
        this.addLog?.('[rpc] EIP-1193 event listeners attached');
      } catch (err) {
        this.addLog?.(`${TAG} EIP-1193 events failed: ${err}`);
      }

      // ─────────────────────────────────────────────
      // 5️⃣ Récupération du signer / address / chainId
      // ─────────────────────────────────────────────
      const signer = await this.provider.getSigner();
      const address = await signer.getAddress();
      const net0 = await this.provider.getNetwork();
      const providerChainId0 = Number(net0?.chainId);

      // ✅ source of truth = UI desired chain (fallback to current chainId, then provider)
      const uiDesired = Number((this as any).desiredChainId ?? this.chainId ?? providerChainId0);

      this.addLog?.(`${TAG} network(before) providerChainId=${providerChainId0} uiDesired=${uiDesired} currentChainId=${this.chainId ?? 'null'}`);

            // Record wallet reality (do NOT let it override UI intent)
              try { (this as any).walletChainId = providerChainId0; } catch { }
            this.addLog?.(`${TAG} walletChainId=${(this as any).walletChainId ?? 'null'} desiredChainId=${(this as any).desiredChainId ?? 'null'}`);

      // Met à jour l’état du composant
      this.takerAddress = address;
      this.isConnected = true;

      // ✅ Do NOT let provider overwrite UI choice
      // (UI reste stable sur uiDesired)
      try { this.setChain(uiDesired, 'attach'); } catch { }

            // ✅ Swap-like behavior:
              // - NEVER force switch or disconnect on attach
              // - Keep UI chain = desiredChainId (if set), otherwise align to wallet chain once.
              const desired = Number((this as any).desiredChainId ?? NaN);
            if (Number.isFinite(desired) && desired > 0) {
                try { this.setChain(desired, 'auto'); } catch { }
                if (providerChainId0 !== desired) {
                    this.addLog?.(`${TAG} [chain-mismatch] attach keep UI | wallet=${providerChainId0} desired=${desired} (switch only on execute)`);
                 }
              } else {
                try { this.setChain(providerChainId0, 'attach'); } catch { }
              }

      // ✅ Only now we can proceed safely
      this.bindPortfolioIfReady('attachEthersProvider');
      this.addLog?.(`${TAG} ✅ connected addr=${address} chainId=${Number(this.chainId)}`);

      console.log(`${TAG} AVANT refresh: sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol}`);

      // 🔁 Premier refresh de balance post-connexion
      await this.refreshNativeBalance();
      this.addLog?.(`${TAG} balance refreshed after connect`);

      // Recharge les tokens et balances
      await this.refreshTokensForChain();
      console.log(`${TAG} APRÈS refreshTokensForChain: sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol}`);
      console.log(`${TAG} availableTokens=`, this.availableTokens.map(t => t.symbol));

      // Sélection des tokens par défaut seulement si rien ou invalide
      if (!this.availableTokens.some(t => t.symbol === this.sellTokenSymbol)) {
        const sellToken = this.getDefaultSellTokenForChain(Number(this.chainId ?? uiDesired));
        console.log(`${TAG} SELL invalide → fallback`, sellToken?.symbol);
        if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
      } else {
        console.log(`${TAG} SELL conservé =`, this.sellTokenSymbol);
      }

      console.log(`${TAG} availableBuyTokens=`, this.availableBuyTokens.map(t => t.symbol));
      if (!this.availableTokens.some(t => t.symbol === this.buyTokenSymbol)) {
        const buyToken = this.getDefaultBuyTokenForChain(Number(this.chainId ?? uiDesired));
        console.log(`${TAG} BUY invalide → fallback`, buyToken?.symbol);
        if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
      } else {
        console.log(`${TAG} BUY conservé =`, this.buyTokenSymbol);
      }

      console.log(`${TAG} FINAL: sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol}`);

      this.cd.detectChanges();

    } catch (err) {
      console.error('[attachEthersProvider] ❌ erreur', err);
      this.takerAddress = null;
      this.isConnected = false;
      this.provider = null;
    } finally {
      this._attachProviderSeq = 0;
      this._attachProviderPromise = null;
    }
  }






  private async restoreSessionIfAny(): Promise<void> {
    //if (this._suspendRestoreSession) {
    //  this.addLog?.(`[restoreSession] skip (suspended)`);
    //  return;
    //}


    // cleanup stale handles (safety)
    try { if (this._restoreSessionPollTimer) { clearInterval(this._restoreSessionPollTimer); } } catch { }
    try { this._restoreSessionUnsub?.(); } catch { }
    this._restoreSessionPollTimer = null;
    this._restoreSessionUnsub = null;
    const TAG = '[restoreSession]';

    // 🧨 "kill switch" for an execution already started:
    // each call captures a runId. Any suspend increments _restoreSessionRunId which invalidates this run.
    const runId = ++this._restoreSessionRunId;
    const isAborted = () => this._suspendRestoreSession || this._restoreSessionRunId !== runId;

    // Abortable sleep (so we can stop between retries immediately on connect CTA)
    const sleep = (ms: number) => new Promise<boolean>(resolve => {
      try {
        // if already aborted, resolve immediately
        if (isAborted()) return resolve(false);

        // cancel previous sleep if any (shouldn't happen, but keep it safe)
        try {
          if (this._restoreSessionSleepTimer) clearTimeout(this._restoreSessionSleepTimer);
          this._restoreSessionSleepTimer = null;
        } catch { /* no-op */ }
        try {
          if (this._restoreSessionSleepResolve) this._restoreSessionSleepResolve(false);
          this._restoreSessionSleepResolve = null;
        } catch { /* no-op */ }

        this._restoreSessionSleepResolve = resolve;
        this._restoreSessionSleepTimer = setTimeout(() => {
          this._restoreSessionSleepTimer = null;
          const r = this._restoreSessionSleepResolve;
          this._restoreSessionSleepResolve = null;
          r?.(!isAborted());
        }, ms);
      } catch {
        resolve(false);
      }
    });

    // 🔍 Lecture des flags (uniquement pour log/diag, on NE bloque PAS la restauration)
    let suppressWcUriUntil = 0;
    let suppressAutoRestoreUntil = 0;
    let skipAutoRestoreOnce = false;
    try {
      suppressWcUriUntil = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0') || 0;
      suppressAutoRestoreUntil = Number(localStorage.getItem('st/suppressAutoRestoreUntil') || '0') || 0;
      skipAutoRestoreOnce = localStorage.getItem('st/skipAutoRestoreOnce') === '1';
    } catch { /* no-op */ }

    this.addLog?.(`${TAG} boot-flags | supWcUriUntil=${suppressWcUriUntil} (${Math.max(0, suppressWcUriUntil - Date.now())}ms left) | supAutoRestoreUntil=${suppressAutoRestoreUntil} (${Math.max(0, suppressAutoRestoreUntil - Date.now())}ms left) | skipAutoRestoreOnce=${skipAutoRestoreOnce}`);

    // ✅ IMPORTANT : on NE bloque plus la restauration par cooldown ici.
    // Si tu veux consommer le one-shot "skipAutoRestoreOnce", on le loggue puis on le consomme,
    // mais on n'empêche pas la réhydratation silencieuse.
    if (skipAutoRestoreOnce) {
      this.addLog?.(`${TAG} skipAutoRestoreOnce present → consumed (but continuing silent restore)`);
      try { localStorage.removeItem('st/skipAutoRestoreOnce'); } catch { }
    }

    // 🔎 état global au démarrage (window.ethereum) + installation de la sonde si absente
    try {
      const winEth: any = (window as any)?.ethereum;
      this.addLog?.(`${TAG} boot | hasWindowEth=${!!winEth}`);
      if (winEth && !(winEth as any).__rpcDebugProbeInstalled) {
        this.installRpcDebugProbeOnWindow?.('restoreSession');
      }
    } catch { /* no-op */ }

    // 🧩 Hook post-attach : synchronise services + balance + sonde provider
    const afterAttach = async () => {
      try {
        this.addLog('[bridge][restoreSession] afterAttach()');
        this.isConnected = true;
        this.addLog(`[bridge][restoreSession] taker = ${this.takerAddress}`);
        if (this.takerAddress) this.wallet.address$.next(this.takerAddress);
        if (this.chainId) this.wallet.chainId$.next(this.chainId);
        await this.refreshNativeBalance();
        this.addLog?.(`${TAG} provider attached → synced + balance refreshed`);
        this.installRpcDebugProbe?.('restoreSession');


        this.syncIsConnectedWithWcLastUri('bridge/restore-afterAttach');
      } catch (e: any) {
        this.addLog?.(`${TAG} afterAttach error: ${e?.message ?? e}`);
      }
    };

    // 0) Stratégie doc-style : getProvider('eip155') × 5 (réhydratation silencieuse, SANS créer d'URI)
    if (typeof (modal as any).getProvider === 'function') {
      for (let i = 1; i <= 1; i++) {
        if (isAborted()) {
          this.addLog?.(`${TAG} aborted (suspended) before getProvider try #${i}`);
          return;
        }
        try {
          this.addLog?.(`${TAG} getProvider try #${i}`);
          const raw = await (modal as any).getProvider('eip155');
          const prov = raw?.provider ?? raw ?? null;

          if (isAborted()) {
            this.addLog?.(`${TAG} aborted (suspended) after getProvider await`);
            return;
          }

          if (prov && typeof (prov as any).request === 'function') {
            this.addLog?.(`${TAG} getProvider -> FOUND existing provider (silent reattach)`);
            await this.attachEthersProvider(prov);
            // 🔎 sonde sur le provider + window.ethereum
            this.installRpcDebugProbe?.('restoreSession');
            this.installRpcDebugProbeOnWindow?.('restoreSession');
            await afterAttach();
            return;
          } else {
            this.addLog?.(`${TAG} getProvider -> no provider (null or missing request)`);
          }
        } catch (e: any) {
          this.addLog?.(`${TAG} getProvider try #${i} failed: ${e?.message ?? e}`);
        }
        if (this._suspendRestoreSession) {
          this.addLog?.(`${TAG} abort (suspended) after getProvider try #${i}`);
          return;
        }
        if (!(await sleep(2000))) { this.addLog?.(`${TAG} aborted during backoff`); return; }
      }
    } else {
      this.addLog?.(`${TAG} getProvider not available on modal`);
    }
    if (isAborted()) { this.addLog?.(`${TAG} aborted (suspended) before legacy`); return; }
    // 1) Stratégie legacy : getWalletProvider('eip155') (toujours sans créer d'URI)
    try {
      if (typeof (modal as any).getWalletProvider === 'function') {
        this.addLog?.(`${TAG} getWalletProvider (legacy)`);
        const raw = await (modal as any).getWalletProvider('eip155');
        const prov = raw?.provider ?? raw ?? null;

        if (prov && typeof (prov as any).request === 'function') {
          this.addLog?.(`${TAG} legacy provider -> FOUND (silent reattach)`);
          await this.attachEthersProvider(prov);
          // 🔎 sonde sur le provider + window.ethereum
          this.installRpcDebugProbe?.('restoreSession');
          this.installRpcDebugProbeOnWindow?.('restoreSession');
          await afterAttach();
          return;
        } else {
          this.addLog?.(`${TAG} legacy provider -> none`);
        }
      } else {
        this.addLog?.(`${TAG} getWalletProvider not available on modal`);
      }
    } catch (e: any) {
      this.addLog?.(`${TAG} getWalletProvider error: ${e?.message ?? e}`);
    }
    if (isAborted()) { this.addLog?.(`${TAG} aborted (suspended) before fallback`); return; }
    // 2) Fallback : subscribeProviders (laisser WC v2 se réhydrater) + poll doux (60s)
    if (typeof (modal as any).subscribeProviders === 'function') {
      this.addLog?.(`${TAG} subscribeProviders armed (fallback)`);
      let pollTimer: any = null;

      const unsub = (modal as any).subscribeProviders((state: any) => {
        if (isAborted()) return;
        if (this._suspendRestoreSession) {
          this.addLog?.(`${TAG} subscribeProviders event ignored (suspended)`);
          return;
        }
        const prov = state?.['eip155']?.provider ?? state?.['eip155'] ?? null;
        this.addLog?.(`${TAG} subscribeProviders event → prov=${!!prov}`);
        if (!prov || typeof (prov as any).request !== 'function') return;

        try { unsub?.(); } catch { /* no-op */ }
        if (pollTimer) clearInterval(pollTimer);
        // clear handles
        this._restoreSessionPollTimer = null;
        this._restoreSessionUnsub = null;

        (async () => {
          try {
            this.addLog?.(`${TAG} subscribeProviders -> attaching silent provider`);
            await this.attachEthersProvider(prov);
            this.installRpcDebugProbe?.('restoreSession');
            this.installRpcDebugProbeOnWindow?.('restoreSession');
            await afterAttach();
          } catch (e: any) {
            this.addLog?.(`${TAG} subscribeProviders attach failed: ${e?.message ?? e}`);
          }
        })();
      });
      // store handles so suspendRestoreSession() can hard-stop them
      this._restoreSessionUnsub = unsub;
      // 🔁 Poll léger du state (2s × 30 ≈ 60s), sans générer d'URI
      let polls = 0;
      pollTimer = setInterval(async () => {
        polls++;
        if (isAborted()) {
          this.addLog?.(`${TAG} poll stopped (suspended)`);
          try { unsub?.(); } catch { }
          try { if (pollTimer) clearInterval(pollTimer); } catch { }
          this._restoreSessionPollTimer = null;
          this._restoreSessionUnsub = null;
          return;
        }
        try {
          const st = (modal as any).getState?.();
          const prov = st?.eip155?.provider ?? st?.eip155 ?? null;
          this.addLog?.(`${TAG} poll #${polls} → prov=${!!prov}`);

          if (prov && typeof (prov as any).request === 'function') {
            try { unsub?.(); } catch { /* no-op */ }
            if (pollTimer) clearInterval(pollTimer);
            this.addLog?.(`${TAG} poll -> attaching silent provider`);
            await this.attachEthersProvider(prov);
            this.installRpcDebugProbe?.('restoreSession');
            this.installRpcDebugProbeOnWindow?.('restoreSession');
            await afterAttach();
          } else if (polls >= 30) {
            try { unsub?.(); } catch { /* no-op */ }
            if (pollTimer) clearInterval(pollTimer);
            this.addLog?.(`${TAG} poll timeout (no provider after 60s)`);
          }
        } catch (e: any) {
          this.addLog?.(`${TAG} poll error: ${e?.message ?? e}`);
        }
      }, 2000);
      // store poll timer handle for hard-stop on CTA connect
      this._restoreSessionPollTimer = pollTimer;
      // ⛔ Très important : on ne tente PAS de "connect()" ici → donc pas de nouvelle session, pas d'URI, pas de deeplink.
      this.addLog?.(`${TAG} passive mode: will NOT initiate new pairing or wc uri at boot`);
      return;
    }

    // Si on arrive ici, aucune stratégie n'a trouvé de provider silencieux.
    this.addLog?.(`${TAG} no provider found (all strategies exhausted)`);
  }








  private async logWalletConnectStorage() {
    try {
      // 📦 Dump localStorage complet
      const lsKeys = Object.keys(localStorage);

      // 🎯 Dump des clés commençant par wc@2
      const wcKeys = lsKeys.filter(k => k.startsWith('wc@2'));
      wcKeys.forEach(k => {
      });

      // 📦 Dump IndexedDB pour WalletConnect v2
      if ('indexedDB' in window) {
        const dbs = await (indexedDB as any).databases?.();
        if (dbs) {
        } else {
        }

        // Ouvrir la DB du SignClient si présente
        const wcDbName = dbs?.find((d: any) => d.name?.includes('walletconnect'))?.name;

        if (wcDbName) {
          const request = indexedDB.open(wcDbName);
          request.onsuccess = () => {
            const db = request.result;
          };
          request.onerror = () => {
          };
        }
      } else {
      }
    } catch (err) {
    }
  }







  private async restoreSessionDocStyle() {
    try {
      if (!modal) return;

      await this.logWalletConnectStorage();

      // 📦 Log du contenu localStorage lié à WalletConnect / AppKit
      const wcKeys = Object.keys(localStorage).filter(k => k.startsWith('wc@2:'));
      const wcDump = wcKeys.map(k => `${k}=${localStorage.getItem(k)}`).join(' | ');


      const address = await modal.getAddress?.();
      const chainId = await modal.getChainId?.();
      const provider: any = await modal.getWalletProvider?.();



      if (address && provider?.request) {
        this.provider = new BrowserProvider(provider);
        this.addLog('resumeOpenProbe');
        this.resumeOpenProbe('session-restored');
        // this.takerAddress = address;
        this.isConnected = true;
        if (chainId != null) this.setChain(Number(chainId));
        this.cd.detectChanges();

      } else {

      }
    } catch (e: any) {

    }
  }
  private subscribeEvmChanges() {
    if (!modal?.subscribeProviders) return;


    modal.subscribeProviders((state: any) => {
      const evm = state?.['eip155'];
      if (!evm) return;

      if ('address' in evm) {
        this.takerAddress = evm.address ?? null;
        this.isConnected = !!evm.address;
      }
      if ('chainId' in evm && evm.chainId != null) {
        this.setChain(Number(evm.chainId));
      }
      this.cd.detectChanges();
    });
  }
  get hasInsufficientGasBuffer(): boolean {
    const nativeSymbol = this.getNativeTokenSymbol(this.chainId ?? 1);
    const isNativeToken = this.sellTokenSymbol === nativeSymbol;
    const balance = +this.getTokenBalance(this.sellTokenSymbol) || 0;
    const amount = +this.sellAmount || 0;
    const gas = Number(this.fullGasWei) / 1e18;

    if (!isNativeToken || !this.takerAddress || amount <= 0) return false;

    // Petite marge de sécurité de 5 %
    return (amount + gas * 1.05) > balance;
  }


  getNativeTokenSymbol(chainId: number): string {
    return {
      1: 'ETH',
      42161: 'ETH',
      137: 'MATIC',
      56: 'BNB'
      // … ajoute d'autres si besoin
    }[chainId] ?? 'ETH';
  }

  getTokenLabel(symbol: string): string {
    const key = 'TOKENS.' + symbol.toUpperCase();
    const translated = this.translate.instant(key);
    return translated !== key ? translated : symbol;
  }

  /* swap.component.ts */
  onCurrencyChanged(code: string) {
    this.defaultFiat = code;

    // Pas besoin de changer les prix en CAD ici :
    // garde des prix USD et laisse getSellFiatValue() convertir via fiatRates
    if (this.availableTokens.length) {
      this.price.fetchPricesByTokens(this.availableTokens, 'usd')
        .subscribe(map => {
          this.priceMap = map; // ← clés address_chainId
          console.log('💱 priceMap (USD) remis à jour', this.priceMap);
        });
    }

    if (this.availableBuyTokens.length) {
      this.price.fetchPricesByTokens(this.availableBuyTokens, 'usd')
        .subscribe(map => {
          this.priceBuyMap = map; // ← clés address_chainId
          console.log('💱 priceMap (USD) remis à jour', this.priceBuyMap);
        });
    }
  }



  // swap.component.ts  (ou swap-alert.component.ts)
  //getTokenLogo(symbol: string): string {
  //  return (
  //    this.availableTokens.find(t => t.symbol === symbol)?.logoURI ||
  //    'assets/tokens/unknown.svg'          // fallback très léger
  //  );
  //}
  getNetworkLogo(network: string): string {
    switch (network) {
      case 'ethereum': return 'assets/networks/ethereum.png';
      case 'arbitrum': return 'assets/networks/arbitrum.png';
      case 'optimism': return 'assets/networks/optimism.png';
      default: return 'assets/networks/default.png';
    }
  }

  getNetworkLabel(network: string): string {
    switch (network) {
      case 'ethereum': return 'Ethereum';
      case 'arbitrum': return 'Arbitrum';
      case 'optimism': return 'Optimism';
      default: return 'Unknown';
    }
  }

  selectNetwork(id: number) {
    this.selectedNetwork = id;
  }

  selectBuyNetwork(id: number) {
    this.selectedBuyNetwork = id;
  }
  getSellFiatValue(): string {
    const amount = parseFloat(this.sellAmount || '0');
    if (!amount) return '';

    const sym = this.sellTokenSymbol?.toUpperCase();
    const tok = this.availableTokens.find(t =>
      t.symbol?.toUpperCase() === sym && Number(t.chainId) === Number(this.chainId ?? 1)
    );
    const key = tok ? `${tok.address?.toLowerCase()}_${Number(tok.chainId)}` : null;

    // prix USD depuis le map actuel (address_chainId)
    const unitUsd =
      (key && typeof this.priceMap[key] === 'number') ? this.priceMap[key] : 0;

    // conversion USD -> devise courante
    const fiatCode = this.defaultFiat?.toUpperCase?.() || 'USD';
    const usdToFiat = this.fiatRates?.[fiatCode] ?? 1;

    // fallback pour stables si le prix n'est pas encore peuplé
    const isStable = ['USDC', 'USDT', 'DAI', 'FDUSD', 'USDC.E'].includes(sym || '');
    const unitFiat = unitUsd > 0 ? unitUsd * usdToFiat : (isStable ? usdToFiat : 0);

    const total = amount * unitFiat;
    if (!total) return '';

    const locale = this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US';
    const formatted = total.toLocaleString(locale, {
      style: 'currency',
      currency: fiatCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return '~ ' + formatted;
  }





  private closeQuoteWithReason(reason: string) {
    const BLOCK_WHILE_EXEC = new Set(['']);
    // Raisons qui DOIVENT pouvoir fermer la modale même en cours d’exécution
    const TERMINAL_REASONS = new Set([
      'success',
      'error',
      'fatal-error',
      'user-cancel',
      'user-rejected',
      'timeout',
      'forceReconnectWalletSession',
      'softReloadAfterNetworkSwitch',
      'networkChanged',
      'force-close'
    ]);

    // ✅ cancel token: toute fermeture de quote invalide les retours async tardifs (late-connect)
    this._quoteLifeId++;
    this._activeQuoteConnectSeq = null;
    this._activeQuoteConnectLifeId = null;
    this.connectInFlight = false;
    this.connectInFlightUntil = 0;
    this.addLog?.(`[quote][life] bump lifeId=${this._quoteLifeId} | reason=${reason}`);
    this.cancelQuoteProviderPump(`quote-close:${reason}`);

    const status = this.bridgeStatus ?? 'idle';
    const isExecPhase = BLOCK_WHILE_EXEC.has(status);
    const isTerminal = TERMINAL_REASONS.has(reason);

    if (isExecPhase && !isTerminal) {
      // Empêche la fermeture intempestive (ex: 'child-close') pendant approve/pending/executing
      this.addLog(`🧯 [quote] close BLOCKED by=${reason} | bridgeStatus=${status}`);

      return;
    }

    this.addLog(`🧯 [quote] close by=${reason} | bridgeStatus=${status}`);
    try { this.closeQuote?.(); } catch { /* noop */ }
  }




  getGasFeeFiat(): string {
    if (!this.fullGasWei || !this.nativeTokenUsd) return '';

    const feeEth = Number(this.fullGasWei) / 1e18;
    const fiat = feeEth * this.nativeTokenUsd;

    return fiat.toLocaleString(
      this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US',
      {
        style: 'currency',
        currency: this.defaultFiat,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );
  }

  async changeChain(id: number) {
    this.lockChainToSeo = false;
    this.showChainMenu = false;
    this.closeQuoteWithReason('changeChain');
        try {
            // Swap-like behavior: changing the UI chain must NOT depend on the wallet chain.
              // We switch wallet chain only at execute time (deterministic + WC friendly).
              const walletCid = Number((this as any).walletChainId ?? NaN);
            this.addLog?.(`[changeChain] enter | id=${id} connected=${!!this.isConnected} wallet=${Number.isFinite(walletCid) ? walletCid : 'null'} desired=${(this as any).desiredChainId ?? 'null'}`);
      
              // Always apply UI immediately
              await this.applyChainUi(id);
      
              // Best-effort info log if wallet differs
              if (this.isConnected && Number.isFinite(walletCid) && walletCid > 0 && walletCid !== id) {
                  this.addLog?.(`[changeChain] UI changed while wallet differs | ui=${id} wallet=${walletCid} (switch on execute)`);
                }
          } catch (e) {
              console.error('⛔️ Erreur de changement de réseau', e);
              alert('Impossible de changer de réseau : ' + (e as any).message);
            }
  }



  /**
* "Glue" : met l’UI dans le même état logique que si on avait booté sur cette chaîne.
* - met à jour chainId/chainInfo (setChain)
* - aligne swapApi
* - reconstruit les listes de tokens
* - recalcule les tokens SELL/BUY par défaut si besoin
*/
  private async applyChainUi(id: number): Promise<void> {
    // 🧠 setChain(id) → met à jour chainId/chainInfo + rebind TokenPortfolioCacheService
    this.setChain(id);

    // aligne l’API de swap sur la chaîne courante
    this.swapApi.setChainId(id);

    // 🔄 Rebuild des listes de tokens (availableTokens / popularTokens) pour le nouveau chainId
    await this.refreshTokensForChain();

    // Vérifier que popularTokens n'est pas vide (debug visuel)
    //this.addLog("popularTokens après refresh" + this.popularTokens);

    // Sélectionner les tokens par défaut **uniquement si la sélection courante est invalide**
    const sellIsValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
    const buyIsValid = this.availableTokens.some(t => t.symbol === this.buyTokenSymbol);

    if (!sellIsValid) {
      const sellToken = this.getDefaultSellTokenForChain(id);
      this.addLog("[changeChain] SELL invalide → fallback " + sellToken?.symbol);
      if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
    } else {
      this.addLog("[changeChain] SELL conservé =" + this.sellTokenSymbol);
    }

    if (!buyIsValid) {
      const buyToken = this.getDefaultBuyTokenForChain(id);
      this.addLog("[changeChain] BUY invalide → fallback " + buyToken?.symbol);
      if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
    } else {
      this.addLog("[changeChain] BUY conservé =" + this.buyTokenSymbol);
    }

    this.cd.detectChanges();
  }
  //async changeChain(id: number) {
  //  this.lockChainToSeo = false;
  //  this.showChainMenu = false;
  //  this.closeQuoteWithReason('changeChain');
  //  try {
  //    const isConnected = !!this.provider && this.isConnected; // vrai provider prêt
  //    if (isConnected) {
  //      await this.rawProvider.request({
  //        method: 'wallet_switchEthereumChain',
  //        params: [{ chainId: '0x' + id.toString(16) }]
  //      });

  //      // on met aussi à jour l’état local
  //      this.chainId = id;
  //      this.chainInfo = CHAIN_MAP[id];
  //      this.swapApi.setChainId(id);
  //    } else {
  //      // switch local UI
  //      this.chainId = id;
  //      this.chainInfo = CHAIN_MAP[id];
  //      this.swapApi.setChainId(id);
  //    }

  //    // 🔄 Attendre le rechargement réel des tokens
  //    await this.refreshTokensForChain();

  //    // Vérifier que popularTokens n'est pas vide
  //    console.log("popularTokens après refresh", this.popularTokens);

  //    // Sélectionner les tokens par défaut
  //    // Sélectionner les tokens par défaut **uniquement si la sélection courante est invalide**
  //    const sellIsValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
  //    const buyIsValid = this.availableBuyTokens.some(t => t.symbol === this.buyTokenSymbol);

  //    if (!sellIsValid) {
  //      const sellToken = this.getDefaultSellTokenForChain(id);
  //      console.log("[changeChain] SELL invalide → fallback", sellToken?.symbol);
  //      if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
  //    } else {
  //      console.log("[changeChain] SELL conservé =", this.sellTokenSymbol);
  //    }

  //    if (!buyIsValid) {
  //      const buyToken = this.getDefaultBuyTokenForChain(id);
  //      console.log("[changeChain] BUY invalide → fallback", buyToken?.symbol);
  //      if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
  //    } else {
  //      console.log("[changeChain] BUY conservé =", this.buyTokenSymbol);
  //    }

  //    this.hardReloadAfterCancel('changeChain');
  //    /*this.cd.detectChanges();*/

  //  } catch (e) {
  //    console.error('⛔️ Erreur de changement de réseau', e);
  //    alert('Impossible de changer de réseau : ' + (e as any).message);
  //  }
  //}


  async changeBuyChain(id: number) {
    this.lockChainToSeo = false;
    this.showNetworkBuyDropdown = false;
    this.closeQuoteWithReason('changeChain');
    try {
      this.buyChainId = id;
      localStorage.setItem('bridge:lastBuyChainId', String(id));
      // Pas de wallet => on fait juste le switch local (UI + tokens)
      await this.applyBuyChainUi(id);
    } catch (e) {
      console.error('⛔️ Erreur de changement de réseau', e);
    }
  }

  private async applyBuyChainUi(id: number): Promise<void> {
    // 🧠 setChain(id) → met à jour chainId/chainInfo + rebind TokenPortfolioCacheService
    this.setBuyChain(id);



    // 🔄 Rebuild des listes de tokens (availableTokens / popularTokens) pour le nouveau chainId
    await this.refreshTokensForChain();

    // Vérifier que popularTokens n'est pas vide (debug visuel)
    //this.addLog("popularTokens après refresh" + this.popularTokens);


    const buyIsValid = this.availableTokens.some(t => t.symbol === this.buyTokenSymbol);


    if (!buyIsValid) {
      const buyToken = this.getDefaultBuyTokenForChain(id);
      this.addLog("[changeChain] BUY invalide → fallback " + buyToken?.symbol);
      if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
    } else {
      this.addLog("[changeChain] BUY conservé =" + this.buyTokenSymbol);
    }

    this.cd.detectChanges();
  }
  getDefaultSellTokenForChain(chainId: number): any {
    const tokens = this.popularTokens
      .filter(t => t.chainId === chainId)
      .sort((a, b) => b.volumeUsd24h - a.volumeUsd24h);

    return tokens.length > 0 ? tokens[0] : undefined;
  }

  getDefaultBuyTokenForChain(chainId: number): any {
    const tokens = this.popularBuyTokens
      .filter(t => t.chainId === chainId)
      .sort((a, b) => b.volumeUsd24h - a.volumeUsd24h);

    return tokens.length > 1 ? tokens[1] : undefined;
  }




  async isPermit2Approved(owner: string, token: string, spender: string): Promise<boolean> {
    const abi = [
      "function allowance(address,address,address) view returns (uint160 amount,uint48 expiration,uint48 nonce)",
    ];
    const c = new Contract(PERMIT2_ADDRESS, abi, this.provider);
    const [amount] = await c['allowance'](owner, token, spender);
    return BigInt(amount) > 0n;
  }

  async buildPermit2Signature() {
    if (!this.enablePermit2) return;
    if (!this.provider) {
      alert("Connecte ton wallet avant de signer le permit.");
      return;
    }
    const signer = await this.provider.getSigner();
    const owner = await signer.getAddress();
    const token = this.sellTokenAddress;
    const spender = this.quote.target;
    const amount = this.quote.value.takerTokenAmount;

    // récupérer le nonce
    const allowanceAbi = [
      'function allowance(address,address,address) view returns (uint160,uint48,uint48)'
    ];
    const c = new Contract(PERMIT2_ADDRESS, allowanceAbi, this.provider);
    const [, , nonceBig] = await c['allowance'](owner, token, spender);
    const nonce = Number(nonceBig);

    // … puis buildPermitSingle + signTypedData comme montré
  }

  // Normaliser une valeur "wei" (déjà en wei) vers bigint
  private parseWei(v: any): bigint {
    try {
      if (typeof v === 'bigint') return v;
      if (typeof v === 'number') return BigInt(Math.trunc(v));
      if (typeof v === 'string') return v.startsWith('0x') ? BigInt(v) : BigInt(v || '0');
    } catch { }
    return 0n;
  }

  // MM-like EXPECTED-first pour le gating; fallbacks: mmNetwork → mmMax
  private pickMmExpectedWei(r: any): bigint {
    return this.parseWei(r?.mmExpectedNetworkFeeWei ?? r?.mmNetworkFeeWei ?? r?.mmMaxNetworkFeeWei ?? 0);
  }


  // swap.component.ts
  isSwapDisabled(): boolean {
    // 0) Pas de quote → on bloque proprement
    if (!this.quote) {
      this.swapDisabled = true;
      this.swapReasons = [this.translate.instant('SWAP_TX_MISSING')];
      return true;
    }

    // 1) Gating "métier" standard (BalanceValidator)
    const args = {
      takerAddress: this.takerAddress,
      chainId: this.chainId ?? 1,
      sellTokenSymbol: this.sellTokenSymbol,
      sellAmount: this.sellAmount,
      fullGasWei: this.pickMmExpectedWei(this.quote),
      availableTokens: this.availableTokens,
      tokenBalances: this.tokenCachedBalances,
      getNativeTokenSymbol: (cid: number) => this.getNativeTokenSymbol(cid),
      marginPct: 0.05,
    };
    const base = this.balanceValidator.isSwapDisabled(args);

    // 2) Surcouche : si la route principale a échoué à la simulation
    const mainKey = this.getProviderKey(this.quote);
    const simFailedOnMain =
      this.bridgeStatus === 'error' &&
      !!this.lastSimFailedKey &&
      !!mainKey &&
      mainKey === this.lastSimFailedKey;

    let disabled = base.disabled || simFailedOnMain;

    // Raisons (fusion propre + message de sim échouée)
    let reasons: string[] = Array.isArray(base.reasons) ? [...base.reasons] : [];
    if (simFailedOnMain) {
      const msg = this.translate.instant('ROUTE_DISABLED_AFTER_SIM') || 'Route disabled after simulation failure.';
      if (!reasons.includes(msg)) reasons.push(msg);
    }

    // 3) 🔧 Bypass UI du check gas en mode debug
    //    -> on retire "INSUFFICIENT_NATIVE_GAS" des raisons
    //    -> si c'était la seule raison, on ré-active (sauf si simFailedOnMain)
    if ((this as any).debugBypassGasCheck) {
      reasons = reasons.filter(r => r !== 'INSUFFICIENT_NATIVE_GAS');
      if (!simFailedOnMain && reasons.length === 0) {
        disabled = false;
      }
    }

    // 4) Propagation UI
    this.swapDisabled = disabled;
    this.swapReasons = reasons;

    return disabled;
  }





  // ⬇️ Ajoute près d’isSwapDisabled()
  private altValidationCache = new WeakMap<any, { disabled: boolean; reasons: string[] }>();

  /** Construit les args de validation, en priorisant les données de la route si présentes */
  private buildValidationArgsForRoute(route: any) {
    const routeChainId = Number(
      route?.chainId ??
      route?.transactionRequest?.chainId ??
      this.chainId ?? 1
    );

    // Gas par route si dispo, sinon fallback sur le gas courant
    const routeFullGasWei =
      (typeof route?.gas?.fullWei === 'bigint' ? route?.gas?.fullWei :
        route?.gas?.fullWei ? BigInt(route?.gas?.fullWei) :
          typeof route?.fullGasWei === 'bigint' ? route?.fullGasWei :
            route?.fullGasWei ? BigInt(route?.fullGasWei) :
              this.fullGasWei) ?? 0n;

    return {
      takerAddress: this.takerAddress,
      chainId: routeChainId,
      sellTokenSymbol: this.sellTokenSymbol,
      sellAmount: this.sellAmount,
      fullGasWei: routeFullGasWei,
      availableTokens: this.availableTokens,
      tokenBalances: this.tokenCachedBalances,
      getNativeTokenSymbol: (cid: number) => this.getNativeTokenSymbol(cid),
      marginPct: 0.05, // même marge que ta quote principale
    };
  }

  /** Validation d’une route alternative : mêmes règles que le bouton principal */
  validateAlternativeRoute = (route: any): { disabled: boolean; reasons: string[] } => {
    const cached = this.altValidationCache.get(route);
    if (cached) return cached;

    const args = this.buildValidationArgsForRoute(route);
    const res = this.balanceValidator.isSwapDisabled(args); // ✅ ta logique actuelle

    // ➕ surcouche : si cette alternative a échoué à la simulation
    const key = this.getProviderKey(route);
    if (this.failedAltKeys.has(key)) {
      res.disabled = true;
      res.reasons = [...(res.reasons || []), this.translate.instant('ALT_DISABLED_AFTER_SIM')];
    }

    this.altValidationCache.set(route, res);
    return res;
  };


  private getProviderKey(x: any): string {
    const raw =
      x?.providerKey ?? x?.ProviderKey ??
      x?.toolKey ?? x?.ToolKey ??
      x?.tool ?? x?.Tool ??
      x?.source ?? x?.Source ??
      x?.providerName ?? x?.ProviderName ??
      x?.name ?? '';
    return String(raw || '').toLowerCase().trim();
  }
  validateAlternative(route: any): { disabled: boolean; reasons: string[] } {
    const key = this.getProviderKey(route);
    const disabled = !!(this.bridgeStatus === 'error' && this.lastSimFailedKey && key === this.lastSimFailedKey);
    const reasons = disabled ? [this.translate.instant('ALT_DISABLED_AFTER_SIM')] : [];
    return { disabled, reasons };
  }

  async loadBalancesOptimized() {
    if (!this.takerAddress) return;



    // 1️⃣ Récupère uniquement les adresses possédées
    const ownedAddresses = await this.wallet.getOwnedTokensRaw(this.takerAddress, this.chainId ?? 1);


    if (!ownedAddresses.length) {
      console.warn("⚠️ Aucun token whitelisté trouvé");
      return;
    }

    // 2️⃣ Map vers availableTokens (logo, decimals, etc.)
    const ownedTokens = this.availableTokens.filter(t =>
      ownedAddresses.includes((t.address || '').toLowerCase())
    );


    // 2️⃣bis Ajout forcé du token natif si présent dans availableTokens
    const nativeToken = this.availableTokens.find(t =>
      t.address === '0x0000000000000000000000000000000000000000'
    );
    if (nativeToken && !ownedTokens.includes(nativeToken)) {
      ownedTokens.push(nativeToken);

    }


    if (!ownedTokens.length) {
      console.warn("⚠️ Aucun token de la whitelist trouvé dans le portefeuille");
      return;
    }

    // 3️⃣ Charge uniquement les balances pour ces tokens
    await this.loadBalancesForTokens(ownedTokens, true);


    // 4️⃣ Mets à jour la liste 'Vos tokens'
    // 4️⃣ Mets à jour la liste 'Vos tokens'
    //this.userTokens = ownedTokens.filter(t => {
    //  const key = `${t.address.toLowerCase()}_${t.chainId}`;
    //  return parseFloat(this.tokenBalances[key] || '0') > 0;
    //});

    //console.log("🎯 Tokens affichés dans 'Vos tokens':", this.userTokens);

    // 5️⃣ Trie des populaires
    this.popularTokens = [...this.availableTokens].sort(
      (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
    );


  }









  private async loadBalancesForTokens(tokens: any[], isPriority: boolean) {
    if (!this.takerAddress) return;



    const limitConcurrency = isPriority ? 10 : 5;
    let index = 0;

    //    const worker = async () => {
    //      while (index < tokens.length) {
    //        const token = tokens[index++];

    //        try {
    //          let balance = '0';


    //          balance = await this.swapApi.getBalance(
    //            token,
    //            this.takerAddress!,
    //            token.chainId
    //          );

    //          // 🔑 Clé unique : chainId + address
    //          const key = `${token.address.toLowerCase()}_${token.chainId}`;
    //          this.tokenBalances[key] = balance;
    //          this.cd.detectChanges();
    ////          if (parseFloat(balance) > 0) {
    /////*            this.userTokens.push(token);*/
    ////            this.cd.detectChanges();
    ////          }
    //        } catch (err) {
    //          console.error(`❌ Erreur lors de la récupération du solde pour ${token.symbol}`, err);
    //          const key = `${token.chainId}_${(token.address || '').toLowerCase()}`;
    //          this.tokenBalances[key] = '0';
    //        }
    //      }
    //    };

    //const workers = Array.from({ length: limitConcurrency }, () => worker());
    //await Promise.allSettled(workers);
  }



  /** Called when user clicks “Valider” on an alternative row */
  /** Called when user clicks “Valider” on an alternative row */
  /** Called when user clicks “Valider” on an alternative row */
  //onAlternativeSelected(route: any) {
  //  // Reset UI léger
  //  this.bridgeStatus = 'idle';
  //  this.bridgeHash = null;
  //  this.bridgeError = null;

  //  // 1) mémoriser la sélection
  //  const key = this.getRouteKey(route);
  //  this.selectedAltKey = key;
  //  this.selectedAlternative = route;

  //  // 2) extraire la TX de la route (formats possibles)
  //  const rawTx = route?.transactionRequest ?? (
  //    route?.to && route?.data ? { to: route.to, data: route.data, value: route?.value } : null
  //  );

  //  if (!rawTx?.to || !rawTx?.data) {
  //    this.addLog(`[ALT] route sélectionnée SANS transactionRequest (provider=${route?.providerName || route?.tool || route?.source || '(?)'})`);
  //    return;
  //  }

  //  // 🔧 2bis) Sanitize: on enlève tout ce qui peut bloquer / influencer le gas
  //  const tx = sanitizeTxForWallet(rawTx); // retire gas/gasLimit/gasPrice/maxFeePerGas/maxPriorityFeePerGas/type

  //  // 3) injecter uniquement les champs que executeSwap consomme
  //  this.quote = {
  //    ...this.quote,
  //    transactionRequest: {
  //      to: tx.to,
  //      data: tx.data,
  //      value: tx.value ?? this.quote?.transactionRequest?.value ?? '0x0',
  //    },
  //    // champs utilisés pour allowance & logs
  //    fromTokenAddress: route?.fromTokenAddress ?? route?.inTokenAddress ?? this.quote?.fromTokenAddress,
  //    inTokenAddress: route?.inTokenAddress ?? this.quote?.inTokenAddress,
  //    allowanceTarget: route?.allowanceTarget ?? this.quote?.allowanceTarget,
  //    inputAmountRaw: route?.inputAmountRaw ?? this.quote?.inputAmountRaw,
  //  };

  //  // 🧹 Par sécurité: purge de tout hint gas restant
  //  delete (this.quote as any).transactionRequest.gas;
  //  delete (this.quote as any).transactionRequest.gasLimit;
  //  delete (this.quote as any).transactionRequest.gasPrice;
  //  delete (this.quote as any).transactionRequest.maxFeePerGas;
  //  delete (this.quote as any).transactionRequest.maxPriorityFeePerGas;
  //  delete (this.quote as any).transactionRequest.type;

  //  // 🟣 DEBUG: ne laisse pas une simu échouée re-désactiver le bouton alt
  //  if (this.debugBypassGasCheck) {
  //    this.lastSimFailedKey = null;
  //    try { this.failedAltKeys?.clear?.(); } catch { }
  //    this.swapDisabled = false;
  //    this.swapReasons = [];
  //  }

  //  this.addLog(`[ALT] adopt TX (no refresh): key=${key} to=${String(tx.to).slice(0, 6)}… dataLen=${(tx.data || '').length}`);

  //  // 4) go!
  //  this.executeSwap();
  //}
  // Helper JSON sûr pour logs (gère BigInt, références circulaires, troncature)
  private safeJson(obj: any, maxLen = 5000): string {
    const seen = new WeakSet();
    const replacer = (_k: string, v: any) => {
      if (typeof v === 'bigint') return v.toString();
      if (typeof v === 'function') return '[Function]';
      if (v && typeof v === 'object') {
        if (seen.has(v)) return '[Circular]';
        seen.add(v);
      }
      return v;
    };
    try {
      let s = JSON.stringify(obj, replacer);
      if (s.length > maxLen) s = s.slice(0, maxLen) + `… (len=${s.length})`;
      return s;
    } catch {
      try { return String(obj); } catch { return '[Unserializable]'; }
    }
  }
  async onAlternativeSelected(route: any): Promise<void> {
    // 🔁 Soft reset deeplink/cooldown pour ce NOUVEAU run ALT
    await this.softReloadBeforeRunIfNeeded('alt');
    this.logAltState('onAltSelected:enter');

    // Reset léger de l’UI (on repart propre)
    this.bridgeStatus = 'idle';
    this.bridgeHash = null;
    this.bridgeError = null;

    let pickedKey = 'n/a';

    // 1) Mémoriser la sélection (et verrouiller tout de suite l’UI sur CETTE alt)
    const key = this.getRouteKey(route);
    this.selectedAltKey = key;
    this.selectedAlternative = route;

    this.validatingKey = key;        // ✅ annonce immédiate de la route en cours
    this.bridgeStatus = 'pending';   // ✅ feedback instantané (avant toute async)
    this.logAltState('onAltSelected:after-select+pending');

    this.addLog?.(
      `[ALT][select] key=${key} routeId=${route?.routeId ?? route?.id ?? '∅'} step=enrich`
    );

    // ✅ Cooldown + reset de la session WC entre 2 quotes (ALT → nouvelle confirmation MM)
    await this.cooldownAndResetWcSession('alt');
    this.logAltState('onAltSelected:after-cooldown');

    // 1bis) ⚠️ NE PLUS armer le deeplink ici en ALT.
    //       L’annonce/deeplink sera déplacée juste avant l’envoi de la TX
    //       dans executeBridge() pour éviter toute ouverture prématurée.
    this.addLog('[ALT] pre-deeplink deferred: will announce just-before-send');
    this.logAltState('onAltSelected:before-enrich/approve-triplet');

    try {
      // 2) Extraire la TX depuis la route (plusieurs formats possibles)
      const rawTx =
        route?.transactionRequest ??
        (route?.to && route?.data ? { to: route.to, data: route.data, value: route?.value } : null);

      if (!rawTx?.to || !rawTx?.data) {
        this.addLog(
          `[ALT] route sélectionnée SANS transactionRequest (provider=${route?.providerName || route?.tool || route?.source || '(?)'})`
        );
        // Pas de TX → on annule proprement l’état d’UI
        this.validatingKey = null;
        this.bridgeStatus = 'idle';
        return;
      }

      // 3) Sanitize: retirer tout hint gas pour laisser le wallet / RPC décider
      const tx = sanitizeTxForWallet(rawTx); // enlève gas/gasLimit/gasPrice/maxFeePerGas/maxPriorityFeePerGas/type

      // 4) Injecter uniquement ce que executeBridge consomme (sans refetch de quote)
      //    + normaliser token/spender/amount pour l’approve binaire BRIDGE
      const altTokenAddr =
        (
          route?.fromTokenAddress ||
          route?.inTokenAddress ||
          route?.action?.fromToken?.address ||
          this.quote?.sellTokenAddress ||
          this.quote?.inTokenAddress ||
          this.quote?.fromTokenAddress ||
          ''
        ).toLowerCase();

      const altSpender =
        (
          route?.AllowanceTarget ||        // ✅ backend (pascal)
          route?.allowanceTarget ||        // (camel)
          route?.estimate?.approvalAddress ||
          this.quote?.allowanceTarget ||
          ''
        ).toLowerCase();

      this.addLog(`[ALT][spender] picked=${altSpender || '(none)'}`);

      // 🔎 DEBUG: dump de la route et de la quote juste avant l'extraction de rawNeeded
      try {
        this.addLog('[ALT][dump][route] ' + this.safeJson(route, 1200));
        this.addLog('[ALT][dump][quote] ' + this.safeJson(this.quote, 1200));
      } catch {
        // ignore
      }

      // Source unique & canonique du montant à vendre (base units) : backend → quote.inputAmountRaw
      let rawNeeded: string | number | null = this.quote?.inputAmountRaw ?? null;
      pickedKey = 'quote.inputAmountRaw';

      if (rawNeeded == null) {
        this.addLog('⛔ [ALT][needed] manquant: quote.inputAmountRaw introuvable — abandon pour éviter approve=0');
        this.validatingKey = null;
        this.bridgeStatus = 'error';
        this.bridgeError = 'inputAmountRaw manquant dans la quote';
        return;
      }

      const neededDec =
        typeof rawNeeded === 'string' && rawNeeded.startsWith('0x')
          ? BigInt(rawNeeded).toString()
          : String(rawNeeded);

      this.addLog(`[ALT][needed] pickedKey=${pickedKey} neededDec=${neededDec}`);
      this.addLog(
        `[ALT][approve-triplet] token=${altTokenAddr} spender=${altSpender} amount(baseUnits)=${neededDec}`
      );

      // 🔧 Enrichir la route ALT (main immuable : on ne touche pas à this.quote)
      const enrichedAlt = {
        ...route,
        // TX portée par l'ALT uniquement
        transactionRequest: {
          to: tx.to,
          data: tx.data,
          value: tx.value ?? this.quote?.transactionRequest?.value ?? '0x0',
        },
        // ✅ Montant en base units disponible sur la route (backend-friendly)
        FromAmountRaw: neededDec,          // Pascal
        fromAmountRaw: neededDec,          // camel
        inputAmountRaw: neededDec,         // compat
        fromAmount: neededDec,
        // Normaliser aussi l’obj estimate pour les intégrations qui le lisent
        estimate: { ...(route?.estimate ?? {}), fromAmount: neededDec },
        // Sécurité: refléter token/spender utilisés
        AllowanceTarget: altSpender || route?.AllowanceTarget,
        allowanceTarget: altSpender || route?.allowanceTarget,
        fromTokenAddress: altTokenAddr || route?.fromTokenAddress,
        inTokenAddress: altTokenAddr || route?.inTokenAddress,
      };

      // purge défensive des hints gas sur l’ALT uniquement
      try {
        delete (enrichedAlt as any).transactionRequest.gas;
        delete (enrichedAlt as any).transactionRequest.gasLimit;
        delete (enrichedAlt as any).transactionRequest.gasPrice;
        delete (enrichedAlt as any).transactionRequest.maxFeePerGas;
        delete (enrichedAlt as any).transactionRequest.maxPriorityFeePerGas;
        delete (enrichedAlt as any).transactionRequest.type;
      } catch {
        // ignore
      }

      this.selectedAlternative = enrichedAlt;

      this.addLog(
        `[ALT][enrich] patched ALT for approve flow (key=${key}) ` +
        `| amount(baseUnits)=${neededDec} | spender=${altSpender} | token=${altTokenAddr}`
      );

      // 5) Mode debug: bypass des flags de simulation échouée
      if (this.debugBypassGasCheck) {
        this.lastSimFailedKey = null;
        try {
          this.failedAltKeys?.clear?.();
        } catch {
          // ignore
        }
        this.swapDisabled = false;
        this.swapReasons = [];
      }

      this.addLog(
        `[ALT] adopt TX (no refresh): key=${key} to=${String(tx.to).slice(0, 6)}… dataLen=${(tx.data || '').length}`
      );
      this.addLog?.(
        `[ALT][select][post-enrich] key=${key} hasQuote=${!!this.quote} ` +
        `altHasTx=${!!this.selectedAlternative?.transactionRequest} mainHasTx=${!!this.quote?.transactionRequest}`
      );

      this.logAltState('onAltSelected:before-execBridge');

      // ─────────────────────────────────────────────────────────────
      // 6) Go exécution – même pattern que la MAIN (déclenchement différé)
      // ─────────────────────────────────────────────────────────────
      setTimeout(() => {
        try {
          this.addLog('[ALT][exec] deferred executeBridge() start');
          void this.executeBridge();
        } catch (e: any) {
          this.addLog(
            `[ALT][exec] executeBridge() sync error: ${e?.message || e}`
          );
          // petit fallback UI défensif
          if (this.validatingKey === key) this.validatingKey = null;
          if (!isTerminal(this.bridgeStatus)) {
            this.bridgeStatus = 'error';
            this.bridgeError = e?.message || String(e);
          }
        }
      }, 120);
      // ─────────────────────────────────────────────────────────────

    } catch (err: any) {
      // Sécurité: si une exception sync/await remonte AVANT le setTimeout
      this.bridgeStatus = 'error';
      this.bridgeError = err?.message || String(err);
      this.addLog(`[ALT] onAlternativeSelected error | key=${key} | ${this.bridgeError}`);
      if (this.validatingKey === key) this.validatingKey = null;
    }
  }



  private finalizeSwap(ok: boolean, hash?: string) {
    this.bridgeStatus = ok ? 'success' : 'error';
    if (ok && hash) this.bridgeHash = hash;
    // petit délai si tu veux laisser l’état visible, sinon reset direct :
    setTimeout(() => {
      this.bridgeStatus = 'idle';
      this.validatingKey = null;      // ✅ très important
    }, 1500);
  }

  // pense aussi à faire this.validatingKey = null; lors d’un closeQuote()/hard/soft reload


  /** Extract a provider key from a route (supports several backends) */
  private getRouteKey(r: any): string {
    const raw =
      r?.providerKey ?? r?.ProviderKey ??
      r?.toolKey ?? r?.tool ??
      r?.source ?? r?.Source ??
      r?.providerName ?? r?.name ??
      r?.routeId ?? r?.id ?? '';

    let key = String(raw).trim();
    if (!key) {
      const chain = r?.chainId ?? r?.fromChainId ?? r?.chain ?? 'na';
      const sell = (r?.sellToken?.symbol ?? r?.fromToken?.symbol ?? r?.sellTokenSymbol ?? 'SELL').toUpperCase();
      const buy = (r?.buyToken?.symbol ?? r?.toToken?.symbol ?? r?.buyTokenSymbol ?? 'BUY').toUpperCase();
      key = `main:${chain}:${sell}->${buy}`;
    }
    return key.toLowerCase();
  }

  get selectedLanguage(): string {
    const l = this.translate.currentLang || localStorage.getItem('lang') || 'en';
    return l.toLowerCase();
  }

  /**
 * Construit et signe un PermitSingle pour Permit2.
 * Nécessite :
 *  - this.provider    : BrowserProvider déjà initialisé
 *  - this.quote       : l’objet quote renvoyé par OpenOcean (= contient target et takerTokenAmount)
 *  - this.sellTokenAddress : token vendu (USDC ici)
 */
  /**
   * Construit et signe un PermitSingle pour Permit2.
   * 
   * @param params (optionnel) : objet contenant les champs spécifiques pour 0x Permit2
   */
  async buildPermitAndSign(params?: {
    token: string;
    amount: bigint;
    expiration: bigint;
    nonce: bigint;
    spender: string;
    sigDeadline: bigint;
  }): Promise<{ permit: PermitSingle; signature: string }> {
    if (!this.provider) {
      throw new Error('Wallet non connecté');
    }

    const signer = await this.provider.getSigner();
    const owner = await signer.getAddress();
    const { chainId } = await this.provider.getNetwork();
    const chainIdNum = Number(chainId);

    // ----------------------------
    // 1️⃣ Lecture des paramètres
    // ----------------------------
    let token: string;
    let amount: bigint;
    let expiration: bigint;
    let nonce: bigint;
    let spender: string;
    let sigDeadline: bigint;

    if (params) {
      token = params.token;
      amount = params.amount;
      expiration = params.expiration;
      nonce = params.nonce;
      spender = params.spender;
      sigDeadline = params.sigDeadline;
    } else {
      token = this.sellTokenAddress;
      spender = this.quote.target;
      amount = BigInt(this.quote.value?.takerTokenAmount ?? '0');

      // 🔍 Récupération du nonce on-chain si pas fourni
      const allowanceAbi = [
        'function allowance(address,address,address) view returns (uint160,uint48,uint48)'
      ];
      const permit2 = new Contract(PERMIT2_ADDRESS, allowanceAbi, this.provider);
      const [, , rawNonce] = await permit2['allowance'](owner, token, spender);
      nonce = BigInt(rawNonce);

      const defaultDeadline = BigInt(Math.floor(Date.now() / 1000) + 60 * 30);
      expiration = defaultDeadline;
      sigDeadline = defaultDeadline;
    }

    // ----------------------------
    // 2️⃣ Clamp automatique du nonce à uint48
    // ----------------------------
    const nonceMax = (1n << 48n) - 1n;
    const safeNonce = nonce > nonceMax ? nonce % (nonceMax + 1n) : nonce;

    // ----------------------------
    // 3️⃣ Construction PermitSingle
    // ----------------------------
    const permit: PermitSingle = {
      details: {
        token,
        amount,
        expiration,
        nonce: safeNonce // ✅ Utilisation du nonce corrigé
      },
      spender,
      sigDeadline
    };

    // ----------------------------
    // 4️⃣ Domain & Types EIP-712
    // ----------------------------
    const domain: TypedDataDomain = {
      name: 'Permit2',
      chainId: chainIdNum,
      verifyingContract: PERMIT2_ADDRESS
    };

    const types = {
      PermitSingle: [
        { name: 'details', type: 'PermitDetails' },
        { name: 'spender', type: 'address' },
        { name: 'sigDeadline', type: 'uint256' }
      ],
      PermitDetails: [
        { name: 'token', type: 'address' },
        { name: 'amount', type: 'uint160' },
        { name: 'expiration', type: 'uint48' },
        { name: 'nonce', type: 'uint48' } // ⚠️ uint48 => safeNonce garanti
      ]
    };

    // ----------------------------
    // 5️⃣ Signature EIP-712
    // ----------------------------
    const signature: string = await signer.signTypedData(domain, types, permit);

    return { permit, signature };
  }



  formatTokenAmount(raw: string | number | bigint,
    decimals: number): string {

    // 0. Protection
    if (raw === '' || raw === null || raw === undefined) return '';

    // 1. Conversion → JS number pour l’affichage
    const valueNum = Number(raw.toString());

    // 2. Choix dynamique des décimales
    let min = 2, max = 2;
    const abs = Math.abs(valueNum);

    if (abs >= 100) { max = 2; }            // 123 → “123.45”
    else if (abs >= 1) { max = 4; }            // 7 → “7.003”
    else if (abs >= 0.01) { max = 6; }            // 0.31
    else { min = 4; max = Math.min(decimals, 8); }

    // 3. NumberFormat caché (perf mobile)
    const key = `${min}-${max}`;
    if (!this.nfCache.has(key)) {
      this.nfCache.set(key, new Intl.NumberFormat('en-US', {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
      }));
    }
    return this.nfCache.get(key)!.format(valueNum);
  }

  toggleSettings() {
    this.showSettings = !this.showSettings;
  }


  getTokenBalance(symbol: string): string {
    const token = this.userCachedTokens.find(
      t => t.symbol === symbol && t.chainId === this.chainId
    );
    if (!token) return '';

    const key = `${token.address.toLowerCase()}_${token.chainId}`;
    const balance = this.tokenCachedBalances[key];
    if (!balance) return '';

    const parsed = parseFloat(balance);
    return formatTokenAmount(parsed);
  }

  selectBuyToken(symbol: string) {
    console.log('[selectBuyToken] →', symbol);
    console.trace();
    this.buyTokenSymbol = symbol;

    // ⚡ règle auto : choisir le premier token ≠ buy dans popularTokens (trié par volume)
    if (this.sellTokenSymbol === symbol && this.chainId === this.buyChainId) {
      const next = this.popularTokens.find(t => t.symbol !== symbol);
      if (next) {
        this.sellTokenSymbol = next.symbol;
      }
    }
  }

  async loadAllBalances() {
    const dbg = (window as any).debugLog;

    if (!this.takerAddress) {
      dbg?.('❌ [loadAllBalances] takerAddress undefined');
      console.warn('[loadAllBalances] ❌ takerAddress undefined');
      return;
    }
    const taker = this.takerAddress as string; // snapshot non-null

    dbg?.('🚀 [loadAllBalances] start pour', taker);
    console.group(`[loadAllBalances] Chargement balances pour ➜ ${taker}`);

    // 1️⃣ Vérif qu’on a bien les tokens
    if (!this.availableTokens?.length) {
      dbg?.('⚠️ [loadAllBalances] availableTokens vide');
      console.warn('[loadAllBalances] Tokens list is empty');
    }

    // 2️⃣ Boucle séquentielle — écriture par clé canonique
    //for (const token of (this.availableTokens || [])) {
    //  const key = `${(token.address || '').toLowerCase()}_${Number(token.chainId)}`;
    //  dbg?.('🔁 [balance] getBalance sur', token.symbol, '| key=', key);
    //  console.groupCollapsed(`[${token.symbol}] récupération balance`);

    //  try {
    //    const balance = await this.swapApi.getBalance(token, taker, token.chainId);
    //    dbg?.(`✅ ${token.symbol} balance`, balance);
    //    this.tokenBalances[key] = balance ?? '0';
    //  } catch (err) {
    //    dbg?.(`❌ ${token.symbol} erreur`, err);
    //    console.error(`❌ Erreur récupération balance ${token.symbol}`, err);
    //    // Écrire '0' sur la MÊME clé (pas de variant symbol/clé inversée)
    //    this.tokenBalances[key] = '0';
    //  }

    //  console.groupEnd();
    //}

    // 3️⃣ Log final + dérivation userTokens avec la même clé
    //dbg?.('📊 [loadAllBalances] tableau final', this.tokenBalances);
    //console.table(this.tokenBalances);
    console.groupEnd();

    //this.userTokens = (this.availableTokens || []).filter(t => {
    //  const k = `${(t.address || '').toLowerCase()}_${Number(t.chainId)}`;
    //  return parseFloat(this.tokenBalances[k] || '0') > 0;
    //});

    // (Optionnel) tri des populaires conservé
    this.popularTokens = [...(this.availableTokens || [])].sort(
      (a, b) => (b.volumeUsd24h || 0) - (a.volumeUsd24h || 0)
    );

    //console.log('[📊 tokenBalances] Composant :', this.constructor.name);
    //console.table(this.tokenBalances);
  }

  get isBridge(): boolean {
    return this.route.snapshot.queryParamMap.get('bridge') === '1';
  }

  get bridgeLabel(): string {
    return this.isSwap ? 'Go to bridge' : 'Go to swap';
  }

  get bridgeQuery(): any {
    return { bridge: this.isBridge ? '0' : '1' };
  }

  get bridgeGradient(): string {
    return this.isBridge
      ? 'bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600'
      : 'bg-gradient-to-r from-purple-300 via-purple-500 to-indigo-600';
  }

  get invBridgeLogo(): string {
    return 'text-blue-500';
  }
  get invBridgeGradientDark(): string {
    return this.isSwap
      ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-purple-600 to-purple-600'
      : 'text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700';
  }

  get invBridgeGradient(): string {
    return 'bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700';
  }


  get isArabicLang(): boolean {
    return this.translate.currentLang === 'ar' || this.translate.currentLang === 'zh';
  }

  /**
 * Connecte le wallet :
 *  • Desktop : MetaMask extension
 *  • Mobile : WalletConnect v2 + MetaMask mobile
 *  • Restaure la session WalletConnect si elle existe déjà
 */
  /**
 * Ouvre une connexion :
 *  • Desktop  → MetaMask extension (eth_requestAccounts)
 *  • Mobile   → WalletConnect v2 + MetaMask mobile  (1 seule autorisation)
 */
  /* Dans ta classe */
  private pollId: any = null;

  /* … */
  openWcModal(uri: string) {
    this.wcUri = uri || '';
    // Connect flow → on réutilise phase=tx (pas de nouveau type)
    this._showWcModalForPhase('tx', 'connect', 0);
  }

  closeWcModal() {
    this.wcUri = '';
    this._hideWcModal('user-close');
  }



  async connectWallet(): Promise<void> {
    try {
      /* this.closeQuote(); */

      // Empêche tout auto-restore pendant que l'utilisateur initie un connect
      sessionStorage.setItem('st/skipAutoRestoreOnce', '1');

      if (!modal) initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c');
      await initSignClient();

      // ✅ Autorise temporairement le deeplink MetaMask pour cette action utilisateur
      (window as any).__allowWcDeeplinkFor?.(15_000);

      await modal!.open({ view: 'Connect', namespace: 'eip155' });

      // Attendre que le provider EIP-1193 soit prêt
      const provider: any = await new Promise((resolve) => {
        let done = false;
        const unsub = modal!.subscribeProviders?.((state: any) => {
          if (done) return;
          const evm = state?.['eip155'];
          if (!evm) return;
          const p = evm.provider ?? evm;
          if (p) {
            done = true;
            try { unsub?.(); } catch { }
            resolve(p);
          }
        });
      });

      const pType = modal!.getWalletProviderType?.();

      if (typeof provider.request !== 'function') {
        throw new Error('Invalid EIP-1193 provider');
      }

      this.provider = new BrowserProvider(provider);

      const signer = await this.provider.getSigner();
      const address = await signer.getAddress();
      const { chainId } = await this.provider.getNetwork();

      this.takerAddress = address;
      this.isConnected = true;

      // Sauvegarde simple de session locale (pour ton restore)
      saveSimpleSession({
        address,
        chainId: Number(chainId),
        providerType: pType ?? 'unknown',
        ts: Date.now(),
      });

      // 💾 Sauvegarde WalletConnect (si tu l’utilises)
      await backupSession();

      // Sync UI + tokens
      this.setChain(Number(chainId));
      await this.refreshTokensForChain();

      // Vérifs de tokens côté UI
      const sellValid = this.availableTokens.some(t => t.symbol === this.sellTokenSymbol);
      const buyValid = this.availableBuyTokens.some(t => t.symbol === this.buyTokenSymbol);

      if (!sellValid) {
        const sellToken = this.getDefaultSellTokenForChain(Number(chainId));
        console.log('[attachEthersProvider] SELL invalide → fallback', sellToken?.symbol);
        if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
      } else {
        console.log('[attachEthersProvider] SELL conservé =', this.sellTokenSymbol);
      }

      if (!buyValid) {
        const buyToken = this.getDefaultBuyTokenForChain(Number(chainId));
        console.log('[attachEthersProvider] BUY invalide → fallback', buyToken?.symbol);
        if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);
      } else {
        console.log('[attachEthersProvider] BUY conservé =', this.buyTokenSymbol);
      }

      this.cd.detectChanges();

      // Connexion OK → on peut lever le skip auto-restore
      sessionStorage.removeItem('st/skipAutoRestoreOnce');

    } catch (err: any) {
      // Nettoyage minimal en cas d'échec
      sessionStorage.removeItem('st/skipAutoRestoreOnce');
      alert('Connexion échouée: ' + (err?.message || 'Unknown error'));
    }
  }





  //async connectWallet(): Promise<void> {
  //  try {
  //    if (!modal) initAppKit('8d74b0ff39c361ecaa9c3dd96ac0055c');

  //    await modal!.open({ view: 'Connect', namespace: 'eip155' });



  //    const provider: any = await new Promise((resolve) => {
  //      let done = false;
  //      const unsub = modal!.subscribeProviders?.((state: any) => {
  //        if (done) return;

  //        const evm = state?.['eip155'];
  //        if (!evm) return;

  //        // Supporte les deux formes : provider direct ou inclus dans .provider
  //        const p = evm.provider ?? evm;
  //        if (p) {
  //          done = true;
  //          try { unsub?.(); } catch { }

  //          resolve(p);
  //        }
  //      });
  //    });

  //    const pType = modal!.getWalletProviderType?.();


  //    if (typeof provider.request !== 'function') {

  //      throw new Error('Invalid EIP-1193 provider');
  //    }


  //    this.provider = new BrowserProvider(provider);

  //    const signer = await this.provider.getSigner();
  //    const address = await signer.getAddress();
  //    const { chainId } = await this.provider.getNetwork();

  //    this.takerAddress = address;
  //    this.isConnected = true;
  //    this.setChain(Number(chainId));
  //    // 🔄 Attendre le rechargement réel des tokens
  //    await this.refreshTokensForChain();

  //    // Vérifier que popularTokens n'est pas vide
  //    console.log("popularTokens après refresh", this.popularTokens);

  //    // Sélectionner les tokens par défaut
  //    const sellToken = this.getDefaultSellTokenForChain(Number(chainId));
  //    const buyToken = this.getDefaultBuyTokenForChain(Number(chainId));

  //    console.log("sellToken =", sellToken);
  //    console.log("buyToken =", buyToken);

  //    if (sellToken?.symbol) this.selectSellToken(sellToken.symbol);
  //    if (buyToken?.symbol) this.selectBuyToken(buyToken.symbol);

  //      this.cd.detectChanges();

  //  } catch (err: any) {
  //    alert('Connexion échouée: ' + (err?.message || 'Unknown error'));
  //  }
  //}
  async disconnectWallet() {
    try {
      this.closeQuoteWithReason('disconnectWallet');
      localStorage.removeItem('wallet');
      localStorage.setItem('st/skipAutoRestoreOnce', '1');

      // ❌ await this.wc2.disconnect(); ✅ tu gardes si tu l’as déjà
      await this.wc2.disconnect().catch(() => { });

      // ❌ killWalletConnectV2(this.wc2?.signClient)
      // ✅
      await killWalletConnectV2(signClient);

      // MetaMask/injected revoke (inchangé)
      const eth: any = (window as any).ethereum;
      try {
        eth?.removeAllListeners?.();
        if (typeof eth?.request === 'function') {
          await eth.request({
            method: 'wallet_revokePermissions',
            params: [{ eth_accounts: {} }]
          }).catch(() => { });
        }
        if (typeof eth?.disconnect === 'function') {
          await eth.disconnect().catch(() => { });
        }
      } catch (e) {
        console.warn('[disconnect] MM revoke/disconnect:', e);
      }

      // Purge localStorage (inchangé)
      try {
        ['wallet', 'walletconnect', 'walletconnect_session', 'wc_session_id'].forEach(k => localStorage.removeItem(k));
        Object.keys(localStorage)
          .filter(k => k.startsWith('wc@2:') || k.startsWith('w3m') || k.startsWith('wagmi') || k.toLowerCase().includes('appkit'))
          .forEach(k => localStorage.removeItem(k));
      } catch { }

      // IndexedDB
      await purgeWCIndexedDB();

      // ❌ teardownAppKit(this.modal); this.modal = undefined;
      // ✅
      teardownAppKit(modal);
      modal = undefined;

      // Reset UI/state
      this.takerAddress = null;
      this.provider = null;
      this.isConnected = false;
      //this.chainId = null;
      //this.chainInfo = null;
      this.showWcModal = false;
      this.wcUri = '';

    } finally {
      // pas de reload automatique
    }
  }





  getFormattedAddress(address: string | null): string {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }

  // Nouvelle méthode pour basculer entre les modes clair et sombre
  toggleTheme() {
    const body = document.body;
    if (body.classList.contains('light-mode')) {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('dark-mode');
      body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
    }
  }

  // Nouvelle méthode pour vérifier l'état du mode
  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }

  formatAmount(value: string | number, decimals: number = 18, isSellAmount: boolean = false): string {
    try {
      const bigValue = BigInt(value.toString());
      if (isSellAmount) {
        return bigValue.toString() + '.000000';
      }
      const divisor = BigInt(Math.pow(10, decimals));
      const wholePart = bigValue / divisor;
      const fractionalPart = bigValue % divisor;
      const fractionalStr = fractionalPart.toString().padStart(decimals, '0').slice(0, 6);
      const result = `${wholePart}.${fractionalStr}`;
      return result === '0.000000' && bigValue > 0 ? '0.000001' : result;
    } catch (error) {
      console.error('Erreur dans formatAmount :', error, { value, decimals });
      return '0.000000';
    }
  }


  filterTokens(search: string, type: 'sell' | 'buy') {
    const target = search.toLowerCase();

    const filtered = this.availableTokens
      .filter(token => token.symbol.toLowerCase().startsWith(target))
      .sort((a, b) => a.symbol.localeCompare(b.symbol));

    if (type === 'sell') {
      this.filteredSellTokens = filtered;
      if (!filtered.some(t => t.symbol === this.sellTokenSymbol)) {
        this.sellTokenSymbol = filtered.length > 0 ? filtered[0].symbol : '';
      }
    } else {
      this.filteredBuyTokens = filtered;
      if (!filtered.some(t => t.symbol === this.buyTokenSymbol)) {
        this.buyTokenSymbol = filtered.length > 0 ? filtered[0].symbol : '';
      }
    }
  }



  private getBuyTokenBySymbol(symLike: string | null | undefined, chainId: number) {
    const sym = String(symLike ?? '').toUpperCase();
    return this.allTokens.find(
      (t: any) =>
        String(t?.symbol ?? '').toUpperCase() === sym &&
        Number(t?.chainId) === Number(chainId)
    );
  }



  private getTokenBySymbol(symLike: string | null | undefined, chainId: number) {
    const sym = String(symLike ?? '').toUpperCase();
    return this.availableTokens.find(
      (t: any) =>
        String(t?.symbol ?? '').toUpperCase() === sym &&
        Number(t?.chainId) === Number(chainId)
    );
  }

  getTokenAddress(symLike: string | null | undefined, chainId?: number): string {
    const cid = Number(chainId ?? this.chainId ?? 1);

    const raw = String(symLike ?? '').trim();
    // autoriser une adresse directe
    if (/^0x[a-fA-F0-9]{40}$/.test(raw)) return raw;

    const sym = raw.toUpperCase();

    // 1) whitelist / tokens disponibles
    const tok = this.getTokenBySymbol(sym, cid);
    if (tok?.address) return tok.address;

    // 2) fallback connu
    const fb = FALLBACK_TOKEN_ADDRESSES[cid]?.[sym];
    if (fb) return fb;

    // 3) rien trouvé
    return '';
  }

  getBuyTokenAddress(symLike: string | null | undefined, chainId?: number): string {
    const cid = Number(chainId ?? this.chainId ?? 1);

    const raw = String(symLike ?? '').trim();
    // autoriser une adresse directe
    if (/^0x[a-fA-F0-9]{40}$/.test(raw)) return raw;

    const sym = raw.toUpperCase();

    // 1) whitelist / tokens disponibles
    const tok = this.getBuyTokenBySymbol(sym, cid);
    if (tok?.address) return tok.address;

    // 2) fallback connu
    const fb = FALLBACK_TOKEN_ADDRESSES[cid]?.[sym];
    if (fb) return fb;

    // 3) rien trouvé
    return '';
  }





  getTokenDecimalsByAddress(address: string): number | undefined {
    const allTokens = [...this.filteredSellTokens, ...this.filteredBuyTokens];
    const token = allTokens.find(t => t.address?.toLowerCase() === address?.toLowerCase());
    return token?.decimals;
  }


  async fetchNativeTokenUsd(): Promise<number> {
    const t0 = Date.now();
    const cid = this.chainId ?? null;
    const symbol = this.getNativeTokenSymbol(this.chainId ?? 1);
    this.addLog(`[price][nativeUsd][enter] cid=${cid} → symbol=${symbol}`);
    try {
      const prices = await firstValueFrom(this.price.fetchPrices([symbol], 'usd'));
      const val = prices?.[symbol];
      const dt = Date.now() - t0;
      if (Number.isFinite(val) && val > 0) {
        this.addLog(`[price][nativeUsd][ok] ${symbol}/USD=${val} in ${dt}ms`);
        return val;
      } else {
        this.addLog(`[price][nativeUsd][empty] symbol=${symbol} got=${JSON.stringify(prices)} in ${dt}ms`);
        return 0;
      }
    } catch (err: any) {
      const dt = Date.now() - t0;
      this.addLog(`[price][nativeUsd][fail] symbol=${symbol} in ${dt}ms reason=${err?.message || err}`);
      console.warn(`❌ Erreur CoinGecko (${symbol}/USD) :`, err);
      return 0;
    }
  }

  private applyGasFromQuote(q: any) {
    try {
      const toBig = (v: any): bigint => {
        if (v === null || v === undefined) return 0n;
        if (typeof v === 'bigint') return v;
        const s = String(v).trim();
        if (!s) return 0n;
        // hex ou décimal entier
        return s.startsWith('0x') ? BigInt(s) : BigInt(s);
      };
      const pick = <T>(...vals: T[]): T | undefined =>
        vals.find(v => v !== undefined && v !== null && v !== '');

      // --- 1) gasPriceWei (priorité backend → LiFi → tx)
      let gasPriceWei = toBig(
        pick(
          q?.gasPriceWei, q?.GasPriceWei,
          q?.estimate?.gasCosts?.[0]?.price,
          q?.includedSteps?.find((s: any) => s?.estimate?.gasCosts?.length)?.estimate?.gasCosts?.[0]?.price,
          q?.transactionRequest?.gasPrice
        )
      );

      // --- 2) totalNetworkFee (wei) (priorité backend → somme LiFi)
      let totalGasWei = toBig(pick(q?.totalNetworkFee, q?.TotalNetworkFee));

      if (totalGasWei === 0n) {
        const top = (q?.estimate?.gasCosts ?? []).map((g: any) => toBig(g?.amount));
        const steps = (q?.includedSteps ?? [])
          .flatMap((s: any) => (s?.estimate?.gasCosts ?? []).map((g: any) => toBig(g?.amount)));
        totalGasWei = [...top, ...steps].reduce((acc: bigint, v: bigint) => acc + v, 0n);
      }

      // --- 3) fallback : EstimatedGas × GasPriceWei
      if (totalGasWei === 0n) {
        const estGasUnits = toBig(pick(q?.estimatedGas, q?.EstimatedGas));
        if (estGasUnits > 0n && gasPriceWei > 0n) {
          totalGasWei = estGasUnits * gasPriceWei;
        }
      }

      // --- 4) prix USD du token natif (priorité backend → LiFi)
      let nativeTokenUsd =
        Number(pick(q?.gasTokenPriceUsd, q?.GasTokenPriceUsd)) ||
        Number(
          pick(
            q?.estimate?.gasCosts?.[0]?.token?.priceUSD,
            q?.includedSteps?.find((s: any) => s?.estimate?.gasCosts?.length)?.estimate?.gasCosts?.[0]?.token?.priceUSD
          ) ?? 0
        ) || 0;

      // ✅ met exactement à jour ce que faisait updateGasCost
      this.gasPriceWei = gasPriceWei;
      /* this.fullGasWei = totalGasWei;*/
      this.nativeTokenUsd = nativeTokenUsd;

      console.log('[💰 GAS from quote]',
        'fullGasWei=', this.fullGasWei.toString(),
        'gasPriceWei=', this.gasPriceWei.toString(),
        'nativeTokenUsd=', this.nativeTokenUsd);
    } catch (err) {
      console.warn('applyGasFromQuote() error', err);
      this.gasPriceWei = 0n;
      this.fullGasWei = 0n;
      this.nativeTokenUsd = 0;
    }
  }









  /** Montant du SOLDE (≠ sellAmount) dans la devise courante */
  getTokenFiatBalance(symbol: string): string {
    const bal = parseFloat(this.getTokenBalance(symbol) || '0');
    if (!bal) return '';

    const unit = this.priceMap[symbol] ??
      (['USDC', 'USDT'].includes(symbol) ? 1 : 0);

    const total = bal * unit;
    if (!total) return '';

    return total.toLocaleString(
      this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US',
      {
        style: 'currency',
        currency: this.defaultFiat,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );
  }


  /** Calcule le prix payé et fees pour une route (ISO LiFi) */
  private async computeIsoFeeForRoute(route: any): Promise<{
    mode: 'legacy' | 'eip1559' | 'none',
    gasLimit: bigint,
    priceWei: bigint,
    feeWei: bigint
  }> {
    const tr: any = route?.transactionRequest ?? route?.TransactionRequest ?? route ?? {};
    const gasLimitHex = tr.gasLimit ?? tr.gas ?? null;
    const gasPriceHex = tr.gasPrice ?? null;              // legacy
    const maxFeeHex = tr.maxFeePerGas ?? null;          // eip-1559
    const maxPrioHex = tr.maxPriorityFeePerGas ?? null;

    if (!gasLimitHex || (!gasPriceHex && !(maxFeeHex && maxPrioHex))) {
      return { mode: 'none', gasLimit: 0n, priceWei: 0n, feeWei: 0n };
    }

    const gasLimit = BigInt(gasLimitHex);
    let priceWei: bigint;
    let mode: 'legacy' | 'eip1559' = 'legacy';

    if (gasPriceHex) {
      // Legacy
      mode = 'legacy';
      priceWei = BigInt(gasPriceHex);
    } else {
      // EIP-1559: prix « payé » estimé = min(maxFee, baseFee + tip)
      mode = 'eip1559';
      let baseFeeWei = 0n;
      try {
        const rpc: any = this.provider as any;
        const latest = await rpc.send('eth_getBlockByNumber', ['latest', false]);
        baseFeeWei = latest?.baseFeePerGas ? BigInt(latest.baseFeePerGas) : 0n;
      } catch { }
      const maxFee = BigInt(maxFeeHex);
      const maxPrio = BigInt(maxPrioHex);
      const paid = baseFeeWei > 0n ? (baseFeeWei + maxPrio) : maxFee;
      priceWei = paid < maxFee ? paid : maxFee;
    }

    const feeWei = priceWei * gasLimit;
    return { mode, gasLimit, priceWei, feeWei };
  }



  // 🔮 Calcule une preview quasi-identique à MetaMask (t=0)
  // 🔮 Calcule une preview quasi-identique à MetaMask (t=0) — tip dynamique P60 + uplift
  private async previewWalletFeesAligned(rawTx: any) {
    try {
      if (!this.provider || !this.chainId) return;
      if (this.chainId && isL2Chain(Number(this.chainId))) {
        const rpc: any = this.provider as any;
        const unitWei = BigInt(await rpc.send('eth_gasPrice', []));
        const tr0: any = this.quote?.transactionRequest ?? this.quote ?? {};
        const gasLimitHex = tr0.gasLimit ?? tr0.gas ?? this.quote?.estimatedGas ?? this.quote?.EstimatedGas;
        const gasLimit = gasLimitHex ? BigInt(gasLimitHex) : 21000n;

        this.mmUnitWei = unitWei;
        this.gasPriceWei = unitWei;
        this.fullGasWei = unitWei * gasLimit;

        return; // ⛔ pas de estimateGas sur L2
      }

      // 1) Nettoyer la tx (aucun champ de frais ni gasLimit)
      const cleanTx = sanitizeTxForWallet({
        from: this.takerAddress ?? undefined,
        to: rawTx?.to,
        data: rawTx?.data ?? '0x',
        value: rawTx?.value ?? 0n,
        chainId: this.chainId
      });

      const rpc: any = (this.provider as any);

      console.log("[FEE][preview][estimateGas cleanTx]", cleanTx);

      const gasLimit: bigint = await this.provider.estimateGas(cleanTx);
      const bufferedGasLimit: bigint = (gasLimit * 125n) / 100n; // +25%

      // 3) base fee (dernier bloc)
      let baseFeeWei = 0n;
      try {
        const latest = await rpc.send('eth_getBlockByNumber', ['latest', false]);
        baseFeeWei = BigInt(latest?.baseFeePerGas ?? '0x0');
      } catch { baseFeeWei = 0n; }

      // 3bis) priority fee (tip) dynamique = avg(P60 sur 5 blocs) + 0.3 gwei, clampé
      const fallbackTip = 1_500_000_000n; // 1.5 gwei si feeHistory indispo
      let tipWei = fallbackTip;
      try {
        const blocks = 5;
        const percentiles = [70]; // P60 pour un léger biais conservateur
        const fh = await rpc.send('eth_feeHistory', [blocks, 'latest', percentiles]);

        let sum = 0n, n = 0n;
        for (const r of (fh?.reward ?? [])) { if (r?.[0]) { sum += BigInt(r[0]); n++; } }
        const avgP60 = n > 0n ? (sum / n) : 0n;

        const uplift = 300_000_000n;  // +0.3 gwei
        const minTip = 500_000_000n;  // 0.5 gwei
        const maxTip = 3_000_000_000n; // 3 gwei

        const dynamic = avgP60 > 0n ? (avgP60 + uplift) : fallbackTip;
        tipWei = dynamic < minTip ? minTip : (dynamic > maxTip ? maxTip : dynamic);

        // Log de traçage (optionnel)
        console.log('[FEE][tip]', {
          minTip: Number(minTip),
          maxTip: Number(maxTip),
          dynamic: Number(dynamic)
        });

        // Log de traçage (optionnel)
        console.log('[FEE][tip]', {
          p60Gwei: Number(avgP60) / 1e9,
          upliftGwei: Number(uplift) / 1e9,
          usedGwei: Number(tipWei) / 1e9
        });
      } catch {
        tipWei = fallbackTip;
      }

      // 4) MetaMask-style "Marché": maxFeePerGas = 2*baseFee + tip
      const maxWeiPerGas = (baseFeeWei * 2n) + tipWei;


      this.mmBaseFeeWei = baseFeeWei;
      this.mmTipWei = tipWei;
      this.mmUnitWei = maxWeiPerGas;            // prix unitaire “MM-like”
      this.mmBufferedGasLimit = bufferedGasLimit; // juste informatif
      // 5) Coût max affiché (single line "comme MetaMask")
      const feeWei = bufferedGasLimit * maxWeiPerGas;
      this.fullGasWei = feeWei;

      // 6) Conversion USD (prise de prix natif)
      const nativeUsd = await getOnChainNativeUsd(this.chainId, this.provider);
      if (nativeUsd) this.nativeTokenUsd = nativeUsd;

      const feeEth = Number(feeWei) / 1e18;
      const feeUsdRaw = this.nativeTokenUsd ? feeEth * this.nativeTokenUsd : 0;

      // 7) Logs de contrôle — valeurs brutes (pas d’arrondi ici)
      console.log('[FEE][preview][MM-like]', {
        chain: this.chainId,
        gasLimit: gasLimit.toString(),
        bufferedGasLimit: bufferedGasLimit.toString(),
        baseFeeGwei: Number(baseFeeWei) / 1e9,
        tipGwei: Number(tipWei) / 1e9,
        maxFeePerGasGwei: Number(maxWeiPerGas) / 1e9,
        feeEthRaw: feeEth,
        feeUsdRaw: feeUsdRaw
      });
    } catch (e) {
      console.warn('[FEE][preview] fallback on wallet only', e);
    }
  }



  // dans export class SwapComponent { ... ICI ... }

  // ──────────────────────────────────────────────────────────────
  // Helper d'affichage (facultatif)
  private async normalizeAltRoute(
    rIn: any,
    opts: {
      mode: 'no-wallet' | 'l2' | 'l1',
      nativeUsd?: number,
      unitWei?: bigint,            // L2: eth_gasPrice
      paidPerGas?: bigint,         // L1: min(maxFee, baseFee+tip)
      baseFeeWei?: bigint,         // L1 (info)
      tipWei?: bigint,             // L1 (info)
      bufferPct?: number,          // % buffer sur gasLimit
      lifiFallbackCap?: boolean,   // no-wallet: prendre maxFee fourni
      snapshotLiFi?: boolean,      // garder l’affichage "LiFi" par route
      minTipWei?: bigint,
      // affichage reçu estimé
      buyTokenDecimals?: number,
      buyTokenSymbol?: string,
      buyTokenUsdPrice?: number
    }
  ): Promise<any> {
    const r = { ...(rIn ?? {}) }; // clone modifiable
    const tr: any = r?.transactionRequest ?? r?.TransactionRequest ?? r ?? {};
    const dbg = Boolean((this as any).debugAltNormalize);
    const id =
      r?.providerName || r?.tool || r?.provider || r?.routeId || r?.id || r?.name || 'alt';

    const nz = (v: any) => {
      try {
        const s = String(v);
        return (s === '' || s === '0' || s === '0x0' || s === '0x') ? null : s;
      } catch { return null; }
    };
    const toWei = (v: any): bigint => {
      try {
        if (typeof v === 'bigint') return v;
        if (typeof v === 'number') return BigInt(Math.trunc(v));
        if (typeof v === 'string' && v) return v.startsWith('0x') ? BigInt(v) : BigInt(v);
      } catch { }
      return 0n;
    };
    const toEth = (w: any): number => {
      try {
        const n =
          typeof w === 'bigint' ? Number(w) :
            typeof w === 'number' ? w :
              (w != null ? (String(w).startsWith('0x') ? Number(BigInt(w)) : Number(w)) : 0);
        return n / 1e18;
      } catch { return 0; }
    };
    const usd = Number(r.lifiGasTokenPriceUsd ?? opts.nativeUsd ?? 0);

    /* ── 1) Snapshot LiFi (affichage) ─────────────────────── */
    if (opts.snapshotLiFi) {
      const est = r?.estimate ?? r?.Estimate ?? r?.step?.estimate ?? null;
      const toTok = est?.toToken ?? r?.toToken ?? r?.action?.toToken ?? null;

      // a) reçu estimé
      r.toAmountRaw = String(est?.toAmount ?? r?.toAmountRaw ?? 0);
      r.toAmountUsd = est?.toAmountUSD ?? r?.toAmountUsd ?? null;
      r.toTokenDecimals = Number(r?.toTokenDecimals ?? toTok?.decimals ?? opts.buyTokenDecimals ?? 18);
      r.buyTokenSymbol = r.buyTokenSymbol ?? toTok?.symbol ?? opts.buyTokenSymbol;
      if (!r.formattedBuyAmount && r.toAmountRaw && r.toTokenDecimals >= 0) {
        r.formattedBuyAmount = Number(r.toAmountRaw) / Math.pow(10, r.toTokenDecimals);
      }
      r.buyTokenUsdPrice = Number(r.buyTokenUsdPrice ?? opts.buyTokenUsdPrice ?? 0);

      // b) frais LiFi pour affichage
      r.lifiEstimatedGas = r.lifiEstimatedGas ?? r.estimatedGas ?? est?.gasCosts?.[0]?.estimate ?? null;
      r.lifiGasPriceWei = r.lifiGasPriceWei ?? r.gasPriceWei ?? est?.gasCosts?.[0]?.price ?? null;
      r.lifiGasAmountWei = r.lifiGasAmountWei ?? r.gasAmountWei ?? est?.gasCosts?.[0]?.amount ?? null;
      r.lifiGasFeeUsd = r.lifiGasFeeUsd ?? r.gasFeeUsd ?? est?.gasCosts?.[0]?.amountUSD ?? null;
      r.lifiGasTokenPriceUsd = Number(r.lifiGasTokenPriceUsd ?? r.gasTokenPriceUsd ?? opts.nativeUsd ?? 0);
    }

    /* ── 2) MM expected/network/max : flatten depuis singleRoutes[0] ── */
    const sr0 = r?.singleRoutes?.[0] ?? null;
    const mmExpectedFromPayload =
      toWei((r as any).MmExpectedNetworkFeeWei) ||
      toWei((r as any).mmExpectedNetworkFeeWei) ||
      toWei(sr0?.mmExpectedNetworkFeeWei) ||
      0n;
    const mmNetworkFromPayload =
      toWei((r as any).MmNetworkFeeWei) ||
      toWei((r as any).mmNetworkFeeWei) ||
      toWei(sr0?.mmNetworkFeeWei) ||
      0n;
    const mmMaxFromBackend =
      toWei((r as any).MmMaxNetworkFeeWei) ||
      toWei((r as any).mmMaxNetworkFeeWei) ||
      toWei(sr0?.mmMaxNetworkFeeWei) ||
      0n;

    // Exposition au niveau route (pour l’enfant/CTA)
    if (!r.mmExpectedNetworkFeeWei && mmExpectedFromPayload > 0n) r.mmExpectedNetworkFeeWei = mmExpectedFromPayload;
    if (!r.mmNetworkFeeWei && mmNetworkFromPayload > 0n) r.mmNetworkFeeWei = mmNetworkFromPayload;
    if (!r.mmMaxNetworkFeeWei && mmMaxFromBackend > 0n) r.mmMaxNetworkFeeWei = mmMaxFromBackend;

    if (dbg) {
      console.log('[SWAP][ALT][NORM][IN]', {
        id, mode: opts.mode, usd,
        topLevel: {
          mmExpected: (r as any).mmExpectedNetworkFeeWei ?? null,
          mmNetwork: (r as any).mmNetworkFeeWei ?? null,
          mmMax: (r as any).mmMaxNetworkFeeWei ?? null,
        },
        sr0: {
          mmExpected: sr0?.mmExpectedNetworkFeeWei ?? null,
          mmNetwork: sr0?.mmNetworkFeeWei ?? null,
          mmMax: sr0?.mmMaxNetworkFeeWei ?? null,
        },
        lifi: {
          estGas: r.lifiEstimatedGas ?? null,
          priceWei: r.lifiGasPriceWei ?? null,
          amountWei: r.lifiGasAmountWei ?? null,
          feeUsd: r.lifiGasFeeUsd ?? null,
        }
      });
    }

    /* ── 3) Cap MM-like local (si backend muet) ───────────────── */
    const rawLimit =
      toWei(r.lifiEstimatedGas) || toWei(r.estimatedGas) ||
      toWei(tr.gasLimit) || toWei(tr.gas) || 0n;

    const bufferPct = Math.max(0, Number(opts.bufferPct ?? 0));
    const bufferedLimit = rawLimit > 0n ? (rawLimit * BigInt(100 + bufferPct)) / 100n : 0n;

    let mmMaxLocal: bigint = 0n;
    if (opts.mode === 'l1') {
      const pricePerGas = toWei(opts.paidPerGas ?? 0n); // min(maxFee, baseFee+tip) fourni par le parent
      if (bufferedLimit > 0n && pricePerGas > 0n) mmMaxLocal = bufferedLimit * pricePerGas;
    } else if (opts.mode === 'l2') {
      const unitWei = toWei(opts.unitWei ?? 0n);        // eth_gasPrice côté L2
      if (bufferedLimit > 0n && unitWei > 0n) mmMaxLocal = bufferedLimit * unitWei;
    } else {
      // no-wallet: on prend ce qu’on a (backend mm / sinon rien)
      mmMaxLocal = mmMaxFromBackend;
    }

    // Fallback LiFi si aucun MM n’est disponible
    const liFiWei =
      toWei(r.lifiGasAmountWei) ||
      (() => {
        const p = toWei(r.lifiGasPriceWei);
        const g = toWei(r.lifiEstimatedGas);
        return (p > 0n && g > 0n) ? p * g : 0n;
      })();

    // Choix final pour la "cap" exposée à l’enfant (legacy): max-backend → max-local → lifi
    const mmFullWei = (mmMaxFromBackend > 0n ? mmMaxFromBackend :
      (mmMaxLocal > 0n ? mmMaxLocal :
        (liFiWei > 0n ? liFiWei : 0n)));

    // Exposer pour l’enfant (compat: gas.fullWei est une cap/worst-case)
    (r as any).gas = (r as any).gas || {};
    (r as any).gas.fullWei = mmFullWei;

    if (true) {
      const expEth = toEth(r.mmExpectedNetworkFeeWei);
      const netEth = toEth(r.mmNetworkFeeWei);
      const maxEth = toEth(r.mmMaxNetworkFeeWei);
      const lifiEth = toEth(liFiWei);
      const locMaxEth = toEth(mmMaxLocal);
      const fullEth = toEth(mmFullWei);
      const reason =
        (r.mmExpectedNetworkFeeWei ? 'expected_present' :
          r.mmNetworkFeeWei ? 'fallback_mmNetwork' :
            r.mmMaxNetworkFeeWei ? 'fallback_mmMax' :
              liFiWei > 0n ? 'fallback_liFi' : 'missing_all');

      console.log('[SWAP][ALT][NORM][OUT]', {
        id, mode: opts.mode, bufferPct,
        rawLimit: Number(rawLimit), bufferedLimit: Number(bufferedLimit),
        mmExpectedWei: r.mmExpectedNetworkFeeWei ?? null,
        mmNetworkWei: r.mmNetworkFeeWei ?? null,
        mmMaxBackendWei: mmMaxFromBackend || null,
        mmMaxLocalWei: mmMaxLocal || null,
        liFiWei: liFiWei || null,
        gasFullWei: mmFullWei || null,
        mmExpectedEth: expEth, mmExpectedUsd: expEth && usd ? expEth * usd : null,
        mmNetworkEth: netEth, mmNetworkUsd: netEth && usd ? netEth * usd : null,
        mmMaxEth: maxEth, mmMaxUsd: maxEth && usd ? maxEth * usd : null,
        liFiEth: lifiEth, liFiUsd: lifiEth && usd ? lifiEth * usd : null,

        gasFullEth: fullEth, gasFullUsd: fullEth && usd ? fullEth * usd : null,
        reason
      });
    }

    return r;
  }



  private installRpcDebugProbeOnWindow(label: string = 'global'): void {
    const w: any = (window as any);
    const p: any = w?.ethereum;
    if (!p) { this.addLog(`[rpc] debug probe skipped (${label}): no window.ethereum`); return; }
    if (p.__rpcDebugProbeInstalled) return;

    const SENSITIVE = new Set([
      'wallet_switchEthereumChain', 'wallet_addEthereumChain', 'eth_requestAccounts',
      'eth_sendTransaction', 'eth_sign', 'personal_sign',
      'eth_signTypedData', 'eth_signTypedData_v3', 'eth_signTypedData_v4'
    ]);

    if (typeof p.request === 'function') {
      const origReq = p.request.bind(p);
      p.request = async (args: { method: string; params?: any[] }) => {
        try {
          if (args?.method && SENSITIVE.has(args.method)) {
            this.addLog(`[rpc][${label}] ${args.method} params=${JSON.stringify(args.params ?? [])}`);
          }
        } catch { }
        return origReq(args);
      };
    }
    if (typeof p.send === 'function') {
      const origSend = p.send.bind(p);
      p.send = async (method: string, params?: any[]) => {
        try {
          if (method && SENSITIVE.has(method)) {
            this.addLog(`[rpc][${label}] ${method} params=${JSON.stringify(params ?? [])}`);
          }
        } catch { }
        return origSend(method, params);
      };
    }
    p.__rpcDebugProbeInstalled = true;
    this.addLog(`[rpc] debug probe installed (${label}) on window.ethereum`);
  }

  private _installQuotePropDebugHook() {
    const self: any = this as any;
    if (!('quote' in self)) return;

    let _q = self['quote'];
    try {
      Object.defineProperty(self, 'quote', {
        configurable: true,
        enumerable: true,
        get() { return _q; },
        set(v: any) {
          if (_q && !v) {
            const st = new Error().stack?.split('\n').slice(1, 4).map(s => s.trim()).join(' | ');
            self.addLog(`🧯 [modal] quote -> falsy (FERMETURE SANS closeQuote*) | stack=${st || 'n/a'}`);
          }
          _q = v;
        }
      });
      this.addLog('🔧 [modal] debug hook installed on quote');
    } catch (e) {
      this.addLog(`⚠️ [modal] hook install failed on quote: ${e}`);
    }
  }


  async fetchQuote() {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    // ─────────────────────────────────────────────
    // TEST 2 — MOCK QUOTE (no API, no on-chain, no provider)
    // ─────────────────────────────────────────────
    const MOCK_MODE = true;              // ⬅️ toggle easy
    const MOCK_DELAY_MS = 0;             // ⬅️ mets 300-800ms si tu veux simuler un délai “réseau”
    const MOCK_MIN_GAS_WEI = 500_000_000_000_000n; // 0.0005 ETH (juste pour afficher un truc)

    // reset UI like prod flow
    this.closeQuoteWithReason?.('fetchQuote(mock)');
    this.swapDisabled = false;
    this.isLoadingQuote = true;
    this.quoteErrorMessage = null;

    const effectiveChain = this.chainId ?? (this as any).chainIdFromSeo ?? 1;

    // ⚠️ pour le test, on NE bloque PAS si chainId/token addr manquants
    // on veut juste ouvrir la quote UI et ensuite tester WC.
    try {
      this.addLog?.(
        `[quote][mock] start | chain=${effectiveChain} addr=${this.takerAddress ?? '(null)'} ` +
        `sell=${this.sellTokenSymbol} buy=${this.buyTokenSymbol} amount=${this.sellAmount ?? '(null)'}`
      );
      const p: any = this.provider as any;
      this.addLog?.(`[quote][mock][probe] providerPresent=${!!p} (no calls made)`);
    } catch { /* no-op */ }

    // helpers
    const now = Math.floor(Date.now() / 1000);
    const sellSym = (this.sellTokenSymbol || 'TOKEN').toUpperCase();
    const buySym = (this.buyTokenSymbol || 'TOKEN').toUpperCase();

    const sellDecimals = (this as any).getTokenDecimals ? (this as any).getTokenDecimals(sellSym) : 18;
    const buyDecimals = (this as any).getTokenDecimals ? (this as any).getTokenDecimals(buySym) : 18;

    // On fabrique un amount "raw" cohérent pour l’UI
    const sellAmountInput = (this.sellAmount ?? '1').toString().replace(',', '.').trim();
    const sellAmountRaw = (this as any).toAmountDecimals
      ? (this as any).toAmountDecimals(sellAmountInput, sellSym)   // ton helper
      : sellAmountInput;

    // buyAmount mock: +1.5% juste pour visuel
    const buyAmountRaw = (() => {
      // si c’est déjà un string “raw”, on fait simple: on concat pas, on laisse une valeur plausible
      // (ton UI se base souvent sur formatAmount(decimals))
      return (typeof sellAmountRaw === 'string' && sellAmountRaw.length > 0)
        ? sellAmountRaw
        : '0';
    })();

    const fmt = (x: any, d: number) =>
      (this as any).formatAmount ? (this as any).formatAmount(String(x), d) : String(x);

    // transactionRequest mock (juste pour que les chemins UI qui checkent existence soient satisfaits)
    const mockTx = {
      to: '0x0000000000000000000000000000000000000001',
      data: '0x',
      value: '0x0',
      gasLimit: '0x5208', // 21000
      // champs optionnels si ton UI les affiche
      maxFeePerGas: '0x0',
      maxPriorityFeePerGas: '0x0'
    };

    const buildMockQuote = () => {
      // ✅ “quote” shape minimal + compatible avec ton UI (inspiré de buildUltraQuote)
      const q: any = {
        // flags / meta
        isMock: true,
        chainId: effectiveChain,
        deadline: (now + 1800).toString(),
        nonce: '0',

        // tokens
        inTokenAddress: this.sellTokenAddress ?? this.getTokenAddress?.(sellSym, effectiveChain) ?? '',
        outTokenAddress: this.buyTokenAddress ?? this.getTokenAddress?.(buySym, effectiveChain) ?? '',
        sellTokenSymbol: sellSym,
        buyTokenSymbol: buySym,

        // amounts (raw)
        amountDecimals: String(sellAmountRaw),
        buyAmount: String(buyAmountRaw),

        // UI formatted
        formattedSellAmount: fmt(sellAmountRaw, sellDecimals),
        formattedBuyAmount: fmt(buyAmountRaw, buyDecimals),

        // fees mock (pour les sections “gas”)
        totalNetworkFee: MOCK_MIN_GAS_WEI.toString(),
        formattedGasFee: fmt(MOCK_MIN_GAS_WEI.toString(), 18),

        // tx request (pour rendre le panneau “execute” et l’UX identiques)
        transactionRequest: mockTx,

        // alts mock (si ton composant enfant lit quote.singleRoutes)
        singleRoutes: [
          {
            key: 'mock-cheapest',
            provider: 'mock',
            title: 'Mock route (CHEAPEST)',
            buyAmount: String(buyAmountRaw),
            gasAmountWei: MOCK_MIN_GAS_WEI.toString(),
            totalNetworkFee: MOCK_MIN_GAS_WEI.toString()
          },
          {
            key: 'mock-fastest',
            provider: 'mock',
            title: 'Mock route (FASTEST)',
            buyAmount: String(buyAmountRaw),
            gasAmountWei: (MOCK_MIN_GAS_WEI + 200_000_000_000_000n).toString(),
            totalNetworkFee: (MOCK_MIN_GAS_WEI + 200_000_000_000_000n).toString()
          }
        ]
      };

      this.quote = q;

      // si tu relies aussi otherRoutes ailleurs
      try { (this as any).otherRoutes = q.singleRoutes; } catch { }

      // garde une cohérence avec tes champs gas “fullGasWei”
      try { this.fullGasWei = MOCK_MIN_GAS_WEI; } catch { }

      // si tu as ultraMode dans ton flow, on le met stable
      try { this.ultraMode = false; } catch { }

      this.addLog?.(`[quote][mock] done | hasQuote=${!!this.quote} routes=${q.singleRoutes?.length ?? 0}`);
    };

    try {
      if (!MOCK_MODE) {
        // si un jour tu veux remettre la vraie version, tu replaces ici ton code actuel.
        this.addLog?.('[quote][mock] MOCK_MODE=false (noop)');
        return;
      }

      if (MOCK_DELAY_MS > 0) {
        await new Promise(r => setTimeout(r, MOCK_DELAY_MS));
      }
      buildMockQuote();

    } catch (e: any) {
      console.error('❌ [quote][mock] error', e);
      this.addLog?.(`[quote][mock] error | ${e?.message || e}`);
      this.quoteErrorMessage = "⚠️ Mock quote failed.";
      // this.quote = null; // optionnel
    } finally {
      this.isLoadingQuote = false;
      this.addLog?.('[quote][mock] complete');
    }

    // comme dans ton flow original
    this.lockBodyScroll?.(true);
  }

















  get isSwap(): boolean {
    const value = this.route.snapshot.queryParamMap.get('bridge');
    return value === null || value === '0';
  }

  // Mapping simple des décimales par token symbol
  async prepareUltraQuoteAndPermit(data: any): Promise<void> {
    try {
      if (!this.sellAmount || !this.sellTokenSymbol || !this.buyTokenSymbol) {
        throw new Error('Paramètres de swap incomplets.');
      }

      this.sellTokenAddress = this.getTokenAddress(this.sellTokenSymbol);
      this.buyTokenAddress = this.getTokenAddress(this.buyTokenSymbol);

      if (!this.sellTokenAddress || !this.buyTokenAddress) {
        throw new Error('Impossible de déterminer les adresses des tokens.');
      }

      this.buildUltraQuote(data);  // ✅ Quote enrichie, mais sans signature

      console.log('✅ [prepareUltraQuoteAndPermit] Quote prête (sans signature)');

    } catch (err: any) {
      console.error('❌ Erreur prepareUltraQuoteAndPermit :', err.message ?? err);
      /*this.quote = null;*/
      this.permit = undefined;
      this.permitSig = undefined;
    }
  }



  buildUltraQuote(data: any): void {
    if (!this.sellTokenAddress || !this.buyTokenAddress || !this.sellAmount) {
      console.error("❌ Paramètres manquants pour buildUltraQuote");
      return;
    }

    const sellDecimals = this.getTokenDecimals(this.sellTokenSymbol);
    const buyDecimals = this.getTokenDecimals(this.buyTokenSymbol);

    const sellAmountRaw = this.toAmountDecimals(this.sellAmount, this.sellTokenSymbol);
    const gasPriceDecimals = this.gasPriceWei?.toString() ?? '0';

    this.quote = {
      ...data,
      IsPermit2: data.isPermit2 === true,
      inTokenAddress: this.sellTokenAddress,
      outTokenAddress: this.buyTokenAddress,
      amountDecimals: sellAmountRaw,
      flag: data.flag ?? '0',
      permitSig: this.permitSig ?? '',
      feeAmount1: data.feeAmount1 ?? '0',
      feeAmount2: data.feeAmount2 ?? '0',
      gasPriceDecimals,
      nonce: data.nonce ?? '0',
      deadline: data.deadline ?? Math.floor(Date.now() / 1000 + 1800).toString(),
      permit: this.permit ?? data.permit ?? '',

      // UI
      formattedSellAmount: this.formatAmount(sellAmountRaw, sellDecimals),
      formattedBuyAmount: this.formatAmount(data.buyAmount, buyDecimals),
      formattedGasFee: this.formatAmount(data.totalNetworkFee ?? '0', 18),
      sellTokenSymbol: this.sellTokenSymbol,
      buyTokenSymbol: this.buyTokenSymbol
    };

    console.log('✅ [buildUltraQuote] Quote enrichie :', this.quote);
  }

  private getTokenDecimals(symbol: string): number {
    const map: Record<string, number> = {
      ETH: 18, WETH: 18,
      USDC: 6, USDT: 6,
      DAI: 18, MATIC: 18
      // ajoute d’autres si besoin
    };
    return map[symbol?.toUpperCase()] ?? 18;
  }
  /** Poll on-chain until allowance >= needed (or timeout/partial). */
  private async pollAllowanceUntil(
    tokenAddr: string,
    spender: string,
    owner: string,
    needed: bigint,
    opts: { timeoutMs?: number; intervalMs?: number } = {}
  ): Promise<'ok' | 'partial' | 'timeout'> {
    const { timeoutMs = 60_000, intervalMs = 1_000 } = opts;
    if (!this.provider) return 'timeout';
    const signer = await this.provider.getSigner();
    const erc20 = new Contract(tokenAddr, ERC20_ABI, signer);
    const t0 = Date.now();
    let last = 0n;

    this.addLog(`[SWAP][APPROVE][POLL] start | token=${tokenAddr} spender=${spender} needed=${needed}`);

    while (true) {
      try {
        const cur = await (erc20['allowance'] as (o: string, s: string) => Promise<bigint>)(owner, spender);
        if (cur !== last) {
          this.addLog(`[SWAP][APPROVE][POLL] tick | allowance=${cur}`);
          last = cur;
        }
        if (cur >= needed) {
          this.addLog(`[SWAP][APPROVE][POLL] ok | allowance=${cur} ≥ needed=${needed}`);
          return 'ok';
        }
      } catch { /* transient RPC read; ignore */ }

      if (Date.now() - t0 > timeoutMs) {
        this.addLog(`[SWAP][APPROVE][POLL] timeout ${timeoutMs}ms | last=${last}`);
        return last > 0n && last < needed ? 'partial' : 'timeout';
      }
      await new Promise(r => setTimeout(r, intervalMs));
    }
  }

  bridgeDisabled = true;
  bridgeReasons: string[] = [];
  isBridgeDisabled(): boolean {
    const reasons: string[] = [];

    // 1) Wallet
    if (!this.takerAddress) reasons.push('WALLET_DISCONNECTED');

    // 2) Montant invalide
    const amountOk = Number(this.sellAmount) > 0;
    if (!amountOk) reasons.push('INVALID_AMOUNT');

    // 3) Gaz natif insuffisant ?
    const insufficientNative = this.hasInsufficientGasBuffer;
    if (insufficientNative) reasons.push('INSUFFICIENT_NATIVE_GAS');

    // 4) Appliquer le bypass (on retire uniquement la raison gaz)
    this.bridgeReasons = this.debugBypassGasCheck
      ? reasons.filter(r => r !== 'INSUFFICIENT_NATIVE_GAS')
      : reasons;

    this.bridgeDisabled = this.bridgeReasons.length > 0;
    return this.bridgeDisabled;
  }
  private _scrollY = 0;


  private lockScroll(): void {
    this._scrollY = window.scrollY || window.pageYOffset || 0;
    const s = document.body.style;
    s.position = 'fixed';
    s.top = `-${this._scrollY}px`;
    s.left = '0';
    s.right = '0';
    s.width = '100%';
    // Bonus anti-overscroll (mobile):
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overscrollBehavior = 'none';
  }

  private unlockScroll(): void {
    const y = this._scrollY || 0;
    const s = document.body.style;
    s.position = '';
    s.top = '';
    s.left = '';
    s.right = '';
    s.width = '';
    document.documentElement.style.overscrollBehavior = '';
    document.body.style.overscrollBehavior = '';
    window.scrollTo(0, y);
  }


  async fetchBridgeQuote() {
    const _run = ((this as any)._bRun = ((this as any)._bRun ?? 0) + 1);
    const _t0 = performance.now?.() ?? Date.now();
    const _dt = () => Math.round((performance.now?.() ?? Date.now()) - _t0);
    const _L = (m: string, o?: any) => {
      try { this.addLog(`[BRIDGE][QUOTE][run=${_run}][+${_dt()}ms] ${m}${o ? ' ' + JSON.stringify(o) : ''}`); } catch { }
    };
    this.closeQuote();
    this.isLoadingQuote = true;
    this.quoteErrorMessage = null;

    // ───────── helpers ─────────
    const toHex = (x: bigint | number | string | undefined | null): string => {
      if (x == null) return '0x0';
      if (typeof x === 'string' && x.startsWith('0x')) return x;
      return '0x' + BigInt(String(x)).toString(16);
    };
    const ceilTo = (x: bigint, step: bigint) => ((x + step - 1n) / step) * step;
    const MICRO_WEI = 1_000_000n; // micro-wei pour arrondis propres
    const nativeSymbol = (cid: number) =>
      ({ 1: 'ETH', 10: 'ETH', 56: 'BNB', 137: 'MATIC', 8453: 'ETH' } as any)[cid] ?? 'ETH';

    // Parse "gasTokenPriceUsd" (gère "0,74", "0.74 USD", " $1,234.56 ")
    const parseUsd = (input: any): number => {
      if (input == null) return 0;
      if (typeof input === 'number') return Number.isFinite(input) ? input : 0;
      const s = String(input).replace(/[^\d.,-]/g, '').replace(',', '.');
      const n = parseFloat(s);
      return Number.isFinite(n) ? n : 0;
    };

    const buildGasOverrides = (tr: any) => {
      const ov: any = {};
      const gasLimitHex = tr?.gasLimit ?? tr?.gas;
      if (gasLimitHex) ov.gasLimit = BigInt(gasLimitHex);
      if (tr?.maxFeePerGas && tr?.maxPriorityFeePerGas) {
        ov.maxFeePerGas = BigInt(tr.maxFeePerGas);
        ov.maxPriorityFeePerGas = BigInt(tr.maxPriorityFeePerGas);
      } else if (tr?.gasPrice) {
        ov.gasPrice = BigInt(tr.gasPrice); // legacy → on convertira en 1559
      }
      return ov;
    };

    // ───────── validations ─────────
    const sellToken = this.sellTokenSymbol;
    const buyToken = this.buyTokenSymbol;

    // ✅ iOS/locale safety: always normalize decimal comma -> dot for computations + backend
    const sellAmountInput = (this.sellAmount ?? '').toString();
    const sellAmountNorm = sellAmountInput.replace(/\s+/g, '').replace(',', '.');
    if (sellAmountNorm !== sellAmountInput) {
      try { this.sellAmount = sellAmountNorm as any; } catch { /* no-op */ }
      _L('❌ Params missing', { sellAmount: sellAmountNorm, sellToken, buyToken });
    }

    if (!sellAmountNorm || !sellToken || !buyToken) {

      _L('❌ Params missing', { sellAmount: this.sellAmount, sellToken, buyToken });
      this.isLoadingQuote = false;
      return;
    }

    _L('[pre] symbols', { sellToken, buyToken, sellAmount_input: sellAmountNorm });

    // décimales + amount en wei
    let decimals = tokenDecimalsMap[sellToken];
    if (decimals === undefined) {
      const tokenAddr = this.getTokenAddress(sellToken);
      decimals = this.getTokenDecimalsByAddress(tokenAddr) ?? 18;
    }
    const rawSellAmount = this.toWei(sellAmountNorm, decimals ?? 18);

    const taker = this.takerAddress ?? environment.defaultTaker;
    const fromChainId = this.chainId ?? 1;
    const toChainId = this.buyChainId ?? 137;
    const slippage = 100;       // 1% bps
    const bridge = 'openocean'; // adapte si besoin

    const _nativeSymbol = (cid: number) =>
      ({ 1: 'ETH', 10: 'ETH', 56: 'BNB', 137: 'POL', 8453: 'ETH' } as any)[cid] ?? 'ETH';
    _L('[pre] context', {
      isConnected: this.isConnected,
      chainId_now: this.chainId, buyChainId_now: this.buyChainId,
      fromChainId_used: fromChainId, toChainId_used: toChainId,
      fromNative: _nativeSymbol(fromChainId), toNative: _nativeSymbol(toChainId),
      decimals_used: decimals, rawSellAmount: String(rawSellAmount)
    });

    try {
      // ───────── appel backend ─────────
      _L('→ getQuote()');
      const sellTokenAddr = this.getTokenAddress(sellToken, fromChainId);
      const buyTokenAddr = this.getBuyTokenAddress(buyToken, toChainId);
      console.log('[BRIDGE][SELLTOKEN_ADRESSES]', sellTokenAddr);
      console.log('[BRIDGE][BUYTOKEN_ADRESSES]', buyTokenAddr);
      const resp = await firstValueFrom(
        this.bridgeApi.getQuote(
          sellTokenAddr, buyTokenAddr, rawSellAmount, taker,
          fromChainId, toChainId, slippage, bridge
        )
      );
      if (!resp?.success) throw new Error(resp?.message || 'Bridge quote error');
      const data = resp.data ?? resp;
      console.log('[BRIDGE][RAW_QUOTE]', JSON.stringify(data, (k, v) => typeof v === 'bigint' ? v.toString() : v, 2));
      _L('← getQuote()', {
        ok: !!resp?.success, msg: resp?.message,
        quote_from: Number(data?.fromChainId ?? data?.FromChainId ?? fromChainId),
        quote_to: Number(data?.toChainId ?? data?.ToChainId ?? toChainId),
        toolKey: data?.toolKey ?? data?.ToolKey, source: data?.Source
      });

      // base UI
      this.quote = {
        ...data,
        formattedSellAmount: resp.formattedSellAmount,
        formattedBuyAmount: resp.formattedBuyAmount,
        formattedGasFee: resp.formattedGasFee ?? this.formatAmount(data.totalNetworkFee ?? '0', 18)
      };

      // sécurité provider suspect
      const tool = this.quote?.toolKey?.toLowerCase?.();
      const src = this.quote?.Source?.toLowerCase?.();
      if (tool === 'gaszipbridge' || src === 'gaszipbridge') {
        this.quote = null;
        this.quoteErrorMessage = this.translate.instant('QUOTE_UNAVAILABLE_BODY');
        this.isLoadingQuote = false;
        return;
      }

      // ───────── Références réseau 1559 ─────────
      let baseFeeWei = 0n;
      let tipMinWei = 1_000_000_000n; // 1 gwei fallback
      if (this.provider) {
        const rpc = this.provider as any;
        try {
          const latest = await rpc.send('eth_getBlockByNumber', ['latest', false]);
          baseFeeWei = latest?.baseFeePerGas ? BigInt(latest.baseFeePerGas) : 0n;
        } catch (e) { console.warn('[BRIDGE] baseFee fetch KO', e); _L('[warn] baseFee fetch KO'); }

        // skip sur Arbitrum ou fallback direct
        if ((this.chainId ?? 1) === 42161) {
          // Arbitrum : legacy → juste utiliser gasPrice
          try {
            const gp = await rpc.send('eth_gasPrice', []);
            tipMinWei = BigInt(gp);
          } catch {/* keep fallback */ }
        } else {
          try {
            const tipHex = await rpc.send('eth_maxPriorityFeePerGas', []);
            if (tipHex) tipMinWei = BigInt(tipHex);
          } catch {
            try {
              const fh = await rpc.send('eth_feeHistory', [6, 'latest', [50, 75]]);
              const avg = (a: string[]) => a.length ? a.map(x => BigInt(x)).reduce((p, c) => p + c, 0n) / BigInt(a.length) : 0n;
              const p50 = avg(fh.reward.map((r: string[]) => r[0]));
              const p75 = avg(fh.reward.map((r: string[]) => r[1]));
              tipMinWei = (p50 > 0n ? p50 : (p75 > 0n ? p75 : tipMinWei));
            } catch {/* keep fallback */ }
          }
        }
      }

      // mémoriser pour les ALT
      (this as any).tipMinWei = tipMinWei;
      _L('⛽ base/tip', { baseFeeGwei: Number(baseFeeWei) / 1e9, tipMinGwei: Number(tipMinWei) / 1e9 });

      const paidFrom1559 = (maxFee: bigint, maxPrio: bigint) => {
        let mf = maxFee, mp = maxPrio;
        const MIN_FLOOR = 1_000_000_000n; // 1 gwei

        // Si la route fournit déjà un tip, on le respecte (on met juste un plancher doux)
        if (mp === 0n) mp = tipMinWei;      // seulement si absent
        if (mp < MIN_FLOOR) mp = MIN_FLOOR; // petit plancher, pas de boost au p50/p75

        // Ne pas "monter" le maxFee; on le complète seulement s'il manque (legacy -> 1559)
        if (mf === 0n) mf = baseFeeWei + mp;
        // puis calcule paid = min(mf, baseFee + mp) comme tu le fais déjà

        mp = ceilTo(mp, MICRO_WEI);
        mf = ceilTo(mf, MICRO_WEI);
        const paid = (baseFeeWei + mp) < mf ? (baseFeeWei + mp) : mf;
        return { paid, mf, mp };
      };

      // ───────── Prix USD natif (main route) — robuste ─────────
      let mmUsdPrice =
        parseUsd(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd);

      if (!mmUsdPrice || mmUsdPrice <= 0) {
        try {
          if (this.provider) {
            mmUsdPrice = (await this.nativeTokenPrice.getOnChainUsd(Number(fromChainId), this.provider)) || 0;
          }
        } catch { /* ignore */ }
      }
      if (!mmUsdPrice || mmUsdPrice <= 0) {
        try {
          mmUsdPrice = (await this.nativeTokenPrice.getUsdPrice(Number(fromChainId))) || 0;
        } catch { /* ignore */ }
      }
      this.nativeTokenUsd = mmUsdPrice || 0;

      // ───────── Route principale (ISO MM) ─────────
      const tr0: any = data?.transactionRequest ?? data?.tx ?? data?.TransactionRequest ?? {};
      let ov = buildGasOverrides(tr0);

      // convert legacy -> 1559 si besoin (mimer le legacy sans sur-booster le tip)
      if (ov.gasPrice && (!ov.maxFeePerGas || !ov.maxPriorityFeePerGas)) {
        const ONE_GWEI = 1_000_000_000n;
        const g = BigInt(ov.gasPrice);              // gasPrice legacy proposé par la route
        // essayer d'approcher g = baseFee + priority ; au minimum 1 gwei de priority
        let mp = (baseFeeWei > 0n && g > baseFeeWei) ? (g - baseFeeWei) : ONE_GWEI;
        if (mp < ONE_GWEI) mp = ONE_GWEI;           // floor 1 gwei
        // (optionnel) limiter le tip pour éviter des valeurs aberrantes :
        // if (mp > 3_000_000_000n) mp = 3_000_000_000n; // 3 gwei max

        let mf = baseFeeWei + mp;                    // cap minimal cohérent
        ov.maxPriorityFeePerGas = ceilTo(mp, MICRO_WEI);
        ov.maxFeePerGas = ceilTo(mf, MICRO_WEI);
        delete ov.gasPrice;
      }


      // gasLimit → estimate + buffer 12% si possible
      let gasLimit = ov.gasLimit ?? 0n;
      if (this.provider && tr0?.to && tr0?.data) {
        try {
          const signer = await this.provider.getSigner();
          const from = await signer.getAddress();
          const est = await this.provider.estimateGas({ from, to: tr0.to, data: tr0.data, value: tr0.value ?? '0x0' });
          const withBuffer = (BigInt(est.toString()) * 112n) / 100n;
          if (withBuffer > gasLimit) gasLimit = withBuffer;
        } catch {/* ignore */ }
      }
      if (gasLimit === 0n) gasLimit = 21000n;
      ov.gasLimit = gasLimit;

      // prix payé (attendu) + caps arrondies
      const calc0 = paidFrom1559(BigInt(ov.maxFeePerGas ?? 0n), BigInt(ov.maxPriorityFeePerGas ?? 0n));
      ov.maxFeePerGas = calc0.mf;
      ov.maxPriorityFeePerGas = calc0.mp;
      const expectedPaidWei0 = calc0.paid;     // min(maxFee, baseFee+tip)
      const maxPaidWei0 = ov.maxFeePerGas;     // plafond

      // fees attendus vs max
      const mmExpectedNetworkFeeWei: bigint = expectedPaidWei0 * gasLimit;
      const mmMaxNetworkFeeWei: bigint = (ov.maxFeePerGas as bigint) * gasLimit;
      const mmExpectedNetworkFeeNative = Number(mmExpectedNetworkFeeWei) / 1e18;
      const mmMaxNetworkFeeNative = Number(mmMaxNetworkFeeWei) / 1e18;

      // payload RPC propre
      const txRpc = {
        to: tr0?.to,
        data: tr0?.data ?? '0x',
        value: tr0?.value ?? '0x0',
        gas: toHex(gasLimit), // “Site suggéré”
        maxFeePerGas: toHex(ov.maxFeePerGas),
        maxPriorityFeePerGas: toHex(ov.maxPriorityFeePerGas),
        type: '0x2'
      };

      // ───────── injection UI ─────────
      this.gasPriceWei = expectedPaidWei0;        // attendu
      this.fullGasWei = mmExpectedNetworkFeeWei;

      this.quote = {
        ...this.quote,
        transactionRequest: { ...(this.quote?.transactionRequest ?? {}), ...txRpc },

        estimatedGas: gasLimit.toString(),
        gasPriceWei: expectedPaidWei0.toString(),
        totalNetworkFee: mmExpectedNetworkFeeWei.toString(), // “site-suggéré” (attendu)

        // Attendu (MM)
        mmPaidGasPriceWei: expectedPaidWei0.toString(),
        mmExpectedNetworkFeeWei: mmExpectedNetworkFeeWei.toString(),
        mmExpectedNetworkFeeNative,

        // Max (plafond MM)
        mmMaxFeePerGasWei: maxPaidWei0.toString(),
        mmMaxNetworkFeeWei: mmMaxNetworkFeeWei.toString(),
        mmMaxNetworkFeeNative,

        // Back-compat
        mmGasLimit: gasLimit.toString(),
        mmPriorityFeeWei: ov.maxPriorityFeePerGas.toString(),
        mmNetworkFeeWei: mmExpectedNetworkFeeWei.toString(),
        mmNetworkFeeNative: mmExpectedNetworkFeeNative,
        mmGasPriceGwei: Number(expectedPaidWei0) / 1e9
      };


      _L('[fees] main', {
        expectedWei: String(mmExpectedNetworkFeeWei),
        maxWei: String(mmMaxNetworkFeeWei),
        gasLimit: String(gasLimit), paidGwei: Number(expectedPaidWei0) / 1e9
      });


      // USD pour les deux lignes MM (avec fallback de prix)
      const priceForMmUsd =
        (this.nativeTokenUsd && this.nativeTokenUsd > 0)
          ? this.nativeTokenUsd
          : parseUsd(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd);

      if (priceForMmUsd && priceForMmUsd > 0) {
        (this.quote as any).mmExpectedNetworkFeeUsd = mmExpectedNetworkFeeNative * priceForMmUsd;
        (this.quote as any).mmMaxNetworkFeeUsd = mmMaxNetworkFeeNative * priceForMmUsd;
        (this.quote as any).mmNetworkFeeUsd = (this.quote as any).mmExpectedNetworkFeeUsd; // back-compat
      }

      console.log('[BRIDGE][MAIN]', {
        baseFeeGwei: Number(baseFeeWei) / 1e9,
        tipMinGwei: Number(tipMinWei) / 1e9,
        expectedGwei: Number(expectedPaidWei0) / 1e9,
        maxGwei: Number(maxPaidWei0) / 1e9,
        gasLimit: gasLimit.toString(),
        expectedFeeEth: mmExpectedNetworkFeeNative,
        maxFeeEth: mmMaxNetworkFeeNative,
        nativeUsd: this.nativeTokenUsd
      });
      console.log('[BRIDGE][MAIN][RPC→MM]', txRpc);

      // ===== ALTERNATIVE ROUTES — ISO MetaMask =====
      {
        let nativeUsdForAlts = this.nativeTokenUsd ?? 0;
        if (!nativeUsdForAlts || nativeUsdForAlts <= 0) {
          try {
            if (this.provider) {
              const onchain = await this.nativeTokenPrice.getOnChainUsd(Number(fromChainId), this.provider);
              if (onchain && onchain > 0) nativeUsdForAlts = onchain;
            }
          } catch { /* ignore */ }
          if (!nativeUsdForAlts || nativeUsdForAlts <= 0) {
            nativeUsdForAlts =
              parseUsd(data?.gasTokenPriceUsd ?? data?.GasTokenPriceUsd) ||
              (await this.nativeTokenPrice.getUsdPrice(Number(fromChainId))) || 0;
          }
        }

        const routes: any[] = (data?.singleRoutes ?? data?.SingleRoutes ?? []).filter(Boolean);
        if (routes.length) {
          const baseFeeRef: bigint = baseFeeWei;
          const tipMinRef: bigint = (this as any).tipMinWei ?? 1_000_000_000n;
          const ceilToMicro = (x: bigint) => ((x + 1_000_000n - 1n) / 1_000_000n) * 1_000_000n;

          for (const r of routes) {
            const trR: any = r?.transactionRequest ?? r?.TransactionRequest ?? r ?? {};

            const gasLimitHex = trR?.gasLimit ?? trR?.gas ?? null;
            const gasPriceHex = trR?.gasPrice ?? null;
            const maxFeeHex = trR?.maxFeePerGas ?? null;
            const maxPrioHex = trR?.maxPriorityFeePerGas ?? null;

            let gasLimitAlt = gasLimitHex ? BigInt(gasLimitHex) : 21000n;

            let maxFeePg: bigint;
            let maxPrioPg: bigint;
            if (gasPriceHex && !(maxFeeHex && maxPrioHex)) {
              maxPrioPg = tipMinRef;
              maxFeePg = baseFeeRef + maxPrioPg;
            } else {
              maxPrioPg = maxPrioHex ? BigInt(maxPrioHex) : tipMinRef;
              if (maxPrioPg < tipMinRef) maxPrioPg = tipMinRef;
              let mf = maxFeeHex ? BigInt(maxFeeHex) : (baseFeeRef + maxPrioPg);
              if (mf < baseFeeRef + maxPrioPg) mf = baseFeeRef + maxPrioPg;
              maxFeePg = mf;
            }
            maxPrioPg = ceilToMicro(maxPrioPg);
            maxFeePg = ceilToMicro(maxFeePg);

            const paidWeiAlt = (baseFeeRef + maxPrioPg) < maxFeePg ? (baseFeeRef + maxPrioPg) : maxFeePg;
            const feeWeiAltExpected = paidWeiAlt * gasLimitAlt;
            const feeWeiAltMax = maxFeePg * gasLimitAlt;
            const feeEthAltExpected = Number(feeWeiAltExpected) / 1e18;

            if (nativeUsdForAlts > 0) {
              r.gasTokenPriceUsd = nativeUsdForAlts;
              r.GasTokenPriceUsd = nativeUsdForAlts;
              r.gasFeeUsd = feeEthAltExpected * nativeUsdForAlts; // attendu
              r.GasFeeUsd = r.gasFeeUsd;
            } else {
              r.gasFeeUsd = r.GasFeeUsd = undefined;
            }

            const toHexAlt = (x: bigint | number | string | undefined | null): string =>
              x == null ? '0x0' : (typeof x === 'string' && x.startsWith('0x') ? x : ('0x' + BigInt(String(x)).toString(16)));

            r.gasPriceWei = paidWeiAlt.toString();       // attendu
            r.GasPriceWei = r.gasPriceWei;
            r.estimatedGas = gasLimitAlt.toString();
            r.EstimatedGas = r.estimatedGas;
            r.gasAmountWei = feeWeiAltExpected.toString(); // attendu
            r.GasAmountWei = r.gasAmountWei;

            // ✅ MM-like (gating): exposer l'EXPECTED et l'utiliser comme seuil
            r.mmExpectedNetworkFeeWei = feeWeiAltExpected.toString();
            r.mmMaxNetworkFeeWei = feeWeiAltMax.toString();
            // compat: mmNetwork = expected si absent
            r.mmNetworkFeeWei = r.mmNetworkFeeWei ?? r.mmExpectedNetworkFeeWei;

            // ✅ seuil de gating pour l’enfant/validator = EXPECTED
            (r as any).gas = { ...((r as any).gas || {}), fullWei: feeWeiAltExpected };
            (r as any).fullGasWei = (r as any).gas.fullWei;

            // (optionnel) garder le cap max pour debug/affichage si besoin
            (r as any).gas.fullWeiMax = feeWeiAltMax;


            const txRpcAlt = {
              ...(r.transactionRequest ?? trR),
              gas: toHexAlt(gasLimitAlt),
              maxFeePerGas: toHexAlt(maxFeePg),
              maxPriorityFeePerGas: toHexAlt(maxPrioPg),
              type: '0x2'
            };
            r.transactionRequest = txRpcAlt;
            r.TransactionRequest = txRpcAlt;
          }

          data.singleRoutes = routes;
          if (this.quote) this.quote.singleRoutes = routes;
        }
      }

      // ───────── prix USD pour l’UI (inchangé + mm USD) ─────────
      const toNum = (v: any) => (typeof v === 'number' ? v : Number(String(v).replace(/\s/g, '').replace(',', '.'))) || 0;
      const findPrice = (addr?: string, chainId?: number | string, symbol?: string): number | undefined => {
        if ((!addr && !symbol) || chainId == null) return;
        const cid = Number(chainId), al = addr?.toLowerCase(), su = symbol?.toUpperCase();
        const t = this.allTokens.find(t =>
          Number(t.chainId) === cid && ((al && t.address?.toLowerCase() === al) || (su && t.symbol?.toUpperCase() === su))
        );
        const usd = toNum(t?.priceUSD); return usd > 0 ? usd : undefined;
      };
      this.inTokenPriceUSD = findPrice(this.quote?.fromTokenAddress, this.quote?.fromChainId);
      this.outTokenPriceUSD = findPrice(this.quote?.toTokenAddress, this.quote?.toChainId);
      this.bridgeFeePriceUSD = findPrice(undefined, this.quote?.fromChainId, this.quote?.bridgeFeeSymbol);
      this.gasFeePriceUSD = findPrice(undefined, this.quote?.fromChainId, this.quote?.gasFeeSymbol);

      // recalcul USD si on a *un* prix (this.nativeTokenUsd ou prix LiFi parsé)
      const uiUsd =
        (this.nativeTokenUsd && this.nativeTokenUsd > 0)
          ? this.nativeTokenUsd
          : parseUsd((this.quote as any)?.gasTokenPriceUsd ?? (this.quote as any)?.GasTokenPriceUsd);

      if (uiUsd && uiUsd > 0) {
        if (this.quote?.mmExpectedNetworkFeeNative != null)
          (this.quote as any).mmExpectedNetworkFeeUsd = this.quote.mmExpectedNetworkFeeNative * uiUsd;
        if (this.quote?.mmMaxNetworkFeeNative != null)
          (this.quote as any).mmMaxNetworkFeeUsd = this.quote.mmMaxNetworkFeeNative * uiUsd;
        if ((this.quote as any).mmExpectedNetworkFeeUsd != null)
          (this.quote as any).mmNetworkFeeUsd = (this.quote as any).mmExpectedNetworkFeeUsd;
      }

      // fin
      this.ultraMode = false;
      _L('[gate] call isBridgeDisabled()');
      this.isBridgeDisabled();
      _L('[gate] result', { disabled: this.bridgeDisabled });

    } catch (err: any) {
      console.error('❌ Erreur fetchBridgeQuote :', err);
      _L('❌ catch', { message: err?.message });
      this.quoteErrorMessage = err?.message ?? '⚠️ Une erreur est survenue sur le bridge.';
      this.isBridgeDisabled();
      this.quote = null;
    } finally {
      this.isLoadingQuote = false;
      _L('✔ finally', { hasQuote: !!this.quote });
    }
    if (this.quote)
      this.lockScroll();
  }


  // Convertir une quantité décimale en string entière wei
  toWei(amount: number | string, decimals: number): string {
    const amt = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (BigInt(Math.floor(amt * Math.pow(10, decimals)))).toString();
  }


  toAmountDecimals(amount: string | number, symbol: string): string {
    const decimals = TOKEN_DECIMALS_MAP[symbol] ?? 18;
    const amt = typeof amount === 'string' ? parseFloat(amount) : amount;
    return (BigInt(Math.floor(amt * Math.pow(10, decimals)))).toString();
  }



  async simulateSwap() {
    if (!this.quote || !this.provider || !this.quote.value) {
      console.warn("🚫 Quote, Provider ou quote.value manquant pour simulateSwap");
      console.log("Debug :", {
        quote: this.quote,
        provider: this.provider,
        quoteValue: this.quote?.value
      });
      return;
    }

    const signer = await this.provider.getSigner();
    const domain = this.quote.domain;
    const types = this.quote.types;
    const value = this.quote.value;

    const takerToken = value.takerToken.toLowerCase();

    // ✅ Liste des tokens compatibles Permit2
    const permitTokens = [
      '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
      '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
      '0x6b175474e89094c44da98b954eedeac495271d0f', // DAI
      '0xc02aaA39b223fe8d0a0e5c4f27ead9083c756cc2'  // WETH
      // Ajoute d’autres tokens compatibles Permit2 si nécessaire
    ];
    console.log(`🧪 Vérification Permit2 : token = ${takerToken}`);
    const isPermit2Compatible = this.enablePermit2 && permitTokens.includes(takerToken);

    if (isPermit2Compatible) {
      console.log("🪪 Token compatible Permit2 → génération d’un PermitSingle");

      try {
        const result = await this.buildPermitAndSign();
        this.permit = result.permit;
        this.permitSig = result.signature;
        this.signature = null;
        console.log("✅ Permit2 signé avec succès");
      } catch (err) {
        console.error("❌ Erreur buildPermitAndSign :", err);
        this.permit = undefined;
        this.permitSig = undefined;

      }

    } else {
      console.log("✍️ Signature classique EIP-712 (non-Permit2)");

      try {
        this.signature = await signer.signTypedData(domain, types, value);
        this.permit = undefined;
        this.permitSig = undefined;

        console.log('✍️ Signature générée :', this.signature);
      } catch (err) {
        console.error('❌ Erreur lors de la génération de signature classique :', err);
      }
    }
  }





  /** 
   * 1 seule pop-up si this.ultraMode === true
   * 2 pop-ups sinon (approve + swap)
   */
  /**
 * Exécute le swap :
 *  • ULTRA  : 1 seule pop-up (Permit2 + routeur gasless)
 *  • CLASSIC : approve éventuel puis swap (2 pop-ups max)
 */
  /**
 * Exécute le swap :
 *  • ULTRA  : Permit2 + routeur gasless → 1 pop-up
 *  • CLASSIC : approve éventuelle + swap → 2 pop-ups
 */
  //async executeSwap() {
  //  console.log('🧾 [ULTRA] executeSwap =\n');
  //  //------------------------------------------------------------------
  //  // 0️⃣  Vérifs communes
  //  //------------------------------------------------------------------
  //  if (!this.quote || !this.provider || !this.takerAddress) {
  //    console.error('Quote / provider / address manquants');
  //    return;
  //  }

  //  //------------------------------------------------------------------
  //  // ULTRA MODE  (Permit2 / 1 pop-up)
  //  //------------------------------------------------------------------
  //  if (this.quote.IsPermit2) {
  //    const {
  //      inTokenAddress, outTokenAddress, amountDecimals,
  //      flag, feeAmount1, feeAmount2, gasPriceDecimals,
  //      nonce, deadline, permit
  //    } = this.quote as any;

  //    // ✓ champs obligatoires
  //    for (const [k, v] of Object.entries({
  //      inTokenAddress, outTokenAddress, amountDecimals,
  //      flag, gasPriceDecimals, nonce, deadline, permit
  //    })) {
  //      if (!v && v !== '0') {
  //        console.error(`❌ Champ manquant dans quote → ${k}`);
  //        return;
  //      }
  //    }

  //    // 1. Body backend
  //    const swapBody = {
  //      from: this.takerAddress, inTokenAddress, outTokenAddress,
  //      amountDecimals, flag,
  //      feeAmount1: feeAmount1 ?? '0',
  //      feeAmount2: feeAmount2 ?? '0',
  //      gasPriceDecimals, nonce, deadline, permit
  //    };

  //    console.log('🧾 [ULTRA] swapBody to OpenOcean =\n' + JSON.stringify(swapBody, null, 2));
  //    // 2. Appel backend
  //    let swapResp;
  //    try {
  //      swapResp = await firstValueFrom(this.swapApi.getGaslessSwap(swapBody));
  //    } catch (err) {
  //      console.error('❌ /swap 500 (ULTRA)', err);
  //      return;
  //    }
  //    if (!swapResp?.to || !swapResp?.data) {
  //      console.error('❌ Réponse ULTRA incomplète', swapResp);
  //      return;
  //    }

  //    // 3. Envoi TX
  //    try {
  //      this.bridgeStatus = 'pending';

  //      const signer = await this.provider.getSigner();
  //      const tx = await signer.sendTransaction({
  //        to: swapResp.to,
  //        data: swapResp.data,
  //        value: BigInt(swapResp.value ?? '0'),
  //        gasLimit: BigInt(300_000)          // ← évite estimateGas
  //      });

  //      console.log('🚀 TX ULTRA :', tx.hash);
  //      await tx.wait();

  //      this.bridgeStatus = 'success';
  //      this.bridgeHash = tx.hash;
  //      this.bridgeError = null;
  //    } catch (e: any) {
  //      console.error('❌ ULTRA fail :', e);
  //      this.bridgeStatus = 'error';
  //      this.bridgeHash = null;
  //      this.bridgeError = e?.message || 'Unknown error';
  //    }
  //    return;                                // ← FIN ULTRA
  //  }

  //  //------------------------------------------------------------------
  //  // CLASSIC  (approve éventuelle + swap)
  //  //------------------------------------------------------------------
  //  const signer = await this.provider.getSigner();
  //  const owner = await signer.getAddress();
  //  const isETH = this.quote.value.takerToken.toLowerCase() ===
  //    '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
  //  const target = this.quote.target;
  //  const valueToSend = isETH ? this.quote.value.takerTokenAmount : 0n;

  //  try {
  //    //--------------------------------------------------------
  //    // 1️⃣  Approve si nécessaire
  //    //--------------------------------------------------------
  //    if (!isETH) {
  //      const erc20 = new Contract(
  //        this.quote.value.takerToken,
  //        [
  //          'function allowance(address,address) view returns(uint256)',
  //          'function approve(address,uint256) returns(bool)'
  //        ],
  //        signer
  //      );

  //      const allowance: bigint = await erc20['allowance'](owner, target);
  //      const required: bigint = BigInt(this.quote.value.takerTokenAmount);

  //      if (allowance < required) {
  //        this.bridgeStatus = 'approve';
  //        const txA = await erc20['approve'](target, required);
  //        await txA.wait();
  //        console.log('✅ Approve confirmé');
  //      }
  //    }

  //    //--------------------------------------------------------
  //    // 2️⃣  Swap
  //    //--------------------------------------------------------
  //    this.bridgeStatus = 'pending';

  //    const tx = await signer.sendTransaction({
  //      to: target,
  //      data: this.quote.data,
  //      value: valueToSend,
  //      gasLimit: BigInt(350_000)            // ← fixe le gas, pas d’estimation
  //    });

  //    console.log('🚀 TX Classique :', tx.hash);
  //    await tx.wait();

  //    this.bridgeStatus = 'success';
  //    this.bridgeHash = tx.hash;
  //    this.bridgeError = null;

  //  } catch (e: any) {
  //    console.error('❌ Classic fail :', e);
  //    const msg = e?.message || '';
  //    const simErr = msg.includes('SafeERC20') || msg.includes('execution reverted');

  //    this.bridgeStatus = 'error';
  //    this.bridgeHash = null;
  //    this.bridgeError = simErr
  //      ? 'La transaction est partie, mais la simulation gas a échoué. Vérifie sur Etherscan.'
  //      : msg;
  //  }
  //}
  //buildSwapBodyForUltra(): any {
  //  if (!this.quote || !this.permit || !this.permitSig) {
  //    throw new Error('❌ Données manquantes pour construire le swapBody ULTRA.');
  //  }

  //  // 🔁 fallback deadline si jamais absent
  //  const defaultDeadline = Math.floor(Date.now() / 1000 + 1800); // +30 min

  //  const swapBody = {
  //    from: this.takerAddress,
  //    inTokenAddress: this.quote.inTokenAddress,
  //    outTokenAddress: this.quote.outTokenAddress,
  //    amountDecimals: this.quote.amountDecimals,
  //    flag: Number(this.quote!.flag ?? 0),
  //    feeAmount1: this.quote.feeAmount1 ?? '0',
  //    feeAmount2: this.quote.feeAmount2 ?? '0',
  //    gasPriceDecimals: this.quote.gasPriceDecimals,
  //    nonce: this.quote.nonce ?? 0,
  //    deadline: Number(this.quote!.deadline ?? 0),

  //    // ✅ Format attendu par OpenOcean
  //    permit: {
  //      details: {
  //        token: this.permit.details.token,
  //        amount: this.permit.details.amount,
  //        expiration: this.permit.details.expiration,
  //        nonce: this.permit.details.nonce
  //      },
  //      spender: this.permit.spender,
  //      sigDeadline: this.permit.sigDeadline,
  //      signature: this.permitSig
  //    }
  //  };

  //  console.log('📦 [buildSwapBodyForUltra] Ready to send:', JSON.stringify(swapBody, (_, v) =>
  //    typeof v === 'bigint' ? v.toString() : v, 2));

  //  return swapBody;
  //}

  buildSwapBodyForUltra(): any {
    return {
      from: this.takerAddress,
      to: this.quote!.target,
      data: this.quote!.data,
      amountDecimals: this.quote!.amountDecimals,
      feeAmount1: this.quote.feeAmount1 ?? '0',
      feeAmount2: this.quote.feeAmount2 ?? '0',
      flag: Number(this.quote!.flag ?? 0),
      gasPriceDecimals: this.quote.gasPriceDecimals,
      deadline: Number(this.quote!.deadline ?? 0),
      inToken: this.quote!.inTokenAddress,
      outToken: this.quote!.outTokenAddress,
      nonce: this.quote.nonce ?? 0,
      permit: this.quote.permit, // ✅ déjà encodé (0x...)
      usdvaluation: Number(this.quote!.usdValuation ?? 0.03)
    };
  }



  /** Récupère la TX (to/data/value/chainId) depuis la quote courante */
  /** Récupère la TX (to/data/value/chainId) depuis la quote ou une route alternative */
  /** Extract the tx object from a LiFi/OpenOcean-like quote or alt route */
  private getTxFromQuote(q: any): { to?: string; data?: string; value?: string } | null {
    const tx = q?.transactionRequest ?? q?.TransactionRequest ?? null;
    console.log('[BRIDGE][TXCHECK]', {
      hasTx: !!tx, to: tx?.to, dataLen: tx?.data?.length, value: tx?.value,
      sourceKeys: Object.keys(q || {})
    });
    if (!tx?.to || !tx?.data) return null;
    return { to: tx.to, data: tx.data, value: tx.value ?? '0x0' };
  }




  /** URL RPC par défaut (fallback si aucun provider connecté) */
  private getRpcUrlForChain(chainId: number): string {
    switch (Number(chainId)) {
      case 1: return 'https://eth-mainnet.g.alchemy.com/v2/YOUR_KEY';
      case 42161: return 'https://arb-mainnet.g.alchemy.com/v2/YOUR_KEY';
      case 137: return 'https://polygon-mainnet.g.alchemy.com/v2/YOUR_KEY';
      case 56: return 'https://bsc-dataseed.binance.org'; // public OK
      default: return 'https://eth-mainnet.g.alchemy.com/v2/YOUR_KEY';
    }
  }

  // ✔️ Nouveau simulateur: estimateGas => fallback call
  //private async simulateTxPreflight(tx: { to: string; data: string; value?: string; chainId?: number })
  //: Promise<{ ok: boolean; error?: string; raw?: any }> {
  //  const chainId = Number(tx.chainId ?? this.chainId ?? 1);
  //  const provider = this.provider ?? new ethers.JsonRpcProvider(this.getRpcUrlForChain(chainId), chainId);
  //  const from = this.takerAddress;

  //  try {
  //    const gas = await provider.estimateGas({
  //      from,
  //      to: tx.to,
  //      data: tx.data,
  //      value: tx.value ?? '0x0'
  //    });
  //    return { ok: true, raw: gas.toString() };
  //  } catch (egErr: any) {
  //    try {
  //      const res = await provider.call({
  //        from,
  //        to: tx.to,
  //        data: tx.data,
  //        value: tx.value ?? '0x0'
  //      });
  //      return { ok: true, raw: res }; // même "0x" = OK (pas une erreur)
  //    } catch (callErr: any) {
  //      console.error('🔍 simulateTxPreflight error:', callErr);
  //      const msg = this.extractRevertReason(callErr);
  //      return { ok: false, error: msg, raw: callErr };
  //    }
  //  }
  //}
  // state pour la comparaison
  private simulatedFeeWei: bigint = 0n;
  private simulatedMaxFeePerGasWei: bigint = 0n;

  get lifiFeeFiat(): string | null {
    if (!this.fullGasWei || !this.nativeTokenUsd) return null;
    const eth = Number(this.fullGasWei) / 1e18;
    const fiat = eth * this.nativeTokenUsd;
    return fiat.toLocaleString(this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US', {
      style: 'currency', currency: this.defaultFiat, minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }
  get simulatedFeeFiat(): string | null {
    if (!this.simulatedFeeWei || !this.nativeTokenUsd) return null;
    const eth = Number(this.simulatedFeeWei) / 1e18;
    const fiat = eth * this.nativeTokenUsd;
    return fiat.toLocaleString(this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US', {
      style: 'currency', currency: this.defaultFiat, minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /** Récupère le estimatedGas de la quote (backend/alternatives), en bigint */
  private getBestEstimatedGasFromQuote(q: any): bigint {
    if (!q) return 0n;

    // priorité au champ normalisé du backend
    let raw =
      q?.estimatedGas ?? q?.EstimatedGas ??
      q?.transactionRequest?.gas ?? q?.transactionRequest?.gasLimit ??
      q?.TransactionRequest?.gas ?? q?.TransactionRequest?.gasLimit;

    // fallback: première route (LiFi/SingleRouteOption)
    if (!raw && Array.isArray(q?.singleRoutes) && q.singleRoutes.length > 0) {
      const r0 = q.singleRoutes[0];
      raw = r0?.estimatedGas ?? r0?.EstimatedGas ?? r0?.gasLimit ?? r0?.GasLimit;
    }

    if (!raw) return 0n;
    const s = String(raw);
    return s.startsWith('0x') ? BigInt(s) : BigInt(s);
  }

  /** Construit la tx exacte à estimer côté wallet (mêmes champs que la quote) */
  private buildTxForEstimation() {
    const q = this.quote ?? {};
    const tr = q?.transactionRequest ?? q?.TransactionRequest ?? {};

    // to / data / value depuis la quote
    const to = tr.to ?? q?.target ?? q?.Target ?? null;
    const data = tr.data ?? q?.data ?? q?.Data ?? null;

    // value peut être "0x...", decimal string, number, ou null
    let valueHex: string | undefined;
    const rawVal = tr.value ?? q?.value ?? q?.Value ?? null;
    if (rawVal != null) {
      const s = String(rawVal);
      valueHex = s.startsWith('0x') ? s : '0x' + BigInt(s).toString(16);
    }

    return { to, data, value: valueHex };
  }



  private parseHexOrDecToBigIntSafe(v: any): bigint {
    if (v == null) return 0n;
    const s = String(v);
    try { return s.startsWith('0x') ? BigInt(s) : BigInt(s); }
    catch { return 0n; }
  }

  private async updateGasCost(estimatedGasFromBackend?: bigint): Promise<void> {
    try {
      const estBackend =
        (estimatedGasFromBackend && estimatedGasFromBackend > 0n)
          ? estimatedGasFromBackend
          : this.parseHexOrDecToBigIntSafe(this.quote?.estimatedGas ?? this.quote?.EstimatedGas);

      // Pas de wallet → on garde backend
      if (!this.provider) {
        const priceWei = this.parseHexOrDecToBigIntSafe(this.quote?.gasPriceWei ?? this.quote?.GasPriceWei);
        this.gasPriceWei = priceWei || 0n;
        //this.fullGasWei = (priceWei && estBackend) ? priceWei * estBackend : 0n;
        this.cd?.detectChanges?.();
        return;
      }

      // Vérifie la chaîne du wallet
      const net = await this.provider.getNetwork().catch(() => null);
      const currentChain = Number(net?.chainId ?? 0);
      const expectedChain = Number(this.chainId ?? (this as any).chainIdFromSeo ?? 1);
      if (!currentChain || currentChain !== expectedChain) {
        console.warn('[updateGasCost] Wallet chain mismatch → fallback backend', { currentChain, expectedChain });
        const priceWei = this.parseHexOrDecToBigIntSafe(this.quote?.gasPriceWei ?? this.quote?.GasPriceWei);
        this.gasPriceWei = priceWei || 0n;
        //this.fullGasWei = (priceWei && estBackend) ? priceWei * estBackend : 0n;
        this.cd?.detectChanges?.();
        return;
      }

      // Construit la tx et estime le gas côté MetaMask
      const { to, data, value } = this.buildTxForEstimation();
      const signer = await this.provider.getSigner();
      const from = await signer.getAddress();

      let mmGasLimit: bigint;
      if (to && data) {
        try {
          const est = await this.provider.estimateGas({ from, to, data, value });
          mmGasLimit = BigInt(est.toString());
        } catch (e) {
          console.warn('[updateGasCost] estimateGas MM a échoué → fallback backend', e);
          mmGasLimit = estBackend > 0n ? estBackend : 21000n;
        }
      } else {
        console.warn('[updateGasCost] tx incomplète → fallback backend');
        mmGasLimit = estBackend > 0n ? estBackend : 21000n;
      }

      // Prix EIP-1559 “site suggéré ~12s”
      let priceWei: bigint;
      try {
        const { priceWei: p, baseFeeWei, priorityWei, factor } =
          await getSuggestedEip1559Price(this.provider, "slow");
        priceWei = p;
        console.log('[EIP-1559][suggested]', {
          baseFeeGwei: Number(baseFeeWei) / 1e9,
          tipGwei: Number(priorityWei) / 1e9,
          factor,
          priceGwei: Number(priceWei) / 1e9
        });
      } catch (e) {
        console.warn('[updateGasCost] EIP-1559 price fail → eth_gasPrice', e);
        try {
          const hex = await this.provider.send('eth_gasPrice', []);
          priceWei = BigInt(hex);
        } catch {
          priceWei = 2_000_000_000n; // 2 gwei plancher
        }
      }

      // Applique
      this.gasPriceWei = priceWei;
      /*this.fullGasWei = priceWei * mmGasLimit;*/

      // (facultatif) pousser ces valeurs dans la quote pour sync le preview
      this.quote = {
        ...(this.quote ?? {}),
        estimatedGas: mmGasLimit.toString(),
        EstimatedGas: mmGasLimit.toString(),
        gasPriceWei: priceWei.toString(),
        GasPriceWei: priceWei.toString(),
        totalNetworkFee: (priceWei * mmGasLimit).toString(),
        TotalNetworkFee: (priceWei * mmGasLimit).toString(),
      };

      console.log('[MetaMask fee calc]', {
        chainId: expectedChain,
        gasLimit: mmGasLimit.toString(),
        priceGwei: Number(priceWei) / 1e9,
        feeEth: Number(this.fullGasWei) / 1e18
      });

      this.cd?.detectChanges?.();
    } catch (e) {
      console.warn('[updateGasCost] fallback zeros', e);
      this.gasPriceWei = 0n;
      this.fullGasWei = 0n;
      this.cd?.detectChanges?.();
    }
  }




  private async flushBackendLogs(
    outcome: 'success' | 'error' | 'cancelled',
    reason?: string,
    details?: string
  ): Promise<void> {
    try {
      const runId = String(this._runSeq || Date.now());
      const sessionId = (localStorage.getItem('wc_session_id') || this.takerAddress || 'na') + '';
      const traceId = crypto?.randomUUID?.() || Math.random().toString(36).slice(2);

      // Payload compact
      const body = {
        sessionId,
        traceId,
        outcome,
        reason: reason || null,
        details: details || null,
        lines: this.debugLogs.slice(-180) // garde les 180 dernières lignes max
      };

      await fetch(`${environment.backendUrl}/admin/runs/${encodeURIComponent(runId)}/ingest`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'x-run-id': runId,
          'x-session-id': sessionId
        },
        body: JSON.stringify(body),
        // Hint réseau faible: laisse le navigateur gérer la compression (HTTP/2 + gzip/brotli)
      }).catch(() => { /* silencieux */ });
    } catch {
      // ne jamais bloquer l'UX si l’ingestion échoue
    } finally {
      // Nettoyage local si tu veux
      // this.debugLogs = [];
    }
  }















  /**
   * Préflight avant envoi (SWAP) :
   *  1) 💸 Vérifie que le solde natif couvre (fees + value) avec estimation robuste.
   *  2) 🧪 Lance une simulation EVM (estimateGas → fallback call).
   *
   * - Si alt fournie → on marque l’alt comme échouée (désactivation ciblée)
   * - Sinon → on désactive le bouton principal
   * Retourne true si OK, false sinon (et met à jour l’UI + message clair).
   */
  private async simulateTxPreflight(alt?: any): Promise<boolean> {
    const quoteOrAlt = alt ?? this.quote;
    const tx = this.getTxFromQuote(quoteOrAlt);

    if (!this.provider || !tx) {
      console.warn('[Swap] simulateTxPreflight: provider/tx manquants');
      this.flushBackendLogs('error', 'CLIENT_STATE_INVALID', 'provider/tx missing').catch(() => { });
      return false;
    }

    // 🔧 En bypass, on NE SKIPPE PLUS : on exécute le préflight mais on log
    if ((this as any).debugBypassGasCheck) {
      this.addLog?.('🔧 debugBypassGasCheck → preflight forcé (no skip)');
    }

    // 🔎 Args visibles pour corrélation
    try {
      const sel = typeof tx.data === 'string' ? tx.data.slice(0, 10) : '';
      this.addLog?.(`[SIM] preflight args | to=${tx.to} selector=${sel} value=${tx.value ?? '0x0'}`);
    } catch { /* no-op */ }

    try {
      const provider = this.provider;
      const signer = await provider.getSigner();
      const userAddress = await signer.getAddress();

      /* ────────────────────────────────────────────────
       * 1) 💸 Vérif du solde natif (fees + value)
       * ──────────────────────────────────────────────── */
      const userBalance = await provider.getBalance(userAddress);

      // 1.a GasLimit : estimateGas → fallback quote → 21000
      let gasLimit: bigint;
      try {
        const est = await provider.estimateGas({
          from: userAddress,
          to: tx.to!,
          data: tx.data!,
          value: tx.value ?? '0x0',
        });
        gasLimit = BigInt(est.toString());
        this.addLog?.(`[SIM][estimateGas] ok gas=${gasLimit.toString()}`);
      } catch (egErr: any) {
        // 🔴 Trace fine sur l’échec d’estimation
        const label = this.getSimFailLabel(egErr);
        this.addLog?.(`⛔ [SIM][estimateGas] ${label}`);
        const code = egErr?.code ?? egErr?.error?.code;
        const reason = egErr?.reason || egErr?.error?.message || egErr?.message || '(n/a)';
        const dataHd = (egErr?.data || egErr?.error?.data || '').toString().slice(0, 10);
        this.addLog?.(`⛔ [SIM][estimateGas] code=${String(code)} reason=${reason} dataHead=${dataHd}`);
        // ➕ mémorise la raison pour le fallback POST-sim
        (this as any).lastPreflightError = reason || dataHd || code || 'estimateGas_error';

        const qGas = quoteOrAlt?.transactionRequest?.gasLimit ?? quoteOrAlt?.TransactionRequest?.gasLimit;
        const gl = qGas != null ? BigInt(String(qGas)) : 21000n;
        gasLimit = gl > 0n ? gl : 21000n;
      }

      // 1.b Prix du gas : JAMAIS de getFeeData() (évite eth_maxPriorityFeePerGas)
      const tr = quoteOrAlt?.transactionRequest ?? quoteOrAlt?.TransactionRequest ?? {};
      let maxFeePerGas: bigint | null = tr.maxFeePerGas ? BigInt(String(tr.maxFeePerGas)) : null;
      let gasPriceLegacy: bigint | null = tr.gasPrice ? BigInt(String(tr.gasPrice)) : null;

      // Legacy universel
      if (!gasPriceLegacy) {
        try {
          const gp = await (provider as any).send?.('eth_gasPrice', []);
          if (gp) gasPriceLegacy = BigInt(gp);
        } catch { /* ignore */ }
      }

      // Cap EIP-1559 si baseFee dispo (sans appeler maxPriority)
      if (!maxFeePerGas) {
        try {
          const latest = await (provider as any).send?.('eth_getBlockByNumber', ['latest', false]);
          if (latest?.baseFeePerGas) {
            const base = BigInt(latest.baseFeePerGas);
            const tip = 1_500_000_000n; // ~1.5 gwei
            maxFeePerGas = base * 2n + tip;
          }
        } catch { /* ignore */ }
      }

      // 1.c Fee estimée (pessimiste mais raisonnable)
      let feeWei: bigint;
      if (maxFeePerGas) feeWei = gasLimit * maxFeePerGas;
      else if (gasPriceLegacy) feeWei = gasLimit * gasPriceLegacy;
      else feeWei = gasLimit * 1_500_000_000n; // 1.5 gwei fallback

      this.simulatedFeeWei = feeWei;
      this.simulatedMaxFeePerGasWei = (maxFeePerGas ?? gasPriceLegacy ?? 0n);

      // Log résumé gas/fees (best-effort)
      try {
        const gasP = (maxFeePerGas ?? gasPriceLegacy ?? 0n).toString();
        this.addLog?.(
          `[SIM][gas] gasLimit=${gasLimit.toString()} ` +
          `priceWei=${gasP} feeWei=${this.simulatedFeeWei.toString()}`
        );
      } catch { /* no-op */ }

      // 1.d Value (souvent 0) — conversion hex-safe
      const valueWei = (() => {
        if (!tx.value) return 0n;
        const v: string = String(tx.value);
        return (v.startsWith('0x') || v.startsWith('0X')) ? BigInt(v) : BigInt(v);
      })();

      const requiredWei = feeWei + valueWei;

      // Log balances vs requirement
      try {
        this.addLog?.(
          `[SIM] balances | nativeWei=${userBalance.toString()} ` +
          `requiredWei=${requiredWei.toString()} (feeWei=${feeWei.toString()} valueWei=${valueWei.toString()})`
        );
      } catch { /* no-op */ }

      if (userBalance < requiredWei) {
        // Message UX (identique à ta version)
        const nat = this.getNativeTokenSymbol(this.chainId ?? this.selectedNetwork ?? 1) || 'ETH';
        const deficit = requiredWei - userBalance;
        const deficitEth = Number(deficit) / 1e18;
        const fiat = this.nativeTokenUsd ? (deficitEth * this.nativeTokenUsd) : null;

        const fiatStr = fiat
          ? fiat.toLocaleString(
            this.defaultFiat === 'EUR' ? 'fr-FR' : 'en-US',
            { style: 'currency', currency: this.defaultFiat, minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )
          : null;

        const friendly =
          this.translate?.instant?.('SWAP_GAS_DEFICIT_MSG', {
            amountEth: deficitEth.toFixed(6).replace(/\.?0+$/, ''),
            symbol: nat,
            amountFiat: fiatStr ?? ''
          }) ||
          `Le swap n’est pas possible pour l’instant : votre solde ${nat} est insuffisant pour les frais réseau. ` +
          `Ajoutez ~${deficitEth.toFixed(6)} ${nat}` + (fiatStr ? ` (${fiatStr})` : '') + `, puis réessayez.`;

        const lifiEth = this.fullGasWei ? (Number(this.fullGasWei) / 1e18).toFixed(6) : null;
        const simEth = this.simulatedFeeWei ? (Number(this.simulatedFeeWei) / 1e18).toFixed(6) : null;

        if (lifiEth && simEth) {
          const lifiFiat = this.lifiFeeFiat;
          const simFiat = this.simulatedFeeFiat;
          this.bridgeError =
            `[ux] ${friendly}\n\n` +
            `Comparatif frais réseau:\n` +
            `- LiFi: ${lifiEth} ${nat}` + (lifiFiat ? ` (${lifiFiat})` : '') + `\n` +
            `- Simulation: ${simEth} ${nat}` + (simFiat ? ` (${simFiat})` : '');
        } else {
          this.bridgeError = `[ux] ${friendly}`;
        }

        const isBypass = !!(this as any).debugBypassGasCheck;

        if (!isBypass) {
          // ---- Comportement BLOQUANT inchangé (bypass OFF) ----
          this.bridgeStatus = 'error';

          // Marquage “route échouée” (alt vs main)
          const mainKey = this.getProviderKey(this.quote);
          if (alt) {
            const altKey = this.getProviderKey(alt);
            if (altKey) this.failedAltKeys.add(altKey);
            this.lastSimFailedKey = altKey || 'alt';
          } else {
            this.lastSimFailedKey = mainKey || 'main';
            this.swapDisabled = true;
            const label = this.translate?.instant?.('NEED_NATIVE_FOR_GAS') || `Ajoutez du ${nat} pour payer les frais réseau.`;
            if (Array.isArray(this.swapReasons) && !this.swapReasons.includes(label)) {
              this.swapReasons.push(label);
            }
          }

          this.cd?.detectChanges?.();
          this.flushBackendLogs('error', 'INSUFFICIENT_NATIVE_GAS', friendly).catch(() => { });
          return false; // bloquant si bypass OFF
        }

        // ---- Mode BYPASS : warning non-bloquant ----
        this.addLog?.('⚠️ [SWAP] Gas natif insuffisant mais bypass actif → non bloquant');
        this.cd?.detectChanges?.();
        return true;
      }

      /* ────────────────────────────────────────────────
       * 2) 🧪 Simulation logique EVM (estimateGas → call)
       * ──────────────────────────────────────────────── */
      try {
        await provider.estimateGas({ from: userAddress, to: tx.to!, data: tx.data!, value: tx.value ?? '0x0' });
      } catch (egErr2: any) {
        // On log l’erreur d’estimation puis on tente eth_call
        try {
          const callRes = await provider.call({ from: userAddress, to: tx.to!, data: tx.data!, value: tx.value ?? '0x0' });
          const head = String(callRes ?? '').slice(0, 10);
          this.addLog?.(`[SIM][eth_call] ok head=${head}`);
        } catch (callErr: any) {
          const label = this.getSimFailLabel(callErr);
          this.addLog?.(`⛔ [SIM][eth_call] ${label}`);
          // 🔴 Trace fine revert call
          const code = callErr?.code ?? callErr?.error?.code;
          const reason = callErr?.reason || callErr?.error?.message || callErr?.message || '(n/a)';
          const dataHd = (callErr?.data || callErr?.error?.data || '').toString().slice(0, 10);
          this.addLog?.(`⛔ [SIM][eth_call] code=${String(code)} reason=${reason} dataHead=${dataHd}`);
          // ➕ mémorise la raison pour le fallback POST-sim
          (this as any).lastPreflightError = reason || dataHd || code || 'eth_call_error';

          const msg = this.extractRevertReason(callErr);
          this.bridgeStatus = 'error';
          this.bridgeError = msg || (this.translate?.instant?.('SIMULATION_FAILED') || 'La simulation a échoué pour cette route.');

          if (alt) {
            const altKey = this.getProviderKey(alt);
            if (altKey) this.failedAltKeys.add(altKey);
            this.lastSimFailedKey = altKey || 'alt';
          } else {
            const mainKey = this.getProviderKey(this.quote);
            this.lastSimFailedKey = mainKey || 'main';
            this.swapDisabled = true;
            const label = this.translate?.instant?.('ALT_DISABLED_AFTER_SIM') || 'La simulation a échoué pour cette route.';
            if (Array.isArray(this.swapReasons) && !this.swapReasons.includes(label)) {
              this.swapReasons.push(label);
            }
          }

          this.cd?.detectChanges?.();

          this.flushBackendLogs('error', 'EXECUTION_REVERTED', reason).catch(() => { });
          return false;
        }
      }

      // ✅ Tout est OK
      return true;
    } catch (e: any) {
      this.bridgeStatus = 'error';
      const extracted = this.extractRevertReason(e as any);
      this.bridgeError = extracted;
      // ➕ mémorise aussi ici (catch global) — accès safe au message
      const safeMsg =
        (e && typeof e === 'object' && 'message' in e)
          ? (e as any).message
          : String(e ?? '');
      (this as any).lastPreflightError = extracted || safeMsg || 'preflight_catch';

      if (alt) {
        const altKey = this.getProviderKey(alt);
        if (altKey) this.failedAltKeys.add(altKey);
        this.lastSimFailedKey = altKey || 'alt';
      } else {
        const mainKey = this.getProviderKey(this.quote);
        this.lastSimFailedKey = mainKey || 'main';
        this.swapDisabled = true;
        const label = this.translate?.instant?.('ALT_DISABLED_AFTER_SIM') || 'La simulation a échoué pour cette route.';
        if (Array.isArray(this.swapReasons) && !this.swapReasons.includes(label)) {
          this.swapReasons.push(label);
        }
      }

      this.cd?.detectChanges?.();
      const reason = this.extractRevertReason(e) || (this as any).lastPreflightError || 'preflight_catch';
      this.flushBackendLogs('error', 'INTERNAL_ERROR', reason).catch(() => { });
      return false;
    }
  }






  private extractRevertReason(err: any): string {
    try {
      const data: string = err?.error?.data ?? err?.data ?? err?.info?.error?.data ?? null;
      if (data && typeof data === 'string' && data.startsWith('0x08c379a0')) {
        // Error(string)
        const reason = ethers.toUtf8String('0x' + data.slice(10 + 64));
        return `execution reverted: ${reason}`;
      }
      if (err?.error?.message) return err.error.message;
      if (err?.message) return err.message;
    } catch { }
    return 'execution reverted (unknown reason)';
  }


  private async forceReconnectWalletSession(reason: string) {
    //if (Date.now() < this._reconnectLockUntil) return;
    //this._reconnectLockUntil = Date.now() + 20_000;
    //this.addLog(`🔁 WC force reconnect → HARD RELOAD | reason=${reason}`);

    //try {
    //  // (1) couper la session
    //  try { await this.disconnectWalletReload?.(); } catch { }

    //  // (1bis) PURGE EXPLICITE des pairings WalletConnect v2 (si dispo)
    //  try {
    //    const sc = (window as any).__wcSignClient || (this as any).wcSignClient || (this as any).appKit?.getSignClient?.();
    //    const core = sc?.core;
    //    const pairing = core?.pairing;
    //    const list = pairing?.getPairings?.() || [];
    //    for (const p of list) { try { await pairing.delete({ topic: p.topic }); } catch { } }
    //  } catch (e: any) {
    //    this.addLog('[reconnect] pairings purge skipped: ' + (e?.message || e));
    //  }
    //  //this.closeQuoteWithReason('forceReconnectWalletSession');
    //  // (2) UI propre
    // /* try { this.closeQuote?.(); } catch { }*/

    //  // (3) geler deeplink + auto-restore et poser un **one-shot anti reattach**
    //  try {
    //    const until = Date.now() + 8000;
    //    sessionStorage.setItem('st/suppressWcUriUntil', String(until));
    //    localStorage.setItem('st/suppressAutoRestoreUntil', String(until));
    //    sessionStorage.setItem('skipWcDeeplinkOnce', '1');
    //    localStorage.setItem('st/skipAutoRestoreOnce', '1');
    //    // ➕ nouveau flag pour empêcher le silent reattach une fois
    //    sessionStorage.setItem('st/skipSilentReattachOnce', '1');

    //    // (optionnel, très ciblé) nettoyer les hints d’auto-connect de web3modal/appkit
    //    Object.keys(localStorage).forEach(k => {
    //      if (k.startsWith('W3M') || k.startsWith('w3m') || k.startsWith('wc@2:')) {
    //        try { localStorage.removeItem(k); } catch { }
    //      }
    //    });
    //  } catch { }

    //  // (4) hard reload
    //  this.hardReloadBridge();
    //} catch (err: any) {
    //  this.addLog('⚠️ reconnect failed: ' + (err?.message || err));
    //  this.hardReloadBridge();
    //}
  }






  private hardReloadBridge(): void {
    //try {
    //  // si tu utilises le Router:
    //  // this.router.navigateByUrl('/bridge', { replaceUrl: true });
    //  // sinon rechargement plein
    //  window.location.reload();
    //} catch {
    //  window.location.href = window.location.href;
    //}
  }













  // ✅ Pas de dépendances exotiques : utilise seulement window/location + ton wallet service
  private async hardReloadAfterCancel(reason: string) {
    const t0 = Date.now();
    try {
      this.addLog(`🧨 [hard-reload] start | reason=${reason}`);

      // (A) Déconnexion propre du wallet (si dispo chez toi)
      try { await this.wallet.disconnect(); }
      catch (e) { this.addLog(`⚠️ [hard-reload] wallet.disconnect error: ${String(e)}`); }

      // (B) Purge locale minimale (optionnelle mais safe)
      try {
        // évite que l’UI revive en "approve" après reload
        this.bridgeStatus = 'idle';
        this.bridgeError = null;
        this.bridgeHash = null;
        this.quote = null;
        // si tu stockes un URI WC / modale dans l’état
        this.showWcModal = false as any;
        this.wcUri = '' as any;
      } catch (e) { this.addLog(`⚠️ [hard-reload] purge state error: ${String(e)}`); }

      // (C) Petite pause pour laisser WC fermer la session côté app
      await new Promise(r => setTimeout(r, 250));

      // (D) Reload “fort” avec cache-busting & conservation de debug
      const u = new URL(window.location.href);
      u.searchParams.set('reloadTs', String(Date.now()));
      u.searchParams.set('reloadReason', reason);
      // conserve ?debug=1 si présent
      if (/\bdebug=1\b/.test(window.location.search)) u.searchParams.set('debug', '1');

      this.addLog(`🔁 [hard-reload] redirect → ${u.pathname}${u.search}`);
      window.location.replace(u.toString()); // fin du monde actuel 🌋
    } catch (e) {
      this.addLog(`❌ [hard-reload] failed: ${String(e)} | fallback window.location.reload()`);
      try { window.location.reload(); } catch { }
    } finally {
      this.addLog(`⏱️ [hard-reload] elapsed=${Date.now() - t0}ms`);
    }
  }

  private showPreflightError(msgKey: string, fallback: string) {
    this.bridgeStatus = 'error';
    this.bridgeError = this.translate.instant(msgKey) || fallback;
    this.addLog(`⛔ [SIM] Probable échec: ${this.bridgeError}`);
  }


  /** Faut-il réveiller le wallet pour la TX principale (WC mobile) ? */
  private shouldWakeForWcTx(): boolean {
    // aujourd’hui, on conditionne au flag global
    return !!(this as any).wakeEnabled;
  }

  /** Petit helper async pour temporiser */
  private delay(ms: number): Promise<void> {
    return new Promise(res => setTimeout(res, ms));
  }

  /** Réveil conditionnel du wallet (no-op si pas nécessaire) */
  // avant
  // private async wakeWalletIfNeeded(_reason?: string): Promise<void> {

  // après
  private async wakeWalletIfNeeded(ctx?: string, runId?: number): Promise<void> {
    const now = Date.now();
    const normRunId = runId ?? null;

    // ─────────────────────────────────────────────
    // 1) Anti-doublon : même ctx + même runId récemment
    // ─────────────────────────────────────────────
    if (
      this._lastWcWake &&
      this._lastWcWake.ctx === ctx &&
      this._lastWcWake.runId === normRunId &&
      now - this._lastWcWake.at < 8000 // 8s, à ajuster si tu veux
    ) {
      this.addLog?.(
        `[deeplink][wake] skip: already woke wallet for ctx=${ctx} runId=${normRunId} Δ=${now - this._lastWcWake.at}ms`
      );
      return;
    }

    try {
      this.addLog?.(
        `[deeplink][wake] ENTER ctx=${ctx ?? 'n/a'} runId=${String(runId ?? '-')}`
      );

      // 0) feature flag global
      if (!this.shouldWakeForWcTx?.()) {
        this.addLog?.('[deeplink][wake] skip: wake disabled by shouldWakeForWcTx()');
        return;
      }

      // 1) provider requis
      if (!this.provider) {
        this.addLog?.('[deeplink][wake] skip: missing provider');
        return;
      }

      // 2) seulement en mobile (MetaMask mobile / AppKit / WC)
      const isMobile = this.isMobileDevice?.() ?? false;
      if (!isMobile) {
        this.addLog?.('[deeplink][wake] skip: not mobile');
        return;
      }

      // 3) runId obligatoire (garantit le “1 deeplink par run”)
      if (typeof runId !== 'number') {
        this.addLog?.('[deeplink][wake] skip: missing runId');
        return;
      }

      // 4) déjà réveillé pour ce run ? → on ne réouvre JAMAIS
      if ((this as any).__dlOpenedForRun === runId) {
        this.addLog?.(
          `[deeplink][wake] skip: already foregrounded for runId=${runId}`
        );
        return;
      }

      // 5) on log l’état "silent" pour debug, mais on ne bloque plus dessus
      const silentFlag = (this as any).isWcSilentAttached?.();
      if (typeof silentFlag !== 'undefined') {
        this.addLog?.(
          `[deeplink][wake] info: isWcSilentAttached=${String(silentFlag)}`
        );
      }

      // 6) réveil "doux" best-effort (sans deeplink) pour s'assurer que le provider est chaud
      try {
        const signer = await this.provider.getSigner();
        await (this as any)?.txFlow?.wakeWalletSilentlyIfNeeded?.(signer);
      } catch (err: any) {
        this.addLog?.(
          `[deeplink][wake] silent-wake error: ${err?.message ?? String(err)}`
        );
        // on continue quand même, c'est du best-effort
      }

      // 7) phase logique pour les logs et foreground
      const phase: 'apprv' | 'trx' =
        ctx && ctx.startsWith('apprv') ? 'apprv' : 'trx';

      this.addLog?.(
        `[deeplink][wake] OK → foregroundMetaMaskGeneric phase=${phase} runId=${runId}`
      );

      try {
        // ouverture réelle (deeplink metamask / app WC)
        (this as any).foregroundMetaMaskGeneric?.(runId, phase);

        // on marque ce run comme “servi” pour ne plus jamais réouvrir
        (this as any).__dlOpenedForRun = runId;
      } catch (err: any) {
        this.addLog?.(
          `[deeplink][wake] ERR foregroundMetaMaskGeneric ctx=${ctx ?? 'n/a'} runId=${String(
            runId
          )} e=${err?.message ?? String(err)}`
        );
      }
    } catch (err: any) {
      this.addLog?.(
        `[deeplink][wake] ERR wrapper ctx=${ctx ?? 'n/a'} runId=${String(
          runId ?? '-'
        )} e=${err?.message ?? String(err)}`
      );
    }
  }



  // --- BRIDGE COMPAT SHIMS -------------------------------------------------

  /** Switch réseau via EIP-1193 (shim Bridge) */
  private async switchToChain(targetChainId: number): Promise<void> {
    try {
      const hex = '0x' + Number(targetChainId).toString(16);
      const eth: any = (window as any).ethereum || (this as any).rawProvider;
      if (eth?.request) {
        this.addLog(`[wallet] wallet_switchEthereumChain → ${hex}`);
        await eth.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: hex }] });
      }
    } catch (e: any) {
      this.addLog(`[wallet] switchToChain failed: ${e?.message || e}`);
      // on ne jette pas : certains wallets sont déjà sur le bon réseau
    }
    // aligne l’UI locale (même si le wallet était déjà good)
    try { this.setChain(Number(targetChainId)); } catch { }
  }

  /** “txFlow” simplifié : proxy vers l’envoi + watcher existants */
  private txFlow = {
    wakeWalletSilentlyIfNeeded: async (_signer: any) => {
      // noop volontaire pour Bridge
    },
    sendViaSignerWithWatchdog: async (signer: any, tx: any) => {
      this.addLog('[TXFLOW] enter sendViaSignerWithWatchdog');
      this.addLog('[TXFLOW] signer ' + JSON.stringify({
        hasSend: !!signer && typeof signer.sendTransaction === 'function'
      }));
      this.addLog('[TXFLOW] tx ' + JSON.stringify({
        from: tx?.from,
        to: tx?.to,
        value: String(tx?.value ?? '0x0'),
        dataLen: (tx?.data ?? '0x').length,
      }));

      const sent = await signer.sendTransaction(tx);
      this.addLog(`[TXFLOW] sendTransaction ok | hash=${sent.hash}`);

      // informer le cancel-flow qu’on a un hash pour la phase trx
      try { this.cfOnHash?.('trx'); } catch { }

      try {
        sessionStorage.removeItem('st/allowWcDeeplinkUntil');
        sessionStorage.removeItem('st/allowWcRunId');
        this.addLog('[deeplink] allow cleared (post-send)');
      } catch { /* noop */ }

      const net = await this.provider!.getNetwork();
      await this.watchSwapReceiptUntilFinal(sent.hash, Number(net.chainId));
    },
    markUserCancelled: () => {
      this.bridgeStatus = 'cancelled';
      this.bridgeError = null;
    }
  };


  // 👇 près des autres const utilitaires
  private static readonly TOPIC_TRANSFER =
    '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef';

  // ⬇️ remplace intégralement la version shim
  private async startHashlessWatchExecution(opts: {
    owner: string; chainId: number;
    routerTo?: string | null;
    tokenIn?: string | null; expectedInWei?: bigint | null;
    tokenOut?: string | null; expectedOutWei?: bigint | null;
  }): Promise<void> {
    const p = this.provider; if (!p) return;

    const owner = (opts.owner || '').toLowerCase();
    const router = (opts.routerTo || '').toLowerCase();
    const tIn = (opts.tokenIn || '').toLowerCase();
    const tOut = (opts.tokenOut || '').toLowerCase();
    const chainId = opts.chainId;

    this.addLog(`[BRIDGE][HASHLESS] start | owner=${owner} chain=${chainId} router=${router} tIn=${tIn} tOut=${tOut}`);

    // 1) Prépare les filtres de logs (ERC20 Transfer)
    const pad = (a: string) => '0x' + a.replace(/^0x/, '').padStart(64, '0');
    const filters: any[] = [];
    if (tIn && router) filters.push({ address: tIn, topics: [BridgeComponent.TOPIC_TRANSFER, pad(owner), pad(router)] });
    if (tOut && router) filters.push({ address: tOut, topics: [BridgeComponent.TOPIC_TRANSFER, null, pad(owner)] });

    let resolved = false;
    const onLog = async (log: any) => {
      if (resolved) return;
      try {
        const txHash = String(log?.transactionHash || '');
        if (txHash) {
          resolved = true;
          this.addLog(`[SWAP][HASHLESS] log hit → tx=${txHash}`);
          this.bridgeHash = txHash;
          // Dès que le hash est connu, on enlève la fenêtre d’auto-deeplink
          try {
            sessionStorage.removeItem('st/allowWcDeeplinkUntil');
            sessionStorage.removeItem('st/allowWcRunId');
            this.addLog('[deeplink] allow cleared (post-hash detection)');
          } catch { /* noop */ }
          // on passe sur le watcher receipt “classique”
          await this.watchSwapReceiptUntilFinal(txHash, chainId);
        }
      } catch {/* ignore */ }
    };

    // 2) Armer les listeners
    for (const f of filters) p.on(f, onLog);

    // 3) Sécurité: désarmer proprement si l’instance est détruite
    const teardown = () => { try { for (const f of filters) p.off(f, onLog); } catch { } };
    const stopOnDestroy = () => teardown();
    // (si tu as déjà un hook ngOnDestroy enregistré, garde-le; sinon ce petit guard suffit)
    try { (this as any).__hashlessTeardown?.(); } catch { }
    (this as any).__hashlessTeardown = stopOnDestroy;

    // NB: pas de “fallback nonce scan” agressif → on reste soft pour éviter régressions.
  }
  private wakeEnabled = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);





  private async ensureWalletOnDesiredChainForExecute(runId: number, src: string): Promise < boolean > {
    const TAG = `[exec][chain-guard]`;
    const desired = Number((this as any).desiredChainId ?? this.chainId ?? NaN);
    if (!Number.isFinite(desired) || desired <= 0) {
        this.addLog?.(`${TAG} skip (no desired) | runId=${runId} src=${src}`);
        return true;
      }
    if (!this.rawProvider || typeof (this.rawProvider as any).request !== 'function') {
        this.addLog?.(`${TAG} fail (missing rawProvider) | runId=${runId} desired=${desired}`);
        return false;
      }
    let walletCid = Number((this as any).walletChainId ?? NaN);
    try {
        const net = await this.provider?.getNetwork?.();
        const cid = Number(net?.chainId);
        if (Number.isFinite(cid) && cid > 0) walletCid = cid;
      } catch { }
    this.addLog?.(`${TAG} enter | runId=${runId} src=${src} desired=${desired} wallet=${Number.isFinite(walletCid) ? walletCid : 'null'}`);
    if (Number.isFinite(walletCid) && walletCid === desired) {
        this.addLog?.(`${TAG} OK already aligned | chainId=${desired}`);
        return true;
      }
    const toHex = (n: number) => '0x' + n.toString(16);
    try {
       this.addLog?.(`${TAG} request switch | from=${Number.isFinite(walletCid) ? walletCid : 'null'} to=${desired} (${toHex(desired)})`);
        await (this.rawProvider as any).request({ method: 'wallet_switchEthereumChain', params: [{ chainId: toHex(desired) }] });
        for (let i = 1; i <= 20; i++) {
            await new Promise(r => setTimeout(r, 150));
            try {
                const net = await this.provider?.getNetwork?.();
                const cid = Number(net?.chainId);
                if (Number.isFinite(cid) && cid > 0) {
                    (this as any).walletChainId = cid;
                    if (cid === desired) {
                        this.addLog?.(`${TAG} aligned after switch | i=${i} wallet=${cid}`);
                        return true;
                      }
                  }
              } catch { }
          }
        const finalCid = Number((this as any).walletChainId ?? NaN);
        this.addLog?.(`${TAG} FAIL still mismatched | desired=${desired} wallet=${Number.isFinite(finalCid) ? finalCid : 'null'}`);
        return false;
      } catch (e: any) {
          this.addLog?.(`${TAG} switch FAILED | desired=${desired} err=${e?.message ?? String(e)}`);
          try {
              const name = CHAIN_MAP?.[desired]?.name ?? String(desired);
              alert(`Veuillez changer de réseau dans votre wallet vers ${name}, puis réessayer.`);
            } catch { }
          return false;
        } finally {
        const w = Number((this as any).walletChainId ?? NaN);
        this.addLog?.(`${TAG} exit | runId=${runId} desired=${desired} wallet=${Number.isFinite(w) ? w : 'null'}`);
      }
 }

  // ─────────────────────────────────────────────────────────────
  // EXECUTION DU SWAP (approve AVANT simulation) — VERSION GATEKEEPER (timeout 180s)
  // ─────────────────────────────────────────────────────────────
  // ─────────────────────────────────────────────────────────────
  // EXECUTION DU SWAP (approve AVANT simulation) — VERSION GATEKEEPER (timeout 180s)
  // ─────────────────────────────────────────────────────────────
  async executeBridge(intentToken?: string) {
    // Identifiant de "run" pour verrouiller les réouvertures
    const runId = ++this._runSeq;
    this.addLog(`[RUN] executeBridge runId=${runId}`);
    this.addLog?.(`[ALT][panel] before-send hasQuote=${!!this.quote} hasTx=${!!this.quote?.transactionRequest} valKey=${this.validatingKey} selKey=${this.selectedAltKey}`);


    // ✅ Align Swap: reset cancel-flow PER RUN (timers + hasHash flags)
    try {
      const cf: any = (this as any).cancelFlowV1;
      if (cf?.timers) {
        for (const t of cf.timers.values()) { try { window.clearTimeout(t); } catch { } }
        cf.timers.clear();
      }
      if (cf?.hasHash) { cf.hasHash.apprv = false; cf.hasHash.trx = false; }
      cf.runId = runId;
    } catch { }

    // harmoniser avec openDeeplinkOnce (qui utilise __dlOpenedForRun)
    // si tu gardes un reset côté executeSwap:
    try { (this as any).__dlOpenedForRun = null; } catch { }
    if (this._deeplinkReopenTimer) { try { clearTimeout(this._deeplinkReopenTimer); } catch { } }
    this.addLog('🔥 [START] executeBridge (bridge-parity)');

    /* await this.preDeeplinkAnnounce('main-cta', runId);*/

    // ─────────────────────────────────────────────────────────────
    // 0) GUARDS DE BASE
    // ─────────────────────────────────────────────────────────────
    if ((!this.quote && !this.selectedAlternative) || !this.provider || !this.takerAddress) {

      this.addLog('⛔ [GUARD] missing quote/provider/takerAddress');
      this.bridgeStatus = 'error';
      this.bridgeError = this.translate.instant('BRIDGE_TX_MISSING');
      return;
    }


        // ─────────────────────────────────────────────────────────────
          // 0.05) CHAIN GUARD (swap-like): wallet switch enforced ONLY here
          // ─────────────────────────────────────────────────────────────
          {
     const ok = await this.ensureWalletOnDesiredChainForExecute(runId, 'executeBridge');
          if (!ok) {
              this.addLog?.(`⛔ [GUARD] chain-guard failed | runId=${runId} desired=${(this as any).desiredChainId ?? 'null'} wallet=${(this as any).walletChainId ?? 'null'}`);
              this.bridgeStatus = 'error';
              this.bridgeError = this.translate.instant('WRONG_NETWORK');
              return;
           }
        }

    const isAlt = !!this.selectedAlternative;
    const routeObj = this.selectedAlternative ?? this.quote;
    const currentKey = this.getProviderKey(routeObj);
    this.addLog(`[CTX] isAlt=${isAlt} key=${currentKey || 'main'} chainId=${this.chainId} addr=${this.takerAddress}`);

    const tx = this.getTxFromQuote(routeObj);

    // Helper: lit la balance depuis le cache this.tokenBalances et la convertit en WEI (bigint)
    const cachedErc20BalanceWei = (token: string, chainIdNum: number): bigint => {
      try {
        if (!token || token.length !== 42) return 0n;
        const key = `${token.toLowerCase()}_${chainIdNum}`;
        const raw = (this.tokenCachedBalances as any)?.[key]; // ex: "12.34" (unités humaines)
        if (!raw) return 0n;

        // retrouver les décimales à partir de userTokens
        const t = (this.userTokens || []).find(
          (x: any) => String(x?.address).toLowerCase() === token.toLowerCase() && Number(x?.chainId) === chainIdNum
        );
        const decimals = Number(t?.decimals ?? t?.tokenDecimals ?? 18);
        if (!Number.isFinite(decimals) || decimals < 0 || decimals > 36) return 0n;

        // conversion sûre string → wei
        // (on ne veut PAS de float; on utilise parseUnits si dispo)
        const s = String(raw).trim();
        if (!s) return 0n;
        // parseUnits style minimaliste sans dépendre d'ethers: supporte uniquement "entier" et "entier.decim"
        const parts = s.split('.');
        const intPart = parts[0].replace(/\D/g, '') || '0';
        const fracPart = (parts[1] || '').replace(/\D/g, '');
        const fracPadded = (fracPart + '0'.repeat(decimals)).slice(0, decimals);
        const weiStr = (intPart + (decimals ? fracPadded : '')).replace(/^0+/, '') || '0';
        return BigInt(weiStr);
      } catch { return 0n; }
    };

    // ─────────────────────────────────────────────────────────────
    // 0.1) SNAPSHOT ROUTE & TX + ALLOWANCE PROBE + SIM PROBE (logs only)
    // ─────────────────────────────────────────────────────────────
    try {
      this.dbg.logRouteSnapshot(this.addLog.bind(this), routeObj, tx, currentKey || 'main');
    } catch (e: any) {
      this.addLog(`[DBG] logRouteSnapshot error: ${e?.message || e}`);
    }

    try {
      const owner = this.takerAddress;
      const spender = routeObj?.allowanceTarget || routeObj?.spender || tx?.to || null;
      const tokenAddr = this.sellTokenAddress || null;

      const rawWei =
        routeObj?.steps?.[0]?.estimate?.fromAmount ??
        routeObj?.estimate?.fromAmount ??
        routeObj?.fromAmount ??
        routeObj?.amount ??
        routeObj?.sellAmount ??
        routeObj?.transactionRequest?.amount ??
        routeObj?.transactionRequest?.value ?? null;

      let required: bigint = 0n;
      try {
        if (typeof rawWei === 'number') required = BigInt(Math.trunc(rawWei));
        else {
          const s = String(rawWei ?? '').trim();
          if (!s) required = 0n;
          else if (/^\d+$/.test(s)) required = BigInt(s);
          else if (/^0x[0-9a-f]+$/i.test(s)) required = BigInt(s);
          else required = BigInt(Math.trunc(Number(s) || 0));
        }
      } catch { required = 0n; }

      await this.dbg.logAllowanceProbe(this.provider, this.addLog.bind(this), tokenAddr, owner, spender, required);
    } catch { /* silent */ }

    try {
      if (this.showDebug && this.provider && tx) {
        await this.dbg.probeSimulation(this.provider, this.addLog.bind(this), tx);
      }
    } catch (e: any) {
      this.addLog(`[DBG] probeSimulation error: ${e?.message || e}`);
    }

    // ─────────────────────────────────────────────────────────────
    // 0.2) TX ABSENT → STOP
    // ─────────────────────────────────────────────────────────────
    if (!tx) {
      this.addLog('⛔ [GUARD] tx missing from route');
      this.bridgeStatus = 'error';
      this.bridgeError = this.translate.instant('SWAP_TX_MISSING');
      if (isAlt) { if (currentKey) this.failedAltKeys.add(currentKey); }
      else { this.lastSimFailedKey = currentKey || 'main'; }
      return;
    }

    // ─────────────────────────────────────────────────────────────
    // 1) CONTEXTE WALLET + PARAMS APPROVE
    // ─────────────────────────────────────────────────────────────
    const provider = this.provider!;
    let signer = await provider.getSigner();
    const owner = await signer.getAddress();

    // helpers
    const toAddr = (x: any) => String(x ?? '').trim().toLowerCase();
    const isAddr = (a?: string) => {
      const s = toAddr(a);
      return !!(s && s.startsWith('0x') && s.length === 42 && s !== '0x0000000000000000000000000000000000000000');
    };

    // spender (multi-sources pour couvrir Odos / OKX / LiFi)
    const approveSpender = toAddr(
      routeObj?.allowanceTarget ||
      routeObj?.approvalAddress ||
      routeObj?.estimate?.approvalAddress ||
      routeObj?.spender ||
      routeObj?.value?.approvalAddress ||
      routeObj?.transactionRequest?.to || ''
    );

    // token vendu — source canonique alignée sur validateMainQuoteWithTxFlow
    const tokenAddr = (() => {
      const backend =
        routeObj?.fromTokenAddress ||
        routeObj?.fromToken?.address ||
        this.quote?.fromTokenAddress ||
        this.quote?.fromToken?.address;
      const fallbacks = [
        routeObj?.sellTokenAddress,
        routeObj?.inTokenAddress,
        routeObj?.sellToken?.address,
        routeObj?.tokenIn?.address,
        routeObj?.inToken?.address,
        this?.quote?.sellTokenAddress,
        this?.quote?.inTokenAddress,
        this?.quote?.sellToken?.address,
        this?.quote?.tokenIn?.address,
        this?.quote?.inToken?.address,
        this.sellTokenAddress
      ].map(toAddr).find(isAddr);
      return toAddr(backend) || fallbacks || '';
    })();


    // Vente "native" → (1) tx.value > 0 ou (2) mapping natif (0xeeee…/0x1010…)
    let isNativeSell = false;
    try { isNativeSell = BigInt(String(tx?.value ?? '0')) > 0n; } catch { isNativeSell = false; }
    if (!isNativeSell && isAddr(tokenAddr)) {
      try {
        const chainIdNum = Number((await provider.getNetwork()).chainId);
        if (this.isNativeToken?.(tokenAddr, chainIdNum)) isNativeSell = true;
      } catch { /* noop */ }
    }

    // Montant à autoriser — source canonique: ROOT sellAmount / SellAmount
    let needed = 0n;
    let pickedKey = 'root.sellAmount';
    try {
      const raw =
        routeObj?.inputAmountRaw ??
        routeObj?.estimate?.fromAmount ??
        routeObj?.fromAmount ??
        routeObj?.value?.takerTokenAmount ??
        routeObj?.value?.fromAmount ??
        routeObj?.sellAmount ??
        0;

      const s = String(raw ?? '').trim();
      needed = !s ? 0n : (s.startsWith('0x') || s.startsWith('0X')) ? BigInt(s) : BigInt(s);
    } catch { needed = 0n; }
    this.addLog(`[BRIDGE][APPROVE] inputs | spender=${approveSpender} token=${tokenAddr} isNative=${isNativeSell} needed=${needed} (key=${pickedKey})`);

    // ─────────────────────────────────────────────────────────────
    // 2) APPROVE + POLL (méthode Bridge: ethers.Contract)
    // ─────────────────────────────────────────────────────────────
    const ERC20_ABI = [
      "function allowance(address owner, address spender) view returns (uint256)",
      "function approve(address spender, uint256 value) returns (bool)",
      "function balanceOf(address) view returns (uint256)"
    ];

    // 🔁 Lecture d’allowance en pouvant forcer un réseau de lecture (ex: toChainId)
    const readAllowance = async (
      token: string,
      _owner: string,
      _spender: string,
      readChainId?: number
    ): Promise<bigint> => {
      if (!token || !_owner || !_spender) return 0n;
      const p = (readChainId ? this.getReadonlyProvider(readChainId) : null) || this.provider;
      if (!p) { this.addLog?.(`[READ][allowance] no provider (cid=${readChainId ?? this.chainId})`); return 0n; }
      const erc20 = new Contract(token, ERC20_ABI, p); // read-only
      this.addLog?.(`[READ][allowance] token=${token} owner=${_owner} spender=${_spender} cid=${readChainId ?? this.chainId}`);
      try {
        const cur = await (erc20['allowance'] as (o: string, s: string) => Promise<bigint>)(_owner, _spender);
        return cur ?? 0n;
      } catch { return 0n; }
    };

    const pollAllowanceUntil = async (
      token: string,
      spender: string,
      _owner: string,
      amount: bigint,
      opts: { timeoutMs?: number; intervalMs?: number; readChainId?: number } = {}
    ): Promise<'ok' | 'partial' | 'timeout'> => {
      const { timeoutMs = 60_000, intervalMs = 1_000, readChainId } = opts;
      const p = (readChainId ? this.getReadonlyProvider(readChainId) : null) || this.provider;
      if (!p) { this.addLog?.(`[BRIDGE][APPROVE][POLL] no provider (cid=${readChainId ?? this.chainId})`); return 'timeout'; }
      const erc20 = new Contract(token, ERC20_ABI, p);
      this.addLog?.(`[BRIDGE][APPROVE][POLL] start | token=${token} spender=${spender} needed=${amount} cid=${readChainId ?? this.chainId}`);
      const t0 = Date.now();
      let last = 0n;
      let firstTick = true;
      this.addLog?.(`[BRIDGE][APPROVE][POLL] tick-arm`);
      while (true) {
        try {
          const cur = await (erc20['allowance'] as (o: string, s: string) => Promise<bigint>)(_owner, spender);
          if (cur !== last) { this.addLog(`[BRIDGE][APPROVE][POLL] tick | allowance=${cur}`); last = cur; }
          if (!firstTick && cur >= amount) { this.addLog(`[BRIDGE][APPROVE][POLL] ok | ${cur} ≥ ${amount}`); return 'ok'; }
          firstTick = false;
        } catch { /* transient */ }
        if (Date.now() - t0 > timeoutMs) {
          this.addLog(`[BRIDGE][APPROVE][POLL] timeout ${timeoutMs}ms | last=${last}`);
          return last > 0n && last < amount ? 'partial' : 'timeout';
        }
        await new Promise(r => setTimeout(r, intervalMs));
      }
    };
    // ✅ Lecture de balance hashless sur le réseau destination (sans changer le wallet)
    const readTokenBalanceOn = async (token: string, owner: string, chainId: number): Promise<bigint> => {
      const p = this.getReadonlyProvider(chainId);
      if (!p) { this.addLog?.(`[HASHLESS][readBal] no ro provider for cid=${chainId}`); return 0n; }
      try {
        const erc20 = new Contract(token, ERC20_ABI, p);
        const bal = await (erc20['balanceOf'] as (a: string) => Promise<bigint>)(owner);
        this.addLog?.(`[HASHLESS][readBal] ok | cid=${chainId} token=${token} owner=${owner} bal=${bal}`);
        return bal ?? 0n;
      } catch (e: any) {
        this.addLog?.(`[HASHLESS][readBal][err] cid=${chainId} token=${token} msg=${e?.message || e}`);
        return 0n;
      }
    };
    // juste avant:
    let mustApproveFirst = false;
    this.addLog(`[DBG][APPROVE-PRECHECK] spender=${approveSpender} token=${tokenAddr} needed=${needed} isNative=${isNativeSell}`);
    if (!isNativeSell && approveSpender && tokenAddr && tokenAddr.length === 42 && needed > 0n) {
      // 🔁 Lire l’allowance sur le réseau source de la route (fromChainId)
      const preAllowance = await readAllowance(
        tokenAddr, owner, approveSpender,
        Number((routeObj as any)?.fromChainId ?? this.chainId)
      );
      this.addLog(`[BRDIGE][APPROVE] pre-check | allowance=${preAllowance} needed=${needed}`);
      mustApproveFirst = preAllowance < needed;
    } else {
      this.addLog('[BRIDGE][APPROVE] skip pre-check (vente native ou params manquants)');
    }

    if (mustApproveFirst) {
      this.addLog(`[FLOW] approve requis avant simulation (allowance < needed)`);
      this._showWcModalForPhase('approve', 'approve-cta', runId);

      // Pré-déclare le handle du poll pour l'utiliser après
      let pollP: Promise<'ok' | 'partial' | 'timeout'> | null = null;

      if (typeof this.ensureAllowanceForRoute === 'function') {
        const token = intentToken || this.gate.generateIntent('swap-allowance', (m) => this.addLog(m));
        this.addLog(`[gate][approve] token=${token}`);
        this.bridgeStatus = 'approve';

        // 0) Revalidation IMMÉDIATE juste avant toute ouverture de MM
        //    => évite d’ouvrir une feuille si l’allowance est déjà suffisante.
        try {
          if (tokenAddr && approveSpender && owner && String(tokenAddr).length === 42 && needed > 0n) {
            const reAllowance = await readAllowance(tokenAddr, owner, approveSpender);
            this.addLog(`[BRIDGE][APPROVE] re-check | allowance=${reAllowance} needed=${needed}`);
            if (reAllowance >= needed) {
              this.addLog('🟢 [BRIDGE][APPROVE] skip après re-check (allowance suffisante) → passer à la simulation');
              // remettre l’état cohérent post-approve et enchaîner la SIM
              this.bridgeStatus = 'pending';
              this.bridgeError = null;
              this.addLog('[UI] status=pending | phase=post-approve → simulation');
              // on court-circuite toute la branche approve ici
              mustApproveFirst = false;
            }
          } else {
            this.addLog('[BRIDGE][APPROVE] re-check skip (params incomplets)');
          }
        } catch (e: any) {
          this.addLog(`⚠️ [BRIDGE][APPROVE] re-check error: ${e?.message ?? e}`);
        }

        if (!mustApproveFirst) {
          // on sort proprement de la branche approve et on retombera plus bas sur la SIM
          this.addLog('[approve] skipped → bypass poll & continue to simulation');
        } else {
          // 1) N’armer le deeplink + foreground QU’APRÈS confirmation “approve nécessaire”
          //    (et taguer l’UI "approve-cta" pour la trace)
          try {
            // no auto-deeplink (parité Swap): pas d’armement ici
            this.addLog('[deeplink][gate] SKIP auto-arm approve-cta (no auto-deeplink)');
          } catch {/* noop */ }

          // 🔔 — wake/foreground APRES revalidation
          try {
            //this.wakeWalletIfNeeded('apprv-pre', runId);
            // si session WC silencieuse → simple foreground suffit
            if (this.isWcSilentAttached() && !this.wcUri) {
              //  this.foregroundMetaMaskGeneric?.(runId, 'apprv');
            }
          } catch { /* no-op */ }

          // (Optionnel) petit délai pour laisser iOS/Android remonter la feuille
          await this.delay(350);


          this.addLog('[approve] BEFORE requestWithIntentEx');
          const res = await this.gate.requestWithIntentEx(
            token,
            async () => {
              this.addLog('[approve] ensureAllowanceForRoute ENTER');
              await this.ensureAllowanceForRoute(routeObj);
              this.addLog('[approve] ensureAllowanceForRoute EXIT (returned)');
            },
            { ctx: 'swap:approve', log: (m) => this.addLog(m), preserveTokenOnSuccess: true, timeoutMs: 180_000 }
          );
          this.addLog(`[approve] AFTER requestWithIntentEx | ok=${res?.ok}`);
          if (!res.ok) {
            if (this.bridgeStatus === 'approve') this.bridgeStatus = 'idle';
            const why = res.reason || 'unknown';
            this.addLog(`⛔ [approve] aborted reason=${why} → ABORT WC + HARD RELOAD`);
            try { await (this as any).abortWalletConnectSafely?.call?.(this, why); } catch { }
            try { await this.forceReconnectWalletSession(why); } catch { }
            return;
          }


          this.addLog('ENTER pollP');
          // Démarrer le poll APRES l’approve (Bridge-like)
          pollP = pollAllowanceUntil(tokenAddr, approveSpender, owner, needed, { timeoutMs: 60_000, intervalMs: 1_000 });
          this.addLog('EXIT pollP');
        }
      }

      // 🧭 Section poll déplacée à l’intérieur du cas “approve envoyée”
      if (mustApproveFirst && pollP) {
        const pollRes = await pollP;
        this.addLog('[MARK] after-poll');
        if (pollRes !== 'ok') {
          this.addLog(pollRes === 'partial'
            ? '⚠️ [BRIDGE][APPROVE] partial: allowance < needed → stop'
            : '⏳ [BRIDGE][APPROVE] timeout: pas d’effet on-chain → stop');
          this.bridgeStatus = 'error';
          this.bridgeError = 'APPROVE_NOT_EFFECTIVE';
          this.cd?.detectChanges?.();
          return;
        }
        try {
          this.addLog('🟢 [BRIDGE] allowance effective → passer à la simulation');
          this.bridgeStatus = 'pending';
          this.bridgeError = null;
          this.addLog('[UI] status=pending | phase=post-approve → simulation');
          this.cd?.detectChanges?.();
        } catch (e: any) {
          this.addLog('⛔ [POST-APPROVE] crash: ' + (e?.message ?? e));
          this.bridgeStatus = 'error';
          this.bridgeError = 'POST_APPROVE_CRASH';
          this.cd?.detectChanges?.();
          return;
        }
      }


    } else {
      this.addLog('🟢 [SWAP][APPROVE] skip: allowance suffisante ou vente native');
    }

    // ─────────────────────────────────────────────────────────────
    // 2.b) Sécu réseau POST-APPROVE
    // 👉 si le wallet a switché de réseau en douce entre
    //    le quote et l’approve, on le réaligne AVANT
    //    la simulation + envoi de la TX de swap.
    // ─────────────────────────────────────────────────────────────
    try {
      const q: any = this.quote;
      const srcChainId =
        Number((routeObj as any)?.fromChainId) ??
        Number((this.quote as any)?.fromChainId) ??
        this.chainId;

      const expectedChainId = Number.isFinite(srcChainId) ? srcChainId : undefined;


      if (expectedChainId && this.provider) {
        const ctxForNet: 'main' | 'alt' = isAlt ? 'alt' : 'main';

        // 🔁 On force softSeq=2 pour activer la logique
        // de _forceChainForRunIfNeeded même sur le 1er run.
        await this._forceChainForRunIfNeeded(ctxForNet, 2, expectedChainId);
      }
    } catch (e: any) {
      this.addLog?.(
        '[NETWORK][POST-APPROVE] warn: exception during post-approve chain check: ' +
        (e?.message ?? e)
      );
    }

    // ─────────────────────────────────────────────────────────────
    // 3) PRÉFLIGHT (simulation) — APRÈS approve si nécessaire
    // ─────────────────────────────────────────────────────────────
    // 🔎 Corrélation WC: si on a soft-reset le wcUri, on veut le voir ici.
    try {
      const uMem = (this as any).wcUri;
      const uLast = (this as any)._wcLastUri;
      const uSS = sessionStorage?.getItem?.('st/wcLastUri');
      const uProv = (this as any).rawProvider?.uri || (this as any).provider?.provider?.uri;
      const pick = uMem || uLast || uSS || uProv || '';
      this.addLog?.(
        `[WC][DBG] before-preflight ` +
        `wcUriLen=${String(uMem).length} ` +
        `lastLen=${uLast ? String(uLast).length : 0} ` +
        `ssLen=${uSS ? String(uSS).length : 0} ` +
        `provLen=${uProv ? String(uProv).length : 0} ` +
        `pickedLen=${pick ? String(pick).length : 0} ` +
        `pickedHead=${pick ? String(pick).slice(0, 28) : '(empty)'}`
      );
    } catch { }

    this.addLog('[SIM] preflight start');
    this.addLog('[MARK] before-preflight-call');
    let preflightOk: boolean;
    try {
      preflightOk = await this.simulateTxPreflight(isAlt ? routeObj : undefined);
    } catch (e: any) {
      this.addLog('⛔ [SIM] preflight exception: ' + (e?.message ?? e));
      preflightOk = false;
    }
    this.addLog?.(`[ALT][pre-send] preflightOk=${preflightOk} hasQuote=${!!this.quote} hasTx=${!!this.quote?.transactionRequest}`);

    // Fallback smart si motif allowance
    if (!preflightOk) {
      const lastErr = (this as any)?.lastPreflightError || '';
      const looksLikeAllowance = /TRANSFER_FROM_FAILED|insufficient allowance|allowance/i.test(String(lastErr));
      if (looksLikeAllowance && !isNativeSell && approveSpender && tokenAddr && needed > 0n) {
        this.addLog('⚠️ [SIM] échec typé allowance → recheck + approve fallback');

        // 🔁 Re-check allowance sur le bon réseau source (fromChainId)
        const cur = await readAllowance(
          tokenAddr, owner, approveSpender,
          Number((routeObj as any)?.fromChainId ?? this.chainId)
        );
        if (cur < needed) {
          this.addLog('ENTER pollP2');
          const pollP2 = pollAllowanceUntil(
            tokenAddr, approveSpender, owner, needed,
            {
              timeoutMs: 60_000, intervalMs: 1_000,
              readChainId: Number((routeObj as any)?.fromChainId ?? this.chainId)
            }
          );
          this.addLog('EXIT pollP2');
          if (typeof this.ensureAllowanceForRoute === 'function') {
            const token = intentToken || this.gate.generateIntent('swap-allowance', (m) => this.addLog(m));
            this.bridgeStatus = 'approve';
            const res2 = await this.gate.requestWithIntentEx(
              token,
              async () => { await this.ensureAllowanceForRoute(routeObj); },
              { ctx: 'swap:approve-retry', log: (m) => this.addLog(m), preserveTokenOnSuccess: true, timeoutMs: 180_000 }
            );
            if (!res2.ok) {
              if (this.bridgeStatus === 'approve') this.bridgeStatus = 'idle';
              const why2 = res2.reason || 'unknown';
              this.addLog(`⛔ [approve-retry] aborted reason=${why2} → stop`);
              return;
            }
          }
          const p2 = await pollP2;
          if (p2 !== 'ok') {
            this.addLog('⛔ [approve-retry] poll failed → stop');
            this.bridgeStatus = 'error';
            this.bridgeError = 'APPROVE_NOT_EFFECTIVE';
            return;
          }
          this.addLog('🟢 [approve-retry] allowance effective → re-simuler');
          preflightOk = await this.simulateTxPreflight(isAlt ? routeObj : undefined);
        }
      }
    }

    if (!preflightOk) {
      this.addLog(`⛔ [SIM] fail on ${currentKey ?? 'unknown'} (isAlt=${isAlt}) → bouton désactivé`);
      if (isAlt) { if (currentKey) this.failedAltKeys.add(currentKey); }
      else { this.lastSimFailedKey = currentKey || 'main'; }
      return;
    }
    this.addLog('[SIM] preflight ok');
    this.bridgeStatus = 'pending';
    this.bridgeError = null;
    this.addLog('[UI] status=pending | phase=signing (pre-send)');
    this.cd?.detectChanges?.();

    // 🆕 entrer explicitement en phase 4
    this.addLog(`[EXEC] phase-4 enter | runId=${runId} isAlt=${isAlt} key=${currentKey || 'main'}`);


    // ─────────────────────────────────────────────────────────────
    // 4) EXÉCUTION — hashless + wake + deeplink 45s (parité Bridge)
    // ─────────────────────────────────────────────────────────────

    const netNow = await provider.getNetwork();
    const chainId = Number(netNow.chainId);
    const routeObjExec = this.selectedAlternative ?? this.quote;
    const txSrc = this.getTxFromQuote?.(routeObjExec) ?? routeObjExec?.transactionRequest;

    // 🆕 log de contexte TX source
    this.addLog('[EXEC] txSrc snapshot ' + JSON.stringify({
      hasTx: !!txSrc,
      to: txSrc?.to,
      value: String(txSrc?.value ?? '0x0'),
      dataLen: (txSrc?.data ?? '0x').length,
    }));

    if (!txSrc?.to) {
      this.addLog('⛔ [EXEC] tx manquante');
      this.bridgeError = this.translate.instant('SWAP_TX_MISSING');
      return;
    }


    // Préparer la tx (wallet-first fees)
    let txToSend = sanitizeTxForWallet({
      from: await signer.getAddress(),
      to: txSrc.to,
      data: txSrc.data ?? '0x',
      value: txSrc.value ?? '0x0',
    });
    this.addLog('[EXEC] txToSend built ' + JSON.stringify({
      from: txToSend.from,
      to: txToSend.to,
      value: String(txToSend.value ?? '0x0'),
      dataLen: (txToSend.data ?? '0x').length,
    }));

    // Resync réseau juste avant l’envoi (anti “changed”)
    {
      const n = await provider.getNetwork();
      if (Number(n.chainId) !== chainId) {
        this.addLog(`🔁 [EXEC] pre-send resync: current=${Number(n.chainId)} → target=${chainId}`);
        await this.switchToChain(chainId);
        await new Promise(r => setTimeout(r, 250));
        signer = await provider.getSigner();
        const from2 = this.takerAddress ?? (await signer.getAddress());
        txToSend = { ...txToSend, from: from2 };
      }
    }
    this.addLog('[EXEC] after resync ' + JSON.stringify({
      from: txToSend.from,
      to: txToSend.to,
      chainId,
    }));
    // no auto-deeplink (parité Swap): aucun wake/arm auto ici
    this.addLog?.('[deeplink][wake] SKIP wakeWalletSilentlyIfNeeded + __allowWcDeeplinkFor (no auto-deeplink)');


    // 🔐 Armement explicite du gate pour la TX (deny-by-default) — 1 RUN = 1 ouverture
    const sendCtx = isAlt ? 'alt-cta' as const : 'main-cta' as const;
    this.addLog(`[gate] runId=${runId} → preDeeplinkAnnounce(${sendCtx})`);
    // ❌ On ne lance plus de timeout local "trx" côté bridge :
    //    – parité avec SwapComponent
    //    – évite les fermetures forcées + fenêtres MM fantômes
    this.addLog('[MARK] before-predeeplink');



    // 🔥 Debug critique: au moment d’ouvrir la modal TX, est-ce qu’on a un wcUri ?
    try {
      const uMem = (this as any).wcUri;
      const uLast = (this as any)._wcLastUri;
      const uSS = sessionStorage?.getItem?.('st/wcLastUri');
      const uProv = (this as any).rawProvider?.uri || (this as any).provider?.provider?.uri;
      const pick = uMem || uLast || uSS || uProv || '';
      this.addLog?.(
        '[WC][DBG] before-tx-modal ' +
        JSON.stringify({
          wcUriLen: uMem ? String(uMem).length : 0,
          lastLen: uLast ? String(uLast).length : 0,
          ssLen: uSS ? String(uSS).length : 0,
          provLen: uProv ? String(uProv).length : 0,
          pickedLen: pick ? String(pick).length : 0,
          pickedHead: pick ? String(pick).slice(0, 28) : '(empty)',
        })
      );
      if (!uMem && pick) {
        (this as any).wcUri = pick;
        (this as any)._wcLastUri = pick;
        try { this.wallet?.wcUri$?.next?.(pick); } catch { }
        this.addLog?.('[WC][DBG] wcUri restored before tx-modal');
      }
    } catch { }

    // 🔸 Armer le timeout local "cancel" de la phase TX (même logique que SwapComponent)
    this.cfPreDeeplink?.('trx', runId);
    this._showWcModalForPhase('tx', `bridge:tx:${sendCtx}`, runId);


    // ✅ Align Swap: ensure modal CTA can open wallet (user click only)
    // (si ton _showWcModalForPhase ne le fait pas déjà)
    (this as any).onWalletModalOpenWallet = () => {
      try {
        const uri = (this as any).wcUri;
        if (uri) { this.addLog(`[WALLET][MODAL] open wallet via wcUri (user click)`); window.open(uri, '_blank'); }
        else { this.addLog(`[WALLET][MODAL] no wcUri → user must open wallet manually`); }
      } catch (e: any) { this.addLog(`[WALLET][MODAL] open wallet error: ${e?.message || e}`); }
    };

    // 🔓 ALT-CTA : on réutilise le même runId → lever explicitement tous les verrous
    //              pour autoriser une nouvelle ouverture contrôlée du deeplink.
    if (sendCtx === 'alt-cta') {
      try { (this as any).__dlOpenedForRun = null; } catch { }
      try { this._deeplinkOpenedForRun = null; } catch { }
      try {
        if (this._deeplinkReopenTimer) {
          clearTimeout(this._deeplinkReopenTimer);
          this._deeplinkReopenTimer = undefined;
        }
      } catch { }
      // Gate/session flags (deny-by-default → on nettoie avant de réarmer)
      try { sessionStorage.removeItem('st/allowWcRunId'); } catch { }
      try { sessionStorage.removeItem('st/allowWcDeeplinkUntil'); } catch { }
      try { sessionStorage.removeItem('st/skipWcDeeplinkOnce'); } catch { }
      try { this.clearAllowWcDeeplink?.(); } catch { }
      this.addLog('[deeplink][gate] locks cleared for alt-cta (runId reuse)');
    }



    // 👉 Foreground MetaMask même SANS wcUri (WC silencieux)
    if (this.isWcSilentAttached?.() && !this.wcUri) {
      // this.foregroundMetaMaskGeneric?.(runId, 'trx');
    }

    // no auto-deeplink (parité Swap): aucun wake/delay auto ici
    this.addLog?.('[deeplink][wake] SKIP auto delay+wake pre-send (no auto-deeplink)');

    // Armer un watcher HASHLESS de succès (solde tokenOut ↑) AVANT l’envoi
    {
      const routerTo = String(txSrc.to || '').toLowerCase();
      const ownerAddr = this.takerAddress!;

      // 1) Collecte déterministe des candidates d'ADDR "buy"
      const cand = {
        alt_buyTokenAddress: toAddr(this.selectedAlternative?.buyTokenAddress),
        alt_outTokenAddress: toAddr(this.selectedAlternative?.outTokenAddress),
        alt_toToken_addr: toAddr(this.selectedAlternative?.toToken?.address),
        q_buyTokenAddress: toAddr(this.quote?.buyTokenAddress),
        q_toTokenAddress: toAddr(this.quote?.toTokenAddress),
        q_toToken_addr: toAddr(this.quote?.toToken?.address),
        ui_buyTokenAddress: toAddr(this.buyTokenAddress),           // ⬅️ NEW (fallback UI)
      };
      this.addLog(`[HASHLESS][pickOut] candidates=${JSON.stringify(cand)}`);
      const buyAddr =
        cand.alt_buyTokenAddress ||
        cand.alt_outTokenAddress ||
        cand.alt_toToken_addr ||
        cand.q_buyTokenAddress ||
        cand.q_toTokenAddress ||
        cand.q_toToken_addr ||
        cand.ui_buyTokenAddress ||                                   // ⬅️ NEW
        '';
      this.addLog(`[HASHLESS][pickOut] picked=${buyAddr || '(empty)'}`);

      // 2) Type "out" (natif si adresse vide OU mappée native)
      const outSym =
        this.selectedAlternative?.buyTokenSymbol ||
        this.quote?.buyTokenSymbol ||
        this.buyTokenSymbol ||
        '';
      // 🔁 Réseau destination pour la LECTURE (toChainId de la route)
      const outChainId =
        Number((this.selectedAlternative as any)?.toChainId ??
          (this.quote as any)?.toChainId ??
          chainId);
      const isNativeOut =
        !buyAddr || this.isNativeToken?.(buyAddr, outChainId) === true ||
        ['ETH', 'MATIC', 'BNB'].includes(String(outSym).toUpperCase());
      this.addLog(`[HASHLESS][ctx] outChainId=${outChainId}`);
      this.addLog(`[HASHLESS][outType] isNative=${isNativeOut} reason=${!buyAddr ? 'empty-buyAddr' : this.isNativeToken?.(buyAddr, outChainId) ? 'map-native' : outSym ? `sym=${outSym}` : 'unknown'}`);

      // 3) Contexte attendu (pour debug)
      let expectedInWei: bigint | null = null; try { expectedInWei = BigInt(String(this.quote?.inputAmountRaw ?? '0')); } catch { }
      let expectedOutWei: bigint | null = null; try { expectedOutWei = BigInt(String(this.quote?.outputAmountRaw ?? '0')); } catch { }
      this.addLog(`[HASHLESS][cfg] timeoutMs=180000 intervalMs=2000 expectedOutWei=${expectedOutWei ?? '(n/a)'}`);

      // 4) Lecteur de balance tokenOut
      const readOutBalance = async (): Promise<bigint> => {
        try {
          // ✅ Lire la balance sur le réseau DESTINATION (outChainId) en read-only
          const ro = this.getReadonlyProvider(outChainId);
          if (!ro) { this.addLog(`[HASHLESS][readBal][err] no ro provider for cid=${outChainId}`); return 0n; }
          if (isNativeOut) {
            const b = await ro.getBalance(ownerAddr);
            const v = BigInt(b.toString());
            this.addLog(`[HASHLESS][readBal] native ok | cid=${outChainId} wei=${v}`);
            return v;
          }
          // ERC20 sur le réseau destination
          const v = await readTokenBalanceOn(buyAddr, ownerAddr, outChainId);
          return v ?? 0n;
        } catch (e: any) {
          this.addLog(`[HASHLESS][readBal][err] cid=${outChainId} ${e?.message || e}`);
          return 0n;
        }
      };

      // 5) Baseline + poll non-bloquant
      const _hashlessBaseline = await readOutBalance();
      this.addLog(`[HASHLESS][baseline] cid=${outChainId} bal=${_hashlessBaseline}`);
      const _hashlessPoll = (async () => {
        const t0 = Date.now();
        const timeoutMs = 180_000;
        const intervalMs = 2_000;
        let tick = 0;
        this.addLog(`[HASHLESS][POLL] start (tokenOut balance watch)`);
        while (Date.now() - t0 < timeoutMs) {
          await new Promise(r => setTimeout(r, intervalMs));
          tick++;
          const cur = await readOutBalance();
          const delta = cur - _hashlessBaseline;
          if (delta > 0n) {
            this.addLog(`[HASHLESS][POLL] ✅ success | bal=${cur} (Δ=+${delta}) after ${tick} ticks`);
            this.cfMarkDone('trx', 'hashless-balance-delta');

            (this as any).bridgeStatus = 'success';
            try { this.bridgeStatus = 'success'; this.bridgeError = null; this.cd?.detectChanges?.(); } catch { }
            return;
          }
          if (tick % 5 === 0) this.addLog(`[HASHLESS][POLL] tick#${tick} | bal=${cur} (no change)`);
        }
        this.addLog(`[HASHLESS][POLL] ⏳ timeout ${timeoutMs}ms | no positive Δ vs baseline=${_hashlessBaseline}`);
      })();
      void _hashlessPoll; // fire-and-forget

      // (optionnel) stats côté router/tokenIn/out pour télémétrie
      const tokenIn = String(this.quote?.fromTokenAddress || this.quote?.fromToken?.address || '').toLowerCase();
      const tokenOut = buyAddr;
      void this.startHashlessWatchExecution({ owner: ownerAddr, chainId: outChainId, routerTo, tokenIn, tokenOut, expectedInWei, expectedOutWei });
    }

    // Envoi via watchdog (no await) — mais on accroche un then pour armer le watcher
    // this.addLog('🚀 [EXEC] sending (hashless mode, no await)…');
    //this.addLog('[MARK] before-send');
    //this.wakeWalletIfNeeded('post-send', runId);

    // ⛓️ promesse d’envoi non bloquante
    this.addLog('[EXEC] about to call txFlow.sendViaSignerWithWatchdog');






    const sendP = this.txFlow.sendViaSignerWithWatchdog(signer, txToSend);
    this.addLog('[EXEC] txFlow.sendViaSignerWithWatchdog returned promise');


    // 🎯 armer le watcher dès que le hash arrive
    let __watchArmed = false;
    const __armByHash = (h?: string) => {
      if (__watchArmed || !h) return;
      __watchArmed = true;
      this.addLog(`[SWAP][TX] sent | hash=${h}`);
      this._hideWcModal?.('hash-received'); // ✅ Align Swap: hide TX modal on hash
      try { this.savePendingSwap?.(h, chainId); } catch { }
      this.watchSwapReceiptUntilFinal?.(h, chainId, { confirmations: 1, timeoutMs: 180_000 })
        ?.catch((e: any) => this.addLog(`[SWAP][WATCH][err] ${e?.message || e}`));
    };

    // 🧷 accroche non bloquante au résultat d’eth_sendTransaction
    sendP
      .then((resp: any) => __armByHash(resp?.hash))
      .catch((e: any) => {
        const msg = String(e?.message || e?.reason || e?.error?.message || '').toLowerCase();
        const code = e?.code ?? e?.error?.code;
        const userRejected =
          code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
          /action_rejected/.test(String(code)) || /denied|rejected|user denied|user rejected/.test(msg);
        if (userRejected) {
          this._hideWcModal?.('user-rejected');
          // 🧯 Refus avant envoi (hashless): on évite toute ré-ouverture de deeplink
          try { setWcSuppressOnce?.(6000); } catch { }
          this.txFlow.markUserCancelled?.();
          this.bridgeStatus = 'cancelled';
          this.bridgeError = null;
          this.addLog('🚫 [EXEC] user rejected (pre-send) → cooldown deeplink 6s');
          try { this.validatingKey = null; } catch { }
          this.cd?.detectChanges?.();
        } else {
          this.addLog(`[EXEC] error (ignored in hashless): ${code || ''} ${e?.message || e}`);
        }
      })
      .finally(() => {
        // Laisser le poll hashless vivre en arrière-plan ; aucune popup ajoutée
        /*                void _hashlessPoll; // fire-and-forget (déjà lancé)*/
      });

    // ⏱️ Fallback doux si le wallet tarde à renvoyer un hash (WC mobile)
    // Fallback doux si le wallet tarde à renvoyer un hash (WC mobile)
    setTimeout(() => {
      if (__watchArmed) return; // le hash est déjà revenu, ne rien faire
      this.addLog(`[BRIDGE][TX] still no hash yet (wallet did not answer yet)`);
      /*      try { this.wakeWalletIfNeeded('kick', runId); } catch { }*/
      // si tu préfères le réveil silencieux :
      // try { this.txFlow?.wakeWalletSilentlyIfNeeded?.(signer); } catch {}
    }, 3000);

    return;
  }




  // ─────────────────────────────────────────────────────────────
  // [restoreSession][wcSync] Sanity check basé sur st/wcLastUri
  // ─────────────────────────────────────────────────────────────
  private syncIsConnectedWithWcLastUri(source: string): void {
    const TAG = '[bridge][restoreSession][wcSync]';
    let hasLast = false;
    let len = 0;

    try {
      const raw = sessionStorage.getItem('st/wcLastUri') || '';
      hasLast = !!raw;
      len = raw.length;
    } catch {
      // no-op
    }

    this.addLog?.(`${TAG} ${source} hasLast=${hasLast} len=${len}`);

    if (!hasLast) {
      // 🧨 Mode hard : on considère que la session WC est zombie → teardown complet
      this.addLog?.(
        `${TAG} ${source} hasLast=false len=${len} → HARD disconnect (no wcLastUri, forcing reset)`
      );

      try {
        // fire-and-forget : on ne peut pas "await" dans une méthode sync,
        // mais disconnectWallet gère ses propres try/catch en interne.
        this.disconnectWallet?.();
      } catch (e: any) {
        this.addLog?.(
          `${TAG} ${source} hard disconnect error: ${e?.message ?? e}`
        );
      }

      // Double sécurité locale au cas où disconnectWallet ne serait pas branché
      this.isConnected = false;
      this.takerAddress = '';
      this.chainId = null;

      try { this.wallet.address$.next(null); } catch { /* no-op */ }
      try { this.wallet.chainId$.next(null); } catch { /* no-op */ }

      return;
    }

    this.addLog?.(`${TAG} ${source} wcLastUri present → keep connected`);
  }





  private recoverySeq = 0;
  private lastRecoveryAt = 0;



  // ✅ version qui n’utilise que des choses déjà présentes dans SwapComponent
  private async wcSoftRecovery(reason: string) {
    const seq = ++this.recoverySeq;
    this.lastRecoveryAt = Date.now();
    this.addLog(`🧯 [recovery#${seq}] soft start | reason=${reason}`);
    try { await this.wallet.disconnect(); } catch (e) { this.addLog(`[recovery#${seq}] disconnect error: ${String(e)}`); }
    try {
      this.takerAddress = null;
      this.provider = null;
      this.quote = null;
      this.bridgeStatus = 'idle';
      this.bridgeError = null;
      this.bridgeHash = null;
      this.tokenBalances = {};
      this.showWcModal = false as any;
      this.wcUri = '' as any;
    } catch (e) { this.addLog(`[recovery#${seq}] purge error: ${String(e)}`); }
    await new Promise(r => setTimeout(r, 900));
    this.addLog(`[recovery#${seq}] done → cooldown 1500ms`);
    await new Promise(r => setTimeout(r, 1500));
  }





  private _inWalletFlow: boolean = false;        // bloque fermetures & handlers pendant MM
  private _pauseQuoteTtl: boolean = false;       // met en pause l'expiration de la quote
  private _txPromptLockUntil: number = 0;


  /** WC “silent reattach” détecté : pas de window.ethereum, provider actif et connecté */
  private isWcSilentAttached(): boolean {
    try {
      const hasWinEth = !!(window as any).ethereum;
      const prov: any = (this.provider as any)?.provider || this.rawProvider || null;
      const isEip1193 = !!prov && typeof prov.request === 'function';
      return !hasWinEth && isEip1193 && !!this.isConnected;
    } catch { return false; }
  }

  // Petit helper pour consommer le flag "skip une fois" du deeplink WC
  private shouldSkipWcDeeplinkOnce(reason?: string, runId?: number): boolean {
    try {
      const raw = sessionStorage.getItem('st/skipWcDeeplinkOnce');
      if (raw === '1') {
        // on consomme le flag (one-shot)
        sessionStorage.removeItem('st/skipWcDeeplinkOnce');
        this.addLog?.(
          `[deeplink][skipOnce] reason=${reason ?? '(n/a)'} runId=${runId ?? -1}`
        );
        return true;
      }
    } catch {
      // storage indispo → on ne bloque pas
    }
    return false;
  }

  /** Fallback générique : juste foregrounder MetaMask (sans wc?uri=...) */
  /** Fallback générique : juste foregrounder MetaMask (sans wc?uri=...) */
  private foregroundMetaMaskGeneric(runId: number, phase: 'apprv' | 'trx'): void {
    try {
      this.addLog?.(`[MM][fg] ENTER phase=${phase} runId=${runId}`);

      // 1) Respecter skipOnce (cas recovery / debug)
      if (this.shouldSkipWcDeeplinkOnce('mm-foreground', runId)) {
        this.addLog?.('[MM][fg] skip: skipOnce=true');
        return;
      }

      // 2) Lire wcLastUri depuis le storage
      let url = '';
      try {
        url = sessionStorage.getItem('st/wcLastUri') || '';
      } catch {
        url = '';
      }

      if (!url || url.length < 4) {
        this.addLog?.('[MM][fg] skip: no usable wcLastUri in storage');
        return;
      }

      // 3) Normaliser “wc...” → “wc:...”
      if (url.startsWith('wc') && !url.startsWith('wc:')) {
        const old = url;
        url = 'wc:' + url.slice(2);
        this.addLog?.(`[MM][fg] normalize url "${old}" -> "${url}"`);
      }

      if (!url.startsWith('wc:')) {
        this.addLog?.(`[MM][fg] skip: uri does not start with "wc:" | uri=${url}`);
        return;
      }

      // 4) Garde anti-doublon par runId (phase ignorée) 🔥 APEX LOCK
      try {
        const w = window as any;
        w.__dlOpenedForRunId = w.__dlOpenedForRunId || {};

        if (w.__dlOpenedForRunId[runId]) {
          this.addLog?.(`[MM][fg] skip: popup already opened for runId=${runId}`);
          return;
        }

        // On verrouille immédiatement pour ce runId
        w.__dlOpenedForRunId[runId] = true;

      } catch {
        // best effort
      }


      // 5) Rediriger Safari vers l’URI wc:…
      const originalHref = window.location.href;
      this.addLog?.(`[MM][fg] OPEN uri=${url}`);
      this.addLog?.(`[MM][fg] href(before)=${originalHref}`);

      // tir du deeplink vers MetaMask / WalletConnect
      window.location.href = url;
      this.addLog?.('[MM][fg] href(after)=<changed>');

      // 6) Patch anti-fenêtre fantôme :
      //    on force la restauration de l’URL HTTP d’origine,
      //    même si Safari nous met sur une page d’erreur chelou.
      if (phase != 'apprv') {
        const forceRestore = () => {
          try {
            history.replaceState(null, '', originalHref);
            this.addLog?.('[MM][fg] restore href after deeplink (force)');
          } catch {
            // best-effort
          }
        };

        // 1er tir rapide pour les cas où le JS continue à tourner en tâche de fond
        setTimeout(forceRestore, 500);

        // 2e tir plus tard pour les cas où iOS throttle les timers
        setTimeout(forceRestore, 2000);
      } else { this.addLog?.('[MM][fg] skip restore for phase=apprv {prevent double-popup}'); }

    } catch (e: any) {
      this.addLog?.(`[MM][fg] EXC ${e?.message || e}`);
    }
  }




  // Dans la classe BridgeComponent
  // APRÈS

  private async ensureAllowanceForRoute(spenderParam?: string): Promise<void> {
    if (!this.provider) return;

    const log = (m: string) => this.addLog?.(`[BRIDGE][APPROVE] ${m}`);

    // --- DEBUG WC FINGERPRINT (local safe to avoid minifier issues)
    const safe = (x: any) => { try { return JSON.stringify(x); } catch { try { return String(x); } catch { return '(unserializable)'; } } };
    const wcDiag = (ctx: string) => {
      const p: any = (this as any)?.provider;
      const raw: any = p?.provider ?? p;
      const flags = {
        hasProvider: !!p,
        hasRequest: !!p?.request,
        isWalletConnectFlag: !!(p?.isWalletConnect || (this as any)?.isWalletConnect),
        hasWcObj: !!raw?.wc,
        hasSession: !!raw?.session || !!raw?.wc?.session || !!p?.session,
        addrKnown: !!this.takerAddress,
        chainKnown: !!this.chainId
      };
      const ctors = {
        provCtor: p?.constructor?.name,
        rawCtor: raw?.constructor?.name
      };
      const actives = {
        addr: this.takerAddress || null,
        chainId: this.chainId ?? null
      };
      this.addLog?.(`[WC][detect][${ctx}] flags=${safe(flags)}`);
      this.addLog?.(`[WC][detect][${ctx}] ctors=${safe(ctors)}`);
      this.addLog?.(`[WC][detect][${ctx}] actives=${safe(actives)}`);
    };
    // Log immédiatement à l’entrée (toujours exécuté si provider présent)
    wcDiag('approve:enter');

    const ZERO = '0x0000000000000000000000000000000000000000';
    const toAddr = (x: any) => String(x ?? '').trim().toLowerCase();
    const now = () => new Date().toISOString().slice(11, 23); // HH:MM:SS.mmm

    const isAddr = (a?: string) => {
      const s = toAddr(a);
      return !!(s && s.startsWith('0x') && s.length === 42 && s !== ZERO);
    };

    // ---- Helpers de pick + logs ------------------------------------------------
    const pickSpenderFromRoute = (route: any, tx?: { to?: string }, manual?: string) => {
      const cands = [
        route?.allowanceTarget,
        route?.transactionRequest?.to ?? route?.transactionTo,
        route?.target,
        tx?.to,
        manual
      ].map(toAddr);

      log(`${now()} [pickSpender] candidates=` +
        cands.map((c, i) => `c${i + 1}=${c || '(empty)'}`).join(' | '));

      const picked = cands.find(isAddr) || '';
      log(`${now()} [pickSpender] picked=${picked || '(none)'}`);
      return picked;
    };

    const pickSellTokenAddress = (route: any, quote: any, ui?: { sellToken?: { address?: string } }): string => {
      const cands = [
        // standards intégrateurs
        route?.sellTokenAddress,
        route?.inTokenAddress,
        route?.sellToken?.address,
        route?.tokenIn?.address,
        route?.inToken?.address,

        // variantes Li.Fi / Bridge (fromToken côté bridge)
        route?.fromTokenAddress,
        route?.fromToken?.address,
        route?.action?.fromToken?.address,
        route?.steps?.[0]?.action?.fromToken?.address,
        route?.steps?.[0]?.fromToken?.address,
        quote?.fromTokenAddress,
        quote?.fromToken?.address,
        quote?.action?.fromToken?.address,
        quote?.steps?.[0]?.action?.fromToken?.address,
        quote?.steps?.[0]?.fromToken?.address,

        // fallback route.value/rawJson éventuel
        route?.value?.fromTokenAddress,
        route?.value?.fromToken?.address,
        route?.value?.action?.fromToken?.address,
        quote?.value?.fromTokenAddress,
        quote?.value?.fromToken?.address,
        quote?.value?.action?.fromToken?.address,

        // variantes côté quote “classiques”
        quote?.sellTokenAddress,
        quote?.inTokenAddress,
        quote?.sellToken?.address,
        quote?.tokenIn?.address,
        quote?.inToken?.address,

        // fallback UI local
        ui?.sellToken?.address,
        this.sellTokenAddress
      ].map(toAddr);

      log(`${now()} [pickToken] cands=${cands.join(' | ')}`);
      return cands.find(isAddr) || '';
    };

    // Approve "fire-and-return" (aucun await) + fallback zero-reset + logs verbeux
    const safeApprove = async (erc20: any, spender: string, needed: bigint) => {
      try {
        log(`${now()} [approve] fire-and-return BEGIN | spender=${spender} amount=${needed}`);
        const p = erc20.approve(spender, needed);
        p.then((tx: any) => {
          log(`${now()} [approve] sent | hash=${tx?.hash ?? '(no-hash)'}`);
          if (tx?.hash) { this.cfOnHash?.('apprv'); }   // ← annule le timeout local
        })
          .catch((e: any) => {
            const code = e?.code ?? e?.error?.code;
            const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
            const userRejected =
              code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
              /action_rejected/.test(String(code).toLowerCase()) ||
              /denied|rejected|user denied|user rejected/.test(msg);
            if (userRejected) { this.cfCancel?.('user_rejected', 'apprv'); } // ← cancel immédiat
            log(`${now()} [approve] send error | ${e?.message || e}`);
          });
        return;
      } catch (e1: any) {
        log(`${now()} [approve] direct failed → zero-reset then re-approve | errCode=${e1?.code} reason=${e1?.reason || ''} msg=${e1?.message || e1}`);
        try {
          const p0 = erc20.approve(spender, 0n);
          p0.then((tx: any) => {
            log(`${now()} [approve] zero-approve sent | hash=${tx?.hash ?? '(no-hash)'}`);
            if (tx?.hash) { this.cfOnHash?.('apprv'); }
          })
            .catch((e: any) => {
              const code = e?.code ?? e?.error?.code;
              const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
              const userRejected =
                code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
                /action_rejected/.test(String(code).toLowerCase()) ||
                /denied|rejected|user denied|user rejected/.test(msg);
              if (userRejected) { this.cfCancel?.('user_rejected', 'apprv'); }
              log(`${now()} [approve] zero-approve error | ${e?.message || e}`);
            });
          const p1 = erc20.approve(spender, needed);
          p1.then((tx: any) => {
            log(`${now()} [approve] re-approve sent | hash=${tx?.hash ?? '(no-hash)'}`);
            if (tx?.hash) { this.cfOnHash?.('apprv'); }
          })
            .catch((e: any) => {
              const code = e?.code ?? e?.error?.code;
              const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
              const userRejected =
                code === 4001 || code === 5000 || code === 'ACTION_REJECTED' ||
                /action_rejected/.test(String(code).toLowerCase()) ||
                /denied|rejected|user denied|user rejected/.test(msg);
              if (userRejected) { this.cfCancel?.('user_rejected', 'apprv'); }
              log(`${now()} [approve] re-approve error | ${e?.message || e}`);
            });
          return;
        } catch (e2: any) {
          log(`${now()} [approve] fallback failed | errCode=${e2?.code} reason=${e2?.reason || ''} msg=${e2?.message || e2}`);
          throw e1;
        }
      }
    };

    try {
      const signer = await this.provider.getSigner();
      const owner = toAddr(await signer.getAddress());
      const chainId = Number((await this.provider.getNetwork()).chainId);
      const routeObj: any = this.selectedAlternative ?? this.quote ?? {};
      const v: any = routeObj;
      const tx = this.getTxFromQuote?.(this.quote) ?? this.quote?.transactionRequest ?? null;

      log(`${now()} [ctx] chainId=${chainId} owner=${owner}`);
      log(`${now()} [ctx] tx.to=${toAddr(tx?.to)} tx.value=${tx?.value ?? '0'}`);

      const dbg = {
        sellTokenAddress: toAddr(v?.sellTokenAddress),
        inTokenAddress: toAddr(v?.inTokenAddress),
        sellToken_addr: toAddr(v?.sellToken?.address),
        tokenIn_addr: toAddr(v?.tokenIn?.address),
        inToken_addr: toAddr(v?.inToken?.address),
        quote_sellToken: toAddr(this?.quote?.sellToken?.address),
      };
      log(`${now()} [debugKeys] ${JSON.stringify(dbg)}`);

      // 1) Token (robuste, version bridge + Li.Fi)
      const token = pickSellTokenAddress(v, this.quote, { sellToken: { address: this.sellTokenAddress } });
      log(`${now()} [derive] tokenPicked=${token || '(empty)'}`);

      // 2) Spender — multi-sources + coercition param
      let manualSpender: any = spenderParam;
      if (manualSpender && typeof manualSpender !== 'string') {
        log(`${now()} warn: spenderParam is not string → typeof=${typeof manualSpender}`);
        try {
          manualSpender = (manualSpender as any)?.to ?? (manualSpender as any)?.allowanceTarget ?? '';
        } catch { manualSpender = ''; }
        log(`${now()} coerced spenderParam → ${toAddr(manualSpender) || '(empty)'}`);
      }
      const spender = pickSpenderFromRoute(v, { to: tx?.to }, manualSpender);

      // 3) Détection "natif"
      let isNativeSell = false;
      let nativeReason = '';
      try {
        isNativeSell = BigInt(tx?.value ?? '0') > 0n;
        if (isNativeSell) nativeReason = 'value>0';
      } catch { /* no-op */ }
      if (!isNativeSell && token && token.length === 42) {
        const nativeByMap = this.isNativeToken?.(token, chainId);
        if (nativeByMap) { isNativeSell = true; nativeReason = 'known-native-address'; }
      }
      log(`${now()} [native] isNativeSell=${isNativeSell} reason=${nativeReason || 'n/a'} token=${token}`);

      if (isNativeSell) {
        log(`${now()} skip: native token (no approve)`);
        return;
      }

      // 4) Validations strictes
      if (!isAddr(spender)) {
        log(`${now()} abort: invalid spender | spender=${spender || '(empty)'} len=${(spender || '').length}`);
        return;
      }
      if (!isAddr(token)) {
        log(`${now()} abort: invalid token | token=${token || '(empty)'} len=${(token || '').length}`);
        return;
      }

      // 5) Montant "needed" — version bridge (multi-sources Li.Fi + quote)
      const rootSell =
        (this as any)?.quote?.sellAmount ??
        (this as any)?.quote?.SellAmount ??
        (this as any)?.quote?.inputAmountRaw ??
        (this as any)?.quote?.fromAmount ??
        (this as any)?.quote?.value?.takerTokenAmount ??
        (this as any)?.quote?.value?.fromAmount ??
        (this as any)?.quote?.steps?.[0]?.estimate?.approvalAmount ??
        null;

      let needed = 0n;
      try {
        const s = String(rootSell ?? '').trim();
        needed = !s ? 0n : (s.startsWith('0x') || s.startsWith('0X')) ? BigInt(s) : BigInt(s);
      } catch { needed = 0n; }
      log(`${now()} [need] key=root.sellAmount value=${needed}`);

      if (needed <= 0n) {
        log(`${now()} skip: needed=0`);
        return;
      }

      // 6) Lecture allowance & décision
      const erc20 = new Contract(
        token,
        [
          'function allowance(address,address) view returns(uint256)',
          'function approve(address,uint256) returns(bool)'
        ],
        signer
      );

      const current: bigint = await erc20['allowance'](owner, spender);
      log(`${now()} [check] owner=${owner} spender=${spender} token=${token} allowance=${current} needed=${needed}`);

      if (current >= needed) {
        log(`${now()} ok: allowance suffisante → no approve`);
        return;
      }

      // 7) Approve — deeplink géré UNIQUEMENT ici (pas dans l'UI)
      const approveRunId = this._runSeq;

      // 🔐 Si on a déjà armé le deeplink pour ce runId, on ne le refait pas
      if (this._approveDeeplinkRunId === approveRunId) {
        log(`${now()} [gate] runId=${approveRunId} déjà armé → skip preDeeplinkAnnounce(approve-cta)`);
      } else {
        this._approveDeeplinkRunId = approveRunId;
        log(`${now()} [gate] runId=${approveRunId} → preDeeplinkAnnounce(approve-cta) (OWNER=ensureAllowanceForRoute)`);

        try {
          // phase interne "apprv" + runId, comme sur swap
          this.cfPreDeeplink?.('apprv', approveRunId);

          const until = Date.now() + 45_000;
          try {
            sessionStorage.setItem('st/allowWcDeeplinkUntil', String(until));
            sessionStorage.setItem('st/allowWcRunId', String(approveRunId));
            const nowTs = Date.now();
            log(`${now()} [deeplink][gate] allow set | until=${until} (deltaMs=${until - nowTs}) runId=${approveRunId}`);
          } catch {
            /* storage not available */
          }

          // Compat éventuelle (même helper que swap)
          // no auto-deeplink: skip __allowWcDeeplinkFor
          this.addLog?.('[deeplink][gate] SKIP __allowWcDeeplinkFor (no auto-deeplink)');
        } catch {
          // annonce optionnelle
          log(`${now()} [gate] preDeeplinkAnnounce(approve-cta) a échoué (ignore)`);
        }
      }

      // Envoi "fire-and-return" (pas d'await → gate + timeout gèrent la feuille)
      safeApprove(erc20, spender, needed);

      // ✅ Grace post-approve (comme swap) + reset du owner
      setTimeout(() => {
        try {
          sessionStorage.removeItem('st/allowWcRunId');
          sessionStorage.removeItem('st/allowWcDeeplinkUntil');
          this._approveDeeplinkRunId = null;
          log(`${now()} [deeplink][gate] cleared (post-approve grace + reset owner)`);
        } catch {
          /* no-op */
        }
      }, 8000);

    } catch (e: any) {
      const code = e?.code ?? e?.error?.code;
      const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase();
      const userRejected =
        code === 4001 ||                           // EIP-1193
        code === 5000 ||                           // MetaMask Mobile
        code === 'ACTION_REJECTED' ||
        /action_rejected/.test(String(code).toLowerCase()) ||
        /denied|rejected|user denied|user rejected/.test(msg);

      log(`${now()} error: code=${code} reason=${e?.reason || ''} msg=${e?.message || e}`);

      try {
        sessionStorage.removeItem('st/allowWcRunId');
        sessionStorage.removeItem('st/allowWcDeeplinkUntil');
        log(`${now()} [gate] reset allow-runId (approve error)`);
      } catch { /* no-op */ }

      if (userRejected) {
        this.cfCancel?.('user_rejected', 'apprv');
        log(`${now()} note: user rejected approval`);
      }
      throw e;
    }
  }














  /**
   * Envoie immédiatement la TX de swap après l'approve (mobile/desktop).
   * - Récupère la tx depuis route/quote/selectedAlternative (transactionRequest ou {to,data,value})
   * - Sanitize la tx pour laisser le wallet estimer les frais
   * - Préflight SIM (anti route périmée), ouverture automatique du wallet, puis race wait⟂poll sur le receipt
   */
  private async autoSendSwapAfterApprove(route: any, parentRunId: string): Promise<void> {
    const runId = `${parentRunId}/swap-1`;
    this.addLog(`🟣 [auto-swap][${runId}] start | status=${this.bridgeStatus}`);

    // empêcher fermetures/TTL pendant le flow (mobile-safe)
    try { (this as any)._inWalletFlow = true; } catch { }
    try { (this as any)._pauseQuoteTtl = true; } catch { }

    let sigTicker: any = null;

    try {
      // 1) Source TX (ordre de priorité robuste)
      const q: any = (this as any).selectedAlternative ?? (this as any).quote ?? route ?? null;
      const rawTx: any =
        q?.transactionRequest ??
        (q?.to && q?.data ? { to: q.to, data: q.data, value: q?.value } : null) ??
        ((this as any).quote?.transactionRequest ??
          (((this as any).quote?.to && (this as any).quote?.data)
            ? { to: (this as any).quote.to, data: (this as any).quote.data, value: (this as any).quote?.value }
            : null));

      if (!rawTx?.to || !rawTx?.data) {
        this.addLog(`❌ [auto-swap][${runId}] no tx found on quote/route → abort`);
        return;
      }

      // 2) Nettoyage des champs de frais (laisser le wallet décider)
      const txReq: any = (this as any).sanitizeTxForWallet?.({
        from: (this as any).takerAddress ?? undefined,
        to: rawTx.to,
        data: rawTx.data,
        value: rawTx.value ?? '0x0',
        chainId: (rawTx.chainId ?? (this as any).chainId) as number | undefined,
      }) ?? {
        from: (this as any).takerAddress ?? undefined,
        to: rawTx.to,
        data: rawTx.data,
        value: rawTx.value ?? '0x0',
        chainId: (rawTx.chainId ?? (this as any).chainId) as number | undefined,
      };

      this.addLog(`📦 [auto-swap][${runId}] tx ready | to=${txReq.to} value=${String(txReq.value)} dataLen=${(txReq.data || '').length}`);

      // 2bis) PRE-FLIGHT SIM: éviter d’ouvrir une popup sur route périmée
      try {
        const preflight = (this as any).preflightSim;
        if (typeof preflight === 'function') {
          const ok = await preflight(txReq); // true/false
          if (!ok) throw new Error('SIM_FAIL');
        }
      } catch (e: any) {
        const m = (e?.message || '').toLowerCase();
        if (/return amount is not enough|insufficient output|minout/.test(m)) {
          this.addLog(`🔁 [auto-swap][${runId}] preflight=FAIL (minOut) → refresh quote`);
          try { const rq = (this as any).refreshQuote; if (typeof rq === 'function') await rq(); } catch { }
          // reconstruire la tx avec la quote fraîche
          const fresher: any = (this as any).selectedAlternative ?? (this as any).quote ?? route ?? null;
          const newRaw: any =
            fresher?.transactionRequest ??
            (fresher?.to && fresher?.data ? { to: fresher.to, data: fresher.data, value: fresher?.value } : null);

          if (!newRaw?.to || !newRaw?.data) {
            this.addLog(`❌ [auto-swap][${runId}] no fresh tx after refresh → abort`);
            (this as any).bridgeStatus = 'error';
            try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'error', title: 'Route périmée', description: 'Impossible d’exécuter ce swap. Nouvelle cotation requise.' }); } catch { }
            return;
          }

          const txReq2: any = (this as any).sanitizeTxForWallet?.({
            from: (this as any).takerAddress ?? undefined,
            to: newRaw.to,
            data: newRaw.data,
            value: newRaw.value ?? '0x0',
            chainId: (newRaw.chainId ?? (this as any).chainId) as number | undefined,
          }) ?? {
            from: (this as any).takerAddress ?? undefined,
            to: newRaw.to,
            data: newRaw.data,
            value: newRaw.value ?? '0x0',
            chainId: (newRaw.chainId ?? (this as any).chainId) as number | undefined,
          };

          Object.assign(txReq, txReq2);
          this.addLog(`📦 [auto-swap][${runId}] tx refreshed | to=${txReq.to} value=${String(txReq.value)} dataLen=${(txReq.data || '').length}`);
        } else {
          // autre échec déterministe → on n’ouvre pas le wallet
          this.addLog(`⛔ [auto-swap][${runId}] preflight SIM fail (non-minOut) → abort`);
          (this as any).bridgeStatus = 'error';
          try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'error', title: 'Simulation échouée', description: 'La transaction ne peut pas être exécutée dans l’état actuel.' }); } catch { }
          return;
        }
      }

      // 3) Prompt-lock (anti double ouverture mobile)
      const now = Date.now();
      if (now < (this as any)._txPromptLockUntil) {
        this.addLog(`⛔ [auto-swap][${runId}] prompt locked (until=${(this as any)._txPromptLockUntil})`);
        return;
      }
      (this as any)._txPromptLockUntil = now + 7000;
      try {
        (window as any).__allowWcDeeplinkFor?.(30_000);
        // au cas où un suppress est actif, on lève le blocage
        sessionStorage.setItem('st/suppressWcUriUntil', String(Date.now() - 1));
      } catch { }

      // 4) Envoi via signer (ouvre MM/WC automatiquement)
      const signer = await (this as any).provider!.getSigner();
      (this as any).bridgeStatus = 'pending';
      this.addLog(`🟠 [auto-swap][${runId}] awaiting wallet signature …`);

      // Watchdog signature: logs toutes 10s tant que la Promise n'a pas résolu
      try { sigTicker = setInterval(() => this.addLog(`⌛ [auto-swap][${runId}] still waiting user signature…`), 10_000); } catch { }

      const txResp = await signer.sendTransaction({
        to: txReq.to,
        data: txReq.data,
        value: typeof txReq.value === 'string' ? (txReq.value as any) : (txReq.value ?? 0n),
      });

      if (sigTicker) { try { clearInterval(sigTicker); } catch { } sigTicker = null; }

      (this as any).swapHash = txResp.hash;
      try { sessionStorage.setItem('st/swapHash', txResp.hash); } catch { }
      this.addLog(`🟢 [auto-swap][${runId}] user signed | tx=${txResp.hash}`);

      // 5) Réaction UX fiable via race (receipt ⟂ polling receipt)
      const provider = this.provider as any;

      const waitReceipt = (async () => {
        const rcpt = await txResp.wait(1); // peut être long en WC mobile
        return { ok: true as const, kind: 'wait' as const, rcpt };
      })();

      const pollReceipt = async () => {
        const start = Date.now();
        while (Date.now() - start < 120_000) { // 120s max
          try {
            const rcpt = await provider.getTransactionReceipt(txResp.hash);
            if (rcpt) return { ok: true as const, kind: 'poll' as const, rcpt };
          } catch { /* one-shot */ }
          this.addLog(`⏳ [auto-swap][${runId}] waiting receipt… (poll)`);
          await new Promise(r => setTimeout(r, 2000));
        }
        return { ok: false as const, kind: 'timeout' as const };
      };

      const first = await Promise.race([waitReceipt, pollReceipt()]);

      if ((first as any)?.ok) {
        const rcpt = (first as any).rcpt;
        const ok = rcpt?.status === 1 || rcpt?.status === '0x1';
        this.addLog(`✅ [auto-swap][${runId}] confirmed via ${(first as any).kind} | status=${rcpt?.status} block=${rcpt?.blockNumber}`);

        if (ok) {
          (this as any).bridgeStatus = 'success';
          (this as any).bridgeError = null;
          try { const fn = (this as any).refreshBalances; if (typeof fn === 'function') await fn.call(this); } catch { }
          try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'success', title: 'Swap confirmé', description: `Tx ${txResp.hash.slice(0, 10)}…` }); } catch { }
          this.addLog(`🎉 [auto-swap][${runId}] done`);
        } else {
          // Revert on-chain: re-quote & garder l’UX utilisable
          this.addLog(`❌ [auto-swap][${runId}] reverted (likely minOut) → refresh & keep UI ready`);
          try { const rq = (this as any).refreshQuote; if (typeof rq === 'function') await rq(); } catch { }
          (this as any).bridgeStatus = 'idle'; // réactive le bouton sur la nouvelle quote
          try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'error', title: 'Route périmée', description: 'Prix mis à jour. Vous pouvez réessayer.' }); } catch { }
        }
      } else {
        // ni wait() ni poll n’ont fini dans la fenêtre → feedback UX explicite
        (this as any).bridgeStatus = 'idle';
        try { const toast = (this as any).addToast; if (typeof toast === 'function') toast({ kind: 'warning', title: 'Confirmation retardée', description: 'On continue à surveiller. Ré-ouvrez l’app si besoin.' }); } catch { }
        this.addLog(`⏱️ [auto-swap][${runId}] timeout waiting for receipt`);
      }

    } catch (e: any) {
      if (sigTicker) { try { clearInterval(sigTicker); } catch { } sigTicker = null; }

      const code = e?.code ?? e?.error?.code;
      const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() ?? '';
      const userRejected =
        code === 4001 || code === 5000 ||
        String(code).toUpperCase() === 'ACTION_REJECTED' ||
        /denied|rejected|user denied|user rejected|action_rejected/.test(msg);

      this.addLog(`❌ [auto-swap][${runId}] failed | code=${String(code)} msg="${msg.slice(0, 120)}" rejected=${userRejected}`);

      if (userRejected) {
        (this as any).bridgeStatus = 'idle';
        (this as any).bridgeError = 'USER_REJECTED';
        return;
      }
      (this as any).bridgeStatus = 'error';
      (this as any).bridgeError = e?.message || 'AUTO_SWAP_FAILED';

    } finally {
      // cleanup guards + hash persistant
      (this as any)._txPromptLockUntil = 0;
      try { (this as any)._pauseQuoteTtl = false; } catch { }
      try { (this as any)._inWalletFlow = false; } catch { }
      try { if (!(this as any).swapHash) sessionStorage.removeItem('st/swapHash'); } catch { }
      this.addLog(`↩️ [auto-swap][${runId}] end | status=${(this as any).bridgeStatus}`);
    }
  }


  /**
* Soft reload avant un NOUVEAU run utilisateur.
* Objectif :
*  - lever un cooldown global résiduel (st/suppressWcUriUntil)
*  - nettoyer les flags deeplink "fantômes"
*  - sans toucher au provider, wallet, balances, etc.
*/
  /**
 * Soft reload avant un NOUVEAU run utilisateur.
 * Objectif :
 *  - lever un cooldown global résiduel (st/suppressWcUriUntil)
 *  - nettoyer les flags deeplink "fantômes" + timers du run précédent
 *  - sans toucher au provider, wallet, balances, etc.
 */
  // deviens async
  /**
 * Soft reload avant un NOUVEAU run utilisateur.
 * Objectif :
 *  - lever un cooldown global résiduel (st/suppressWcUriUntil)
 *  - nettoyer les flags deeplink "fantômes" + timers du run précédent
 *  - sans toucher au provider, wallet, balances, etc.
 */
  // ctx = 'main' pour le CTA principal, 'alt' pour une alternative
  private async softReloadBeforeRunIfNeeded(ctx: 'main' | 'alt'): Promise<void> {
    try {
      // 🔁 Toujours repartir avec un bridgeStatus propre pour le nouveau run
      if (this.bridgeStatus !== 'idle') {
        this.addLog?.(
          `[softReload] reset bridgeStatus → idle (was=${this.bridgeStatus})`
        );
        this.bridgeStatus = 'idle';
        this.bridgeError = null;
      }

      const now = Date.now();

      // Compteur "softReload" pour savoir si on est au 1er / 2e / 3e run
      const softSeq = ((this as any)._softReloadSeq ?? 0) + 1;
      (this as any)._softReloadSeq = softSeq;

      // ───────────────────────────────────────────────
      // 1) Lire les flags deeplink / cooldown
      // ───────────────────────────────────────────────
      const sup = Number(sessionStorage.getItem('st/suppressWcUriUntil') || '0') || 0;
      const allow = Number(sessionStorage.getItem('st/allowWcDeeplinkUntil') || '0') || 0;
      const allowRunId = Number(sessionStorage.getItem('st/allowWcRunId') || '0') || 0;

      const left = sup > now ? sup - now : 0;
      const allowLeft = allow > now ? allow - now : 0;

      const hasCooldownActive = left > 0 || allowLeft > 0;

      // ───────────────────────────────────────────────
      // 2) État runtime réel (ce qui compte vraiment)
      // ───────────────────────────────────────────────
      const hasProvider = !!this.provider;
      const hasTaker = !!this.takerAddress;
      const hasQuoteOrAlt = !!this.quote || !!this.selectedAlternative;

      const stateClean = hasProvider && hasTaker && hasQuoteOrAlt;

      // ───────────────────────────────────────────────
      // 3) Historique de run (info)
      // ───────────────────────────────────────────────
      const seq = (this as any)._runSeq || 0;
      const cfRunId = (this as any).cancelFlowV1?.runId || 0;
      const prevRunFlag = allowRunId > 0 || seq > 0 || cfRunId > 0;

      // Vraie preuve qu'on a déjà envoyé un deeplink une fois
      const realDeeplinkSent = !!(this as any).__dlLast;

      // ───────────────────────────────────────────────
      // 4) Déterminer la chaîne attendue pour ce swap
      // ───────────────────────────────────────────────
      let expectedChainId: number | undefined;
      try {
        const q: any = this.quote;
        expectedChainId =
          (q?.fromChainId as number | undefined) ??
          (q?.chainId as number | undefined) ??
          ((this as any).chainId as number | undefined);
      } catch {
        expectedChainId = undefined;
      }

      this.addLog?.(
        `[softReload][matrix] ctx=${ctx} softSeq=${softSeq} ` +
        `clean=${stateClean} cooldownActive=${hasCooldownActive} ` +
        `prevRunFlag=${prevRunFlag} realDeeplinkSent=${realDeeplinkSent} ` +
        `expectedChainId=${expectedChainId ?? '(none)'}`
      );

      // ───────────────────────────────────────────────
      // CASE B — Pas clean (provider cassé / pas de taker / etc.)
      // 👉 Problème réel → detach obligatoire
      // ───────────────────────────────────────────────
      if (!stateClean) {
        this.addLog?.(
          `[softReload] DETACH (state NOT clean: provider=${hasProvider} taker=${hasTaker} quoteOrAlt=${hasQuoteOrAlt})`
        );
        this._runDetachSequence();
        return;
      }

      // À partir d'ici : stateClean = true

      // ───────────────────────────────────────────────
      // CASE HARD — 2ᵉ run ou plus
      // 👉 Hard reset complet de la session wallet avant nouveau run
      //    + on transmet expectedChainId pour forcer la bonne chaîne
      // ───────────────────────────────────────────────
      if (softSeq >= 2) {
        this.addLog?.(
          `[softReload][HARD] softSeq=${softSeq} (>=2) → hard reset wallet session before new run (expectedChainId=${expectedChainId ?? '(none)'})`
        );
        await this.hardResetWalletSessionForNewRun(ctx, softSeq, expectedChainId);
        return;
      }

      // Ici on est forcément sur le 1er run (softSeq === 1)

      // CASE C — VRAI ancien run + cooldown encore actif
      // 👉 on fait un hard-soft detach pour éviter popup fantôme
      // ⚠️ important: on ne déclenche PAS ça sur le tout 1er run
      //    (connexion AppKit a déjà envoyé un deeplink, mais il
      //     n'y a pas encore eu de run d'exec/pipeline)
      // ───────────────────────────────────────────────
      if (prevRunFlag && realDeeplinkSent && hasCooldownActive) {
        this.addLog?.(
          `[softReload] DETACH (prevRunFlag=true + real previous deeplink + cooldown active → avoid phantom popup)`
        );
        /*   this._runDetachSequence();*/
        return;
      }
      // ───────────────────────────────────────────────
      // CASE A / D — État clean et pas de raison de detach
      // 👉 Pas de detach. On nettoie les flags deeplink…
      //    …et on force la chain si besoin.
      // ───────────────────────────────────────────────
      this.addLog?.(
        `[softReload] SKIP detach (clean state, provider intact)`
      );


      // Reset léger (deeplink / timers / cancelFlow)
      // 🧹 Côté BRIDGE : on repart comme un F5 pour le gate WC
      try {
        sessionStorage.setItem('st/allowWcRunId', '0');
        sessionStorage.setItem('st/allowWcDeeplinkUntil', '0');
        this.addLog?.(
          '[softReload][bridge] reset WC gate flags (allowRunId/allowUntil → 0)'
        );
      } catch { /* no-op */ }

      this._resetDeeplinkFlags();

      // 🟣 Forcer la chain à partir du 2ᵉ run (si on a une expectedChainId)
      // (ici softSeq === 1, mais on garde la signature homogène)
      await this._forceChainForRunIfNeeded(ctx, softSeq, expectedChainId);

    } catch (err: any) {
      this.addLog?.('[softReload] EXC ' + (err?.message || err));
    }
  }





  // 🔥 HARD RESET "F5-like" :
  // - détruit le provider / signer / taker côté front
  // - reset deeplink & timers
  // - relance restoreSession pour se rebrancher sur la session WC existante
  // 🔥 HARD RESET "F5-like" :
  // - détruit le provider / signer / taker côté front
  // - reset deeplink & timers
  // - reset GATE WC (sup/allow/runId)
  // - reset compteurs de run (_runSeq / _softReloadSeq)
  // - relance restoreSession pour se rebrancher sur la session WC existante
  private async hardResetWalletSessionForNewRun(
    ctx: 'main' | 'alt',
    softSeq: number,
    expectedChainId?: number
  ): Promise<void> {
    this.addLog?.(
      `[softReload][HARD] ENTER ctx=${ctx} softSeq=${softSeq}`
    );

    try {
      // ─────────────────────────────────────────────
      // 1) Teardown AppKit / modal (comme en ngOnInit)
      // ─────────────────────────────────────────────
      const teardownAppKit = () => {
        try {
          const w: any = window as any;

          w?.appkit?.destroy?.();
          w?.appKit?.destroy?.();
          w?.modal?.destroy?.();

          try {
            w?.appkit?.getProvider?.()?.disconnect?.();
          } catch { /* no-op */ }
        } catch {
          // no-op, jamais faire planter le hard reset
        }
      };

      this.addLog?.('[softReload][HARD] teardownAppKit…');
      teardownAppKit();
      this.addLog?.('[softReload][HARD] teardownAppKit done');

      // ⚠️ IMPORTANT :
      // On NE tue PAS WalletConnect v2 ici.
      // => PAS de killWalletConnectV2()
      // => la session WC reste vivante côté mobile + storage

      // ─────────────────────────────────────────────
      // 2) Reset de l’état local du composant
      //    (provider / signer / taker + deeplink)
      // ─────────────────────────────────────────────
      try {
        // On détruit le provider JS comme après un F5
        (this as any).provider = null;
        (this as any).signer = null;
        this.takerAddress = null;

        // Flags deeplink internes
        try {
          (this as any).__dlLast = null;
          (this as any).__dlOpenedForRun = null;
        } catch { /* no-op */ }

        try {
          if ((this as any)._deeplinkReopenTimer) {
            clearTimeout((this as any)._deeplinkReopenTimer);
          }
          (this as any)._deeplinkReopenTimer = null;
        } catch { /* no-op */ }

        // Cancel flow V1 si présent
        try {
          (this as any).cancelFlowV1 = null;
        } catch { /* no-op */ }

        // 🧹 NEW — reset complet du GATE WC côté storage
        try {
          sessionStorage.setItem('st/suppressWcUriUntil', '0');
          sessionStorage.setItem('st/allowWcDeeplinkUntil', '0');
          sessionStorage.setItem('st/allowWcRunId', '0');
          this.addLog?.(
            '[softReload][HARD][bridge] reset WC gate flags (sup/allow/runId → 0)'
          );
        } catch { /* no-op */ }

        // 🧮 NEW — reset des compteurs de run côté BRIDGE
        try {
          (this as any)._runSeq = 0;
          (this as any)._softReloadSeq = 0;
          this.addLog?.(
            '[softReload][HARD][bridge] reset _runSeq/_softReloadSeq → 0'
          );
        } catch { /* no-op */ }

        // Reset léger des flags liés au deeplink côté composant
        try {
          this._resetDeeplinkFlags?.();
          this.addLog?.('[softReload] deeplink/timers reset');
        } catch { /* no-op */ }

        this.addLog?.('[softReload][HARD] local component state reset done');
      } catch {
        // on ne veut pas bloquer le reste
      }

      // ─────────────────────────────────────────────
      // 3) Relancer la même logique de "restoreSession"
      //    que celle utilisée au boot (ngOnInit)
      //    → subscribeEvmChanges + restoreSessionDocStyle + restoreSessionIfAny
      // ─────────────────────────────────────────────
      try {
        const anyThis: any = this;

        this.addLog?.(
          '[softReload][HARD] RESTORE (ngOnInit-style) subscribeEvmChanges + restoreSessionDocStyle + restoreSessionIfAny'
        );

        // 3.1) Rebrancher les listeners EVM (comme en ngOnInit)
        if (typeof anyThis.subscribeEvmChanges === 'function') {
          try {
            this.addLog?.('[softReload][HARD] calling this.subscribeEvmChanges()');
            anyThis.subscribeEvmChanges();
          } catch (e: any) {
            this.addLog?.(
              '[softReload][HARD] subscribeEvmChanges EXC ' + (e?.message || e)
            );
          }
        }

        // 3.2) Doc-style restore (modal.getAddress / getWalletProvider)
        if (typeof anyThis.restoreSessionDocStyle === 'function') {
          this.addLog?.('[softReload][HARD] calling this.restoreSessionDocStyle()');
          await anyThis.restoreSessionDocStyle();
        }

        // 3.3) Grosse machine de rehydrate WC / EIP-1193
        if (typeof anyThis.restoreSessionIfAny === 'function') {
          this.addLog?.('[softReload][HARD] calling this.restoreSessionIfAny()');
          await anyThis.restoreSessionIfAny();
        } else {
          this.addLog?.(
            '[softReload][HARD] no restoreSessionIfAny on component (skipped)'
          );
        }
      } catch (err: any) {
        this.addLog?.(
          `[softReload][HARD] restore logic EXC ${err?.message || err}`
        );
      }

      // ─────────────────────────────────────────────
      // 4) Forcer la chaîne si on connaît la fromChainId de la route
      //    (ex: 2ᵉ run Bridge après cancel → on revient sur 137 au lieu de 1)
      // ─────────────────────────────────────────────
      try {
        await this._forceChainForRunIfNeeded(ctx, softSeq, expectedChainId);
      } catch (e: any) {
        this.addLog?.(
          `[softReload][HARD] _forceChainForRunIfNeeded EXC ${e?.message || e}`
        );
      }

      this.addLog?.('[softReload][HARD] completed successfully');
    } catch (err: any) {
      this.addLog?.(
        '[softReload][HARD] EXC ' + (err?.message || err)
      );
    } finally {
      this.addLog?.('[softReload][HARD] EXIT');
    }
  }






  private async _forceChainForRunIfNeeded(
    ctx: 'main' | 'alt',
    softSeq: number,
    expectedChainId?: number
  ): Promise<void> {
    try {
      // 1) On ne force JAMAIS au premier run
      if (softSeq < 2) {
        this.addLog?.(
          `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → skip (first run)`
        );
        return;
      }

      // 2) Sans chain attendue ou sans provider → on ne fait rien
      if (!expectedChainId || !this.provider) {
        this.addLog?.(
          `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → skip (missing expectedChainId or provider)`
        );
        return;
      }

      const reason = `softReload:${ctx}:run#${softSeq}`;

      this.addLog?.(
        `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → switchWalletNetworkSilent(${expectedChainId}) reason=${reason}`
      );

      await this.switchWalletNetworkSilent(expectedChainId, reason);

    } catch (err: any) {
      this.addLog?.(
        `[NETWORK][FORCE] ctx=${ctx} softSeq=${softSeq} → EXC wrapper: ${err?.message ?? err}`
      );
    }
  }

  /**
* Switch réseau côté wallet de façon SILENCIEUSE,
* en réutilisant la logique robuste de changeChain :
* - appelle wallet_switchEthereumChain
* - puis softReloadAfterNetworkSwitch pour resynchroniser provider / chain / address
* - ne touche PAS à l'UI (pas de closeQuote, pas d'applyChainUi, pas d'alert)
*/
  private async switchWalletNetworkSilent(targetChainId: number, reason: string): Promise<void> {
    const hexChainId = '0x' + targetChainId.toString(16);

    try {
      const raw: any = this.rawProvider || this.provider;

      if (!raw || typeof raw.request !== 'function') {
        this.addLog?.(
          `[NETWORK][SILENT] skip switch (no rawProvider.request) reason=${reason} target=${targetChainId}`
        );
        return;
      }

      this.addLog?.(
        `[NETWORK][SILENT] wallet_switchEthereumChain → ${targetChainId} (${hexChainId}) reason=${reason}`
      );

      await raw.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: hexChainId }]
      });

      this.addLog?.(
        `[NETWORK][SILENT] switchEthereumChain OK → softReloadAfterNetworkSwitch(${reason})`
      );

      // On réutilise ta mécanique déjà testée pour resync provider/chain/address
      await this.softReloadAfterNetworkSwitch(reason);

    } catch (e: any) {
      this.addLog?.(
        `[NETWORK][SILENT] switchEthereumChain EXC (${reason}) → ${e?.message ?? e}`
      );
      // ⚠️ ici pas d'alert / pas d'UI agressive : on log seulement
    }
  }
  private _resetDeeplinkFlags(): void {
    try { this.clearAllowWcDeeplink?.(); } catch { }
    try {
      sessionStorage.removeItem('st/allowWcDeeplinkUntil');
      sessionStorage.removeItem('st/allowWcRunId');
      sessionStorage.removeItem('st/skipWcDeeplinkOnce');
    } catch { }
    try {
      (this as any).__dlLock = false;
      (this as any).__dlLast = null;
      (this as any).__dlOpenedForRun = null;
    } catch { }
    try {
      const t = (this as any)._deeplinkReopenTimer;
      if (t) { clearTimeout(t); }
      (this as any)._deeplinkReopenTimer = null;
    } catch { }
    try {
      const cf: any = (this as any).cancelFlowV1;
      if (cf?.timers) {
        cf.timers.forEach((t: any) => { try { clearTimeout(t); } catch { } });
        cf.timers.clear?.();
        if (cf.hasHash) { cf.hasHash.apprv = false; cf.hasHash.trx = false; }
        cf.runId = 0; cf.phase = undefined; cf.lastPhase = undefined;
      }
    } catch { }
    this.addLog?.('[softReload] deeplink/timers reset');
  }

  private _runDetachSequence(): void {
    try {
      const had = !!this.provider || !!this.rawProvider;
      if (!had) {
        this.addLog?.('[softReload] detach skipped (no provider at all)');
        this._resetDeeplinkFlags();
        return;
      }
      this.addLog?.('[softReload] HARD-SOFT DETACH triggered');
      try { (this as any).provider = null; (this as any).rawProvider = null; } catch { }
      this.__restoreInFlight = false;
      this._resetDeeplinkFlags();
      void this.softReloadWalletSession(0);
    } catch (err: any) {
      this.addLog?.('[softReload] DETACH EXC ' + (err?.message || err));
    }
  }


















  /* async executeSwap() {
    this.addLog('🔥 [START] executeSwap');
  
    if (!this.quote || !this.provider || !this.takerAddress) {
      this.addLog('❌ Params manquants: '
        + `quote=${!!this.quote}, provider=${!!this.provider}, taker=${this.takerAddress || 'null'}`);
      console.error('❌ Quote / provider / takerAddress missing');
      return;
    }
    return await this.executeSwapLifi();
  
  }*/



  private async executeWrapUnwrap() {
    if (!this.provider) {
      console.error('❌ Provider manquant');
      return;
    }

    const signer = await this.provider.getSigner();
    const amountWei = this.toAmountDecimals(this.sellAmount, this.quote.sellTokenSymbol);

    // Adresse WETH Mainnet
    const WETH_ADDRESS = '0xC02aaa39b223FE8D0A0e5C4F27eAD9083C756Cc2';
    const wethAbi = [
      "function deposit() payable",
      "function withdraw(uint256 wad)"
    ];
    const wethContract = new ethers.Contract(WETH_ADDRESS, wethAbi, signer);

    if (this.quote.sellTokenSymbol === 'ETH' && this.quote.buyTokenSymbol === 'WETH') {
      console.log(`🔄 Wrapping ${this.sellAmount} ETH → WETH`);
      const tx = await wethContract["deposit"]({ value: amountWei });
      console.log('📜 TX hash =', tx.hash);
      await tx.wait();
      console.log('✅ Wrap terminé');
    }

    if (this.quote.sellTokenSymbol === 'WETH' && this.quote.buyTokenSymbol === 'ETH') {
      console.log(`🔄 Unwrapping ${this.sellAmount} WETH → ETH`);
      const tx = await wethContract["withdraw"](amountWei);
      console.log('📜 TX hash =', tx.hash);
      await tx.wait();
      console.log('✅ Unwrap terminé');
    }
  }
  async onClickExecuteBridge() {
    await this.softReloadBeforeRunIfNeeded('main');
    // 0) Gardes minimales
    if (!this.quote) { this.addLog('[main] click ignored: no quote'); return; }
    if (!this.isConnected) {
      this.addLog('[main] click ignored: wallet not connected');
      this.swapDisabled = true;
      this.swapReasons = ['WALLET_DISCONNECTED'];
      return;
    }

    // 1) Clé de la MAIN + purge du contexte ALT (évite "alternative is executing")
    const mainKey = (this.getRouteKey?.(this.quote) || 'main').toString().toLowerCase();
    this.selectedAltKey = null;
    this.addLog('[ALT][VIS] selectedAlternative -> null (onClickExecuteBridge)');
    this.selectedAlternative = null;

    // 2) Verrou UI immédiat sur la MAIN
    this.validatingKey = mainKey;   // ✅ clé explicite de la main
    this.bridgeStatus = 'pending';
    this.bridgeHash = null;
    this.bridgeError = null;

    await this.cooldownAndResetWcSession('main');


    // 3) Pas d’ouverture immédiate → WC pur, on garde l’armement (allow) actif
    this.addLog('[main] no immediate deeplink (WC-style, allow kept)');

    // 4) Exécution asynchrone (simulate/approve/send) – états finaux gérés ailleurs
    setTimeout(() => this.executeBridge(), 120);
  }





  async executeSwapLifi(intentToken?: string): Promise<void> {
    // Helper local : détecter toutes les annulations utilisateur (MM mobile, EIP-1193, ethers v6)
    const isUserRejected = (e: any) => {
      const code = e?.code ?? e?.error?.code;
      const msg = (e?.message || e?.reason || e?.error?.message || '').toLowerCase?.() || '';
      return (
        code === 4001 ||                          // EIP-1193 standard
        code === 5000 ||
        code === -32000 ||   // MetaMask Mobile
        code === 'ACTION_REJECTED' ||             // ethers v6
        /action_rejected/.test(String(code).toLowerCase()) ||
        /denied|rejected|user denied|user rejected|cancel/.test(msg)
      );
    };

    // Log util minimal : extrait toutes les infos d’erreur courantes
    const extractErr = (e: any) => ({
      code: e?.code,
      message: e?.message,
      reason: e?.reason,
      // chemins fréquents sous WalletConnect/MetaMask
      error_code: e?.error?.code,
      error_message: e?.error?.message,
      info_error_code: e?.info?.error?.code,
      info_error_message: e?.info?.error?.message,
      data_original_code: e?.data?.originalError?.code,
      data_original_message: e?.data?.originalError?.message,
    });

    this.addLog('🌉 [LiFi] start');

    if (!this.provider) {
      this.addLog('❌ [LiFi] provider absent → invite à connecter');
      alert('Connecte ton wallet avant d’exécuter le swap.');
      return;
    }
    if (!this.quote?.transactionRequest) {
      this.addLog('⚠️ [LiFi] transactionRequest manquante dans la quote');
      alert('Pas de transaction prête à être exécutée.');
      return;
    }

    // === Helper snapshot (logs uniquement, aucune logique) ===
    const snapshot = (tag: string) => {
      this.addLog(
        `[UI] ${tag} | bridgeStatus=${this.bridgeStatus} | ` +
        `validatingKey=${String(this.validatingKey)} | ` +
        `selectedAltKey=${String(this.selectedAltKey)} | ` +
        `quoteHasTx=${!!this.quote?.transactionRequest} | ` +
        `visible=${(typeof document !== 'undefined' ? document.visibilityState : 'n/a')}`
      );
    };

    try {
      this.bridgeStatus = 'pending';
      this.bridgeError = null;
      this.bridgeHash = null;
      snapshot('enter-pending');

      const signer = await this.provider.getSigner();
      const address = await signer.getAddress();
      const { chainId } = await this.provider.getNetwork();
      this.addLog(`👛 [LiFi] signer=${address}, chainId=${Number(chainId)}`);

      const sellTokenAddr =
        this.quote.fromTokenAddress?.toLowerCase?.() ||
        this.quote.inTokenAddress?.toLowerCase?.() || '';
      this.addLog(`🔎 [LiFi] sellToken=${sellTokenAddr || '(n/a)'}`);
      if (!sellTokenAddr) throw new Error('Adresse du token source introuvable dans la quote.');

      // ─────────────────────────────────────────────────────────────
      // 1) APPROVE (si ERC20)
      // ─────────────────────────────────────────────────────────────
      if (sellTokenAddr !== ethers.ZeroAddress) {
        const spender = this.quote.allowanceTarget || this.quote.transactionRequest.to;
        const erc20 = new ethers.Contract(
          sellTokenAddr,
          [
            'function allowance(address owner, address spender) view returns (uint256)',
            'function approve(address spender, uint256 value) returns (bool)'
          ],
          signer
        );

        const allowance: bigint = await erc20['allowance'](address, spender);
        const amountRequired = BigInt(this.quote.inputAmountRaw || 0);
        this.addLog(`💳 [LiFi] allowance=${allowance.toString()} | required=${amountRequired.toString()} | spender=${spender}`);

        if (allowance < amountRequired) {
          this.addLog('🔑 [LiFi] Approve nécessaire → approve MaxUint256…');

          const resApprove = await this.gate.requestWithIntentEx(
            intentToken || this.gate.generateIntent('swap-erc20-approve', (m) => this.addLog(m)),
            async () => {
              (window as any).__allowWcDeeplinkFor?.(12_000);
              try {
                const approveTx = await erc20['approve'](spender, ethers.MaxUint256);
                this.addLog(`📤 [LiFi] Approve tx sent: ${approveTx.hash}`);
                const approveRcpt = await approveTx.wait();
                this.addLog(`✅ [LiFi] Approve confirmé: status=${approveRcpt?.status}`);
              } catch (e: any) {
                const info = extractErr(e);
                this.addLog(`[LiFi][approve] ❌ catch | code=${String(info.code)} / err.code=${String(info.error_code)} / info.err.code=${String(info.info_error_code)} / data.orig.code=${String(info.data_original_code)} | msg="${info.message || info.reason || info.error_message || info.info_error_message || info.data_original_message || ''}"`);
                if (isUserRejected(e)) {
                  throw { __userRejected: true, code: info.code ?? info.error_code, message: info.message, meta: info };
                }
                throw e;
              }
            },
            {
              ctx: 'swap:erc20-approve',
              log: (m) => this.addLog(m),
              preserveTokenOnSuccess: true,
              timeoutMs: 180_000,
            }
          );

          if (!resApprove.ok) {
            this.addLog(`[gate][approve] not ok | reason=${resApprove.reason} | err=${JSON.stringify((resApprove as any).error ?? {}, null, 2).slice(0, 1000)}`);

            const canceled =
              resApprove.reason === 'user-rejected' ||
              (resApprove as any).error?.__userRejected === true;

            if (canceled) {
              this.addLog('⛔ [LiFi] Approve annulée → reset doux + hard reload + cooldown deeplink');
              try { setWcSuppressOnce?.(8000); } catch { }
              try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }
              this.bridgeError = this.translate.instant('USER_CANCELLED');
              this.bridgeStatus = 'cancelled';
              //this.closeQuoteWithReason('cancel-approve');
              //await this.forceReconnectWalletSession('cancel-approve');
              return;
            }

            if (resApprove.reason === 'timeout') {
              this.addLog('⏱️ [LiFi] Approve timeout → STOP + cooldown deeplink');
              try { setWcSuppressOnce?.(8000); } catch { }
              try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }
              this.bridgeStatus = 'idle';
              this.bridgeError = this.translate.instant('WALLET_TIMEOUT');
              //this.closeQuoteWithReason('cancel-approve');
              //await this.forceReconnectWalletSession('cancel-approve');

              return;
            }

            this.addLog('⚠️ [LiFi] Approve erreur → STOP');
            this.bridgeStatus = 'error';
            this.bridgeError = this.translate.instant('UNEXPECTED_ERROR');
            return;
          }
        } else {
          this.addLog('✅ [LiFi] Approve suffisante → pas d’approve');
        }
      } else {
        this.addLog('⛽ [LiFi] Token natif → skip approve');
      }

      // ─────────────────────────────────────────────────────────────
      // 2) SEND SWAP TX
      // ─────────────────────────────────────────────────────────────
      const tr = this.quote.transactionRequest;
      const txRequestRaw: any = {
        to: tr.to,
        data: tr.data,
        value: tr.value ?? '0x0',
        from: address
      };

      const sanitizeTxForWallet = (tx: any) => {
        const { gas, gasLimit, gasPrice, maxFeePerGas, maxPriorityFeePerGas, type, ...rest } = tx || {};
        return rest;
      };
      const txRequest = sanitizeTxForWallet(txRequestRaw);

      this.addLog(
        '📦 [LiFi] TX ready (wallet-estimated fees): ' +
        `to=${txRequest.to}, dataLen=${(txRequest.data || '').length}, ` +
        `value=${txRequest.value}, fees='(auto by wallet)'`
      );

      let txResponse: any;
      snapshot('before-send-intent');
      const resSend = await this.gate.requestWithIntentEx(
        intentToken || this.gate.generateIntent('swap-send', (m) => this.addLog(m)),
        async () => {
          (window as any).__allowWcDeeplinkFor?.(12_000);
          try {
            txResponse = await signer.sendTransaction(txRequest);
            this.addLog(`📤 [LiFi] TX sent: ${txResponse.hash}`);
            // 🔸 Hash obtenu → on désarme le timeout local "cancel:trx"
            if (txResponse?.hash) { this.cfOnHash?.('trx'); }
          } catch (e: any) {
            const info = extractErr(e);
            this.addLog(`[LiFi][send] ❌ catch | code=${String(info.code)} / err.code=${String(info.error_code)} / info.err.code=${String(info.info_error_code)} / data.orig.code=${String(info.data_original_code)} | msg="${info.message || info.reason || info.error_message || info.info_error_message || info.data_original_message || ''}"`);
            if (isUserRejected(e)) {
              this.cfCancel?.('user_rejected', 'trx');
              throw { __userRejected: true, code: info.code ?? info.error_code, message: info.message, meta: info };
            }
            throw e;
          }
        },
        {
          ctx: 'swap:send',
          log: (m) => this.addLog(m),
          preserveTokenOnSuccess: false,
          timeoutMs: 30_000,
        }
      );

      if (!resSend.ok) {
        snapshot('send-result-not-ok');
        this.addLog(`[gate][send] not ok | reason=${resSend.reason} | err=${JSON.stringify((resSend as any).error ?? {}, null, 2).slice(0, 1000)}`);

        const canceled =
          resSend.reason === 'user-rejected' ||
          (resSend as any).error?.__userRejected === true;

        if (canceled) {
          // 🔸 Cancel côté gate (aucun hash) → cancel-flow (trx)
          this.cfCancel?.('user_rejected', 'trx');
          this.addLog('⛔ [LiFi] Envoi annulé → reset doux + hard reload + cooldown deeplink');
          try { setWcSuppressOnce?.(8000); } catch { }
          try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }
          this.bridgeStatus = 'cancelled';
          this.bridgeError = this.translate.instant('USER_CANCELLED');
          //this.closeQuoteWithReason('cancel-send');
          //await this.forceReconnectWalletSession('cancel-send');
          snapshot('after-cancel-reset');
          return;
        }

        if (resSend.reason === 'timeout') {
          // 🔸 Timeout avant hash → cancel-flow (trx: timeout)
          this.cfCancel?.('timeout', 'trx');
          this.addLog('⏱️ [LiFi] Envoi timeout → reset doux + force reconnect + cooldown deeplink');
          try { setWcSuppressOnce?.(8000); } catch { }
          try { sessionStorage.setItem('st/skipWcDeeplinkOnce', '1'); } catch { }

          this.bridgeStatus = 'idle';
          this.bridgeError = this.translate.instant('WALLET_TIMEOUT');

          // [+] abort explicite de la session WC (évite l’UI bloquée en "en cours")
          try { await (this as any).abortWalletConnectSafely?.call?.(this, 'timeout-send'); } catch { }


          //this.closeQuoteWithReason('timeout-send');
          //await this.forceReconnectWalletSession('timeout-send');
          snapshot('after-timeout-reset');
          try { this.validatingKey = null; } catch { }
          return;
        }

        this.addLog('⚠️ [LiFi] Envoi erreur → STOP');
        this.bridgeStatus = 'error';
        this.bridgeError = this.translate.instant('UNEXPECTED_ERROR');
        return;
      }

      snapshot('after-send-ok-waiting-receipt');
      this.addLog('⏳ [LiFi] Attente receipt…');
      const receipt = await txResponse.wait();
      this.addLog(`✅ [LiFi] TX confirmé: status=${receipt?.status}, block=${receipt?.blockNumber}`);

      this.bridgeStatus = 'success';
      this.bridgeHash = txResponse.hash;

    } catch (err: any) {
      snapshot('final-catch');
      const info = {
        code: err?.code,
        message: err?.message,
        reason: err?.reason,
        error_code: err?.error?.code,
        error_message: err?.error?.message,
        info_error_code: err?.info?.error?.code,
        info_error_message: err?.info?.error?.message,
        data_original_code: err?.data?.originalError?.code,
        data_original_message: err?.data?.originalError?.message,
      };
      this.addLog(`❌ [LiFi] Erreur (final catch): code=${String(info.code)} / err.code=${String(info.error_code)} / info.err.code=${String(info.info_error_code)} / data.orig.code=${String(info.data_original_code)} | msg="${info.message || info.reason || info.error_message || info.info_error_message || info.data_original_message || ''}"`);

      const msg = err?.message || String(err);
      this.bridgeStatus = 'error';
      this.bridgeError = msg;

    } finally {
      // [+] Normalisation UI : si on n’est plus en pending, on libère la clé de validation
      if (this.bridgeStatus !== 'pending') {
        if (this.validatingKey) { this.addLog(`[UI] finalize: clearing validatingKey=${this.validatingKey}`); }
        try { this.validatingKey = null; } catch { }
      }
    }
  }













  /**
   * 🔹 Mode 0x Permit2 → Envoi direct avec Permit2 signé
   */
  async executeSwapOx() {
    if (!this.provider) {
      console.error('❌ Provider non initialisé');
      return;
    }

    const signer = await this.provider.getSigner();
    console.log('🟣 Mode 0x Permit2 détecté (One‑Click)');

    // ✅ Récupération sécurisée des valeurs critiques
    const permitAmount =
      this.quote.PermitAmount ??
      this.quote.permitAmount ??
      this.quote.amountDecimals ??
      null;

    const sellTokenAddr = this.quote.SellTokenAddress ?? this.quote.sellTokenAddress ?? '';
    const permitDeadline = this.quote.PermitDeadline ?? this.quote.permitDeadline ?? '0';
    const permitNonce = this.quote.PermitNonce ?? this.quote.permitNonce ?? '0';
    const txTo = this.quote.TransactionTo ?? this.quote.transactionTo ?? '';
    const txData = this.quote.TransactionData
      ?? this.quote.transactionData
      ?? this.quote.data // fallback si TransactionData manquant
      ?? '';
    const txValue = this.quote.TransactionValue ?? this.quote.transactionValue ?? '0';

    // 🔍 Log des champs critiques pour debug
    console.log('🔍 Champs critiques 0x Permit2 :', {
      permitAmount,
      sellTokenAddr,
      permitDeadline,
      permitNonce,
      txTo,
      txValue,
      txDataPreview: txData ? txData.slice(0, 20) + '...' : '(vide)'
    });

    try {
      if (!permitAmount || permitAmount === '0') {
        throw new Error('Montant Permit2 manquant');
      }

      // 1️⃣ Génération de la signature Permit2 EIP‑712
      console.log('🔏 Génération de la signature Permit2...');
      const { permit, signature } = await this.buildPermitAndSign({
        token: sellTokenAddr,
        amount: BigInt(permitAmount),
        expiration: BigInt(permitDeadline),
        nonce: BigInt(permitNonce),
        spender: txTo,
        sigDeadline: BigInt(permitDeadline)
      });

      // 2️⃣ Encodage Permit2
      const encodedPermit = encodePermitSingle(await signer.getAddress(), permit, signature);
      this.permit = permit;
      this.permitSig = signature;
      this.quote.permit = encodedPermit;
      console.log('✅ Permit2 signé et encodé');

      // 3️⃣ Injection dans transactionData
      const finalTxData = this.injectPermitIntoCalldata(txData, encodedPermit);

      // 4️⃣ Envoi direct du swap
      this.bridgeStatus = 'pending';
      console.log('🚀 Envoi du swap avec Permit2 inclus...');
      const tx = await signer.sendTransaction({
        to: txTo,
        data: finalTxData,
        value: BigInt(txValue ?? '0'),
        gasLimit: BigInt(350_000)
      });

      console.log('📜 TX envoyée :', tx.hash);
      await tx.wait();

      this.bridgeStatus = 'success';
      this.bridgeHash = tx.hash;
      this.bridgeError = null;
    } catch (err: any) {
      console.error('❌ Swap 0x Permit2 failed:', err);
      this.bridgeStatus = 'error';
      this.bridgeError = err?.message || 'Swap Permit2 error';
    }
  }

  private injectPermitIntoCalldata(originalData: string, encodedPermit: string): string {
    const cleanPermit = encodedPermit.replace(/^0x/, '').toLowerCase();
    const cleanData = originalData.toLowerCase();

    // On cherche un placeholder rempli uniquement de zéros
    const zeroPattern = '0'.repeat(cleanPermit.length);
    const idx = cleanData.indexOf(zeroPattern);

    if (idx > 0) {
      console.log(`✅ Permit2 injecté dans calldata à l'offset ${idx}`);
      return '0x' + cleanData.substring(0, idx) + cleanPermit + cleanData.substring(idx + cleanPermit.length);

    }

    console.warn('⚠️ Impossible de trouver le placeholder du Permit2 dans calldata');
    return originalData.startsWith('0x') ? originalData : '0x' + originalData;
  }

  private async buildWrapUnwrapQuote() {
    // Estimation gas (unwrap ~20k gas, wrap ~23k gas)
    const estimatedGas = this.sellTokenSymbol === 'WETH' ? 20000 : 23000;

    // Récupère prix natif (ETH)
    const nativeUsd = await this.fetchNativeTokenUsd();

    // Convertit montant sell en wei
    const sellAmountWei = this.toAmountDecimals(this.sellAmount, this.sellTokenSymbol);

    // Calcule coût gas en wei
    const feeData = await this.provider?.getFeeData();
    const gasPriceWei = feeData?.gasPrice ?? 0n;
    const fullGasWei = BigInt(estimatedGas) * (gasPriceWei ?? 0n);

    this.quote = {
      sellTokenSymbol: this.sellTokenSymbol,
      buyTokenSymbol: this.buyTokenSymbol,
      formattedSellAmount: this.sellAmount,
      formattedBuyAmount: this.sellAmount, // wrap/unwrap = 1:1
      sellTokenUsdPrice: nativeUsd,
      buyTokenUsdPrice: nativeUsd,
      estimatedGas,
      gasPriceWei: gasPriceWei.toString(),
      totalNetworkFee: fullGasWei.toString(),
      source: 'Native Wrap/Unwrap',
    };

    this.fullGasWei = fullGasWei;
    this.gasPriceWei = gasPriceWei;
    this.nativeTokenUsd = nativeUsd;

    console.log('💡 Fake quote wrap/unwrap générée :', this.quote);
  }

  // 🛡️ Détection native synchronisée avec backend GetWrappedTokenAddress()
  private isNativeToken(address: string, chainId: number): boolean {
    const lower = address?.toLowerCase();
    if (!lower) return false;

    // Adresses natives génériques
    if (
      lower === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' ||
      lower === '0x0000000000000000000000000000000000000000'
    ) {
      return true;
    }

    // Adresses natives spécifiques par réseau
    const nativeByChain: Record<number, string[]> = {
      137: ['0x0000000000000000000000000000000000001010'], // MATIC sur Polygon
    };

    return nativeByChain[chainId]?.includes(lower) ?? false;
  }

  async executeSwapOpenOcean() {
    if (!this.provider) {
      console.error('❌ Provider non initialisé');
      return;
    }

    const signer = await this.provider.getSigner();
    const network = await this.provider.getNetwork();
    const chainId = Number(network.chainId);

    // 🔹 ULTRA mode (Permit2 / Gasless)
    if (this.enablePermit2 && this.quote.IsPermit2) {
      console.log('🟢 Mode OpenOcean ULTRA détecté');
      const swapBody = this.buildSwapBodyForUltra();

      try {
        this.bridgeStatus = 'pending';
        const swapResp = await firstValueFrom(this.swapApi.getGaslessSwap(swapBody));

        if (!swapResp?.to || !swapResp?.data) {
          throw new Error('Réponse incomplète du backend OpenOcean');
        }

        const tx = await signer.sendTransaction({
          to: swapResp.to,
          data: swapResp.data,
          value: BigInt(swapResp.value ?? '0'),
          gasLimit: BigInt(300_000)
        });

        console.log('🚀 TX ULTRA envoyée :', tx.hash);
        await tx.wait();

        this.bridgeStatus = 'success';
        this.bridgeHash = tx.hash;
        this.bridgeError = null;
      } catch (err: any) {
        console.error('❌ ULTRA OpenOcean fail:', err);
        this.bridgeStatus = 'error';
        this.bridgeError = err?.message || 'Erreur OpenOcean ULTRA';
      }
      return;
    }

    // 🔹 CLASSIQUE mode
    try {
      console.log('🟡 Mode OpenOcean Classique détecté');
      console.log('📦 Quote Classique reçue :', JSON.stringify(this.quote, null, 2));

      const takerTokenLower = this.quote.value?.takerToken?.toLowerCase();
      const isNative = this.isNativeToken(takerTokenLower, chainId);

      const target = this.quote.target ?? this.quote.Target ?? this.quote.to ?? this.quote.To ?? null;
      console.log("🎯 Target détecté pour Classic :", target);

      if (!target) {
        throw new Error("❌ Target manquant dans la quote classique");
      }

      const valueToSend = isNative ? BigInt(this.quote.value.takerTokenAmount) : 0n;

      // 🔍 Approve uniquement si ERC20
      if (!isNative) {
        console.log("🔍 Token ERC20 détecté → vérification allowance...");
        const erc20 = new Contract(
          this.quote.value.takerToken,
          [
            'function allowance(address,address) view returns(uint256)',
            'function approve(address,uint256) returns(bool)'
          ],
          signer
        );

        const owner = await signer.getAddress();
        const allowance: bigint = await erc20['allowance'](owner, target);
        const required: bigint = BigInt(this.quote.value.takerTokenAmount);

        if (allowance < required) {
          this.bridgeStatus = 'approve';
          const txA = await erc20['approve'](target, required);
          await txA.wait();
          console.log('✅ Approve confirmé');
        } else {
          console.log("✅ Allowance suffisante, approve inutile");
        }
      } else {
        console.log("💡 Pas d'approve nécessaire : token natif détecté");
      }

      // 🚀 Envoi de la transaction de swap
      this.bridgeStatus = 'pending';

      console.log("🧾 Dernière vérification avant envoi de TX :");
      console.log("🔹 Target        :", target);
      console.log("🔹 Amount        :", valueToSend.toString());
      console.log("🔹 Data (truncated) :", this.quote.data?.slice(0, 50) + '...');
      console.log("🔹 GasLimit     :", '350000');
      console.log("🔹 Token natif  :", isNative);
      console.log("🔹 TakerToken   :", this.quote.value?.takerToken);
      console.log("🔹 TakerAmount  :", this.quote.value?.takerTokenAmount);
      console.log("🔹 ChainId      :", chainId);

      const tx = await signer.sendTransaction({
        to: target,
        data: this.quote.data,
        value: valueToSend,
        gasLimit: BigInt(350_000)
      });

      console.log('🚀 TX Classique envoyée :', tx.hash);
      await tx.wait();

      this.bridgeStatus = 'success';
      this.bridgeHash = tx.hash;
      this.bridgeError = null;
    } catch (e: any) {
      console.error('❌ Classic fail :', e);
      this.bridgeStatus = 'error';
      this.bridgeError = e?.message || 'Erreur swap classique';
    }
  }










  selectSellToken(symbol: string) {
    console.log('[selectSellToken] →', symbol);
    console.trace();
    this.sellTokenSymbol = symbol;

    // ⚡ règle auto : choisir le premier token ≠ sell dans popularTokens (trié par volume)
    if (this.buyTokenSymbol == symbol) {
      const next = this.popularTokens.find(t => t.symbol !== symbol);
      if (next) {
        this.buyTokenSymbol = next.symbol;
      }
    }
  }


  getSellTokenName(symbol: string) {
    const t = this.filteredSellTokens.find(t => t.symbol === symbol);
    return t?.name || '';
  }












  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.translate.get('COPY_SIGNATURE').subscribe((message: string) => {
      alert(message);
    });
  }
}





